import{routeSlugs,speciesForLevel,speciesTypes,statsFor,pokemonPower,damageFor,effectiveness,emphasizedEffectiveness,combatIntervalMs,masteryDamageMultiplier,pokemonMasteryXpToNext,authoritativeDefeats,trainerPerks,trainerTalentPoints,trainerTalentPointsFromDefeats,trainerTalentPointsSpent,normalizeTrainerTalents,killXpBonusForDefeats,TRAINER_TALENT_KEYS,xpToNext,chainForSpecies,MAX_TRAINER_LEVEL,trainerXpToNext,trainerXpForKill,offlinePokemonXpPct,OFFLINE_POKEMON_PCT_PER_RANK,combatXpReward,configureBattleData,encountersForRoute,rollFish,evolutionDepthForSpecies,ROUTE_LEVEL_RANGES,ROUTE_UNLOCK_LEVELS,typeUnlockLevel,isZoneHuntLevel,ZONE_HUNT_MIN_LEVEL,ENDGAME_ZONES,endgameZoneAccess,zoneConfigForBand,featuredSpecialSpecies,msUntilNextGmt3Hour,rollZoneSpecial,encounterLevel,HUNT_DIFFICULTIES,speciesMinRouteLevel}from'./battle-data.js';

import{BALLS,POTIONS,STONES,DROP_ITEMS,SHOP_ITEMS,PURCHASABLE_TM_ITEMS,TM_ITEMS,ITEM_BY_SLUG,STONES_BY_TYPE,FISHING_ROD_ITEMS,rollDrops,sellValue,lootTableForSpecies,isDropBucketSlug,canonicalizeDropOnlyMap}from'./items-data.js';
import{initCityPixi,isPixiRendererEnabled}from'./world/city-world.js';
import{lockMapScale}from'./world/map-scale.js?v=20260803-map-lock-2';
import{simulationWindow,transientDeadline}from'./background-runtime.mjs';
import{huntMapStageFor,huntMapStageConfigFor}from'./hunt-map-flow.mjs';
import{loadMovesData,isMovesReady,getMove,getMoveFx,unlockedMoves,newlyUnlockedMoves,defaultLoadout,sanitizeLoadout,pickNextMove,moveDisplayName,getEquipSlots,moveCooldownTurns,moveCombatRange,isCombatMove}from'./moves-data.js?v=20260728-myst-fx-map-1';
import{loadPokedexData,isPokedexReady,allPokedexSpecies,pokedexEntry,pokemonSellPrice,formatDexNumber,speciesLocations,speciesCatchFactor}from'./pokedex-data.js';
import{typeGlyph,typeIconCircle}from'./type-icons.js';
import{hydrateUiIcons,idlecoinMark,uiIcon}from'./ui-icons.js';
import{SCHEMATIC_HUB,routeNodeAnchorsForBand}from'./world-map-layout.js';
import{WORLD_MAP_MANIFEST,WORLD_MAP_ART_VERSION,worldMapEntry,routeArtTier}from'./world-map-manifest.js';
import{t,typeLabel,normalizeTypeId,rarityLabel,itemName,itemDesc,mapTitle,formatNumber,formatDateTime,formatTime,initI18n,setLocale,getLocale,SUPPORTED_LOCALES,onLocaleChange,applyStaticI18n}from'./i18n/index.js?v=20260727-atlas-guide-3';
import{SPECIMEN_RARITIES,IV_QUALITY_BANDS,IV_TOTAL_MAX,SHINY_SOFT_PITY_KILLS,shinyChanceForResearch,captureChance as balancedCaptureChance,ivScore as specimenIvScore,rollSpecimenRarity,rollIvs}from'./capture-balance.mjs';
import{captureErrorReason,captureFailureMessageKey}from'./capture-sync.mjs';
import{clearNotificationMarkers,dismissCaptureNotification,dismissInventoryNotification,inventoryUnreadQty,normalizeNotificationState,recordNotification}from'./notification-markers.mjs';
import{inventoryTooltipPosition}from'./inventory-tooltip.mjs';
import{evolutionCoinCost}from'./economy-balance.mjs';
import{promoteReservePokemon}from'./team-active.js';
import{applyPokemonXpProgress,normalizePokemonLevel}from'./progression/pokemon-progression.mjs';
import{COMPARE_MODE_OWNED,COMPARE_MODE_SPECIES,COMPARE_LEVEL_MAX,compareEvolutionOptions,normalizeCompareLevel,ownedCompareEntries,resolveOwnedCompareSelection}from'./compare-core.mjs';
import{DEFAULT_TRAINER_GENDER,DEFAULT_TRAINER_SPRITE,defaultSpriteForGender,isValidTrainerSprite,looksForGender}from'./trainer-looks.js';
import{DEFAULT_STARTER_REGION,STARTER_REGIONS,isValidStarterSlug,regionById}from'./starter-regions.js';
import{DEFAULT_OUTFIT_COLORS,OUTFIT_COLOR_COUNT,OUTFIT_PIECES,clearOutfitCompositeCache,compositeOutfitSprite,entityMaskAsset,normalizeOutfitColors,outfitColorCss,outfitColorsKey,trimmedSpriteUrl}from'./outfit-colors.js';
import{bestStepTowardLand,buildRouteLandIndex,constrainToLand,isLandAtPercent,landPathBlocked,pickRandomLandPercent,routeDistance,scaleRouteDelta,stepOnLand,stepTowardRoute}from'./world/route-land.js?v=20260724-engage-fix-3';
import{initRoutePixi,loadRouteMapDoc}from'./world/route-world.js?v=20260728-claude-camera-1';
import{FISHING_RODS,bestOwnedFishingRod,fishingRodFor,FISHING_SPOTS,FISHING_BAITS,rollFishingMaterials,fishingCastMs}from'./fishing-balance.mjs';
import{initAccountGate}from'./auth/account-ui.js?v=20260801-token-hash-1';
import{signOutAccount,onClientSessionSuperseded,startClientSessionWatch,stopClientSessionWatch}from'./net/supabase-client.js?v=20260801-token-hash-1';
import{acceptMarketWallet,flushWalletSync,initMarketState,recordIdlecoinDelta,walletSyncEnabled}from'./market/market-state.js';
import{purchaseShopItem,sellInventoryItems,sellPlayerPokemon,setPlayerPokemonLocked,spendIdlecoin}from'./market/market-api.js';
import{initMarketUI,openMarket,closeMarket}from'./market/market-ui.js';
import{collectionSyncEnabled,initCollectionSync,refreshPlayerPokemon,serverAttemptCapture,serverBreedCreateEgg,serverBreedHatch,serverBreedTickEggs,serverPokemonToLocal}from'./collection/collection-sync.js';
import{flushSessionSync,initProgressSync,inventorySyncEnabled,pendingKillCount,progressSyncEnabled,recordServerKill,refreshInventory,refreshProgress}from'./collection/progress-sync.js';
import{encounterQueueLength,encountersSyncEnabled,ensureEncounterQueue,fetchEncounterBatch,initEncounterSync,setShinyAltarInvocation,takeQueuedEncounterSync}from'./collection/encounter-sync.js';
import{armOfflineExit,consumeCleanExitStamp,initSessionLifecycle,setBackgroundKeepAlive}from'./collection/session-lifecycle.js';
import{claimOfflineHunt,consumeInventoryItem,ensureStarterPokemon,evolvePlayerPokemon,grantPokemonXp,investTrainerTalentRpc,invokeShinyAltar,listPlayerEggs,migrateProgress,prestigeTrainerRpc,requestEncountersRpc,resolveFishingCastRpc,respecTrainerTalentsRpc,restoreGhostCapturesRpc,setActivePokemon,setTeamRoster}from'./collection/collection-api.js';
import{initChatUI,linkAssetToChat,pushChatSystemMessage}from'./chat/chat-ui.js';
import{initAdminUI,initGameNoticeFeed,openAdminForUser,openAdminPanel,closeAdminPanel}from'./admin/admin-ui.js';
import{loadGameSave,writeGameSave}from'./save/game-save.js';
import{initAltarUI,openAltar,shinyEncounterChance,shinyCaptureChance,rollShinyCardDrop,SHINY_CARD_ALTAR_COST}from'./shiny/altar-ui.js';
import{matchesShinyFilter}from'./shiny/visuals.mjs';
import{assetSlug,entityAssetPath,hasManifestAsset,portraitAssetPath,shinyAssetClass}from'./shiny/assets.mjs';
import{initBreedingUI,openBreeding,refreshBreeding,incubationDefeatsFor}from'./breeding/breeding-ui.js?v=20260729-breeding-1';
import{initAtlasUI,openAtlas,migrateLegacyHuntState,speciesHuntEntries}from'./hunt/atlas-ui.js';
import{MAP_OPENS_ATLAS,atlasSelectionFromMap}from'./world/atlas-entry.js';
import{bossProfileFor,rollBossSummons,resolveAoE}from'./combat/boss-core.mjs';
import{initMasterSystemsUI,openPanel as openMasterPanel,activeBoostMult,BOOST_DEFS,upgradePerks,normalizeUpgrades,normalizeMeta,normalizeMonetization,normalizeProfessions,isVip,vipPerks,CITY_NPCS}from'./systems/master-ui.js?v=20260723-daily-gift-1';
import{npcNear}from'./city/npcs.js';
import{progressQuest,logShinyCapture,logIvQualityCapture,logFishCaught,logCraftCompleted,logFossilRevival,checkAchievements,dailyGiftProgress,shouldShowDailyGiftOnLogin}from'./meta/retention-core.mjs';
import{RELEASE_FEATURES}from'./release/feature-gates.mjs';
import{getMyClan,joinClanOnServer,skipClanRankOnServer}from'./clan/clan-api.js';
import{normalizeClan}from'./clan/clan-core.mjs';
import{getActiveWorldRaid,claimWorldRaidRewards}from'./raid/raid-api.js';
import{initTelemetry,trackEvent}from'./telemetry/telemetry.js';
import{migrateTutorialVersion,TUTORIAL_VERSION}from'./tutorial/tutorial-core.mjs?v=20260727-atlas-guide-3';
import{initTutorial,tutorialEvent,restartTutorial,activeTutorialStepId}from'./tutorial/tutorial-ui.js?v=20260727-atlas-guide-3';
/** Trava do aviso de HP baixo do tutorial: uma vez por mergulho, não por turno. */
let lowHpAnnounced=false;
async function beginEmeraldCheckout(amount){
  if(!RELEASE_FEATURES.paidEmeralds)throw new Error('paid_emeralds_relaunch_pending');
  const payments=await import('./monetization/emerald-purchase.js?v=20260723-monetization-2');
  return payments.beginEmeraldCheckout(amount);
}
async function spendEmerald(amount,reason){
  const payments=await import('./monetization/emerald-purchase.js?v=20260723-monetization-2');
  return payments.spendEmerald(amount,reason);
}
async function purchasePremiumProduct(productId,durationHours){
  const payments=await import('./monetization/emerald-purchase.js?v=20260723-monetization-2');
  return payments.purchasePremiumProduct(productId,durationHours);
}
async function activatePremiumBoost(boostId){
  const payments=await import('./monetization/emerald-purchase.js?v=20260723-monetization-2');
  return payments.activatePremiumBoost(boostId);
}
async function purchaseVip(days){
  const payments=await import('./monetization/emerald-purchase.js?v=20260723-monetization-2');
  return payments.purchaseVip(days);
}
async function purchaseSeasonPass(seasonId){
  const payments=await import('./monetization/emerald-purchase.js?v=20260723-monetization-2');
  return payments.purchaseSeasonPass(seasonId);
}
async function claimSeasonTier(seasonId,tier,track){
  const payments=await import('./monetization/emerald-purchase.js?v=20260723-monetization-2');
  return payments.claimSeasonTier(seasonId,tier,track);
}
async function claimDailyQuest(questId){
  const payments=await import('./monetization/emerald-purchase.js?v=20260723-monetization-2');
  return payments.claimDailyQuest(questId);
}
async function reportDailyQuestProgress(type,amount){
  const payments=await import('./monetization/emerald-purchase.js?v=20260723-monetization-2');
  return payments.reportDailyQuestProgress(type,amount);
}
async function fetchDailyQuests(){
  const payments=await import('./monetization/emerald-purchase.js?v=20260723-monetization-2');
  return payments.currentDailyQuests();
}
async function claimDailyGiftRemote(){
  const payments=await import('./monetization/emerald-purchase.js?v=20260729-daily-gift-authority-1');
  return payments.claimDailyGift();
}
async function fetchDailyGiftRemote(){
  const payments=await import('./monetization/emerald-purchase.js?v=20260729-daily-gift-authority-1');
  return payments.currentDailyGift();
}
async function claimRaidRewards(raidId){
  return claimWorldRaidRewards(raidId);
}
function trackQuestProgress(type,amount=1){
  if(!RELEASE_FEATURES.dailyQuestRewards)return;
  const serverAuthoritative=walletSyncEnabled()&&inventorySyncEnabled();
  // Defeat/capture progress is produced by the encounter trigger on the
  // server. Other local-only activities must not advance a claimable quest
  // while the authoritative endpoint is disabled.
  if(serverAuthoritative&&!['defeat','capture'].includes(String(type||'')))return;
  try{progressQuest(state,type,amount)}catch{}
}
async function syncPremiumEntitlements(){
  if(!activeAccount)return;
  const payments=await import('./monetization/emerald-purchase.js?v=20260723-monetization-2');
  const entitlement=await payments.currentPremiumEntitlements();
  normalizeMonetization(state);
  const expiresAt=Date.parse(entitlement?.vip_expires_at||'')||0;
  state.monetization.vip=expiresAt>Date.now()?{expiresAt}:null;
}

const types = [
  ['elétrico','⚡','#e1cf57',['pichu','elekid','pikachu','magnemite','voltorb','mareep']],
  ['fogo','◒','#ec7950',['growlithe','vulpix','slugma','ponyta','houndour','charmander']],
  ['água','◉','#55aee2',['poliwag','psyduck','tentacool','horsea','lotad','squirtle']],
  ['planta','♧','#6fbd65',['oddish','bellsprout','hoppip','sunkern','chikorita','treecko']],
  ['inseto','✣','#9db552',['caterpie','weedle','paras','venonat','spinarak','scyther']],
  ['voador','◁','#9bb9d7',['pidgey','spearow','zubat','doduo','hoothoot','natu']],
  ['normal','●','#b9b3a4',['rattata','meowth','sentret','zigzagoon','clefairy','jigglypuff']],
  ['psíquico','✦','#dc78a2',['abra','drowzee','natu','ralts','meditite','beldum']],
  ['pedra','◆','#ad9863',['geodude','onix','rhyhorn','larvitar','aron','kabuto']],
  ['terra','▰','#ca9a5c',['sandshrew','diglett','cubone','phanpy','trapinch','swinub']],
  ['fantasma','◌','#7c6aa5',['gastly','misdreavus','shuppet','duskull','sableye','haunter']],
  ['dragão','⌁','#7667d8',['dratini','larvitar','bagon','trapinch','vibrava','shelgon']],
  ['lutador','✊','#c26752',['machop','mankey','makuhita','meditite','tyrogue','hitmonchan']],
  ['veneno','☠','#a76bb0',['ekans','nidorina','koffing','grimer','gulpin','venonat']],
  ['sombrio','☾','#6f625d',['sneasel','murkrow','poochyena','houndour','absol','sableye']],
  ['aço','⬡','#93a9ad',['magnemite','skarmory','aron','beldum','mawile','forretress']],
  ['gelo','❄','#83cfcb',['swinub','sneasel','spheal','smoochum','snorunt','seel']],
  ['fada','✧','#dda2c5',['clefairy','jigglypuff','snubbull','togepi','ralts','mawile']]
];
const typeColors={normal:'#918e73',fogo:'#e85d27','água':'#3d7ee8','elétrico':'#e2b719',planta:'#62ad3f',gelo:'#62bfc3',lutador:'#b92f2a',veneno:'#913a96',terra:'#bd913e',voador:'#8871d1','psíquico':'#e84d79',inseto:'#8fa315',pedra:'#9e8b2f',fantasma:'#65508e','dragão':'#6135d7',sombrio:'#59483e','aço':'#888ba4',fada:'#cb719c'};
const typeColor=(type)=>typeColors[normalizeTypeId(type)]||'#777';
const normalizePokemonTypes=(types,fallbackName)=>{
  const cleaned=(Array.isArray(types)?types:[]).map(normalizeTypeId).filter(Boolean);
  return cleaned.length?cleaned:speciesTypes(fallbackName);
};
const ranges = ROUTE_LEVEL_RANGES;
const rarity = SPECIMEN_RARITIES;
function rarityInfo(pokemon){
  const name=pokemon?.rarity||'Inicial';
  const fromTable=rarity.find(r=>r.name===name);
  const color=pokemon?.color||fromTable?.color||(name==='Inicial'?'#d4a83c':'#a9b5ae');
  const mult=Number(pokemon?.mult)||fromTable?.mult||1;
  return{name,color,mult,label:rarityLabel(name).toUpperCase()};
}
/* Tiers altos ganham efeitos visuais próprios (ver idlemon-theme.css). */
const RARITY_TIER_CLASSES={'Épico':'rarity-epic','Lendário':'rarity-legendary','Mítico':'rarity-mythic','Celestial':'rarity-celestial','Ancião':'rarity-ancient','Secreto':'rarity-secret'};
const rarityTierClass=r=>RARITY_TIER_CLASSES[r?.name]||'';
const $ = s => document.querySelector(s);
const $$ = s => [...document.querySelectorAll(s)];
const title = s => s.charAt(0).toUpperCase()+s.slice(1);
const displayItem = slug => itemName(slug) || ITEM_BY_SLUG[slug]?.name || slug;
const resolveItemLabel = stored => {
  if(!stored)return displayItem('pokeball');
  if(ITEM_BY_SLUG[stored])return displayItem(stored);
  const found=Object.values(ITEM_BY_SLUG).find(it=>it.name===stored);
  return found?displayItem(found.slug):stored;
};
const formatEncounterChance = chance => `${formatNumber(Number(chance||0),{minimumFractionDigits:chance<1?2:1,maximumFractionDigits:2})}%`;
const coinsValue = n => Math.round(Math.abs(Number(n)||0));
const formatCoins = n => `${formatNumber(coinsValue(n))} ${t('common.coins')}`;
const coinsAmount = (n,size=12) => `<span class="coins-inline">${idlecoinMark(size)} ${formatNumber(coinsValue(n))}</span>`;
const cooldownTurnLabel = count => count===0?t('moves.alwaysReady'):(count===1?t('moves.oneTurn'):t('moves.turns',{count}));
const localizedCatchDifficulty = (entry,chance=null) => {
  if(Number.isFinite(chance)){
    if(chance>=.8)return t('catch.easy');
    if(chance>=.55)return t('catch.medium');
    if(chance>=.3)return t('catch.hard');
    return t('catch.veryHard');
  }
  const f = speciesCatchFactor(entry);
  if (f >= 0.7) return t('catch.easy');
  if (f >= 0.45) return t('catch.medium');
  if (f >= 0.22) return t('catch.hard');
  return t('catch.veryHard');
};
const entitySlug = assetSlug;
/** Sprite de mapa (looktype Myst). */
let spriteIndexBySlug=null,spriteScaleBySlug={},shinyEntityManifest={},shinyPortraitManifest={};
const entityAsset = (name, dir='south', frame=0, {shiny=false}={}) => entityAssetPath(name,dir,frame,{shiny,manifest:shinyEntityManifest});
const shinyClassFor=(pokemon,kind='entity')=>{
  if(!pokemon?.shiny)return'';
  const real=kind==='portrait'
    ? Boolean(portraitAssetPath(pokemon.name,{shiny:true,manifest:shinyPortraitManifest}))||hasManifestAsset(shinyEntityManifest,pokemon.name)
    : hasManifestAsset(shinyEntityManifest,pokemon.name);
  return shinyAssetClass(pokemon,real?{[entitySlug(pokemon.name)]:true}:{});
};
async function loadSpriteIndex(){
  const loadJson=url=>fetch(url).then(response=>{
    if(!response.ok)throw new Error(`${url}: HTTP ${response.status}`);
    return response.json();
  });
  const [sprite,entity,portrait]=await Promise.allSettled([
    loadJson('public/game/sprite-index.json'),
    loadJson('public/game/shiny-entity-index.json'),
    loadJson('public/game/shiny-portrait-index.json'),
  ]);
  if(sprite.status==='fulfilled'){
    spriteIndexBySlug=sprite.value.bySlug||{};
    spriteScaleBySlug=sprite.value.scaleBySlug||{};
  }else{
    console.warn('sprite-index load failed',sprite.reason);spriteIndexBySlug={};spriteScaleBySlug={};
  }
  shinyEntityManifest=entity.status==='fulfilled'?(entity.value.bySlug||{}):{};
  shinyPortraitManifest=portrait.status==='fulfilled'?(portrait.value.bySlug||{}):{};
  if(entity.status!=='fulfilled')console.warn('shiny entity index load failed',entity.reason);
  if(portrait.status!=='fulfilled')console.warn('shiny portrait index load failed',portrait.reason);
  return spriteIndexBySlug;
}
const pokemonSpriteScale=name=>{
  const scale=Number(spriteScaleBySlug[entitySlug(name)]);
  return Number.isFinite(scale)&&scale>0?scale:1;
};
const pokemonSpriteScaleStyle=name=>`--pokemon-sprite-scale:${pokemonSpriteScale(name)}`;
/** Retrato UI: portrait shiny real, entidade shiny real ou sprite normal do índice. */
const asset = (name,pokemon=null) => {
  const slug=entitySlug(name);
  if(pokemon?.shiny){
    const portrait=portraitAssetPath(name,{shiny:true,manifest:shinyPortraitManifest});
    if(portrait)return portrait;
    return entityAsset(name,'south',0,{shiny:true});
  }
  return spriteIndexBySlug?.[slug]||entityAsset(name,'south',0);
};
function pokePortrait(name, typeColor, extraClass='', pokemon=null){
  const classes=[extraClass,shinyClassFor(pokemon,'portrait')].filter(Boolean).join(' ');
  return`<span class="poke-portrait ${classes}" style="--slot-color:${typeColor||'#82765b'}"><img src="${asset(name,pokemon)}" alt="" loading="lazy" onerror="this.style.opacity=.2"></span>`;
}
function ivScoreFor(pokemon){
  if(pokemon?.ivs&&Object.keys(pokemon.ivs).length)return specimenIvScore(pokemon.ivs);
  const stored=Number(pokemon?.ivScore);if(Number.isFinite(stored))return Math.max(0,Math.min(IV_TOTAL_MAX,Math.round(stored)));
  const percent=Number(pokemon?.ivTotal);return Number.isFinite(percent)?Math.max(0,Math.min(IV_TOTAL_MAX,Math.round(percent/100*IV_TOTAL_MAX))):0;
}
const formatPokemonIv=pokemon=>`${ivScoreFor(pokemon)}/${IV_TOTAL_MAX}`;
function pokemonIvsGrid(pokemon){
  return`<div class="team-ivs-grid">${Object.entries(pokemon?.ivs||{}).map(([label,value])=>`<div class="${(+value||0)>=25?'iv-high':''}"><span>${label}</span><b>${value}<em>/31</em></b><i><u style="width:${Math.min(100,(+value||0)/31*100)}%"></u></i></div>`).join('')}</div>`
}
function captureHistorySnapshot(pokemon,{isNew=false}={}){return{id:pokemon.id,name:pokemon.name,encounterLevel:pokemon.encounterLevel||pokemon.level||1,capturedAt:pokemon.capturedAt||Date.now(),ball:pokemon.ball,rarity:pokemon.rarity||'Comum',color:pokemon.color||'#a9b5ae',ivs:pokemon.ivs?{...pokemon.ivs}:undefined,ivScore:ivScoreFor(pokemon),ivTotal:pokemon.ivTotal??0,shiny:!!pokemon.shiny,isNew:!!isNew}}
function normalizeNavNotifications(raw){return normalizeNotificationState(raw)}
function normalizeZoneProgress(raw){
  const source=raw&&typeof raw==='object'&&!Array.isArray(raw)?raw:{};
  return Object.fromEntries(ENDGAME_ZONES.map(zone=>{
    const value=source[zone.id]||{};
    // Campos kills/bossesDefeated do Rastro Lendário legado são ignorados.
    return[zone.id,{seenSpecials:Math.max(0,Math.floor(Number(value.seenSpecials)||0))}];
  }));
}
function renderNavNotifications(){
  for(const[kind,id]of Object.entries({captures:'huntCaptureCount',inventory:'inventoryCount'})){
    const badge=document.getElementById(id),count=state?.notifications?.[kind]||0;if(!badge)continue;
    badge.textContent=String(count);badge.classList.toggle('is-zero',count<=0);
  }
}
function addNavNotification(kind,qty=1,slug=''){
  const amount=Math.max(0,Math.floor(Number(qty)||0));if(!amount)return;
  const layerId=kind==='captures'?'captureHistoryModal':'inventoryPanelLayer',layer=document.getElementById(layerId);
  if(layer&&!layer.classList.contains('hidden'))return false;
  state.notifications=recordNotification(state.notifications,kind,amount,slug);renderNavNotifications();
  return true;
}
function markNavNotificationSeen(kind){
  const notifications=normalizeNavNotifications(state.notifications);
  const hasCaptureMarkers=kind==='captures'&&(state.captureHistory||[]).some(entry=>entry?.isNew);
  const hasInventoryMarkers=kind==='inventory'&&Object.keys(notifications.inventoryItems).length>0;
  if(!notifications[kind]&&!hasCaptureMarkers&&!hasInventoryMarkers)return;
  state.notifications=clearNotificationMarkers(notifications,kind);
  if(kind==='captures')state.captureHistory=(state.captureHistory||[]).map(entry=>entry?.isNew?{...entry,isNew:false}:entry);
  renderNavNotifications();save();
}
function dismissInventoryMarker(slug,slot){
  const pending=inventoryUnreadQty(state.notifications,slug);
  if(!pending)return;
  slot?.classList.remove('is-new');
  slot?.querySelector('.inventory-new-marker')?.remove();
  state.notifications=dismissInventoryNotification(state.notifications,slug);
  renderNavNotifications();save();
}
function dismissCaptureMarker(row){
  const key=row?.dataset.captureKey;
  if(!key)return;
  const index=(state.captureHistory||[]).findIndex((entry,entryIndex)=>captureHistoryEntryKey(entry,entryIndex)===key);
  const entry=index>=0?state.captureHistory[index]:null;
  if(!entry?.isNew)return;
  state.captureHistory[index]={...entry,isNew:false};
  row.classList.remove('is-new');
  row.querySelector('.capture-new-marker')?.remove();
  state.notifications=dismissCaptureNotification(state.notifications,1);
  renderNavNotifications();save();
}
function shouldProtectCapture(pokemon){return!!pokemon?.shiny||(pokemon?.ivTotal??0)>=88||['Lendário','Mítico','Celestial','Ancião','Secreto'].includes(pokemon?.rarity)}
function captureGhostMatchKey(entry){
  return[
    String(entry?.name||'').toLowerCase(),
    String(entry?.capturedAt??''),
    String(entry?.rarity||''),
    entry?.shiny?'1':'0',
    JSON.stringify(entry?.ivs||{}),
  ].join('|');
}
function collectionOwnsCapture(entry){
  const key=captureGhostMatchKey(entry);
  const pool=[...(state.collection||[])];
  if(state.starter)pool.push(state.starter);
  for(const pokemon of pool){
    if(entry?.id!=null&&(String(pokemon.id)===String(entry.id)||String(pokemon.serverId)===String(entry.id)))return true;
    if(captureGhostMatchKey({
      name:pokemon.name,
      capturedAt:pokemon.capturedAt,
      rarity:pokemon.rarity,
      shiny:pokemon.shiny,
      ivs:pokemon.ivs,
    })===key)return true;
  }
  return false;
}
async function restoreGhostCapturesFromHistory(){
  if(!collectionSyncEnabled())return;
  const ghosts=(state.captureHistory||[]).filter(entry=>{
    if(!entry?.ivs||!entry?.name)return false;
    if(!shouldProtectCapture({
      shiny:entry.shiny,
      rarity:entry.rarity,
      ivTotal:Math.max(Number(entry.ivTotal)||0,Number(entry.ivScore)||0),
    }))return false;
    return!collectionOwnsCapture(entry);
  }).slice(0,20);
  if(!ghosts.length)return;
  try{
    const response=await restoreGhostCapturesRpc(ghosts.map(entry=>({
      name:entry.name,
      species:entry.name,
      level:1,
      encounterLevel:entry.encounterLevel||1,
      rarity:entry.rarity,
      shiny:!!entry.shiny,
      ball:entry.ball,
      ivs:entry.ivs,
      ivTotal:entry.ivTotal??entry.ivScore,
      capturedAt:entry.capturedAt,
      locked:true,
    })),crypto.randomUUID());
    if(response?.collection)applyServerCollection(response.collection,{force:true});
    else if(response?.ok)await refreshPlayerPokemon();
    if((response?.restored|0)>0){
      showToast(t('log.ghostRestored',{count:response.restored}));
      renderCollection();renderCaptureLog();save();
    }
  }catch(error){
    console.warn('restore_ghost_captures failed',error);
  }
}
const COMBAT_BALANCE_VERSION=2;
const initial = {starter:null,range:0,type:0,mapMode:'ranges',running:false,enemy:null,enemyHp:100,teamHp:100,inventory:{pokeball:24,greatball:8,potion:3,superball:0,ultraball:0,apexball:0,masterball:0,'great-potion':0,'ultra-potion':0,'hyper-potion':0,'full-restore':0,medicine:0,revive:0,'old-rod':1},drops:{},depositItems:{},notifications:{captures:0,inventory:0,inventoryItems:{}},autoPotion:{enabled:false,threshold:50},autoRevive:{enabled:true},autoCapture:false,autoShiny:false,selectedBall:'pokeball',selectedShinyBall:'pokeball',selectedPotion:null,selectedRevive:'revive',lastView:'city',stats:{seconds:0,defeated:0,captured:0,xp:0,coins:120},trainer:{level:1,peakLevel:1,xp:0,prestige:0,name:'',gender:DEFAULT_TRAINER_GENDER,sprite:DEFAULT_TRAINER_SPRITE,colors:{...DEFAULT_OUTFIT_COLORS}},trainerTalents:{trainer:0,hunter:0,catcher:0,researcher:0},trainerFreeRespecs:1,collection:[],captureHistory:[],team:[],log:[],activeHunt:null,lastHunt:null,shinyResearch:{},killCounts:{},zoneProgress:{},offlineHunt:null,pendingOfflineReport:null,fishing:{active:false,rod:'old-rod'},combatBalanceVersion:COMBAT_BALANCE_VERSION,shinyCards:0,altar:{history:[]},altarShiny:null,breeding:{pair:[null,null],incubator:[null,null],mode:'pheromones',doubleStones:false},eggs:[],huntMode:'species',huntSpecies:null,huntLevel:1,tutorial:{version:TUTORIAL_VERSION,done:[],skipped:false,phase:null,current:null,startedAt:null}};
const persistedState=JSON.parse(localStorage.getItem('myst-idle')||'{}'),hadCaptureHistory=Array.isArray(persistedState.captureHistory);
let state = {...initial,...persistedState};
state.collection=(Array.isArray(state.collection)?state.collection:[]).map(p=>{
  if(!p||typeof p!=='object')return null;
  const name=p.name||p.species;
  if(!name)return null;
  return p.name?p:{...p,name:String(name)};
}).filter(Boolean);
state.captureHistory=(Array.isArray(state.captureHistory)?state.captureHistory:[]).filter(p=>p&&p.name);
let activeAccount=null,cloudSaveReady=false,cloudSaveTimer=null,cloudSaveInFlight=null,cloudSaveQueued=false;
let stopGameNoticeFeed=()=>{};
if((Number(persistedState.combatBalanceVersion)||0)<COMBAT_BALANCE_VERSION&&state.starter)state.starter.currentHp=null;
state.combatBalanceVersion=COMBAT_BALANCE_VERSION;
if(!state.depositItems||typeof state.depositItems!=='object'||Array.isArray(state.depositItems))state.depositItems={};
state.depositItems=canonicalizeDropOnlyMap(state.depositItems);
if(state.mapMode!=='bosses')state.mapMode='ranges';
state.stats={...initial.stats,...state.stats};state.trainer={...initial.trainer,...(state.trainer||{})};state.trainer.level=Math.max(1,Math.min(MAX_TRAINER_LEVEL,state.trainer.level||1));state.trainer.peakLevel=Math.max(state.trainer.level,Math.min(MAX_TRAINER_LEVEL,state.trainer.peakLevel||state.trainer.level));state.trainer.xp=Math.max(0,state.trainer.xp||0);state.trainer.prestige=Math.max(0,Math.min(10,Math.floor(state.trainer.prestige||0)));state.trainer.name=String(state.trainer.name||'').trim().slice(0,16);state.trainer.gender=state.trainer.gender==='m'?'m':'f';
state.fishing={active:false,rod:'old-rod',spot:'pier',bait:null,level:1,xp:0,...(state.fishing||{})};state.fishing.active=false;
state.fishing.level=Math.max(1,Number(state.fishing.level)||1);
state.fishing.xp=Math.max(0,Number(state.fishing.xp)||0);
{  const hadSprite=persistedState.trainer&&Object.prototype.hasOwnProperty.call(persistedState.trainer,'sprite');
  if(!hadSprite&&state.starter)state.trainer.sprite='trainer';
  else if(state.trainer.sprite!=='trainer'&&!isValidTrainerSprite(state.trainer.sprite))state.trainer.sprite=defaultSpriteForGender(state.trainer.gender);
}state.trainer.colors=normalizeOutfitColors(state.trainer.colors);state.trainerTalents=normalizeTrainerTalents(state.trainerTalents);{const freeRespecs=Number(state.trainerFreeRespecs);state.trainerFreeRespecs=Number.isFinite(freeRespecs)?Math.max(0,Math.floor(freeRespecs)):1}
// Inventário: se há blob persistido, NÃO espalhar kit inicial (24/8) por cima —
// chaves ausentes/zeradas ficam 0 até o refresh do servidor.
{
  const persistedInv=persistedState.inventory&&typeof persistedState.inventory==='object'?persistedState.inventory:null;
  const next={};
  if(persistedInv){
    for(const slug of Object.keys(initial.inventory||{}))next[slug]=0;
    for(const [slug,qty] of Object.entries(canonicalizeDropOnlyMap(persistedInv)))next[slug]=Math.max(0,Math.floor(Number(qty)||0));
  }else{
    Object.assign(next,initial.inventory||{});
  }
  if(next.superPotion){next['great-potion']=(next['great-potion']||0)+next.superPotion;delete next.superPotion}
  if(!FISHING_RODS.some(rod=>(next[rod.slug]||0)>0))next['old-rod']=1;
  state.inventory=next;
}state.drops=canonicalizeDropOnlyMap(state.drops);state.notifications=normalizeNavNotifications(state.notifications);state.autoPotion={...initial.autoPotion,...(state.autoPotion||{})};state.collection=state.collection||[];state.captureHistory=(hadCaptureHistory?state.captureHistory:state.collection.map(captureHistorySnapshot)).slice(0,100);state.team=Array.isArray(state.team)?state.team.slice(0,5):[];state.log=state.log||[];state.activeHunt=state.activeHunt||null;state.lastHunt=state.lastHunt||null;state.shinyResearch=state.shinyResearch&&typeof state.shinyResearch==='object'?state.shinyResearch:{};state.killCounts=normalizeKillCounts(state.killCounts);state.offlineHunt=state.offlineHunt||null;state.pendingOfflineReport=state.pendingOfflineReport||null;state.marketTransferLog=Array.isArray(state.marketTransferLog)?state.marketTransferLog.slice(-250):[];
state.shinyCards=Math.max(0,Math.floor(Number(state.shinyCards)||0));state.altar=state.altar&&typeof state.altar==='object'?{history:Array.isArray(state.altar.history)?state.altar.history.slice(-50):[]}:{history:[]};state.altarShiny=state.altarShiny||null;
  state.breeding=normalizeBreedingState(state.breeding);
state.eggs=Array.isArray(state.eggs)?state.eggs:[];state.zoneProgress=normalizeZoneProgress(state.zoneProgress);state.huntMode=['legacy','zone'].includes(state.huntMode)?state.huntMode:'species';state.huntSpecies=state.huntSpecies||null;state.huntLevel=Math.max(1,Number(state.huntLevel)||1);
state.huntDifficulty=HUNT_DIFFICULTIES.includes(Number(state.huntDifficulty))?Number(state.huntDifficulty):0;
state.emerald=Math.max(0,Math.floor(Number(state.emerald)||0));
state.badges=Array.isArray(state.badges)?state.badges:[];
state.gymRematches=state.gymRematches&&typeof state.gymRematches==='object'?state.gymRematches:{};
state.eliteProgress=state.eliteProgress&&typeof state.eliteProgress==='object'?{defeated:Array.isArray(state.eliteProgress.defeated)?state.eliteProgress.defeated:[],championDefeated:!!state.eliteProgress.championDefeated}:{defeated:[],championDefeated:false};
normalizeUpgrades(state);normalizeMeta(state);normalizeMonetization(state);normalizeProfessions(state);normalizeClan(state);
state.tutorial=migrateTutorialVersion(
  Object.prototype.hasOwnProperty.call(persistedState,'tutorial')?persistedState.tutorial:null,
  !!state.starter,
);
migrateLegacyHuntState(state);
function normalizeAutomationPrefs(target=state,source=target){
  const src=source&&typeof source==='object'?source:{};
  target.autoCapture=!!(src.autoCapture??target.autoCapture);
  target.autoPotion={...initial.autoPotion,...(target.autoPotion||{}),...(src.autoPotion||{})};
  target.autoRevive={...initial.autoRevive,...(target.autoRevive||{}),...(src.autoRevive||{})};
  // Saves anteriores só tinham uma captura automática. Mantém o comportamento
  // de capturar Shiny até o jogador optar pelo novo controle separado.
  target.autoShiny=Object.prototype.hasOwnProperty.call(src,'autoShiny')?!!src.autoShiny:!!target.autoCapture;
  const ball=src.selectedBall??target.selectedBall;
  target.selectedBall=typeof ball==='string'&&ball?ball:'pokeball';
  const shinyBall=src.selectedShinyBall??target.selectedShinyBall;
  target.selectedShinyBall=typeof shinyBall==='string'&&shinyBall?shinyBall:target.selectedBall;
  const potion=src.selectedPotion??target.selectedPotion;
  target.selectedPotion=typeof potion==='string'&&potion?potion:null;
  const revive=src.selectedRevive??target.selectedRevive;
  target.selectedRevive=typeof revive==='string'&&revive?revive:'revive';
  delete target.vipFilter;
  delete target.vipSpecies;
  const view=src.lastView??target.lastView;
  target.lastView=view==='adventure'?'adventure':'city';
}
normalizeAutomationPrefs(state,persistedState);
if(persistedState.running&&!Object.prototype.hasOwnProperty.call(persistedState,'lastView'))state.lastView='adventure';
function syncAutomationRuntime(){
  selectedBall=state.selectedBall||'pokeball';
  selectedShinyBall=state.selectedShinyBall||selectedBall;
  selectedPotion=state.selectedPotion||null;
}
function applyAutomationUi(){
  const autoCap=$('#autoCapture');
  if(autoCap){
    // Auto-capture é VIP: sem assinatura o controle fica visível, travado e explicado.
    const unlocked=trainerAccountPerks().autoCaptureUnlocked;
    if(!unlocked&&state.autoCapture)state.autoCapture=false;
    autoCap.disabled=!unlocked;
    autoCap.checked=!!state.autoCapture;
    autoCap.closest('.control-title')?.classList.toggle('vip-locked',!unlocked);
    const hint=autoCap.closest('.control-title')?.querySelector('small');
    if(hint)hint.textContent=unlocked?t('auto.captureNormalHint'):t('auto.captureVip');
    $('#captureOptions')?.classList.toggle('enabled',!!state.autoCapture);
    $('#captureCard')?.classList.toggle('is-enabled',!!state.autoCapture);
  }
  const autoPot=$('#autoPotion');
  if(autoPot){
    autoPot.checked=!!state.autoPotion?.enabled;
    $('#potionOptions')?.classList.toggle('enabled',!!state.autoPotion?.enabled);
    $('#potionCard')?.classList.toggle('is-enabled',!!state.autoPotion?.enabled);
  }
  const autoRevive=$('#autoRevive');
  if(autoRevive){
    autoRevive.checked=!!state.autoRevive?.enabled;
    $('#reviveOptions')?.classList.toggle('enabled',!!state.autoRevive?.enabled);
    $('#reviveCard')?.classList.toggle('is-enabled',!!state.autoRevive?.enabled);
  }
  const autoShiny=$('#autoShiny');
  if(autoShiny){
    const unlocked=trainerAccountPerks().autoCaptureUnlocked;
    if(!unlocked&&state.autoShiny)state.autoShiny=false;
    autoShiny.disabled=!unlocked;
    autoShiny.checked=!!state.autoShiny;
    autoShiny.closest('.control-title')?.classList.toggle('vip-locked',!unlocked);
    const hint=autoShiny.closest('.control-title')?.querySelector('small');
    if(hint)hint.textContent=unlocked?t('auto.shinyHint'):t('auto.captureVip');
    $('#shinyCaptureOptions')?.classList.toggle('enabled',!!state.autoShiny);
    $('#shinyCaptureCard')?.classList.toggle('is-enabled',!!state.autoShiny);
  }
}
function canResumeHunt(){
  if(!state.starter||state.offlineHunt)return false;
  if(state.lastView!=='adventure')return false;
  if(state.huntMode==='zone')return !!zoneConfigForBand(state.range);
  if(state.huntMode==='species')return !!state.huntSpecies;
  return state.huntMode==='legacy';
}
function resumeLastHunt(){
  mapPreviewRange=state.range;
  const zone=state.huntMode==='zone';
  travelToRoute(state.type,{
    species:zone?null:state.huntSpecies,
    level:state.huntLevel,
    zone,
  });
}
function normalizeMastery(pokemon){if(!pokemon)return;pokemon.masteryLevel=Math.max(0,Math.min(50,Math.floor(pokemon.masteryLevel||0)));pokemon.masteryXp=Math.max(0,Math.floor(pokemon.masteryXp||0))}
if(state.starter){if(state.starter.starterOrigin==null)state.starter.starterOrigin=true;if(state.starter.starterOrigin)state.starter.locked=true;normalizeMastery(state.starter)}
state.collection.forEach(normalizeMastery);
const trainerAccessLevel=()=>Math.max(state.trainer?.level||1,state.trainer?.peakLevel||1);
const zoneAccessForBand=band=>endgameZoneAccess(band,{trainerLevel:trainerAccessLevel(),mastery:state.starter?.masteryLevel||0,prestige:state.trainer?.prestige||0});
const highestAccessibleRange=()=>Math.max(0,ranges.findLastIndex((_,band)=>trainerAccessLevel()>=(ROUTE_UNLOCK_LEVELS[band]||1)&&zoneAccessForBand(band).unlocked));
const currentZone=()=>state.huntMode==='zone'?zoneConfigForBand(state.range):null;
function encounterRouteKey(){
  const zone=currentZone();
  return zone?.id||route()[0]||'normal';
}
function encounterRouteLevel(){
  return state.huntLevel||ranges[state.range]?.[0]||state.enemy?.level||1;
}
function zoneProgressFor(zoneOrBand){const zone=typeof zoneOrBand==='object'?zoneOrBand:zoneConfigForBand(zoneOrBand);if(!zone)return null;state.zoneProgress=normalizeZoneProgress(state.zoneProgress);return state.zoneProgress[zone.id]}
function formatZoneRotateCountdown(ms){
  const total=Math.max(0,Math.floor(Number(ms)/1000));
  const h=Math.floor(total/3600),m=Math.floor((total%3600)/60),s=total%60;
  if(h>0)return `${h}h ${String(m).padStart(2,'0')}m`;
  return `${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
}
const creditedZoneBossIds=new Set();
function zoneHasLivingSpecial(){
  return (routeSim.wilds||[]).some((wild)=>wild&&(wild.zoneLegendary||wild.zoneMythical)&&!wild.summon);
}
async function spawnZoneHourlySpecial({near=null}={}){
  const zone=currentZone();
  if(!zone?.specialKind||!zone.specialPool?.length)return null;
  if(zoneHasLivingSpecial()||routeSim.wilds.length>=ROUTE_WILD_MAX)return null;
  const species=featuredSpecialSpecies(zone,Date.now());
  if(!species)return null;
  const level=state.huntLevel||ranges[state.range]?.[0]||zone.level;
  let serverEnc=null;
  if(serverGameplayReady()){
    try{
      const rows=await fetchEncounterBatch({
        route:level,
        routeType:zone.id,
        species,
        count:1,
        force:true,
        zoneSpecial:true,
      });
      serverEnc=rows?.[0]||null;
    }catch(error){console.warn('zone special encounter failed',error)}
    if(!serverEnc)return null;
  }
  const special=createWild(species,routeSim.wilds.length,{
    species,
    level,
    forceBoss:true,
    zoneLegendary:zone.specialKind==='legendary',
    zoneMythical:zone.specialKind==='mythical',
    near:near||{x:50,y:50,spread:6},
    serverEncounter:serverEnc,
  });
  if(!special)return null;
  routeSim.wilds.push(special);
  spawnBossSummons(special);
  const progress=zoneProgressFor(zone);
  if(progress)progress.seenSpecials=(progress.seenSpecials||0)+1;
  addLog(t('zone.specialAppearedLog',{name:title(species),zone:t(`zones.${zone.id}.title`)}),t(zone.specialKind==='mythical'?'zone.mythicalBoss':'zone.legendaryBoss'));
  showToast(t('zone.specialAppearedToast',{name:title(species)}));
  return special;
}
function tryRollZoneSpecialOnKill(wild){
  const zone=currentZone();
  if(!zone?.specialKind||wild?.summon||wild?.zoneLegendary||wild?.zoneMythical)return;
  if(zoneHasLivingSpecial())return;
  if(!rollZoneSpecial(zone.specialChancePerKill))return;
  spawnZoneHourlySpecial();
  renderWilds();
}
function noteZoneSpecialResolved(wild){
  const zone=currentZone();
  if(!zone||!(wild?.zoneLegendary||wild?.zoneMythical))return;
  const key=wild?.liveWildId||wild?.id;
  if(key&&creditedZoneBossIds.has(key))return;
  if(key)creditedZoneBossIds.add(key);
  addLog(t('zone.bossDefeated',{name:title(wild.name),zone:t(`zones.${zone.id}.title`)}),title(wild.name));
}
function recordZoneDefeat(wild){
  const zone=currentZone();if(!zone||wild?.summon)return;
  if(wild.zoneLegendary||wild.zoneMythical){noteZoneSpecialResolved(wild);return}
  tryRollZoneSpecialOnKill(wild);
}
const trainerAccountPerks=()=>{
  const base=trainerPerks(trainerAccessLevel(),state.trainer?.prestige||0,state.trainerTalents);
  const ups=upgradePerks(state.upgrades||{});
  const vip=isVip(state,Date.now())?vipPerks():null;
  const now=Date.now();
  const trainerXpBoost=activeBoostMult(state,'trainerXp',now);
  const pokemonXpBoost=activeBoostMult(state,'pokemonXp',now);
  const boostLoot=activeBoostMult(state,'loot',now);
  const boostCap=activeBoostMult(state,'capture',now);
  const shinyBoost=activeBoostMult(state,'shinyLure',now);
  return{
    ...base,
    lootMultiplier:base.lootMultiplier*ups.lootMultiplier*boostLoot*(vip?.lootMultiplier||1),
    captureMultiplier:base.captureMultiplier*ups.captureMultiplier*boostCap,
    xpMultiplier:base.xpMultiplier*trainerXpBoost*(vip?.trainerXpMultiplier||1),
    baseXpMultiplier:base.xpMultiplier,
    trainerXpMultiplier:trainerXpBoost*(vip?.trainerXpMultiplier||1),
    pokemonXpMultiplier:pokemonXpBoost*(vip?.pokemonXpMultiplier||1),
    shinyMultiplier:shinyBoost*(vip?.shinyMultiplier||1),
    offlineCapHours:base.offlineCapHours+ups.offlineCapBonusHours+(vip?.offlineCapBonusHours||0),
    // Reserva só treina com VIP: sem ele o time equipado não recebe nada.
    reserveXpShare:vip?.reserveXpShare||0,
    autoCaptureUnlocked:!!vip?.autoCapture,
    combatIntervalFactor:ups.combatIntervalFactor||1,
    autoRestock:!!(ups.autoRestock||vip?.autoRestock),
    marketFeeRate:vip?.marketFeeRate??0.02,
  };
};
let authoritativeDefeated=null;
const talentDefeats=()=>authoritativeDefeats({
  synced:progressSyncEnabled(),
  serverDefeated:authoritativeDefeated,
  localDefeated:state.stats?.defeated||0,
});
const trainerTalentTotal=()=>trainerTalentPointsFromDefeats(talentDefeats());
const trainerTalentSpent=()=>trainerTalentPointsSpent(state.trainerTalents);
const trainerTalentAvailable=()=>Math.max(0,trainerTalentTotal()-trainerTalentSpent());
function trimTrainerTalentsToBudget(){let excess=trainerTalentSpent()-trainerTalentTotal();if(excess<=0)return;const next={...state.trainerTalents};for(const key of [...TRAINER_TALENT_KEYS].reverse()){const take=Math.min(excess,next[key]||0);next[key]-=take;excess-=take;if(excess<=0)break}state.trainerTalents=normalizeTrainerTalents(next)}
trimTrainerTalentsToBudget();
state.range=Math.max(0,Math.min(highestAccessibleRange(),Number(state.range)||0));migrateLegacyHuntState(state);
let attackStart=Date.now(), selectedBall=state.selectedBall||'pokeball', selectedShinyBall=state.selectedShinyBall||selectedBall, selectedPotion=state.selectedPotion||null, routeStarted=Date.now(), timer, captureHistoryFilter='all', captureLogExpandedKey=null, floatingPanelZ=45, pendingEvolution=null, captureIdSequence=0;
let mapPreviewRange=state.range;
const inventoryChatAssets=new Map();
let teamManagementSelection='starter',teamMoveDraft=[],teamMoveDraftDirty=false;
let floatingPanelPositions={};try{floatingPanelPositions=JSON.parse(localStorage.getItem('idlemon-panel-positions')||'{}')}catch{floatingPanelPositions={}}
const keys=new Set(),cityPlayer={x:47.87,y:47.46,dir:'south',frame:0,stepAt:0},cityFollower={x:47.87,y:48.8,dir:'north',frame:0,stepAt:0};
const cityTrail=[];let cityTrailLast={x:cityPlayer.x,y:cityPlayer.y};
let cityCollision=null,cityPixi=null;
// Enquanto o renderer de tiles não termina de carregar, canMoveCity só tem o
// polígono da cidade — que é MUITO mais permissivo que a colisão real e deixa
// atravessar o Centro Pokémon/loja. Quando o tileset enfim chegava, o jogador
// que tinha andado por dentro de um prédio ficava preso num tile bloqueado
// (só F5 resolvia, porque a posição não é persistida). Segura o passo até a
// colisão definitiva existir.
let cityWorldReady=false;
const cityBoundary=[[1018,1018],[1062,1018],[1060,1046],[1049,1046],[1051,1070],[1009,1070],[1009,1045],[1023,1045]];
const routeSim={player:{x:50,y:84,dir:'north',frame:0,stepAt:0},trainer:{x:50,y:93,dir:'north'},wilds:[],zonePacks:[],target:null,nextTargetAt:0,last:performance.now(),spawnTimer:0,lastMoveAt:performance.now(),chaseBestDist:null,chaseProgressAt:performance.now(),unreachableUntil:new Map(),moveCds:{},playerTurn:0,nextPlayerAttackAt:0,nextEnemyAttackAt:0};
let routeLand=null,routeLandKey=null,routeLandLoadId=0,routePixi=null,routePixiToppers=null;
const routeLandCache=new Map();
const WILD_HP_MULTIPLIER=1;
const WILD_DAMAGE_MULTIPLIER=.5;
// Ritmo da caça. O parceiro corria rápido demais para um idle: a leitura era de
// pressa, não de exploração. Baixamos ~30% e, em compensação, adensamos a
// população de selvagens (ROUTE_WILD_COUNT) para que a distância até a próxima
// presa caia junto — anda mais devagar, mas não espera mais por isso.
const ROUTE_PARTNER_CHASE_SPEED=8.7;
/** Wander in legacy metric units/sec (scaled by route-land for large maps). */
const ROUTE_WILD_WANDER_SPEED=4.7;
const ROUTE_TARGET_ACQUIRE_DELAY_MS=320;
const ROUTE_TRAINER_FOLLOW_DISTANCE=11;
// O treinador precisa ser um pouco mais rápido que o parceiro para não ficar
// para trás; mantivemos a mesma proporção de antes.
const ROUTE_TRAINER_FOLLOW_SPEED=9.5;
const STATS_RENDER_INTERVAL_MS=250;
let lastStatsRenderAt=0;
const routeSpawnGrid=[[14,18],[28,16],[42,14],[56,16],[70,18],[84,20],[12,32],[26,30],[40,28],[54,30],[68,32],[82,34],[16,46],[30,44],[44,42],[58,44],[72,46],[86,48],[14,60],[28,58],[42,56],[56,58],[70,60],[84,62],[18,74],[32,72],[46,70],[60,72],[74,74],[50,82]];
const routeSpawnPoints={
  fogo:[[23,43],[31,67],[51,20],[76,35],[77,62],[54,68],[67,15],[40,50],[62,48],...routeSpawnGrid],
  elétrico:[[22,30],[36,63],[53,25],[73,39],[69,70],[48,76],[40,48],[60,55],...routeSpawnGrid],
  água:[[48,20],[60,35],[72,52],[84,68],[55,78],[40,40],[68,60],...routeSpawnGrid],
  planta:[[14,22],[28,38],[18,62],[38,76],[68,82],[50,40],[72,50],...routeSpawnGrid],
  inseto:[[43,18],[58,34],[45,52],[56,70],[35,82],[22,40],[70,48],...routeSpawnGrid],
  voador:[[20,20],[42,30],[68,22],[75,55],[48,72],...routeSpawnGrid],normal:[[18,28],[35,55],[58,32],[72,68],[48,80],...routeSpawnGrid],
  psíquico:[[18,24],[38,40],[62,22],[76,58],[50,76],...routeSpawnGrid],pedra:[[20,25],[37,55],[58,28],[73,63],[48,80],...routeSpawnGrid],
  terra:[[18,24],[38,42],[62,30],[76,58],[48,78],...routeSpawnGrid],fantasma:[[18,24],[38,30],[60,18],[74,52],[55,76],...routeSpawnGrid],
  dragão:[[20,26],[38,48],[60,25],[75,58],[50,78],...routeSpawnGrid],lutador:[[20,22],[38,42],[62,25],[76,60],[50,78],...routeSpawnGrid],
  veneno:[[20,28],[38,48],[62,25],[75,60],[50,78],...routeSpawnGrid],sombrio:[[18,25],[36,45],[60,24],[75,58],[48,78],...routeSpawnGrid],
  aço:[[18,22],[36,42],[60,24],[74,58],[48,78],...routeSpawnGrid],gelo:[[18,23],[38,42],[62,22],[77,55],[50,78],...routeSpawnGrid],
  fada:[[24,20],[40,38],[65,24],[75,55],[46,76],...routeSpawnGrid]
};
const routePlayerStarts={água:[34,54],planta:[50,86],inseto:[36,86],voador:[50,84],normal:[50,84],psíquico:[50,84],pedra:[50,84],terra:[50,84],fantasma:[50,84],dragão:[50,84],lutador:[50,84],veneno:[50,84],sombrio:[50,84],aço:[50,84],gelo:[50,84],fada:[50,84],fogo:[50,84],elétrico:[50,84]};
/** Overrides por mapa (slug-rN) quando o crop OTBM muda o terreno útil. */
const routeSpawnOverrides={
  'water-r0':[[42,48],[55,40],[68,52],[50,62],[36,58],[60,70],[48,34],...routeSpawnGrid],
  'water-r1':[[40,45],[58,38],[72,50],[48,66],[34,55],[62,72],...routeSpawnGrid],
  'water-r2':[[44,42],[60,48],[70,58],[50,68],[38,52],[66,40],...routeSpawnGrid],
  'water-r3':[[46,44],[58,52],[70,60],[48,70],[36,50],[64,38],...routeSpawnGrid],
  'water-r4':[[40,40],[55,48],[68,55],[48,66],[32,52],[72,42],...routeSpawnGrid],
  'ice-r3':[[48,48],[36,40],[62,42],[50,62],[40,58],[68,55],...routeSpawnGrid],
  'ice-r4':[[50,46],[38,38],[64,44],[52,64],[42,56],[70,52],...routeSpawnGrid],
  'electric-r2':[[48,50],[36,42],[62,40],[54,64],[40,58],[68,55],...routeSpawnGrid],
  'electric-r3':[[50,48],[38,40],[64,42],[52,62],[42,56],[70,50],...routeSpawnGrid],
  'electric-r4':[[48,46],[36,38],[62,44],[50,64],[40,54],[68,52],...routeSpawnGrid],
  'dark-r4':[[48,48],[36,40],[62,42],[50,62],[40,58],[68,55],...routeSpawnGrid],
  'ghost-r3':[[50,50],[38,42],[64,44],[52,64],[42,56],[70,52],...routeSpawnGrid],
  'flying-r4':[[48,46],[36,38],[62,42],[50,62],[40,54],[68,50],...routeSpawnGrid],
  'dragon-r3':[[46,48],[34,40],[60,44],[50,64],[40,56],[68,52],...routeSpawnGrid],
  'rock-r3':[[48,48],[36,40],[62,42],[50,62],[40,58],[68,55],...routeSpawnGrid]
};
const routeStartOverrides={
  'water-r0':[48,58],'water-r1':[46,56],'water-r2':[48,54],'water-r3':[50,56],'water-r4':[48,52],
  'ice-r3':[50,54],'ice-r4':[50,52],'electric-r2':[50,54],'electric-r3':[50,52],'electric-r4':[50,50],
  'dark-r4':[50,52],'ghost-r3':[50,52],'flying-r4':[50,50],'dragon-r3':[48,54],'rock-r3':[50,52],
  'bug-r4':[50,56],'fighting-r2':[50,54],'fighting-r4':[50,52]
};

function hydrateGameState(saved){
  const source=saved&&typeof saved==='object'?saved:{};
  state={...initial,...source};
  state.stats={...initial.stats,...(source.stats||{})};
  state.trainer={...initial.trainer,...(source.trainer||{})};
  state.trainer.level=Math.max(1,Math.min(MAX_TRAINER_LEVEL,state.trainer.level||1));state.trainer.peakLevel=Math.max(state.trainer.level,Math.min(MAX_TRAINER_LEVEL,state.trainer.peakLevel||state.trainer.level));state.trainer.xp=Math.max(0,state.trainer.xp||0);state.trainer.prestige=Math.max(0,Math.min(10,Math.floor(state.trainer.prestige||0)));state.trainer.name=String(state.trainer.name||'').trim().slice(0,16);state.trainer.gender=state.trainer.gender==='m'?'m':'f';state.trainer.colors=normalizeOutfitColors(state.trainer.colors);
  const freeRespecs=Number(source.trainerFreeRespecs);state.trainerTalents=normalizeTrainerTalents(source.trainerTalents);state.trainerFreeRespecs=Number.isFinite(freeRespecs)?Math.max(0,Math.floor(freeRespecs)):1;
  // Inventário: não espalhar kit inicial por cima do blob. Zera e aplica o salvo;
  // se o blob estiver “stripped” (autoridade server), refreshInventory preenche depois.
  {
    const next={};
    for(const slug of Object.keys(initial.inventory||{}))next[slug]=0;
    for(const [slug,qty] of Object.entries(canonicalizeDropOnlyMap(source.inventory)))next[slug]=Math.max(0,Math.floor(Number(qty)||0));
    if(!FISHING_RODS.some(rod=>(next[rod.slug]||0)>0))next['old-rod']=1;
    if(next.superPotion){next['great-potion']=(next['great-potion']||0)+next.superPotion;delete next.superPotion}
    state.inventory=next;
  }
  state.drops=canonicalizeDropOnlyMap(source.drops);state.depositItems=canonicalizeDropOnlyMap(source.depositItems);state.notifications=normalizeNavNotifications(source.notifications);state.autoPotion={...initial.autoPotion,...(source.autoPotion||{})};state.fishing={...initial.fishing,...(source.fishing||{}),active:false};
  state.collection=Array.isArray(source.collection)?source.collection:[];state.captureHistory=(Array.isArray(source.captureHistory)?source.captureHistory:state.collection.map(captureHistorySnapshot)).slice(0,100);state.team=Array.isArray(source.team)?source.team.slice(0,5):[];state.log=Array.isArray(source.log)?source.log:[];
  state.activeHunt=source.activeHunt||null;state.lastHunt=source.lastHunt||null;state.shinyResearch=source.shinyResearch&&typeof source.shinyResearch==='object'?source.shinyResearch:{};state.killCounts=normalizeKillCounts(source.killCounts);state.offlineHunt=source.offlineHunt||null;state.pendingOfflineReport=source.pendingOfflineReport||null;state.marketTransferLog=Array.isArray(source.marketTransferLog)?source.marketTransferLog.slice(-250):[];state.running=false;state.combatBalanceVersion=COMBAT_BALANCE_VERSION;
  state.shinyCards=Math.max(0,Math.floor(Number(source.shinyCards)||0));state.altar=source.altar&&typeof source.altar==='object'?{history:Array.isArray(source.altar.history)?source.altar.history.slice(-50):[]}:{history:[]};state.altarShiny=source.altarShiny||null;
  state.breeding=normalizeBreedingState(source.breeding);state.eggs=Array.isArray(source.eggs)?source.eggs:[];state.zoneProgress=normalizeZoneProgress(source.zoneProgress);
  state.huntMode=['legacy','zone'].includes(source.huntMode)?source.huntMode:'species';state.huntSpecies=source.huntSpecies||null;state.huntLevel=Math.max(1,Number(source.huntLevel)||1);
  state.huntDifficulty=HUNT_DIFFICULTIES.includes(Number(source.huntDifficulty))?Number(source.huntDifficulty):0;
  normalizeAutomationPrefs(state,source);
  if(source.running&&!Object.prototype.hasOwnProperty.call(source,'lastView'))state.lastView='adventure';
  state.emerald=Math.max(0,Math.floor(Number(source.emerald)||0));
  state.badges=Array.isArray(source.badges)?source.badges:[];
  state.gymRematches=source.gymRematches&&typeof source.gymRematches==='object'?source.gymRematches:{};
  state.raid=source.raid||null;state.clan=source.clan||null;state.upgrades=source.upgrades;state.meta=source.meta;state.monetization=source.monetization;state.professions=source.professions;
  normalizeUpgrades(state);normalizeMeta(state);normalizeMonetization(state);normalizeProfessions(state);
  migrateLegacyHuntState(state);
  state.tutorial=migrateTutorialVersion(source.tutorial,!!state.starter);
  if(state.starter){if(state.starter.starterOrigin==null)state.starter.starterOrigin=true;if(state.starter.starterOrigin)state.starter.locked=true;normalizeMastery(state.starter)}state.collection.forEach(normalizeMastery);trimTrainerTalentsToBudget();
  state.range=Math.max(0,Math.min(highestAccessibleRange(),Number(state.range)||0));migrateLegacyHuntState(state);
  syncAutomationRuntime();
}
function normalizeBreedingState(raw){
  const base={pair:[null,null],incubator:[null,null],mode:'pheromones',doubleStones:false};
  if(!raw||typeof raw!=='object')return base;
  // Migração: saves antigos tinham bonuses.{pheromones,cheaper} (checkboxes).
  const legacyMode=raw.bonuses?.cheaper?'free':'pheromones';
  const mode=String(raw.mode||legacyMode).toLowerCase()==='free'?'free':'pheromones';
  return{
    pair:[raw.pair?.[0]??null,raw.pair?.[1]??null],
    incubator:[raw.incubator?.[0]||null,raw.incubator?.[1]||null],
    mode,
    doubleStones:!!raw.doubleStones,
  };
}
function normalizeKillCounts(raw){
  if(!raw||typeof raw!=='object'||Array.isArray(raw))return{};
  const out={};
  for(const[key,value]of Object.entries(raw)){
    const slug=String(key||'').trim();
    const count=Math.max(0,Math.floor(Number(value)||0));
    if(slug&&count>0)out[slug]=count;
  }
  return out;
}
function breedingIvsToGame(ivs){
  const map={HP:'hp',ATK:'atk',DEF:'def',VEL:'spe',ESP:'spa',RES:'spd'};
  const out={hp:15,atk:15,def:15,spa:15,spd:15,spe:15};
  for(const[key,value]of Object.entries(ivs||{})){
    const dest=map[key]||String(key).toLowerCase();
    if(dest in out)out[dest]=Math.max(0,Math.min(31,Math.round(Number(value)||0)));
  }
  return out;
}
function itemCount(slug){return(state.drops[slug]|0)+(state.inventory[slug]|0)}
/** Panic: localStorage idlemon-force-local-gameplay=1 → 100% blob local. */
function forceLocalGameplay(){
  try{return localStorage.getItem('idlemon-force-local-gameplay')==='1'}catch{return false}
}
/** All-or-nothing authority. Signed-in gameplay never falls back to a local
 * economic save if one of its server synchronizers is unavailable. */
function serverGameplayReady(){
  if(forceLocalGameplay())return false;
  return collectionSyncEnabled()
    &&inventorySyncEnabled()
    &&progressSyncEnabled()
    &&encountersSyncEnabled();
}
function canStartAuthoritativeGameplay(){
  // Local visual previews are isolated from real accounts and production data.
  const previewMode = new URLSearchParams(location.search).get('preview');
  if(location.hostname==='localhost'&&previewMode)return true;
  if(activeAccount&&serverGameplayReady())return true;
  if(!activeAccount){
    showToast('Entre na sua conta para caçar com progresso no servidor.');
    return false;
  }
  const pending=[
    !collectionSyncEnabled()&&'coleção',
    !inventorySyncEnabled()&&'inventário',
    !progressSyncEnabled()&&'progresso',
    !encountersSyncEnabled()&&'encontros',
  ].filter(Boolean);
  console.warn('[Hunt] sync ainda incompleto:',pending.join(', ')||'desconhecido');
  showToast(pending.length
    ?`O servidor ainda está sincronizando (${pending.join(', ')}). Tente novamente em instantes.`
    :'O servidor ainda está sincronizando seu progresso. Tente novamente em instantes.');
  return false;
}
function spendItem(slug,qty=1){
  let left=Math.max(0,Math.floor(Number(qty)||0));
  for(const bucket of[state.drops,state.inventory]){
    const take=Math.min(left,bucket[slug]|0);bucket[slug]=(bucket[slug]|0)-take;left-=take;
    if(left<=0)break;
  }
  return left<=0;
}
/** Consome item no servidor quando inventário migrado; senão só local. */
async function consumeGameplayItem(slug,qty=1){
  const amount=Math.max(1,Math.floor(Number(qty)||1));
  if(!inventorySyncEnabled()){
    return spendItem(slug,amount);
  }
  try{
    const response=await consumeInventoryItem(slug,amount,crypto.randomUUID());
    if(response?.inventory)applyServerInventory(response.inventory,{force:true});
    else spendItem(slug,amount);
    return true;
  }catch(error){
    console.warn('consume_inventory_item failed',error);
    return false;
  }
}
function canAffordBreedingStones(stonesByType,multiplier=1){
  for(const[type,qty]of Object.entries(stonesByType||{})){
    const need=Math.max(0,Math.ceil((Number(qty)||0)*multiplier));
    const options=STONES_BY_TYPE[type]||[];
    const available=options.reduce((sum,stone)=>sum+itemCount(stone.slug),0);
    if(available<need)return false;
  }
  return true;
}
function spendBreedingStones(stonesByType,multiplier=1){
  for(const[type,qty]of Object.entries(stonesByType||{})){
    let left=Math.max(0,Math.ceil((Number(qty)||0)*multiplier));
    const options=STONES_BY_TYPE[type]||[];
    if(!options.length)return false;
    for(const stone of options){
      if(left<=0)break;
      const have=itemCount(stone.slug);const take=Math.min(left,have);
      if(take>0){spendItem(stone.slug,take);left-=take}
    }
    if(left>0)return false;
  }
  return true;
}
function breedingStonePayments(stonesByType,multiplier=1){
  const payments=[];
  for(const[type,qty]of Object.entries(stonesByType||{})){
    let left=Math.max(0,Math.ceil((Number(qty)||0)*multiplier));
    for(const stone of(STONES_BY_TYPE[type]||[])){
      if(left<=0)break;
      const have=itemCount(stone.slug);const take=Math.min(left,have);
      if(take>0){payments.push({slug:stone.slug,qty:take});left-=take}
    }
  }
  return payments;
}
function bossSpeciesPayload(name,types){
  const entry=pokedexEntry(name);
  const bst=Number(entry?.bst)||(entry?.baseStats?Object.values(entry.baseStats).reduce((a,b)=>a+Number(b||0),0):0)||420;
  return{bst,types:types||entry?.types||speciesTypes(name)};
}
function shouldRollBossEncounter(level){
  if((Number(level)||0)<200)return false;
  if(state.huntMode==='zone')return false;
  if(routeSim.wilds.some(w=>w.boss))return false;
  if(state.huntMode==='species'&&(state.huntLevel||0)>=200)return Math.random()<0.55;
  return Math.random()<0.14;
}
// A poda vale igual para o espelho local e para a nuvem: o que o servidor é
// dono não precisa — e não cabe — no localStorage. Gravar o state cru com uma
// coleção grande (milhares de Pokémon) estoura a cota de 5 MB da origem, e o
// QuotaExceededError derrubava o boot no meio.
function trimAuthoritativeState(snap){
  // Só esvazia o blob quando TODA a autoridade server está pronta.
  // Em estado híbrido (parcial), manter blob local evita wipe ao relogar.
  if(!serverGameplayReady())return snap;
  if(collectionSyncEnabled()){
    snap.collection=[];
    // Mantém captureHistory no blob para auditoria/recuperação de capturas fantasma.
    snap.team=[...(state.team||[])];
  }
  if(inventorySyncEnabled()){
    // Nunca gravar o kit inicial (24 pokébola…) no blob — senão F5 restaura “brinde”.
    snap.inventory={};
    for(const slug of Object.keys(initial.inventory||{}))snap.inventory[slug]=0;
    snap.drops={};
  }
  if(progressSyncEnabled()){
    // NÃO forçar level/xp = 1 no blob — isso apagava o treinador no F5
    // quando o refresh do player_progress falhava ou atrasava.
    // O servidor continua autoritativo via refreshProgress / report_session;
    // o blob só guarda o último valor conhecido como cache.
    snap.shinyResearch={};
    snap.killCounts={};
  }
  return snap;
}
function cloudSaveSnapshot(){return trimAuthoritativeState(structuredClone(state))}
// Cópia rasa de propósito: save() roda em quase todo handler (addLog inclusive),
// e clonar fundo uma coleção de milhares de Pokémon a cada log custaria caro.
// Os campos podados são substituídos por valores novos, então o state original
// nunca é mutado.
function localSaveSnapshot(){return trimAuthoritativeState({...state})}
async function flushGameSave(){
  clearTimeout(cloudSaveTimer);cloudSaveTimer=null;
  if(!cloudSaveReady||!activeAccount?.session?.user?.id)return null;
  if(cloudSaveInFlight){cloudSaveQueued=true;return cloudSaveInFlight}
  const userId=activeAccount.session.user.id,snapshot=cloudSaveSnapshot();cloudSaveQueued=false;
  cloudSaveInFlight=writeGameSave(userId,snapshot).catch(error=>{console.error('game save sync failed',error);setTimeout(()=>flushGameSave().catch(()=>{}),5000);throw error}).finally(()=>{cloudSaveInFlight=null;if(cloudSaveQueued){cloudSaveQueued=false;queueMicrotask(()=>flushGameSave().catch(()=>{}))}});
  return cloudSaveInFlight;
}
function scheduleGameSave(){if(!cloudSaveReady||!activeAccount)return;clearTimeout(cloudSaveTimer);cloudSaveTimer=setTimeout(()=>flushGameSave().catch(()=>{}),350)}
// save() é chamado no meio de dezenas de handlers (healTeam, changeRoute, o
// boot inteiro) sempre como efeito colateral, nunca como a ação principal.
// Quando o localStorage estoura a cota ou está bloqueado, o throw abortava o
// resto do handler — a cura acontecia mas o diálogo não fechava, e no boot o
// setup() morria antes de ligar o rAF e o renderer da cidade. O espelho local
// é cache: falhar nele nunca pode derrubar quem chamou.
function save(){
  try{
    localStorage.setItem('myst-idle',JSON.stringify(localSaveSnapshot()));
    localStorage.setItem('myst-idle-updated-at',new Date().toISOString());
  }catch(error){
    console.warn('local save failed',error);
    // Estado híbrido com coleção grande: o blob completo não cabe. Grava ao
    // menos o essencial para o F5 não perder treinador, hunt e tutorial.
    try{
      const{collection,captureHistory,log,marketTransferLog,...essential}=state;
      localStorage.setItem('myst-idle',JSON.stringify({...essential,collection:[],captureHistory:[],log:[]}));
      localStorage.setItem('myst-idle-updated-at',new Date().toISOString());
    }catch(fallbackError){console.warn('local save fallback failed',fallbackError)}
  }
  try{scheduleGameSave()}catch(error){console.warn('cloud save schedule failed',error)}
}
async function initCloudGameSave(){
  const userId=activeAccount?.session?.user?.id;if(!userId)return;
  const remote=await loadGameSave(userId),localUpdatedAt=Date.parse(localStorage.getItem('myst-idle-updated-at')||''),remoteUpdatedAt=Date.parse(remote?.updated_at||''),localBelongsToUser=!state.accountUserId||state.accountUserId===userId;
  if(remote?.state&&localBelongsToUser&&Number.isFinite(localUpdatedAt)&&localUpdatedAt>remoteUpdatedAt){state.accountUserId=userId;const uploaded=await writeGameSave(userId,cloudSaveSnapshot());localStorage.setItem('myst-idle-updated-at',uploaded.updated_at)}
  else if(remote?.state){hydrateGameState(remote.state);localStorage.setItem('myst-idle-updated-at',remote.updated_at)}
  else{
    if(state.accountUserId!==userId)hydrateGameState({});
    state.accountUserId=userId;const uploaded=await writeGameSave(userId,cloudSaveSnapshot());localStorage.setItem('myst-idle-updated-at',uploaded.updated_at);
  }
  // Espelho local pelo mesmo caminho tolerante do save(): um throw de cota aqui
  // subia para o catch do chamador, que desligava cloudSaveReady e matava o
  // save na nuvem por causa de uma falha que é só do cache do navegador.
  cloudSaveReady=true;state.accountUserId=userId;mapPreviewRange=state.range;
  try{localStorage.setItem('myst-idle',JSON.stringify(localSaveSnapshot()))}catch(error){console.warn('local mirror after cloud load failed',error)}
}
function applyIdlecoinDelta(delta,source){
  const before=Math.max(0,Math.trunc(Number(state.stats.coins)||0));
  const after=Math.max(0,before+Math.trunc(Number(delta)||0));
  const applied=after-before;
  state.stats.coins=after;
  if(applied)recordIdlecoinDelta(applied,source);
  return after;
}
function marketLocalItems(){
  return Object.values(ITEM_BY_SLUG).filter(item=>item.tradeable!==false&&!['masterball','apexball'].includes(item.slug)).map(item=>({
    slug:item.slug,name:displayItem(item.slug),img:item.img,
    qty:(state.inventory[item.slug]||0)+(state.drops[item.slug]||0),
  })).filter(item=>item.qty>0);
}
function marketLocalPokemon(){
  const equipped=new Set(state.team.map(String));
  return state.collection.filter(pokemon=>!pokemon.locked&&!equipped.has(String(pokemon.id))).map(pokemon=>({...pokemon}));
}
function marketPokemonPayload(pokemon){
  const serverId=pokemon.serverId||pokemon.id;
  // Phase 1+: depósito referencia player_pokemon no servidor (sem mint de payload).
  if(collectionSyncEnabled()&&serverId){
    return{player_pokemon_id:serverId,id:serverId};
  }
  const aliases={hp:['hp','HP'],atk:['atk','ATK'],def:['def','DEF'],spa:['spa','ESP'],spd:['spd','RES'],spe:['spe','VEL']};
  const ivs=Object.fromEntries(Object.entries(aliases).map(([key,names])=>[key,Number(pokemon.ivs?.[names.find(name=>pokemon.ivs?.[name]!=null)])||0]));
  const ball=Object.values(ITEM_BY_SLUG).find(item=>item.slug===pokemon.ball||item.name===pokemon.ball)?.slug||'pokeball';
  return{
    market_asset_id:pokemon.marketAssetId||pokemon.market_asset_id||undefined,
    species:pokemon.name,level:pokemon.level,ivs,rarity:pokemon.rarity||'Comum',
    mult:Number(pokemon.mult)||1,shiny:!!pokemon.shiny,ball,
    moves:[...(pokemon.equippedMoves||[])],
    captured_at:new Date(Number(pokemon.capturedAt)||pokemon.captured_at||Date.now()).toISOString(),
  };
}
function normalizeCollectionPokemon(pokemon){
  if(!pokemon||typeof pokemon!=='object')return null;
  const name=pokemon.name||pokemon.species;
  if(!name)return null;
  return pokemon.name?pokemon:{...pokemon,name:String(name)};
}
function pokemonIdentityKey(pokemon){
  if(!pokemon)return '';
  if(pokemon.fingerprint)return`fp:${pokemon.fingerprint}`;
  const ivs=pokemon.ivs||{};
  const read=(...keys)=>{
    for(const key of keys){
      if(ivs[key]!=null&&ivs[key]!=='')return Number(ivs[key])||0;
    }
    return 0;
  };
  const vals=[
    read('hp','HP'),
    read('atk','ATK'),
    read('def','DEF'),
    read('spa','ESP'),
    read('spd','RES'),
    read('spe','VEL'),
  ].join('.');
  return`id:${String(pokemon.name||pokemon.species||'').toLowerCase()}|${Number(pokemon.ivScore)||0}|${Number(pokemon.capturedAt)||0}|${vals}|${pokemon.shiny?1:0}`;
}
function remapTeamIds(prevTeam,prevCollection,nextCollection){
  const nextById=new Map();
  const nextByServer=new Map();
  const nextByIdentity=new Map();
  for(const pokemon of nextCollection||[]){
    const id=String(pokemon.id||'');
    if(id)nextById.set(id,pokemon);
    if(pokemon.serverId)nextByServer.set(String(pokemon.serverId),pokemon);
    const key=pokemonIdentityKey(pokemon);
    if(key&&!nextByIdentity.has(key))nextByIdentity.set(key,pokemon);
  }
  const prevById=new Map((prevCollection||[]).map(pokemon=>[String(pokemon.id),pokemon]));
  const remapped=[];
  const seen=new Set();
  for(const rawId of prevTeam||[]){
    const id=String(rawId||'');
    if(!id)continue;
    let match=nextById.get(id)||nextByServer.get(id)||null;
    if(!match){
      const prev=prevById.get(id);
      if(prev){
        if(prev.serverId)match=nextByServer.get(String(prev.serverId))||null;
        if(!match)match=nextByIdentity.get(pokemonIdentityKey(prev))||null;
      }
    }
    if(!match)continue;
    const nextId=String(match.id);
    if(seen.has(nextId))continue;
    seen.add(nextId);
    remapped.push(match.id);
  }
  return remapped.slice(0,5);
}
function syncTeamRosterToServer(){
  if(!collectionSyncEnabled())return Promise.resolve(null);
  const reserveIds=(state.team||[])
    .map(id=>{
      const pokemon=state.collection.find(p=>String(p.id)===String(id));
      return pokemon?.serverId||pokemon?.id||id;
    })
    .map(id=>String(id||''))
    .filter(Boolean)
    .slice(0,5);
  return setTeamRoster(reserveIds,crypto.randomUUID()).then(response=>{
    if(Array.isArray(response?.pokemon))applyServerCollection(response.pokemon,{force:true,skipRosterSync:true});
    return response;
  }).catch(error=>{
    console.warn('set_team_roster failed',error);
    throw error;
  });
}
function applyServerCollection(list,{force=false,skipRosterSync=false}={}){
  // Fora do all-or-nothing, não substitui coleção local por refresh server
  // (migração inicial usa force:true).
  if(!force&&!serverGameplayReady())return;
  const mapped=(Array.isArray(list)?list:[]).map(normalizeCollectionPokemon).filter(Boolean);
  // Guarda anti-perda: servidor vazio + local com dados = resposta suspeita.
  if(!mapped.length&&(state.collection?.length||0)>0)return;

  const prevCollection=[...(state.collection||[])];
  const prevTeam=[...(state.team||[])];

  // Parceiro ativo (is_active) vira starter; remove da box para não duplicar no F5.
  const activeRow=mapped.find(p=>p.isActive||p.is_active);
  if(activeRow){
    const prevHp=state.starter?.currentHp;
    state.starter={
      ...(state.starter||{}),
      ...activeRow,
      name:activeRow.name||activeRow.species||state.starter?.name,
      id:state.starter?.id||null,
      serverId:activeRow.serverId||activeRow.id,
      currentHp:prevHp!=null?prevHp:activeRow.currentHp,
      // origin do servidor manda — não herdar starterOrigin do parceiro anterior.
      starterOrigin:activeRow.origin==='starter'||activeRow.starterOrigin===true,
      locked:!!(activeRow.locked||activeRow.origin==='starter'),
      isActive:true,
    };
    ensureStarterCombat();
  }

  const starterIds=new Set();
  if(state.starter?.serverId)starterIds.add(String(state.starter.serverId));
  if(state.starter?.id)starterIds.add(String(state.starter.id));
  const filtered=mapped.filter(p=>{
    const id=String(p.id||'');
    const sid=String(p.serverId||'');
    if(p.isActive||p.is_active)return false;
    if(starterIds.has(id)||(sid&&starterIds.has(sid)))return false;
    return true;
  });
  state.collection=filtered;

  const slotted=filtered
    .filter(p=>Number.isFinite(Number(p.teamSlot))&&Number(p.teamSlot)>=1)
    .sort((a,b)=>Number(a.teamSlot)-Number(b.teamSlot));
  if(slotted.length){
    state.team=slotted.map(p=>p.id).slice(0,5);
  }else{
    state.team=remapTeamIds(prevTeam,prevCollection,filtered);
  }

  save();
  renderCollection();renderCaptureLog();renderPartnerHud();renderPokedex();

  // Espelha o roster local no servidor na primeira sincronização pós-F5
  // (antes de team_slot existir / quando o blob ainda tem a ordem).
  if(!skipRosterSync&&collectionSyncEnabled()&&state.team.length&&!slotted.length){
    void syncTeamRosterToServer().catch(()=>{});
  }
}
function applyServerInventory(inventory,{force=false}={}){
  if(!inventory||typeof inventory!=='object')return;
  if(!force&&!serverGameplayReady())return;
  // Guarda anti-perda: servidor vazio + local com itens = resposta suspeita
  // (migração parcial / RPC degradado). Preserva o local em vez de zerar.
  const serverHasItems=Object.values(inventory).some(qty=>Number(qty)>0);
  const localCount=Object.values(state.inventory||{}).reduce((sum,qty)=>sum+(Number(qty)||0),0)
    +Object.values(state.drops||{}).reduce((sum,qty)=>sum+(Number(qty)||0),0);
  if(!serverHasItems&&localCount>0)return;
  // Zera a partir de 0 — NÃO espalhar initial.inventory (kit 24/8), senão
  // qualquer slug ausente no JSON do servidor “volta” no F5.
  const nextInv={};
  for(const slug of Object.keys(initial.inventory||{}))nextInv[slug]=0;
  const nextDrops={};
  for(const [slug,qty] of Object.entries(canonicalizeDropOnlyMap(inventory))){
    const amount=Math.max(0,Math.floor(Number(qty)||0));
    if(isDropBucketSlug(slug))nextDrops[slug]=amount;
    else nextInv[slug]=amount;
  }
  if(!FISHING_RODS.some(rod=>(nextInv[rod.slug]||0)>0))nextInv['old-rod']=1;
  state.inventory=nextInv;
  state.drops=nextDrops;
  if(inventorySyncEnabled())state.shinyCards=0;
  // Espelho local de depósito gera dupe com player_inventory — limpa.
  if(inventorySyncEnabled()&&state.depositItems&&Object.keys(state.depositItems).length){
    state.depositItems={};
  }
  save();
  renderInventory();renderDropBag();renderBallSelect();renderPlayerInventory();
}
function applyServerPremiumBoosts(boosts){
  if(!boosts||typeof boosts!=='object')return;
  normalizeMonetization(state);
  state.monetization.boosts.pending=Array.isArray(boosts.pending)?boosts.pending.map(row=>({
    id:String(row.id||''),
    key:String(row.boost_key||row.key||''),
    hours:Math.max(1,Number(row.duration_hours||row.hours)||1),
    purchasedAt:Date.parse(row.purchased_at||'')||Number(row.purchasedAt)||Date.now(),
  })).filter(row=>row.id&&row.key):[];
  state.monetization.boosts.active={};
  for(const row of Array.isArray(boosts.active)?boosts.active:[]){
    const key=String(row.boost_key||row.key||'');
    const expiresAt=Date.parse(row.expires_at||'')||Number(row.expiresAt)||0;
    if(key&&expiresAt>Date.now()&&BOOST_DEFS[key])state.monetization.boosts.active[key]={expiresAt,mult:BOOST_DEFS[key].mult};
  }
  save();
}
let progressRecheckTimer=null;
/** Empurra a fila para o servidor e só então reconsulta o progresso. */
function scheduleProgressRecheck(){
  clearTimeout(progressRecheckTimer);
  progressRecheckTimer=setTimeout(async()=>{
    try{
      await flushSessionSync();
      await refreshProgress();
    }catch(error){
      // Falhou o flush: o local segue à frente, que é o lado seguro.
      console.warn('progress recheck failed',error);
    }
  },3000);
}
/** Progresso comparável: nível pesa mais que o resto do XP da barra. */
function trainerProgressRank(level,xp){
  return Math.max(1,Number(level)||1)*1e9+Math.max(0,Number(xp)||0);
}
function applyServerProgress(progress){
  if(!progress||typeof progress!=='object')return;
  const serverDefeated=Number(progress.defeated);
  if(Number.isFinite(serverDefeated)){
    authoritativeDefeated=authoritativeDefeats({synced:true,serverDefeated,localDefeated:state.stats?.defeated||0});
  }
  if(progress.trainer_talents&&typeof progress.trainer_talents==='object'){
    state.trainerTalents=normalizeTrainerTalents(progress.trainer_talents);
  }
  if(progress.free_respecs!=null){
    state.trainerFreeRespecs=Math.max(0,Math.floor(Number(progress.free_respecs)||0));
  }
  // Guarda anti-regressão, irmã da que applyServerInventory já tem: com abates
  // na fila o local está legitimamente à frente, e aceitar o número menor do
  // servidor rebaixava o nível do treinador na cara do jogador (o "+-39 EXP"
  // do beta). Mantém o local e reconsulta depois que o flush creditar.
  const serverRank=trainerProgressRank(progress.trainer_level,progress.trainer_xp);
  const localRank=trainerProgressRank(state.trainer?.level,state.trainer?.xp);
  if(serverRank<localRank&&pendingKillCount()>0){
    scheduleProgressRecheck();
    save();
    renderSpecialization();
    return;
  }
  state.trainer.level=Math.max(1,Math.min(MAX_TRAINER_LEVEL,Number(progress.trainer_level)||state.trainer.level||1));
  state.trainer.peakLevel=Math.max(state.trainer.level,Math.min(MAX_TRAINER_LEVEL,Number(progress.trainer_peak_level)||state.trainer.peakLevel||state.trainer.level));
  state.trainer.xp=Math.max(0,Number(progress.trainer_xp)||0);
  state.trainer.prestige=Math.max(0,Math.min(10,Math.floor(Number(progress.prestige)||0)));
  if(Number.isFinite(serverDefeated))state.stats.defeated=Math.max(0,Math.floor(serverDefeated));
  const serverCaptured=Number(progress.captured);
  if(Number.isFinite(serverCaptured))state.stats.captured=Math.max(0,Math.floor(serverCaptured));
  if(progress.shiny_research&&typeof progress.shiny_research==='object')state.shinyResearch={...progress.shiny_research};
  if(progress.kill_counts&&typeof progress.kill_counts==='object')state.killCounts={...progress.kill_counts};
  save();
  renderStats();renderTrainerHud();renderSpecialization();
}
function applyServerPokemonUpdates(rows){
  if(!Array.isArray(rows)||!rows.length)return;
  let changed=false;
  for(const row of rows){
    const mapped=serverPokemonToLocal(row,{
      rarityColor:name=>rarityInfo({rarity:name}).color,
      statsFor:(name,type,level,ivs,mult)=>statsFor(name,type,level,ivs,mult),
    });
    if(!mapped)continue;
    const id=String(mapped.id);
    if(state.starter&&(String(state.starter.serverId||state.starter.id)===id)){
      state.starter={
        ...state.starter,
        ...mapped,
        id:state.starter.id||mapped.id,
        serverId:mapped.serverId||mapped.id,
        currentHp:state.starter.currentHp,
        starterOrigin:state.starter.starterOrigin,
        locked:!!state.starter.locked||!!mapped.locked,
      };
      ensureStarterCombat();
      changed=true;
      continue;
    }
    const index=state.collection.findIndex(p=>String(p.id)===id||String(p.serverId||'')===id);
    if(index>=0){
      const prev=state.collection[index];
      state.collection[index]={...prev,...mapped,id:prev.id,serverId:mapped.serverId||mapped.id,hp:prev.hp};
      changed=true;
    }
  }
  if(changed){
    save();
    renderPartnerHud();renderCollection();renderRouteReserves();
  }
}

let pokemonXpQueue=new Map();
let pokemonXpFlushTimer=null;
// A fila vivia só em memória com debounce de 2,5s: um F5 dentro da janela
// perdia o XP de Pokémon de verdade (relato do beta). Agora persiste como o
// killQueue do progress-sync e é restaurada no boot.
const POKEMON_XP_QUEUE_KEY=()=>`idlemon-pokemon-xp-queue:v1:${state.accountUserId||'local'}`;
function persistPokemonXpQueue(){
  try{
    if(!pokemonXpQueue.size){localStorage.removeItem(POKEMON_XP_QUEUE_KEY());return}
    localStorage.setItem(POKEMON_XP_QUEUE_KEY(),JSON.stringify([...pokemonXpQueue.entries()]));
  }catch{/* storage cheio/indisponível: a fila em memória ainda vale */}
}
function restorePokemonXpQueue(){
  try{
    const saved=JSON.parse(localStorage.getItem(POKEMON_XP_QUEUE_KEY())||'[]');
    if(!Array.isArray(saved))return;
    for(const entry of saved){
      const id=String(entry?.[0]||'');
      const xp=Math.max(0,Math.floor(Number(entry?.[1])||0));
      if(id&&xp)pokemonXpQueue.set(id,(pokemonXpQueue.get(id)||0)+xp);
    }
  }catch{/* json corrompido: começa vazio */}
}
function queuePokemonXpGrant(pokemonId,xp){
  const id=String(pokemonId||'');
  const amount=Math.max(0,Math.floor(Number(xp)||0));
  if(!id||!amount||!collectionSyncEnabled())return;
  pokemonXpQueue.set(id,(pokemonXpQueue.get(id)||0)+amount);
  persistPokemonXpQueue();
  clearTimeout(pokemonXpFlushTimer);
  pokemonXpFlushTimer=setTimeout(()=>flushPokemonXpGrants().catch(()=>{}),2500);
}
async function flushPokemonXpGrants(){
  if(!pokemonXpQueue.size||!collectionSyncEnabled())return;
  const grants=[...pokemonXpQueue.entries()].map(([id,xp])=>({id,xp}));
  pokemonXpQueue=new Map();
  persistPokemonXpQueue();
  try{
    const response=await grantPokemonXp(grants,crypto.randomUUID());
    if(Array.isArray(response?.pokemon))applyServerPokemonUpdates(response.pokemon);
  }catch(error){
    console.warn('grant_pokemon_xp failed',error);
    for(const g of grants)pokemonXpQueue.set(g.id,(pokemonXpQueue.get(g.id)||0)+g.xp);
    persistPokemonXpQueue();
  }
}
function applyMarketTransfer(transferId,transfer){
  if(state.marketTransferLog.includes(transferId))return;
  if(transfer.direction==='out'&&transfer.kind==='item'){
    let left=Math.max(1,Math.trunc(Number(transfer.qty)||0));
    if((state.inventory[transfer.slug]||0)+(state.drops[transfer.slug]||0)<left)throw new Error('local_item_balance_changed');
    for(const bucket of [state.inventory,state.drops]){const take=Math.min(left,bucket[transfer.slug]||0);bucket[transfer.slug]=(bucket[transfer.slug]||0)-take;left-=take}
  }else if(transfer.direction==='out'&&transfer.kind==='pokemon'){
    const index=state.collection.findIndex(pokemon=>String(pokemon.id)===String(transfer.localId));
    if(index<0)throw new Error('local_pokemon_not_found');
    state.collection.splice(index,1);state.team=state.team.filter(id=>String(id)!==String(transfer.localId));
  }else if(transfer.direction==='in'&&transfer.kind==='item'){
    const bucket=['loot','stone'].includes(ITEM_BY_SLUG[transfer.slug]?.kind)?state.drops:state.inventory;
    const received=Math.max(1,Math.trunc(Number(transfer.qty)||0));bucket[transfer.slug]=(bucket[transfer.slug]||0)+received;addNavNotification('inventory',received,transfer.slug);
  }else if(transfer.direction==='in'&&transfer.kind==='pokemon'){
    const marketAssetId=transfer.market_asset_id;
    const serverId=transfer.player_pokemon_id||marketAssetId;
    if(!state.collection.some(pokemon=>String(pokemon.serverId||pokemon.marketAssetId||pokemon.id)===String(serverId))){
      const ivMap={hp:'HP',atk:'ATK',def:'DEF',spa:'ESP',spd:'RES',spe:'VEL'},ivs=Object.fromEntries(Object.entries(transfer.ivs||{}).map(([key,value])=>[ivMap[key]||key,value]));
      const r=rarityInfo({rarity:transfer.rarity,mult:transfer.mult}),score=Math.max(0,Math.min(186,Number(transfer.iv_total)||0)),name=transfer.species,level=normalizePokemonLevel(transfer.level);
      const pokemon={id:serverId||marketAssetId,serverId:serverId||undefined,marketAssetId,name,level,xp:0,capturedAt:new Date(transfer.captured_at).getTime(),ball:transfer.ball||displayItem(transfer.ball_slug),rarity:transfer.rarity,mult:Number(transfer.mult)||1,color:r.color,ivs,ivScore:score,ivTotal:Math.round(score/186*100),shiny:!!transfer.shiny,types:transfer.types||speciesTypes(name),equippedMoves:transfer.moves||[],autoMoves:true,moveCursor:0,captureProtectionVersion:1};
      pokemon.stats=statsFor(name,pokemon.types[0],level,ivs,pokemon.mult);pokemon.locked=shouldProtectCapture(pokemon);state.collection.unshift(pokemon);
    }
  }
  state.marketTransferLog.push(transferId);state.marketTransferLog=state.marketTransferLog.slice(-250);save();
  renderStats();renderInventory();renderDropBag();renderPlayerInventory();renderCollection();renderCaptureLog();renderPokedex();renderPokedexDetail();
}
function marketPreviewData(){
  const greatball=ITEM_BY_SLUG.greatball,pokemon={custody_id:'preview-pokemon',species:'bulbasaur',name:'Bulbasaur',level:20,ivs:{hp:31,atk:25,def:20,spa:30,spd:18,spe:22},iv_total:146,rarity:'Raro',mult:1.2,shiny:true,ball:'greatball',moves:['tackle'],power:214,types:['planta','veneno']},now=new Date().toISOString(),itemAsset={kind:'item',name:displayItem('greatball'),slug:'greatball',img:greatball.img};
  return{
    results:[
      {kind:'item_group',slug:'greatball',name:displayItem('greatball'),img:greatball.img,catalog_kind:'ball',currency:'idlecoin',qty_left:1949,seller_count:105,min_unit_price:100,max_unit_price:145,newest_at:now,listing_ids:['preview-item']},
      {id:'preview-pokemon-listing',seller_id:'preview-seller',seller_name:'SilverOak',kind:'pokemon',qty_total:1,qty_left:1,unit_price:500,currency:'idlecoin',allow_offers:true,has_pending_offers:true,created_at:now,asset:pokemon},
    ],
    snapshot:{
      wallet:{idlecoin:125400,emerald:18},
      custody_items:[{id:'preview-custody-item',slug:'greatball',qty:8,state:'free',name:displayItem('greatball'),img:greatball.img,catalog_kind:'ball'}],
      custody_pokemon:[{id:'preview-custody-pokemon',...pokemon,state:'free',captured_at:new Date(Date.now()-86400000).toISOString()}],
      my_listings:[{id:'preview-mine',kind:'item',qty_total:20,qty_left:12,unit_price:110,currency:'idlecoin',allow_offers:true,has_pending_offers:true,status:'active',created_at:now,asset:{custody_id:'preview-mine-item',slug:'greatball',name:displayItem('greatball'),img:greatball.img,catalog_kind:'ball'}}],
      deliveries:[{id:'preview-delivery',asset_kind:'item',payload:{kind:'item',slug:'greatball',qty:3},created_at:now}],
      counts:{listings:1,deliveries:1},
    },
    social:{
      offers_received:[{id:'preview-offer-received',direction:'received',buyer_id:'preview-buyer',buyer_name:'MistyWave',qty:4,idlecoin:560,emerald:0,offered_pokemon:[],status:'pending',created_at:now,expires_at:new Date(Date.now()+604800000).toISOString(),asset:itemAsset}],
      offers_sent:[{id:'preview-offer-sent',direction:'sent',seller_id:'preview-seller',seller_name:'SilverOak',qty:1,idlecoin:420,emerald:2,offered_pokemon:['preview-custody-pokemon'],status:'pending',created_at:now,expires_at:new Date(Date.now()+604800000).toISOString(),asset:{kind:'pokemon',name:'Bulbasaur',species:'bulbasaur'}}],
      my_requests:[{id:'preview-my-request',kind:'item',slug:'greatball',name:displayItem('greatball'),img:greatball.img,filters:{},qty_total:10,qty_left:10,unit_price:95,currency:'idlecoin',status:'active',created_at:now}],
      history:[{id:'preview-trade',role:'buyer',counterparty:'SilverOak',kind:'item',qty:5,unit_price:100,currency:'idlecoin',paid_idlecoin:500,paid_emerald:0,asset_name:displayItem('greatball'),created_at:now}],
      medians:[{slug:'greatball',name:displayItem('greatball'),currency:'idlecoin',median_unit_price:102,trades:31}],
      ignored:[{user_id:'preview-ignored',trainer_name:'TeamRocket',created_at:now}],
      counts:{offers_received:1,offers_sent:1,requests:1,ignored:1},
    },
    requests:{items:[{id:'preview-open-request',buyer_id:'preview-buyer',buyer_name:'BrockStone',kind:'item',slug:'greatball',name:displayItem('greatball'),img:greatball.img,filters:{},qty_total:6,qty_left:6,unit_price:108,currency:'idlecoin',created_at:now}],total:1,page:1,pages:1,page_size:12},
  };
}
function chatPreviewData(){
  const now=Date.now(),greatball=ITEM_BY_SLUG.greatball;
  return{
    world:[{id:'preview-chat-1',channel:'world',sender_id:'preview-other',sender_name:'MistyWave',sender_vip:true,body:t('chat.previewWelcome'),created_at:new Date(now-45000).toISOString(),attachments:[]}],
    trade:[{id:'preview-chat-2',channel:'trade',sender_id:'preview-other',sender_name:'SilverOak',body:t('chat.previewTrade'),created_at:new Date(now-20000).toISOString(),attachments:[{kind:'pokemon',slug:'bulbasaur',name:'Bulbasaur',level:20,ivs:{hp:31,atk:25,def:20,spa:30,spd:18,spe:22},iv_total:146,rarity:'Raro',mult:1.2,shiny:true,ball:'greatball',moves:['tackle'],power:214,types:['planta','veneno'],equipped:true,verified:false}]}],
    help:[{id:'preview-chat-3',channel:'help',sender_id:'preview-other',sender_name:'GuideOak',body:t('chat.previewHelp'),created_at:new Date(now-12000).toISOString(),attachments:[{kind:'item',slug:'greatball',name:displayItem('greatball'),img:greatball.img,catalog_kind:'ball',qty:8,verified:false}]}],
  };
}
function route(){return types[state.type]}
function routeMapKey(){return`${routeSlugs[route()[0]]}-r${activeHuntArtTier()}`}
/** Chave do PNG/JSON alinhados ao art tier (não ao band cru). */
function activeHuntDefeats(){
  const hunt=state.activeHunt;
  if(!hunt)return 0;
  return Math.max(0,(state.stats?.defeated||0)-(hunt.defeated||0));
}
function activeHuntStage(){
  const hunt=state.activeHunt;
  if(!hunt||hunt.huntMode!=='species'||!hunt.huntSpecies)return null;
  const computed=huntMapStageFor(hunt.huntSpecies,activeHuntDefeats());
  const saved=Number.isFinite(Number(hunt.mapStage))?Math.max(0,Math.floor(Number(hunt.mapStage))):0;
  return computed==null?saved:Math.max(saved,computed);
}
function activeHuntArtTier(){
  const hunt=state.activeHunt,stage=activeHuntStage();
  if(hunt&&stage!=null){
    const config=huntMapStageConfigFor(hunt.huntSpecies,stage);
    if(config)return config.tier;
  }
  return routeArtTier(state.range);
}
function routeLandMapKey(){return`${routeSlugs[route()[0]]}-r${activeHuntArtTier()}`}
/**
 * Faixa de borda proibida, em % do mapa.
 *
 * Ninguém (jogador, parceiro, treinador ou selvagem) entra nela. Serve para o
 * jogador nunca encostar no limite do mapa: a câmera para de acompanhar ao
 * chegar na borda do mundo, e sem essa folga o sprite ficava colado no canto da
 * tela, com a sensação de estar batendo numa parede invisível.
 */
const ROUTE_EDGE_MARGIN=10;
function spawnPointsForRoute(){const key=routeMapKey();return routeSpawnOverrides[key]||routeSpawnPoints[route()[0]]||routeSpawnPoints.elétrico}
function rawPlayerStartForRoute(){const key=routeMapKey();return routeStartOverrides[key]||routePlayerStarts[route()[0]]||[50,84]}
function playerStartForRoute(){const start=rawPlayerStartForRoute();return constrainRouteLand(start[0],start[1],ROUTE_EDGE_MARGIN)}
function clampRoutePos(x,y,margin=6){
  return[
    Math.max(margin,Math.min(100-margin,Number(x)||50)),
    Math.max(margin,Math.min(100-margin,Number(y)||50))
  ];
}
function constrainRouteLand(x,y,margin=8){
  return constrainToLand(x,y,routeLand,margin);
}
async function ensureRouteLand(mapKey=routeLandMapKey()){
  if(routeLandKey===mapKey&&routeLand)return routeLand;
  if(routeLandCache.has(mapKey)){
    routeLand=routeLandCache.get(mapKey);
    routeLandKey=mapKey;
    return routeLand;
  }
  try{
    const index=buildRouteLandIndex(await loadRouteMapDoc(mapKey));
    routeLandCache.set(mapKey,index);
    routeLand=index;
    routeLandKey=mapKey;
    return index;
  }catch{
    routeLand=null;
    routeLandKey=mapKey;
    return null;
  }
}
function partnerName(){return state.starter?.name||'bulbasaur'}
function clearPartnerHud(){
  const name=$('#partnerHudName'),level=$('#partnerHudLevel'),hpText=$('#partnerHpText'),hpBar=$('#partnerHpBar'),expBar=$('#partnerExpBar'),typeEl=$('#partnerHudType'),sprite=$('#partnerHudSprite'),count=$('#myPokemonCount'),teamCount=$('#routeTeamCount');
  const row=sprite?.closest('.team-pokemon-row');
  if(name)name.textContent='—';
  if(level)level.textContent='—';
  if(hpText)hpText.textContent=t('team.noPartner');
  if(hpBar){hpBar.style.width='0%';setHpState(hpBar.parentElement,0)}
  if(expBar)expBar.style.width='0%';
  if(typeEl){typeEl.textContent='';typeEl.removeAttribute('style')}
  if(sprite){sprite.removeAttribute('src');delete sprite.dataset.sprite}
  if(row){row.classList.remove('active');row.removeAttribute('data-active-label')}
  const slots=`${state.team.length}/6`;
  if(count)count.textContent=slots;
  if(teamCount)teamCount.textContent=slots;
  $('#starterEvolveButton')?.classList.add('hidden');
  const reserve=$('#routeReserveList');if(reserve)reserve.innerHTML='';
}
function recoverStarterFromCollection(){
  if(state.starter?.name)return state.starter;
  const pool=state.collection||[];
  const candidate=pool.find(p=>p.isActive||p.is_active)
    ||pool.find(p=>p.origin==='starter'||p.starterOrigin)
    ||pool[0]
    ||null;
  if(!candidate?.name)return null;
  const id=candidate.id;
  state.starter={
    ...candidate,
    id:null,
    serverId:candidate.serverId||candidate.id,
    isActive:true,
    starterOrigin:candidate.origin==='starter'||candidate.starterOrigin===true,
    locked:!!(candidate.locked||candidate.origin==='starter'),
  };
  if(id!=null)state.collection=pool.filter(p=>String(p.id)!==String(id));
  ensureStarterCombat();
  save();
  return state.starter;
}
function routeEncounterRows(type=route()[0],band=state.range){return encountersForRoute(type,band)}
function routeForms(){return routeEncounterRows().map(encounter=>encounter.slug)}
function primaryTypeFor(name){return speciesTypes(name)[0]||'normal'}
function ensureStarterCombat(){if(!state.starter?.name)return null;state.starter.level=normalizePokemonLevel(state.starter.level);state.starter.xp=state.starter.xp||0;normalizeMastery(state.starter);state.starter.ivs=state.starter.ivs||{hp:15,atk:15,def:15,spa:15,spd:15,spe:15};const type=primaryTypeFor(state.starter.name),stats=statsFor(state.starter.name,type,state.starter.level,state.starter.ivs);if(state.starter.currentHp==null)state.starter.currentHp=stats.hp;state.starter.currentHp=Math.min(state.starter.currentHp,stats.hp);ensureStarterLoadout();return{name:state.starter.name,level:state.starter.level,masteryLevel:state.starter.masteryLevel,masteryXp:state.starter.masteryXp,types:speciesTypes(state.starter.name,type),stats,currentHp:state.starter.currentHp,maxHp:stats.hp}}
function ensureStarterLoadout(){
  if(!state.starter||!isMovesReady())return;
  if(state.starter.autoMoves==null)state.starter.autoMoves=!(state.starter.equippedMoves||[]).length;
  state.starter.equippedMoves=state.starter.autoMoves
    ?defaultLoadout(state.starter.name,state.starter.level)
    :sanitizeLoadout(state.starter.name,state.starter.level,state.starter.equippedMoves);
  if(state.starter.moveCursor==null)state.starter.moveCursor=0;
}
function syncLoadoutAfterLevel(oldLevel,newLevel){
  if(!state.starter||!isMovesReady())return;
  const learned=newlyUnlockedMoves(state.starter.name,oldLevel,newLevel);
  for(const id of learned){
    showToast(t('log.learnedToast',{name:title(state.starter.name),move:moveDisplayName(id)}));
    addLog(t('log.learned',{move:moveDisplayName(id)}),title(state.starter.name));
    if(state.starter.autoMoves===false){const eq=state.starter.equippedMoves||[];if(eq.length<getEquipSlots()&&!eq.includes(id)){eq.push(id);state.starter.equippedMoves=eq}}
  }
  state.starter.equippedMoves=state.starter.autoMoves===false
    ?sanitizeLoadout(state.starter.name,newLevel,state.starter.equippedMoves)
    :defaultLoadout(state.starter.name,newLevel);
  renderMoveLoadout();
}
function setHpState(bar,ratio){if(!bar)return;bar.classList.toggle('low',ratio<=.5&&ratio>.2);bar.classList.toggle('crit',ratio<=.2)}
function flashHud(selector){const el=$(selector);if(!el)return;el.classList.remove('hud-hit');void el.offsetWidth;el.classList.add('hud-hit');setTimeout(()=>el.classList.remove('hud-hit'),380)}
function typeBadgeContent(pokemonTypes){return pokemonTypes.map(type=>`${typeGlyph(type)}${typeLabel(type,{upper:true})}`).join(' · ')}
function paintTypeBadge(el,pokemonTypes){
  if(!el)return;
  const types=Array.isArray(pokemonTypes)?pokemonTypes.filter(Boolean):[];
  if(!types.length){el.textContent='';return}
  const colors=types.map(type=>typeColors[type]||'#777'),background=colors.length>1?`linear-gradient(90deg,${colors[0]} 0 48%,${colors[1]} 52% 100%)`:colors[0];
  el.innerHTML=typeBadgeContent(types);el.style.setProperty('--type-color',background);el.dataset.type=types.join('-');
}
function isOnTeam(pokemon){return state.team.some(id=>String(id)===String(pokemon.id))}
function evolutionLevelRequired(chain,fromIndex){
  if(!chain||fromIndex<0||fromIndex>=chain.length-1)return null;
  return chain.length===2?60:fromIndex===0?40:70;
}
function evolutionRequirement(pokemon){
  if(!pokemon)return null;const chain=chainForSpecies(pokemon.name),index=chain?.indexOf(pokemon.name)??-1;if(index<0||index>=chain.length-1)return null;
  const required=evolutionLevelRequired(chain,index);
  return pokemon.level>=required?{chain,index,next:chain[index+1],required}:null;
}
function evolutionButton(kind,pokemon){const evolution=evolutionRequirement(pokemon);return evolution?`<button class="team-evolve-button" data-evolve-kind="${kind}"${pokemon.id!=null?` data-evolve-id="${pokemon.id}"`:''}>${t('common.evolve')}</button>`:''}
function ownedEvolutionStones(pokemon){const type=speciesTypes(pokemon.name,primaryTypeFor(pokemon.name))[0];return(STONES_BY_TYPE[type]||[]).map(stone=>({...stone,count:(state.drops[stone.slug]||0)+(state.inventory[stone.slug]||0)})).filter(stone=>stone.count>0)}
function evolutionTarget(kind,id){return kind==='starter'?state.starter:state.collection.find(p=>String(p.id)===String(id))}
/* Os PNGs de sprite têm margens transparentes irregulares (canvas 64x32, 32x64 etc.),
   então object-fit centraliza o canvas e não o Pokémon; recorta o conteúdo opaco
   para um quadrado antes de exibir em retratos. */
const portraitCache=new Map();
function centerPortrait(img){
  const src=img.getAttribute('src');if(!src)return;img.dataset.sprite=src;
  let entry=portraitCache.get(src);
  if(!entry){
    entry=new Promise(resolve=>{const probe=new Image();probe.onerror=()=>resolve(src);probe.onload=()=>{
      const w=probe.naturalWidth,h=probe.naturalHeight,work=document.createElement('canvas');work.width=w;work.height=h;
      const ctx=work.getContext('2d');ctx.drawImage(probe,0,0);
      let data;try{data=ctx.getImageData(0,0,w,h).data}catch{return resolve(src)}
      let minX=w,minY=h,maxX=-1,maxY=-1;
      for(let y=0;y<h;y++)for(let x=0;x<w;x++)if(data[(y*w+x)*4+3]>16){if(x<minX)minX=x;if(x>maxX)maxX=x;if(y<minY)minY=y;if(y>maxY)maxY=y}
      if(maxX<0)return resolve(src);
      const bw=maxX-minX+1,bh=maxY-minY+1,size=Math.ceil(Math.max(bw,bh)*1.08),out=document.createElement('canvas');
      out.width=size;out.height=size;const octx=out.getContext('2d');octx.imageSmoothingEnabled=false;
      octx.drawImage(probe,minX,minY,bw,bh,Math.floor((size-bw)/2),Math.floor((size-bh)/2),bw,bh);
      resolve(out.toDataURL())
    };probe.src=src});
    portraitCache.set(src,entry)
  }
  Promise.resolve(entry).then(url=>{if(url!==src&&img.isConnected&&img.dataset.sprite===src)img.src=url})
}
function renderRouteReserves(){
  const reserves=state.collection.filter(isOnTeam).slice(0,5);
  $('#routeTeamCount').textContent=`${1+reserves.length}/6`;
  $('#routeReserveList').innerHTML=reserves.map(p=>{
    const primary=primaryTypeFor(p.name),pokemonTypes=p.types||speciesTypes(p.name,primary),stats=p.stats||statsFor(p.name,primary,p.level,p.ivs,p.mult||1),ratio=Math.max(0,Math.min(1,(p.hp??100)/100)),currentHp=Math.round(stats.hp*ratio),expRatio=Math.max(0,Math.min(1,(p.xp||0)/xpToNext(p.level))),colors=pokemonTypes.map(type=>typeColors[type]||'#777'),typeBackground=colors.length>1?`linear-gradient(90deg,${colors[0]} 0 48%,${colors[1]} 52% 100%)`:colors[0];
    return`<article class="team-pokemon-row reserve ${shinyClassFor(p)}" role="button" tabindex="0" data-promote-pokemon="${p.id}" aria-label="${t('team.makePrincipal',{name:title(p.name)})}" style="--slot-color:${colors[0]}"><div class="team-pokemon-portrait ${shinyClassFor(p)}"><img src="${entityAsset(p.name,'south',0,{shiny:!!p.shiny})}" alt="${title(p.name)}"></div><div class="team-pokemon-info"><div class="hud-row"><span class="hud-identity"><b>${title(p.name)}</b><small class="hud-type" style="--type-color:${typeBackground}">${typeBadgeContent(pokemonTypes)}</small></span><span class="hud-level">${t('common.lv')} <b>${p.level}</b></span></div><div class="hp-bar"><i style="width:${ratio*100}%"></i></div><div class="exp-bar"><i style="width:${expRatio*100}%"></i></div><em>${currentHp}/${stats.hp} HP</em></div>${evolutionButton('collection',p)}</article>`
  }).join('');
  $$('#routeReserveList .team-pokemon-portrait img').forEach(centerPortrait);
  $$('#routeReserveList [data-promote-pokemon]').forEach(card=>{
    // Clicar num membro do time abre a ficha dele. Promover a principal
    // continua possível pelo botão "Pokémon principal" dentro do painel — que
    // é o lugar onde a ação fica explícita, em vez de disparar sem aviso ao
    // encostar no card.
    const open=event=>{
      if(event.target.closest('[data-evolve-kind]'))return;
      openTeamMember(`collection:${card.dataset.promotePokemon}`);
    };
    card.onclick=open;
    card.onkeydown=event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();open(event)}};
  })
}
function promoteTeamPokemon(id){
  const index=state.collection.findIndex(p=>String(p.id)===String(id)&&isOnTeam(p));
  if(index<0||!state.starter)return;
  const reserve=state.collection[index],activeCombat=ensureStarterCombat(),reservePrimary=primaryTypeFor(reserve.name),reserveStats=statsFor(reserve.name,reservePrimary,reserve.level,reserve.ivs,reserve.mult||1);
  ensurePokemonLoadout(reserve);
  const promotedServerId=reserve.serverId||reserve.id;
  const swapped=promoteReservePokemon({...state.starter,stats:activeCombat.stats,types:activeCombat.types}, {...reserve,stats:reserveStats,types:reserve.types||speciesTypes(reserve.name,reservePrimary)}, {activeMaxHp:activeCombat.maxHp,reserveMaxHp:reserveStats.hp});
  if(!swapped)return;
  state.collection[index]={
    ...swapped.reserve,
    starterOrigin:!!(swapped.reserve.starterOrigin||swapped.reserve.origin==='starter'),
  };
  state.starter={
    ...swapped.active,
    starterOrigin:false,
    isActive:true,
  };
  ensureStarterCombat();
  routeSim.moveCds={};routeSim.playerTurn=0;routeSim.nextPlayerAttackAt=0;routeSim.nextEnemyAttackAt=0;
  const routeActor=$('#routePartner');
  if(routeActor){routeActor.querySelector('small').textContent=t('battle.yourPokemon',{name:title(state.starter.name)});setActor(routeActor,state.starter.name,routeSim.player.dir||'south',false,performance.now(),{shiny:!!state.starter.shiny})}
  teamManagementSelection='starter';teamMoveDraft=[];teamMoveDraftDirty=false;
  resetCityFollower();renderPartnerHud();renderCollection();renderPokedex();save();
  showToast(t('team.promotedToast',{name:title(state.starter.name)}));
  if(collectionSyncEnabled()&&promotedServerId){
    void setActivePokemon(promotedServerId,crypto.randomUUID()).then(response=>{
      if(Array.isArray(response?.pokemon))applyServerCollection(response.pokemon,{force:true});
      else if(response?.active){
        applyServerPokemonUpdates([response.active,response.previous].filter(Boolean));
        const activeId=String(response.active.id||promotedServerId);
        state.collection=(state.collection||[]).filter(p=>String(p.id)!==activeId&&String(p.serverId||'')!==activeId);
        if(state.starter){
          state.starter={
            ...state.starter,
            serverId:response.active.id||state.starter.serverId,
            starterOrigin:response.active.origin==='starter',
            isActive:true,
          };
        }
        save();renderCollection();renderPartnerHud();
      }
    }).catch(error=>{
      console.warn('set_active_pokemon failed',error);
      showToast('Falha ao salvar o parceiro ativo no servidor');
    });
  }
}
function grantStarterXp(amount){
  if(!state.starter)return{gained:0,leveled:[],mastery:[]};
  const gained=Math.max(0,amount|0);
  if(!gained)return{gained:0,leveled:[],mastery:[]};
  const old=ensureStarterCombat();
  const progress=applyPokemonXpProgress(state.starter,gained);
  Object.assign(state.starter,progress.pokemon);
  for(const level of progress.levels){
    addLog(t('log.leveled',{name:title(state.starter.name),level}));
    syncLoadoutAfterLevel(level-1,level);
    if(evolutionRequirement(state.starter))showToast(t('evo.canEvolve',{name:title(state.starter.name)}));
  }
  if(progress.levels.length){
    const fresh=ensureStarterCombat();
    state.starter.currentHp=Math.min(fresh.maxHp,(old?.currentHp||1)+Math.max(1,fresh.maxHp-(old?.maxHp||fresh.maxHp)));
  }else{
    ensureStarterCombat();
  }
  if(progress.masteryLevels.length)addLog(t('mastery.leveled',{name:title(state.starter.name),level:progress.masteryLevels.at(-1)}));
  const serverId=state.starter.serverId||state.starter.id;
  if(serverId)queuePokemonXpGrant(serverId,gained);
  renderPartnerHud();
  return{gained,leveled:progress.levels,mastery:progress.masteryLevels};
}
// Só o Pokémon equipado como parceiro ganha EXP — na hunt e no offline. A reserva
// é a exceção do VIP: 10% da EXP do parceiro, e nada sem VIP.
function grantReserveXp(amount){
  const share=trainerAccountPerks().reserveXpShare;
  if(!(share>0))return{gained:0,leveled:[]};
  const gained=Math.max(1,Math.floor((Number(amount)||0)*share)),leveled=[];
  for(const id of state.team){
    const pokemon=state.collection.find(p=>String(p.id)===String(id));if(!pokemon)continue;
    const progress=applyPokemonXpProgress(pokemon,gained);
    Object.assign(pokemon,progress.pokemon);
    if(progress.levels.length){const primary=primaryTypeFor(pokemon.name);pokemon.stats=statsFor(pokemon.name,primary,pokemon.level,pokemon.ivs,pokemon.mult||1);if(pokemon.autoMoves!==false)pokemon.equippedMoves=defaultLoadout(pokemon.name,pokemon.level);leveled.push({name:pokemon.name,levels:progress.levels});addLog(t('log.leveled',{name:title(pokemon.name),level:pokemon.level}))}
    queuePokemonXpGrant(pokemon.serverId||pokemon.id,gained);
  }
  if(leveled.length)renderPartnerHud();
  return{gained,leveled};
}
function grantTrainerXp(amount){
  const gained=Math.max(0,amount|0);if(!gained)return{gained:0,leveled:[]};
  state.trainer=state.trainer||{level:1,xp:0};state.trainer.xp+=gained;const leveled=[];
  while(state.trainer.level<MAX_TRAINER_LEVEL&&state.trainer.xp>=trainerXpToNext(state.trainer.level)){
    state.trainer.xp-=trainerXpToNext(state.trainer.level);state.trainer.level++;state.trainer.peakLevel=Math.max(state.trainer.peakLevel||1,state.trainer.level);leveled.push(state.trainer.level);
    addLog(t('log.trainerLeveled',{level:state.trainer.level}),t('profile.trainer'));
  }
  renderTrainerHud();
  if(leveled.length){
    showLevelUpBanner(leveled[leveled.length-1]);
    tutorialEvent('trainer:level',{level:state.trainer.level});
  }
  return{gained,leveled};
}
let levelUpBannerTimer=null,levelUpBannerCloseTimer=null,levelUpBannerDeadline=0;
function showLevelUpBanner(level){
  const box=$('#levelUpBanner'),levelEl=$('#levelUpLevel');
  if(!box||!levelEl)return;
  const now=performance.now();
  const visible=!box.classList.contains('hidden')&&!box.classList.contains('closing');
  levelUpBannerDeadline=transientDeadline(now,visible?levelUpBannerDeadline:0,2400);
  levelEl.textContent=`${t('common.lv')} ${level}`;
  applyStaticI18n(box);
  clearTimeout(levelUpBannerTimer);clearTimeout(levelUpBannerCloseTimer);
  box.classList.remove('hidden','closing');
  void box.offsetWidth;
  levelUpBannerTimer=setTimeout(()=>{
    box.classList.add('closing');
    levelUpBannerCloseTimer=setTimeout(()=>{
      box.classList.add('hidden');box.classList.remove('closing');levelUpBannerDeadline=0;
    },360);
  },Math.max(0,levelUpBannerDeadline-now));
}
function renderTrainerHud(){
  if($('#trainerLevel'))$('#trainerLevel').textContent=state.trainer?.level||1;
  if($('#trainerPrestige'))$('#trainerPrestige').textContent=state.trainer?.prestige||0;
  const name=String(state.trainer?.name||'').trim();
  if($('#trainerNameLabel'))$('#trainerNameLabel').textContent=name||t('profile.trainer');
  if($('#trainerAvatar'))$('#trainerAvatar').textContent=(name||t('profile.trainer')).charAt(0).toUpperCase();
  if($('#cityTrainerLabel'))$('#cityTrainerLabel').textContent=name||t('profile.trainer');
  if($('#routeTrainerLabel'))$('#routeTrainerLabel').textContent=name||t('profile.trainer');
  renderSpecializationBadge();
}
const SPEC_ICON_NAMES=Object.freeze({
  trainer:'school',hunter:'binoculars',catcher:'pokeball',researcher:'microscope',
  xp:'swords',prestige:'crown',mastery:'award',evolution:'dna',offline:'moon',
  research:'book-2',combat:'target-arrow',shiny:'sparkles',
});
const specIcon=(name,cls='')=>uiIcon(SPEC_ICON_NAMES[name]||name,`spec-icon ${cls}`);
const TRAINER_TALENT_META=Object.freeze([
  {key:'trainer',icon:'trainer',color:'#e85d4c',streak:'exp',perPoint:5,currentPct:rank=>25+rank*5,unit:'pp'},
  {key:'hunter',icon:'hunter',color:'#8fbd67',streak:'loot',perPoint:3,currentPct:rank=>rank*3,unit:'pct'},
  {key:'catcher',icon:'catcher',color:'#5dade2',streak:'catch',perPoint:2,currentPct:rank=>rank*2,unit:'pct'},
  {key:'researcher',icon:'researcher',color:'#b783dc',streak:'shiny',perPoint:5,currentPct:rank=>rank*5,unit:'pct'},
]);
function talentEffectText(key,rank){
  if(key==='trainer')return t('specialization.effect.trainer',{offline:rank*OFFLINE_POKEMON_PCT_PER_RANK});
  if(key==='hunter')return t('specialization.effect.hunter',{value:rank*3});
  if(key==='catcher')return t('specialization.effect.catcher',{value:rank*2});
  return t('specialization.effect.researcher',{value:rank*5});
}
function talentStreakValue(meta,rank){
  const value=meta.currentPct(rank);
  return meta.unit==='pp'
    ? t('specialization.streakValueReserve',{value})
    : t('specialization.streakValuePct',{value:formatNumber(value,{minimumFractionDigits:1,maximumFractionDigits:1})});
}
function talentPerPointText(meta){
  if(meta.key==='trainer')return t('specialization.streakPer.exp',{value:meta.perPoint});
  if(meta.key==='hunter')return t('specialization.streakPer.loot',{value:meta.perPoint});
  if(meta.key==='catcher')return t('specialization.streakPer.catch',{value:meta.perPoint});
  return t('specialization.streakPer.shiny',{value:meta.perPoint});
}
function renderSpecializationBadge(){
  const badge=$('#specializationPointBadge');if(!badge)return;
  const available=trainerTalentAvailable();badge.textContent=available;badge.classList.toggle('hidden',available<=0);
}
function specializationRespecCost(){return 50000*((state.trainer?.prestige||0)+1)}
function renderSpecializationKillGrid(){
  const host=$('#specializationKillGrid');if(!host)return;
  const rows=Object.entries(state.killCounts||{})
    .map(([slug,count])=>({slug,count:Math.max(0,Math.floor(Number(count)||0))}))
    .filter(row=>row.count>0)
    .sort((a,b)=>b.count-a.count||a.slug.localeCompare(b.slug));
  if(!rows.length){
    host.innerHTML=`<p class="specialization-kills-empty">${escHtml(t('specialization.killsEmpty'))}</p>`;
    return;
  }
  host.innerHTML=rows.slice(0,80).map(row=>`<article class="ui-tile specialization-kill-tile">
    <span class="ui-iconbox"><img src="${escHtml(entityAsset(row.slug,'south',0))}" alt=""></span>
    <span class="ui-copy"><b>${escHtml(title(row.slug))}</b><small class="profile-row-value">${formatNumber(row.count)}</small></span>
  </article>`).join('');
}
function escHtml(value){return String(value??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]))}
function renderSpecialization(){
  const points=$('#specializationPoints'),grid=$('#specializationGrid'),killBox=$('#specializationKillXp'),shinyBox=$('#specializationShinyResearch'),respec=$('#specializationRespec');if(!points||!grid||!killBox||!shinyBox||!respec)return;
  const total=trainerTalentTotal(),spent=trainerTalentSpent(),available=Math.max(0,total-spent),defeats=talentDefeats(),killBonus=killXpBonusForDefeats(defeats),atKillCap=killBonus>=.2,nextKill=Math.min(200000,(Math.floor(defeats/1000)+1)*1000),remaining=Math.max(0,nextKill-defeats);
  const statsEyebrow=$('#specializationDialog [data-i18n="specialization.statsEyebrow"]');
  const investEyebrow=$('#specializationDialog [data-i18n="specialization.investEyebrow"]');
  if(statsEyebrow)statsEyebrow.textContent=t('specialization.statsEyebrow');
  if(investEyebrow)investEyebrow.textContent=t('specialization.investEyebrow');
  points.innerHTML=`
    <div class="ui-stat"><small>${t('specialization.stat.totalKills')}</small><b>${formatNumber(defeats)}</b></div>
    <div class="ui-stat ${available>0?'has-points':''}"><small>${t('specialization.stat.available')}</small><b>${available}</b></div>
    <div class="ui-stat"><small>${t('specialization.stat.used')}</small><b>${spent}</b></div>
    <div class="ui-stat"><small>${t('specialization.stat.nextPoint')}</small><b>${atKillCap?'—':formatNumber(remaining)}</b></div>
    <p class="ui-hint specialization-streak-note">${t('specialization.streakNote')}</p>`;
  grid.innerHTML=TRAINER_TALENT_META.map(meta=>{
    const rank=state.trainerTalents[meta.key]||0,nextRank=Math.min(5,rank+1);
    return`<article class="ui-tile specialization-talent specialization-streak-card${rank>=5?' maxed':''}" style="--talent-color:${meta.color}">
      <span class="ui-iconbox specialization-talent-icon">${specIcon(meta.icon)}</span>
      <span class="ui-copy"><b>${t(`specialization.streak.${meta.streak}`)}</b><small>${t('specialization.path')}</small></span>
      <b class="specialization-streak-pct">${talentStreakValue(meta,rank)}</b>
      <p class="ui-hint">${talentPerPointText(meta)}</p>
      <div class="specialization-ranks">${Array.from({length:5},(_,index)=>`<i class="${index<rank?'active':''}"></i>`).join('')}</div>
      <div class="specialization-effect"><span>${t('specialization.pointsInPath',{count:rank})}</span>${rank<5?`<small>${t('specialization.next')}: ${talentEffectText(meta.key,nextRank)}</small>`:`<small>${t('specialization.maxRank')}</small>`}</div>
      <button type="button" class="ui-btn-primary" data-talent-upgrade="${meta.key}" ${rank>=5||available<=0?'disabled':''}>${rank>=5?t('specialization.maxed'):t('specialization.investPlus')}</button>
    </article>`;
  }).join('');
  const killPct=atKillCap?100:Math.min(100,defeats%1000/10);
  killBox.innerHTML=`<div class="ui-row specialization-kill-xp-row"><span class="ui-iconbox">${specIcon('xp')}</span><div class="ui-copy"><small>${t('specialization.killEyebrow')}</small><b>${t('specialization.killBonus',{value:formatNumber(killBonus*100,{minimumFractionDigits:1,maximumFractionDigits:1})})}</b><p class="ui-hint">${atKillCap?t('specialization.killMax',{kills:formatNumber(defeats)}):t('specialization.killNext',{kills:formatNumber(defeats),remaining:formatNumber(remaining),next:formatNumber(nextKill)})}</p><span class="ui-progress specialization-kill-bar"><i style="width:${killPct}%"></i></span></div></div>`;
  const researchRank=state.trainerTalents.researcher||0;
  shinyBox.innerHTML=`<div class="ui-row specialization-shiny-row"><span class="ui-iconbox">${specIcon('shiny')}</span><div class="ui-copy"><small>${t('specialization.shinyEyebrow')}</small><b>${t('specialization.shinyTitle')}</b><p class="ui-hint">${t('specialization.shinyRule',{start:formatNumber(SHINY_SOFT_PITY_KILLS)})}</p><em class="ui-hint">${t('specialization.shinyResearchBonus',{value:researchRank*5})}</em></div><div class="specialization-shiny-stats"><span class="ui-stat"><small>${t('specialization.shinyBase')}</small><b>1/${formatNumber(4096)}</b></span><span class="ui-stat"><small>${t('specialization.shinyPity')}</small><b>${formatNumber(SHINY_SOFT_PITY_KILLS)}</b></span><span class="ui-stat"><small>${t('specialization.shinyCapLabel')}</small><b>1/${formatNumber(512)}</b></span></div></div>`;
  renderSpecializationKillGrid();
  const free=state.trainerFreeRespecs>0,cost=specializationRespecCost();respec.disabled=spent<=0;respec.textContent=free?t('specialization.respecFree',{count:state.trainerFreeRespecs}):t('specialization.respecCost',{cost:formatNumber(cost)});
  const systems=[['prestige','prestige',t('specialization.system.prestige'),t('specialization.system.prestigeWhere')],['team','mastery',t('specialization.system.mastery'),t('specialization.system.masteryWhere')],['team','evolution',t('specialization.system.evolution'),t('specialization.system.evolutionWhere')],['automation','offline',t('specialization.system.offline'),t('specialization.system.offlineWhere')],['pokedex','research',t('specialization.system.research'),t('specialization.system.researchWhere')],['hunt','combat',t('specialization.system.combat'),t('specialization.system.combatWhere')]];
  $('#systemsDiscoveryGrid').innerHTML=systems.map(([target,icon,label,where])=>`<button type="button" class="ui-tile" data-open-system="${target}"><span class="ui-iconbox">${specIcon(icon)}</span><span class="ui-copy"><b>${label}</b><small>${where}</small></span></button>`).join('');
  renderSpecializationBadge();
}
function openSpecialization(){renderSpecialization();$('#specializationDialog')?.classList.remove('hidden');$('#specializationNavButton')?.classList.add('active')}
function closeSpecialization(){$('#specializationDialog')?.classList.add('hidden');$('#specializationNavButton')?.classList.remove('active')}
async function investTrainerTalent(key){
  if(!TRAINER_TALENT_KEYS.includes(key)||trainerTalentAvailable()<=0||(state.trainerTalents[key]||0)>=5)return;
  const nextRank=(state.trainerTalents[key]||0)+1;
  if(!await showGameConfirm(t('specialization.confirmInvest',{name:t(`specialization.${key}.name`),effect:talentEffectText(key,nextRank)})))return;
  if(progressSyncEnabled()){
    try{
      // A point can be reached locally while the encounter queue is still in
      // flight. Credit that queue and reload the authoritative counter before
      // allowing the RPC to spend the point.
      await flushSessionSync();
      await refreshProgress();
      if((state.trainerTalents[key]||0)>=5){
        renderSpecialization();
        showToast(t('specialization.maxed'));
        return;
      }
      if(trainerTalentAvailable()<=0){
        renderSpecialization();
        showToast(t('specialization.noPointsServer'));
        return;
      }
      const response=await investTrainerTalentRpc(key,crypto.randomUUID());
      if(response?.progress)applyServerProgress(response.progress);
      else state.trainerTalents=normalizeTrainerTalents({...state.trainerTalents,[key]:nextRank});
    }catch(error){
      console.warn('invest_trainer_talent failed',error);
      const code=String(error?.message||error||'').toLowerCase();
      if(code.includes('talent_no_points')||code.includes('talent_max_rank')){
        await refreshProgress().catch(()=>{});
        renderSpecialization();
        showToast(code.includes('talent_max_rank')?t('specialization.maxed'):t('specialization.noPointsServer'));
        return;
      }
      showToast(t('sys.syncFail')||'Sync failed');
      return;
    }
  }else{
    state.trainerTalents=normalizeTrainerTalents({...state.trainerTalents,[key]:nextRank});
  }
  renderSpecialization();renderTrainerProgress();save();
  showToast(t('specialization.invested',{name:t(`specialization.${key}.name`),rank:state.trainerTalents[key]}));
}
async function respecTrainerTalents(){
  const spent=trainerTalentSpent();if(!spent)return;const free=state.trainerFreeRespecs>0,cost=specializationRespecCost();if(!free&&state.stats.coins<cost){showToast(t('specialization.notEnoughCoins'));return}
  if(!await showGameConfirm(free?t('specialization.confirmRespecFree'):t('specialization.confirmRespecCost',{cost:formatNumber(cost)})))return;
  if(progressSyncEnabled()){
    try{
      const response=await respecTrainerTalentsRpc(crypto.randomUUID());
      if(response?.progress)applyServerProgress(response.progress);
      else{if(free)state.trainerFreeRespecs--;state.trainerTalents=normalizeTrainerTalents({})}
      if(response?.wallet)acceptMarketWallet(response.wallet);
    }catch(error){
      console.warn('respec_trainer_talents failed',error);
      showToast(t('specialization.notEnoughCoins'));
      return;
    }
  }else{
    if(free)state.trainerFreeRespecs--;
    else if(walletSyncEnabled()){
      try{
        const response=await spendIdlecoin(cost,'respec',crypto.randomUUID());
        if(response?.wallet)acceptMarketWallet(response.wallet);
      }catch(error){
        console.warn('spend_idlecoin respec failed',error);
        showToast(t('specialization.notEnoughCoins'));
        return;
      }
    }else applyIdlecoinDelta(-cost,'respec');
    state.trainerTalents=normalizeTrainerTalents({});
  }
  renderSpecialization();renderTrainerProgress();renderStats();save();showToast(t('specialization.respecced'));
}
function openSpecializationSystem(target){
  closeSpecialization();
  if(target==='prestige'){openTrainerProgress();return}
  if(target==='automation'){openHuntWindow('automationPanel');renderOfflineStatus();return}
  if(target==='pokedex'){openHuntWindow('pokedexPanel');return}
  if(target==='team'){openTeamManagement();return}
  if(target==='hunt'){openAtlas({typeIndex:state.type,band:state.range});return}
}
function renderTrainerProgress(){
  const body=$('#trainerProgressBody'),button=$('#trainerPrestigeButton');if(!body||!button)return;
  const perks=trainerAccountPerks(),prestigeReady=trainerPerks(state.trainer.level,state.trainer.prestige).prestigeAvailable,atCap=state.trainer.level>=MAX_TRAINER_LEVEL;
  const xpMax=atCap?0:trainerXpToNext(state.trainer.level),pct=atCap?100:Math.min(100,state.trainer.xp/xpMax*100);
  body.innerHTML=`
    <section class="ui-section">
      <div class="trainer-progress-level">
        <b>${t('profile.level')} ${state.trainer.level}</b>
        <span class="ui-pill">${t('progress.prestigeShort',{count:state.trainer.prestige})}</span>
        <span class="ui-progress"><i style="width:${pct}%"></i></span>
        <small>${atCap?t('progress.ready'):t('progress.xp',{current:formatNumber(state.trainer.xp),max:formatNumber(xpMax)})}</small>
      </div>
    </section>
    <section class="ui-section">
      <small class="eyebrow">${t('progress.perksEyebrow')}</small>
      <div class="trainer-perk-grid">
        <div class="ui-stat"><small>${t('progress.offlineTraining')}</small><b>${Math.round(perks.offlineTrainingPct)}%</b></div>
        <div class="ui-stat"><small>${t('progress.reserveVip')}</small><b>${Math.round((perks.reserveXpShare||0)*100)}%</b></div>
        <div class="ui-stat"><small>${t('progress.loot')}</small><b>+${Math.round((perks.lootMultiplier-1)*100)}%</b></div>
        <div class="ui-stat"><small>${t('progress.capture')}</small><b>+${Math.round((perks.captureMultiplier-1)*100)}%</b></div>
        <div class="ui-stat"><small>${t('progress.xpBonus')}</small><b>+${formatNumber((perks.xpMultiplier-1+killXpBonusForDefeats(state.stats.defeated))*100,{minimumFractionDigits:1,maximumFractionDigits:1})}%</b></div>
        <div class="ui-stat"><small>${t('progress.offlineCap')}</small><b>${perks.offlineCapHours}h</b></div>
        <div class="ui-stat"><small>${t('progress.mastery')}</small><b>${trainerAccessLevel()>=150?t('common.yes'):t('common.no')}</b></div>
      </div>
      <p class="ui-hint trainer-progress-note">${t('progress.note')}</p>
      <button type="button" class="ui-btn progress-open-specialization" id="progressOpenSpecialization">${t('progress.openSpecialization')}</button>
    </section>`;
  $('#progressOpenSpecialization')?.addEventListener('click',()=>{closeTrainerProgress();openSpecialization()});
  button.disabled=!prestigeReady;
  button.textContent=prestigeReady?t('progress.prestige'):state.trainer.prestige>=10?t('progress.maxPrestige'):t('progress.requires300');
}
function openTrainerProgress(){closeProfile();renderTrainerProgress();$('#trainerProgressDialog')?.classList.remove('hidden')}
function closeTrainerProgress(){$('#trainerProgressDialog')?.classList.add('hidden')}

let outfitDraft={gender:DEFAULT_TRAINER_GENDER,sprite:DEFAULT_TRAINER_SPRITE,colorPiece:'body',colors:{...DEFAULT_OUTFIT_COLORS}};

function profileRow(label,value,extra=''){return`<div class="ui-row profile-row"><div class="ui-copy"><b>${label}</b></div><span class="profile-row-value">${value}${extra}</span></div>`}

function paintProfileAvatar(){
  const img=$('#profileAvatarImg');if(!img)return;
  const slug=trainerSprite(),colors=trainerOutfitColors();
  const request=`${slug}|${outfitColorsKey(colors)}`;
  img.dataset.profilePreview=request;
  compositeOutfitSprite(entityAsset(slug,'south',0),entityMaskAsset(slug,'south',0),colors).then(url=>{
    if(img.dataset.profilePreview!==request)return;
    img.src=url;centerPortrait(img);
  }).catch(()=>{img.src=entityAsset(slug,'south',0);centerPortrait(img)});
}

function renderProfile(){
  const name=String(state.trainer?.name||'').trim()||t('profile.trainer');
  const level=state.trainer?.level||1,prestige=state.trainer?.prestige||0;
  const atCap=level>=MAX_TRAINER_LEVEL,xpMax=atCap?0:trainerXpToNext(level);
  const pct=atCap?100:Math.min(100,(state.trainer.xp||0)/Math.max(1,xpMax)*100);
  const dexOwned=isPokedexReady()?allPokedexSpecies().filter(s=>(ownedBySpecies().get(s.slug)||[]).length>0).length:ownedBySpecies().size;
  const dexTotal=isPokedexReady()?allPokedexSpecies().length:0;
  const dexPct=dexTotal?Math.min(100,dexOwned/dexTotal*100):0;
  if($('#profileName'))$('#profileName').textContent=name;
  if($('#profileLevelLine'))$('#profileLevelLine').textContent=`${t('profile.level')} ${level}`;
  if($('#profilePrestigeBadge'))$('#profilePrestigeBadge').textContent=t('progress.prestigeShort',{count:prestige});
  if($('#profileXpFill'))$('#profileXpFill').style.width=`${pct}%`;
  if($('#profileXpText'))$('#profileXpText').textContent=atCap?t('profile.xpReady'):t('profile.xpLine',{current:formatNumber(state.trainer.xp||0),max:formatNumber(xpMax)});
  if($('#profileChips'))$('#profileChips').innerHTML=`
    <span class="ui-pill"><b>${coinsAmount(state.stats.coins||0,14)}</b></span>
    <span class="ui-pill">${t('profile.pokedex')} <b>${dexTotal?t('profile.pokedexProgress',{owned:formatNumber(dexOwned),total:formatNumber(dexTotal)}):formatNumber(dexOwned)}</b></span>
    <span class="ui-pill">${t('profile.captured')} <b>${formatNumber(state.stats.captured||0)}</b></span>`;
  if($('#profileGeneralRows'))$('#profileGeneralRows').innerHTML=[
    profileRow(t('profile.level'),formatNumber(level)),
    profileRow(t('profile.prestige'),formatNumber(prestige)),
    profileRow(t('profile.peakLevel'),formatNumber(state.trainer.peakLevel||level)),
    profileRow(t('profile.coins'),coinsAmount(state.stats.coins||0,14)),
    profileRow(t('profile.defeated'),formatNumber(state.stats.defeated||0)),
  ].join('');
  const talentTotal=trainerTalentTotal(),talentSpent=trainerTalentPointsSpent(state.trainerTalents);
  if($('#profileProgressRows'))$('#profileProgressRows').innerHTML=[
    profileRow(t('profile.captured'),formatNumber(state.stats.captured||0)),
    profileRow(t('profile.pokedex'),dexTotal?t('profile.pokedexProgress',{owned:formatNumber(dexOwned),total:formatNumber(dexTotal)}):formatNumber(dexOwned),dexTotal?`<span class="profile-mini-bar"><em style="width:${dexPct}%"></em></span>`:''),
    profileRow(t('profile.talents'),`${formatNumber(talentSpent)}/${formatNumber(talentTotal)}`),
  ].join('');
  paintProfileAvatar();
}

function openProfile(){
  closeTrainerProgress();closeOutfitEditor();
  renderProfile();
  $('#profileDialog')?.classList.remove('hidden');
  applyStaticI18n($('#profileDialog'));
}
function closeProfile(){$('#profileDialog')?.classList.add('hidden')}

function paintOutfitPreview(){
  const img=$('#outfitPreviewImg');if(!img)return;
  const slug=outfitDraft.sprite,colors=normalizeOutfitColors(outfitDraft.colors);
  const request=`${slug}|${outfitColorsKey(colors)}`;
  img.dataset.outfitPreview=request;
  compositeOutfitSprite(entityAsset(slug,'south',0),entityMaskAsset(slug,'south',0),colors).then(url=>{
    if(img.dataset.outfitPreview!==request)return;
    img.src=url;centerPortrait(img);
  }).catch(()=>{img.src=entityAsset(slug,'south',0);centerPortrait(img)});
}

function renderOutfitLooks(){
  const host=$('#outfitLooks');if(!host)return;
  const looks=looksForGender(outfitDraft.gender);
  if(!looks.some(l=>l.slug===outfitDraft.sprite))outfitDraft.sprite=looks[0]?.slug||DEFAULT_TRAINER_SPRITE;
  host.innerHTML=looks.map(look=>{
    const selected=look.slug===outfitDraft.sprite;
    return`<button type="button" class="onboarding-look ${selected?'selected':''}" data-outfit-look="${look.slug}" aria-pressed="${selected}"><span class="onboarding-look-frame"><img src="${entityAsset(look.slug,'south',0)}" alt=""></span><b>${t(look.labelKey)}</b></button>`;
  }).join('');
  $$('#outfitLooks [data-outfit-look]').forEach(btn=>{
    btn.onclick=()=>{outfitDraft.sprite=btn.dataset.outfitLook;renderOutfitEditor()};
  });
  $$('#outfitLooks img').forEach(img=>{
    const slug=img.closest('[data-outfit-look]')?.dataset.outfitLook;
    if(!slug)return;
    const request=`${slug}|${outfitColorsKey(outfitDraft.colors)}`;
    img.dataset.lookPreview=request;
    compositeOutfitSprite(entityAsset(slug,'south',0),entityMaskAsset(slug,'south',0),outfitDraft.colors).then(url=>{
      if(img.dataset.lookPreview!==request)return;
      img.src=url;centerPortrait(img);
    }).catch(()=>{img.src=entityAsset(slug,'south',0);centerPortrait(img)});
  });
}

function renderOutfitColors(){
  const piecesHost=$('#outfitColorPieces'),gridHost=$('#outfitColorGrid');
  if(!piecesHost||!gridHost)return;
  if(!OUTFIT_PIECES.includes(outfitDraft.colorPiece))outfitDraft.colorPiece='body';
  outfitDraft.colors=normalizeOutfitColors(outfitDraft.colors);
  piecesHost.innerHTML=OUTFIT_PIECES.map(piece=>{
    const selected=piece===outfitDraft.colorPiece,colorId=outfitDraft.colors[piece];
    return`<button type="button" class="onboarding-color-piece" data-outfit-piece="${piece}" aria-pressed="${selected}"><i class="swatch" style="background:${outfitColorCss(colorId)}"></i>${t(`starter.color.${piece}`)}</button>`;
  }).join('');
  $$('#outfitColorPieces [data-outfit-piece]').forEach(btn=>{
    btn.onclick=()=>{outfitDraft.colorPiece=btn.dataset.outfitPiece;renderOutfitColors()};
  });
  const activePiece=outfitDraft.colorPiece,activeColor=outfitDraft.colors[activePiece];
  gridHost.innerHTML=Array.from({length:OUTFIT_COLOR_COUNT},(_,id)=>{
    const selected=id===activeColor;
    return`<button type="button" class="onboarding-color-swatch" data-outfit-color="${id}" aria-pressed="${selected}" title="${id}" style="background:${outfitColorCss(id)}"></button>`;
  }).join('');
  $$('#outfitColorGrid [data-outfit-color]').forEach(btn=>{
    btn.onclick=()=>{
      outfitDraft.colors={...outfitDraft.colors,[activePiece]:Number(btn.dataset.outfitColor)};
      renderOutfitColors();
      paintOutfitPreview();
      renderOutfitLooks();
    };
  });
}

function renderOutfitEditor(){
  $$('#outfitGender [data-outfit-gender]').forEach(btn=>{
    const selected=btn.dataset.outfitGender===outfitDraft.gender;
    btn.classList.toggle('selected',selected);
    btn.setAttribute('aria-pressed',String(selected));
  });
  renderOutfitLooks();
  renderOutfitColors();
  paintOutfitPreview();
}

function openOutfitEditor(){
  outfitDraft={
    gender:state.trainer.gender==='m'?'m':'f',
    sprite:trainerSprite(),
    colorPiece:'body',
    colors:normalizeOutfitColors(state.trainer.colors),
  };
  if(!looksForGender(outfitDraft.gender).some(l=>l.slug===outfitDraft.sprite)){
    outfitDraft.sprite=defaultSpriteForGender(outfitDraft.gender);
  }
  closeProfile();
  renderOutfitEditor();
  applyStaticI18n($('#outfitDialog'));
  $('#outfitDialog')?.classList.remove('hidden');
}
function closeOutfitEditor(){$('#outfitDialog')?.classList.add('hidden')}
function saveOutfitEditor(){
  state.trainer.gender=outfitDraft.gender==='m'?'m':'f';
  state.trainer.sprite=outfitDraft.sprite;
  state.trainer.colors=normalizeOutfitColors(outfitDraft.colors);
  clearOutfitCompositeCache();
  const el=$('#cityTrainer');if(el)setActor(el,trainerSprite(),cityPlayer.dir||'south',false,performance.now());
  const routeTrainer=$('#routeTrainer');if(routeTrainer)setActor(routeTrainer,trainerSprite(),'north',false,performance.now());
  closeOutfitEditor();
  renderTrainerHud();
  openProfile();
  save();
  showToast(t('profile.outfitSaved'));
}
async function prestigeTrainer(){
  const perks=trainerPerks(state.trainer.level,state.trainer.prestige);if(!perks.prestigeAvailable)return;
  if(!await showGameConfirm(t('progress.confirm')))return;
  if(progressSyncEnabled()){
    try{
      const response=await prestigeTrainerRpc(crypto.randomUUID());
      if(response?.progress)applyServerProgress(response.progress);
      else{
        state.trainer.prestige++;state.trainer.level=1;state.trainer.xp=0;
        state.trainer.peakLevel=Math.max(MAX_TRAINER_LEVEL,state.trainer.peakLevel||1);
        state.trainerFreeRespecs=(state.trainerFreeRespecs||0)+1;
      }
    }catch(error){
      console.warn('prestige_trainer failed',error);
      showToast(t('sys.syncFail')||'Sync failed');
      return;
    }
  }else{
    state.trainer.prestige++;state.trainer.level=1;state.trainer.xp=0;state.trainer.peakLevel=Math.max(MAX_TRAINER_LEVEL,state.trainer.peakLevel||1);state.trainerFreeRespecs++;
  }
  addLog(t('progress.completed',{count:state.trainer.prestige}),t('profile.trainer'));
  renderTrainerHud();renderTrainerProgress();renderSpecialization();renderMapRanges();renderMapRoutes();renderOfflineStatus();save();
  showToast(t('progress.completed',{count:state.trainer.prestige}));
}
function healingSupplyCount(){
  return ['potion','great-potion','ultra-potion','hyper-potion','full-restore','medicine','revive']
    .reduce((sum,slug)=>sum+(state.inventory[slug]||0),0);
}
function renderOfflineStatus(){
  const status=$('#offlineStatus'),button=$('#offlineStartButton'),restBtn=$('#offlineRestButton');
  if(!status)return;
  if(serverGameplayReady()){
    status.textContent=state.running?t('offline.restReady'):t('offline.restIdle');
    if(button){button.classList.add('hidden');button.disabled=true}
    if(restBtn){
      restBtn.classList.remove('hidden');
      restBtn.disabled=!state.running;
    }
    const stageRest=$('#restButton');
    if(stageRest)stageRest.disabled=!state.running;
    return;
  }
  if(restBtn)restBtn.classList.add('hidden');
  if(button)button.classList.remove('hidden');
  if(state.pendingOfflineReport){status.textContent=t('offline.pending');if(button)button.disabled=true;return}
  if(state.offlineHunt){status.textContent=t('offline.active');if(button)button.disabled=true;return}
  const hunt=huntSession(),seconds=hunt?Math.floor((Date.now()-hunt.startedAt)/1000):0,ready=!!hunt&&seconds>=300&&(hunt.samples||[]).some(sample=>sample.kills);
  status.textContent=hunt?(ready?t('offline.ready',{time:formatHuntDuration(seconds)}):t('offline.sampling',{time:formatHuntDuration(seconds)})):t('offline.requirement');
  if(button)button.disabled=!ready;
}
function offlineSample(hunt){
  const now=Date.now(),cut=now-HUNT_RATE_WINDOW_MS,duration=Math.min(HUNT_RATE_WINDOW_MS,Math.max(300000,now-hunt.startedAt)),sums={kills:0,xp:0},items={};
  for(const sample of hunt.samples||[]){
    if(sample.t<cut)continue;sums.kills+=sample.kills||0;sums.xp+=sample.xp||0;
    for(const [slug,qty] of Object.entries(sample.items||{}))if(DROP_ITEMS.some(item=>item.slug===slug))items[slug]=(items[slug]||0)+qty;
  }
  const scale=3600000/duration;
  return{killsPerHour:sums.kills*scale,xpPerHour:sums.xp*scale,itemsPerHour:Object.fromEntries(Object.entries(items).map(([slug,qty])=>[slug,qty*scale]))};
}
function startOfflineHunt(){
  if(serverGameplayReady()){void restOfflineHunt();return}
  const hunt=huntSession();if(!hunt||Date.now()-hunt.startedAt<300000||(hunt.samples||[]).every(sample=>!sample.kills)){showToast(t('offline.notReady'));return}
  const perks=trainerAccountPerks();
  state.offlineHunt={startedAt:Date.now(),typeIndex:hunt.typeIndex,rangeIndex:hunt.rangeIndex,pokemon:(hunt.pokemon||[]).slice(0,4),capHours:perks.offlineCapHours,sample:offlineSample(hunt)};
  finishActiveHunt();state.running=false;routeSim.target=null;routeSim.spawnTimer=0;switchView('city');renderOfflineStatus();save();
  showToast(t('offline.started',{hours:perks.offlineCapHours}));
}
/** Descansa: para a hunt, arma o offline no servidor e volta à cidade. */
async function restOfflineHunt(){
  if(!serverGameplayReady()){startOfflineHunt();return}
  if(!state.running){showToast(t('offline.restNeedHunt'));return}
  const atRisk=healingSupplyCount()<=0;
  try{await flushSessionSync()}catch(error){console.warn('flush before rest failed',error)}
  const armed=armOfflineExit({reason:atRisk?'rest_at_risk':'rest',atRisk});
  finishActiveHunt();state.running=false;routeSim.target=null;routeSim.spawnTimer=0;
  switchView('city');renderOfflineStatus();save();
  if(!armed){showToast(t('offline.restArmFailed'));return}
  showToast(atRisk?t('offline.restArmedRisk'):t('offline.restArmed'));
}
// Offline Hunt (modo servidor): só após "descansar". Fechar sem armar não paga.
async function serverOfflineClaim(){
  if(!progressSyncEnabled()||!inventorySyncEnabled())return;
  const stamp=consumeCleanExitStamp();
  if(!stamp?.exitAt)return;
  let report;
  try{report=await claimOfflineHunt(crypto.randomUUID(),stamp.exitAt)}
  catch(error){console.warn('offline claim failed',error);return}
  if(!report?.claimed||!(Number(report.kills)>0))return;
  if(report.progress)applyServerProgress(report.progress);
  if(report.inventory)applyServerInventory(report.inventory,{force:true});
  if(report.pokemon)applyServerPokemonUpdates([report.pokemon]);
  renderStats();renderDropBag();renderPlayerInventory();renderTrainerHud();
  showServerOfflineReport(report);
}
function offlineStopReasonLabel(reason){
  const key=`offline.stop.${reason||'rest'}`;
  const label=t(key);
  return label===key?t('offline.stop.rest'):label;
}
function showServerOfflineReport(report){
  const body=$('#offlineReportBody');if(!body)return;
  const rows=Object.entries(report.drops||{}).filter(([slug,qty])=>Number(qty)>0&&ITEM_BY_SLUG[slug]);
  const pctLabel=`${Math.round(report.pct||50)}%${report.vip?' · VIP':''}`;
  const monXp=Math.max(0,Number(report.pokemon_xp)||0),monPct=Math.max(0,Number(report.pokemon_pct)||0);
  const monTile=monXp>0?`<div><b>${formatNumber(monXp)}</b><small>${t('offline.pokemonXp')}</small></div>`:'';
  const reserveXp=Math.max(0,Number(report.reserve_xp)||0);
  const monNote=(monXp>0
    ?`<p>${t('offline.pokemonShare',{pct:Math.round(monPct)})}</p>`
    :`<p class="offline-report-locked">${t('offline.pokemonLocked')}</p>`)
    +(reserveXp>0?`<p>${t('offline.reserveShare',{xp:formatNumber(reserveXp)})}</p>`
      :(report.vip?`<p class="offline-report-locked">${t('offline.reserveNone')}</p>`:`<p class="offline-report-locked">${t('offline.reserveVipOnly')}</p>`));
  const stopNote=`<p class="offline-report-stop">${t('offline.stopLabel')}: ${offlineStopReasonLabel(report.stop_reason)}</p>`;
  body.innerHTML=`<div class="offline-report-summary"><div><b>${formatHuntDuration(Math.round((report.hours||0)*3600))}</b><small>${t('offline.time')}</small></div><div><b>${formatNumber(report.kills)}</b><small>${t('hunt.defeated')}</small></div><div><b>${formatNumber(report.xp)}</b><small>${t('offline.trainerXp')}</small></div>${monTile}</div><p>${t('offline.serverEfficiency',{pct:pctLabel})}</p>${stopNote}${monNote}${rows.length?`<div class="offline-report-drops">${rows.map(([slug,qty])=>`<div>${itemIcon(slug)}<span>${displayItem(slug)}</span><b>x${formatNumber(qty)}</b></div>`).join('')}</div>`:`<p>${t('offline.noDrops')}</p>`}`;
  const btn=$('#offlineClaimButton');
  if(btn){btn.textContent=t('offline.gotIt');btn.onclick=()=>$('#offlineReportDialog')?.classList.add('hidden')}
  $('#offlineReportDialog')?.classList.remove('hidden');
}
function prepareOfflineReport(){
  if(state.pendingOfflineReport){showOfflineReport();return}
  const hunt=state.offlineHunt;if(!hunt)return;
  const elapsedMs=Math.max(0,Date.now()-hunt.startedAt);if(elapsedMs<300000){state.offlineHunt=null;save();return}
  const hours=Math.min(elapsedMs/3600000,hunt.capHours||4),yieldFactor=.5,sample=hunt.sample||{};
  const drops={};for(const [slug,rate] of Object.entries(sample.itemsPerHour||{})){const qty=Math.floor(rate*hours*yieldFactor);if(qty>0)drops[slug]=qty}
  state.pendingOfflineReport={hours,kills:Math.floor((sample.killsPerHour||0)*hours*yieldFactor),xp:Math.floor((sample.xpPerHour||0)*hours*yieldFactor),drops,pokemon:hunt.pokemon||[],typeIndex:hunt.typeIndex,rangeIndex:hunt.rangeIndex};
  state.offlineHunt=null;save();showOfflineReport();
}
function showOfflineReport(){
  const report=state.pendingOfflineReport,body=$('#offlineReportBody');if(!report||!body)return;
  const rows=Object.entries(report.drops||{}).filter(([slug,qty])=>qty>0&&ITEM_BY_SLUG[slug]);
  body.innerHTML=`<div class="offline-report-summary"><div><b>${formatHuntDuration(Math.round(report.hours*3600))}</b><small>${t('offline.time')}</small></div><div><b>${formatNumber(report.kills)}</b><small>${t('hunt.defeated')}</small></div><div><b>${formatNumber(report.xp)}</b><small>XP</small></div></div><p>${t('offline.efficiency')}</p>${rows.length?`<div class="offline-report-drops">${rows.map(([slug,qty])=>`<div>${itemIcon(slug)}<span>${displayItem(slug)}</span><b>x${formatNumber(qty)}</b></div>`).join('')}</div>`:`<p>${t('offline.noDrops')}</p>`}`;
  $('#offlineReportDialog')?.classList.remove('hidden');renderOfflineStatus();
}
function closeOfflineReport(){$('#offlineReportDialog')?.classList.add('hidden')}
function claimOfflineReport(){
  if(serverGameplayReady()){
    state.pendingOfflineReport=null;closeOfflineReport();renderOfflineStatus();save();
    showToast(t('offline.serverDisabled'));
    return;
  }
  const report=state.pendingOfflineReport;if(!report)return;
  const perks=trainerAccountPerks(),trainerXp=Math.max(0,Math.round(report.xp||0)),pokemonXp=Math.max(0,Math.round(trainerXp*(perks.pokemonXpMultiplier||1)/(perks.trainerXpMultiplier||1)));
  state.stats.defeated+=report.kills;state.stats.xp+=trainerXp;if(trainerXp>0){grantTrainerXp(trainerXp);grantStarterXp(pokemonXp);grantReserveXp(pokemonXp)}
  const species=report.pokemon||[],researchMultiplier=trainerAccountPerks().researchMultiplier;if(species.length){const each=Math.floor(report.kills/species.length),remainder=report.kills%species.length;species.forEach((name,index)=>state.shinyResearch[name]=(state.shinyResearch[name]||0)+(each+(index<remainder?1:0))*researchMultiplier)}
  for(const [slug,qty] of Object.entries(report.drops||{})){state.drops[slug]=(state.drops[slug]||0)+qty;addNavNotification('inventory',qty,slug)}
  state.pendingOfflineReport=null;closeOfflineReport();renderStats();renderDropBag();renderPlayerInventory();renderTrainerHud();renderOfflineStatus();save();showToast(t('offline.claimed'));
}
function trainerSprite(){
  const slug=state.trainer?.sprite;
  if(isValidTrainerSprite(slug)||slug==='trainer')return slug;
  return state.starter?'trainer':DEFAULT_TRAINER_SPRITE;
}
function trainerOutfitColors(){
  return normalizeOutfitColors(state.trainer?.colors);
}
function usesOutfitColors(name){
  return isValidTrainerSprite(name);
}
async function applyActorSprite(img,name,dir,frame,{shiny=false}={}){
  if(!img)return;
  const base=entityAsset(name,dir,frame,{shiny});
  const request=`${name}|${dir}|${frame}|${shiny?'shiny':'normal'}|${usesOutfitColors(name)?outfitColorsKey(trainerOutfitColors()):'raw'}`;
  img.dataset.actorRequest=request;
  img.onerror=()=>{
    const key=`${shiny?'shiny-':''}${name}-${dir}-${frame}`;
    missingActorFrames.add(key);
    if(frame!==0)applyActorSprite(img,name,dir,0,{shiny});
    else img.style.opacity='.2';
  };
  if(!usesOutfitColors(name)){
    if(img.getAttribute('src')!==base)img.src=base;
    return;
  }
  try{
    const url=await compositeOutfitSprite(base,entityMaskAsset(name,dir,frame),trainerOutfitColors());
    if(img.dataset.actorRequest===request)img.src=url;
  }catch{
    if(img.dataset.actorRequest===request&&img.getAttribute('src')!==base)img.src=base;
  }
}
/** Aplica sprite de NPC da cidade; tints `colors` quando o look tem máscara. */
// `trim`: retratos pequenos (menu de teleporte) precisam do sprite recortado na
// caixa de pixels opacos, porque os PNGs de entidade têm enquadramentos bem
// diferentes entre si. No mundo o PNG cru vale — lá quem posiciona é o wrapper.
async function applyNpcSprite(img,npc,{trim=false}={}){
  if(!img||!npc)return;
  const name=npc.sprite||'meowth';
  const base=entityAsset(name,'south',0);
  const colors=npc.colors&&isValidTrainerSprite(name)?normalizeOutfitColors(npc.colors):null;
  const request=`npc|${npc.id}|${name}|${colors?outfitColorsKey(colors):'raw'}|${trim?'trim':'raw'}`;
  img.dataset.npcSpriteRequest=request;
  const paint=async src=>{
    const url=trim?await trimmedSpriteUrl(src):src;
    if(img.dataset.npcSpriteRequest===request&&img.getAttribute('src')!==url)img.src=url;
  };
  if(trim)await paint(base);
  else if(img.getAttribute('src')!==base)img.src=base;
  if(!colors)return;
  try{
    const url=await compositeOutfitSprite(base,entityMaskAsset(name,'south',0),colors);
    await paint(url);
  }catch{
    await paint(base);
  }
}
let combatFeedbackTimer=null,combatFeedbackCloseAnim=null,combatFeedbackDeadline=0;
const COMBAT_FEEDBACK_MS=4000;
function hideCombatFeedback(){
  clearTimeout(combatFeedbackTimer);combatFeedbackTimer=null;combatFeedbackDeadline=0;
  const box=$('#combatFeedback');
  if(!box||box.classList.contains('hidden')||box.classList.contains('closing'))return;
  box.classList.remove('paused');box.classList.add('closing');
  clearTimeout(combatFeedbackCloseAnim);
  combatFeedbackCloseAnim=setTimeout(()=>{box.classList.add('hidden');box.classList.remove('closing')},220);
}
function restartCombatFeedbackTimer({extend=true}={}){
  const now=performance.now();
  combatFeedbackDeadline=extend?now+COMBAT_FEEDBACK_MS:transientDeadline(now,combatFeedbackDeadline,COMBAT_FEEDBACK_MS);
  $('#combatFeedback')?.style.setProperty('--combat-feedback-duration',`${COMBAT_FEEDBACK_MS}ms`);
  const bar=$('#combatFeedbackTimer');
  if(bar){bar.style.animation='none';void bar.offsetWidth;bar.style.animation=''}
  clearTimeout(combatFeedbackTimer);
  combatFeedbackTimer=setTimeout(hideCombatFeedback,Math.max(0,combatFeedbackDeadline-now));
}
function animateCombatNumber(el,target){
  const raw=target|0;
  const sign=raw<0?'':'+';
  const to=Math.max(0,raw);
  if(raw<=0||matchMedia('(prefers-reduced-motion: reduce)').matches){el.textContent=`${sign}${formatNumber(raw)}`;return}
  const start=performance.now(),duration=450;
  const step=now=>{
    if(!el.isConnected)return;
    const p=Math.min(1,(now-start)/duration),eased=1-Math.pow(1-p,3);
    el.textContent=`+${formatNumber(Math.round(to*eased))}`;
    if(p<1)requestAnimationFrame(step);
  };
  requestAnimationFrame(step);
}
function showCombatFeedback({name,trainerXp,pokemonXp,trainerLevels=[],pokemonLevels=[],drops=[]}){
  const box=$('#combatFeedback'),rows=$('#combatFeedbackRows'),titleEl=$('#combatFeedbackTitle');
  if(!box||!rows||!titleEl)return;
  const wasVisible=!box.classList.contains('hidden')&&!box.classList.contains('closing');
  const fmt=n=>formatNumber(n);
  titleEl.textContent=t('battle.defeatedTitle',{name:title(name)});
  const sprite=$('#combatFeedbackSprite');
  if(sprite){
    const src=asset(name);
    sprite.style.opacity='';sprite.onerror=()=>{sprite.style.opacity='.2'};
    if(sprite.dataset.sprite!==src){sprite.src=src;centerPortrait(sprite)}
  }
  $('#combatFeedbackPortrait')?.style.setProperty('--slot-color',typeColors[primaryTypeFor(name)]||'#82765b');
  const levelNote=(label,levels)=>levels.length?`<div class="combat-feedback-level">⬆ ${t('battle.levelUp',{name:label,level:levels[levels.length-1]})}</div>`:'';
  // Sinal derivado do valor: com '+' fixo um delta negativo virava "+-39" na
  // tela e o jogador lia como perda de XP.
  const signed=xp=>`${(xp|0)<0?'':'+'}${fmt(xp)}`;
  const block=(xp,label,note)=>`
    <div class="combat-feedback-block">
      <div class="combat-feedback-line"><b data-count="${xp|0}">${signed(xp)}</b><span>${label}</span></div>
      <div class="combat-feedback-total">= ${fmt(xp)} ${t('battle.total')}</div>
      ${note}
    </div>`;
  const dropChips=drops.filter(d=>ITEM_BY_SLUG[d.slug]).map(d=>`<span class="combat-feedback-drop${d.rare?' rare':''}" title="${displayItem(d.slug)}">${itemIcon(d.slug)}<b>×${fmt(d.qty)}</b></span>`).join('');
  const dropsBlock=dropChips?`
    <div class="combat-feedback-block combat-feedback-drops">
      <span class="combat-feedback-drops-label">${t('battle.drops')}</span>
      <div class="combat-feedback-drop-list">${dropChips}</div>
    </div>`:'';
  rows.innerHTML=block(trainerXp,t('battle.expTrainer'),levelNote(t('profile.trainer'),trainerLevels))
    +block(pokemonXp,t('battle.expPokemon'),levelNote(title(state.starter?.name||'Pokémon'),pokemonLevels))
    +dropsBlock;
  rows.querySelectorAll('.combat-feedback-line b').forEach(b=>animateCombatNumber(b,Number(b.dataset.count)));
  clearTimeout(combatFeedbackCloseAnim);
  box.classList.remove('hidden','closing','paused');
  restartCombatFeedbackTimer({extend:!wasVisible});
}
// Loot pré-rolado pelo servidor no encounter (wild.serverLoot: {slug:qty}) →
// mesmo formato do rollDrops local, para mostrar na hora do kill.
function serverLootToDrops(lootObj){
  return Object.entries(lootObj||{})
    .filter(([slug,qty])=>Number(qty)>0&&ITEM_BY_SLUG[slug])
    .map(([slug,qty])=>({slug,qty:Number(qty),name:displayItem(slug),rare:!!ITEM_BY_SLUG[slug]?.rare}));
}
/* Demo local do toast de combate (console): __combatFeedbackDemo({name:'pichu',trainerXp:99,...}) */
if(location.hostname==='localhost')window.__combatFeedbackDemo=(o={})=>{
  const slugs=Object.keys(ITEM_BY_SLUG).slice(0,2);
  showCombatFeedback({name:'gengar',trainerXp:6008,pokemonXp:6008,trainerLevels:[],pokemonLevels:[],drops:slugs.map((slug,i)=>({slug,qty:i?1:2,rare:i===1})),...o});
};
if(location.hostname==='localhost')window.__levelUpDemo=(level=state.trainer?.level||2)=>showLevelUpBanner(level);
function renderPartnerHud(){
  const p=ensureStarterCombat();
  if(!p){clearPartnerHud();return}
  const shiny=!!state.starter?.shiny,hudSprite=$('#partnerHudSprite'),row=hudSprite?.closest('.team-pokemon-row'),portrait=hudSprite?.closest('.team-pokemon-portrait'),shinyClasses=shinyClassFor(p);
  for(const node of [row,portrait])if(node){node.classList.remove('shiny','shiny-real','shiny-fallback');node.classList.add(...shinyClasses.split(' ').filter(Boolean))}
  row?.classList.add('active');row?.setAttribute('data-active-label','ACTIVE');
  $('#partnerHudName').textContent=title(p.name);$('#partnerHudLevel').textContent=p.level;
  const spriteSrc=entityAsset(p.name,'south',0,{shiny:!!p.shiny});if(hudSprite.dataset.sprite!==spriteSrc){hudSprite.src=spriteSrc;centerPortrait(hudSprite)}
  row?.style.setProperty('--slot-color',typeColors[p.types[0]]||'#777');paintTypeBadge($('#partnerHudType'),p.types);
  $('#partnerHpBar').style.width=Math.max(0,p.currentHp/p.maxHp*100)+'%';setHpState($('#partnerHpBar').parentElement,p.currentHp/p.maxHp);
  const progressValue=state.starter.xp,progressMax=xpToNext(p.level),masteryLabel=p.level>=300?` · M${p.masteryLevel}${p.masteryLevel<50?` ${p.masteryXp}/${pokemonMasteryXpToNext(p.masteryLevel)}`:''}`:'';
  $('#partnerExpBar').style.width=Math.max(0,Math.min(100,progressValue/progressMax*100))+'%';$('#partnerHpText').textContent=`${p.currentHp}/${p.maxHp} HP · ${progressValue}/${progressMax} EXP${masteryLabel}`;
  $('#starterEvolveButton').classList.toggle('hidden',!evolutionRequirement(state.starter));renderRouteReserves();renderCityPartner();const slots=`${1+state.team.length}/6`;if($('#myPokemonCount'))$('#myPokemonCount').textContent=slots;if($('#routeTeamCount'))$('#routeTeamCount').textContent=slots;renderMoveLoadout()
}
function equippedTeamMembers(){
  const members=state.starter?[{key:'starter',kind:'starter',id:null,pokemon:state.starter}]:[];
  for(const id of state.team){const pokemon=state.collection.find(p=>String(p.id)===String(id));if(pokemon)members.push({key:`collection:${pokemon.id}`,kind:'collection',id:pokemon.id,pokemon})}
  return members.slice(0,6)
}
function ensurePokemonLoadout(pokemon){if(!pokemon||!isMovesReady())return;if(pokemon.autoMoves==null)pokemon.autoMoves=!(pokemon.equippedMoves||[]).length;pokemon.equippedMoves=pokemon.autoMoves?defaultLoadout(pokemon.name,pokemon.level):sanitizeLoadout(pokemon.name,pokemon.level,pokemon.equippedMoves);if(pokemon.moveCursor==null)pokemon.moveCursor=0}
function selectedTeamMember(){const members=equippedTeamMembers();return members.find(member=>member.key===teamManagementSelection)||members[0]||null}
function sameMoveLoadout(a,b){return a.length===b.length&&a.every((id,index)=>id===b[index])}
function selectTeamMember(key,discardDraft=false){
  const member=equippedTeamMembers().find(item=>item.key===key)||equippedTeamMembers()[0];if(!member)return;
  if(teamMoveDraftDirty&&!discardDraft&&key!==teamManagementSelection)showToast(t('team.movesDiscarded'));
  teamManagementSelection=member.key;ensurePokemonLoadout(member.pokemon);teamMoveDraft=[...(member.pokemon.equippedMoves||[])];teamMoveDraftDirty=false;renderTeamManagement()
}
function renderMoveLoadout(){if(!$('#teamManagementOverlay')?.classList.contains('hidden'))teamMoveDraftDirty?renderTeamManagement():selectTeamMember(teamManagementSelection,true)}
function renderTeamManagement(){
  const list=$('#teamManagementList'),detail=$('#teamManagementDetail');if(!list||!detail)return;
  const members=equippedTeamMembers();if(!members.length){list.innerHTML='';detail.innerHTML=`<div class="team-management-empty">${t('team.noPartner')}</div>`;return}
  if(!members.some(member=>member.key===teamManagementSelection)){teamManagementSelection=members[0].key;teamMoveDraft=[];teamMoveDraftDirty=false}
  list.innerHTML=Array.from({length:6},(_,index)=>{
    const member=members[index];
    if(!member)return`<div class="team-management-slot empty"><span>${index+1}</span><div><b>${t('common.emptySlot')}</b></div></div>`;
    const p=member.pokemon,types=p.types||speciesTypes(p.name,primaryTypeFor(p.name)),active=member.key===teamManagementSelection?'active':'',r=rarityInfo(p);
    return`<button class="team-management-slot ${active} ${shinyClassFor(p)} ${rarityTierClass(r)}" data-team-member="${member.key}" style="--member-color:${typeColors[types[0]]||'#777'};--rarity:${r.color}"><span>${index+1}</span><img src="${entityAsset(p.name,'south',0,{shiny:!!p.shiny})}" alt="${title(p.name)}"><div><b>${title(p.name)}</b><small>${t('common.lv')} ${p.level}</small><div class="team-slot-badges"><em class="team-slot-rarity">${r.label}</em><em class="team-slot-iv">IV ${formatPokemonIv(p)}</em></div></div></button>`;
  }).join('')+`<button type="button" class="team-open-deposit" id="teamOpenDeposit"><span aria-hidden="true">⌂</span> ${t('deposit.open')}</button>`;
  $$('#teamManagementList [data-team-member]').forEach(button=>button.onclick=()=>selectTeamMember(button.dataset.teamMember));$$('#teamManagementList img').forEach(centerPortrait);
  $('#teamOpenDeposit').onclick=()=>{closeTeamManagement();openHuntWindow('collectionPanel')};
  renderTeamManagementDetail()
}
function renderTeamManagementDetail(){
  const detail=$('#teamManagementDetail'),member=selectedTeamMember();if(!detail||!member)return;const p=member.pokemon;
  ensurePokemonLoadout(p);if(!teamMoveDraft.length&&!teamMoveDraftDirty)teamMoveDraft=[...(p.equippedMoves||[])];
  const primary=primaryTypeFor(p.name),types=p.types||speciesTypes(p.name,primary),stats=statsFor(p.name,primary,p.level,p.ivs,p.mult||1),r=rarityInfo(p);
  const ivLabel=formatPokemonIv(p),evolution=evolutionRequirement(p);
  const unlocked=isMovesReady()?unlockedMoves(p.name,p.level):[],slots=getEquipSlots(),actual=p.equippedMoves||[];teamMoveDraftDirty=!sameMoveLoadout(teamMoveDraft,actual);
  const power=pokemonPower(stats,r.mult);
  detail.innerHTML=`<article class="team-detail-card ${shinyClassFor(p)} ${rarityTierClass(r)}" style="--rarity:${r.color}">
    <header class="team-detail-identity">
      <div class="team-detail-portrait ${shinyClassFor(p)}"><img src="${entityAsset(p.name,'south',0,{shiny:!!p.shiny})}" alt="${title(p.name)}"></div>
      <div class="team-detail-copy">
        <h3>${title(p.name).toUpperCase()}</h3>
        <div class="team-detail-meta"><span class="team-detail-level">${t('team.levelLabel',{level:p.level})}</span><i></i><span class="team-detail-power">${formatNumber(power)} ${t('common.power')}</span></div>
        <div class="team-detail-badges">
          ${types.map(type=>`<em class="team-type-pill" style="--badge:${typeColors[type]||'#777'}">${typeIconCircle(type,typeColors[type]||'#777')}${typeLabel(type,{upper:true})}</em>`).join('')}
          <b class="team-rarity-pill" style="--badge:${r.color}">${r.label}<span>· ×${formatNumber(r.mult,{minimumFractionDigits:2,maximumFractionDigits:2})}</span></b>
        </div>
      </div>
      <div class="team-detail-actions">
        ${member.kind==='collection'?`<button class="team-detail-primary" data-make-primary="${member.id}">${t('team.equipAsPrincipal')}</button>`:`<button class="team-detail-primary current" type="button" disabled>${t('team.principal')}</button>`}
        ${evolution?`<button class="team-detail-evolve" data-evolve-kind="${member.kind}"${member.id!=null?` data-evolve-id="${member.id}"`:''}>${t('team.evolveTo',{name:title(evolution.next)})}</button>`:''}
      </div>
    </header>
    <div class="team-detail-columns">
      <section><div class="team-detail-label"><span>${t('team.status')}</span></div><div class="team-stats-grid">${[['hp',stats.hp],['atk',stats.atk],['def',stats.def],['spa',stats.spa],['spd',stats.spd],['spe',stats.spe]].map(([key,value])=>`<div><span>${t('dex.stat.'+key)}</span><b>${value}</b></div>`).join('')}</div></section>
      <section><div class="team-detail-label"><span>IVS</span><b>${t('team.ivsTotal',{value:ivLabel})}</b></div>${pokemonIvsGrid(p)}</section>
    </div>
    <section class="team-moves-editor"><div class="team-detail-label"><span>${t('team.equippedMoves')}</span><b>${teamMoveDraft.length}/${slots}</b></div>
      <p>${t('team.movesHint')}</p>
      <div class="team-move-slots">${Array.from({length:slots},(_,index)=>{const id=teamMoveDraft[index],move=id?getMove(id):null;return`<button class="team-move-slot ${move?'filled':''}" data-team-move-slot="${index}" ${move?'':'disabled'}${move?` style="--move-color:${typeColors[move.type]||'#777'}"`:''}>${move?`<b>${move.name}</b><span class="move-chip-row"><em class="move-chip move-chip-type">${typeIconCircle(move.type,typeColors[move.type]||'#777')}${typeLabel(move.type)}</em><em class="move-chip">${move.category==='status'?t('common.status'):`${t('common.power')} ${move.power}`}</em><em class="move-chip move-chip-cd">⟳ ${cooldownTurnLabel(moveCooldownTurns(move))}</em></span>`:`<i class="team-move-slot-plus" aria-hidden="true">+</i><b>${t('common.emptySlot')}</b>`}</button>`}).join('')}</div>
      <div class="team-learned-head"><span>${t('common.learned')}</span><b>${unlocked.length}</b></div><div class="team-learned-moves">${unlocked.map(id=>{const move=getMove(id);if(!move)return'';const equipped=teamMoveDraft.includes(id);return`<button class="${equipped?'equipped':''}" data-team-move="${id}" style="--move-color:${typeColors[move.type]||'#777'}"><b>${move.name}</b><span class="move-chip-row"><em class="move-chip move-chip-type">${typeIconCircle(move.type,typeColors[move.type]||'#777')}${typeLabel(move.type)}</em><em class="move-chip">${move.category==='status'?t('common.status'):`${t('common.power')} ${move.power}`}</em>${move.targeting==='area'?`<em class="move-chip">${t('common.area')}</em>`:''}<em class="move-chip move-chip-cd">⟳ ${cooldownTurnLabel(moveCooldownTurns(move))}</em></span></button>`}).join('')||`<div class="team-moves-empty">${t('team.noMoves')}</div>`}</div>
      <div class="team-move-actions"><span class="${teamMoveDraftDirty?'changed':''}">${teamMoveDraftDirty?t('team.movesPending'):t('team.movesSaved')}</span><button id="applyTeamMoves" ${teamMoveDraftDirty?'':'disabled'}>${t('team.applyMoves')}</button></div>
    </section>
    ${renderAoeSlotHtml(p)}
  </article>`;
  centerPortrait(detail.querySelector('.team-detail-portrait img'));
  detail.querySelector('[data-make-primary]')?.addEventListener('click',button=>promoteTeamPokemon(button.currentTarget.dataset.makePrimary));
  detail.querySelectorAll('[data-team-move-slot]').forEach(button=>button.onclick=()=>{teamMoveDraft.splice(+button.dataset.teamMoveSlot,1);teamMoveDraftDirty=true;renderTeamManagementDetail()});
  detail.querySelectorAll('[data-team-move]').forEach(button=>button.onclick=()=>{const id=button.dataset.teamMove,index=teamMoveDraft.indexOf(id);if(index>=0)teamMoveDraft.splice(index,1);else if(teamMoveDraft.length<slots)teamMoveDraft.push(id);else teamMoveDraft[teamMoveDraft.length-1]=id;teamMoveDraftDirty=true;renderTeamManagementDetail()});
  $('#applyTeamMoves').onclick=()=>{p.equippedMoves=sanitizeLoadout(p.name,p.level,teamMoveDraft);p.autoMoves=false;p.moveCursor=0;teamMoveDraft=[...p.equippedMoves];teamMoveDraftDirty=false;routeSim.moveCds={};routeSim.playerTurn=0;save();renderTeamManagementDetail();showToast(t('team.movesApplied',{name:title(p.name)}))}
  bindAoeSlotControls(p);
}
function ownedTmSlugs(){
  const bag={...state.inventory,...state.drops};
  return Object.keys(bag).filter(slug=>slug.startsWith('tm-')&&(bag[slug]|0)>0);
}
function renderAoeSlotHtml(p){
  const unlocked=(p.level||1)>=100;
  const move=p.aoeMove?getMove(p.aoeMove):null;
  const tms=ownedTmSlugs();
  if(!unlocked){
    return`<section class="team-aoe-slot locked"><header><span>${t('team.aoeSlot')}</span><b>${t('team.aoeLocked',{level:100})}</b></header><p>${t('team.aoeEmpty')}</p></section>`;
  }
  return`<section class="team-aoe-slot">
    <header><span>${t('team.aoeSlot')}</span><b>${move?move.name:t('team.aoeEmpty')}</b></header>
    ${move?`<p>${t('common.area')} · ${typeLabel(move.type)}</p>`:`<p>${t('team.aoeEmpty')}</p>`}
    <div class="team-aoe-actions">
      ${move?`<button type="button" data-aoe-unequip="1">${t('team.unequipAoe')}</button>`:''}
      <button type="button" data-aoe-equip-toggle="1">${t('team.equipTm')} (${t('team.tmOwned',{count:tms.length})})</button>
    </div>
    <div class="team-tm-list hidden" id="teamTmList">${tms.length?tms.map(slug=>`<button type="button" data-equip-tm="${slug}">${displayItem(slug)||slug}</button>`).join(''):`<span>${t('team.noTm')}</span>`}</div>
  </section>`;
}
function bindAoeSlotControls(p){
  const detail=$('#teamManagementDetail');if(!detail)return;
  detail.querySelector('[data-aoe-unequip]')?.addEventListener('click',()=>{p.aoeMove=null;save();renderTeamManagementDetail();showToast(t('team.unequipAoe'))});
  detail.querySelector('[data-aoe-equip-toggle]')?.addEventListener('click',()=>{$('#teamTmList')?.classList.toggle('hidden')});
  detail.querySelectorAll('[data-equip-tm]').forEach(btn=>btn.onclick=()=>{
    const slug=btn.dataset.equipTm;
    const item=ITEM_BY_SLUG[slug];
    const moveId=item?.move||slug.replace(/^tm-/,'');
    const move=getMove(moveId);
    if(!move){showToast(t('team.noTm'));return}
    void (async()=>{
      if(serverGameplayReady()){
        const ok=await consumeGameplayItem(slug,1);
        if(!ok){showToast(t('sys.syncFail')||'Item sync failed');return}
      }else if(!spendItem(slug,1)){showToast(t('team.noTm'));return}
      p.aoeMove=move.id;
      save();renderTeamManagementDetail();showToast(t('team.tmApplied',{move:move.name||slug}));
    })();
  });
}
/**
 * Abre o painel "Meus Pokémon" já na ficha de um membro do time.
 * Usado pelos cards do HUD: clicar num Pokémon deve mostrar o Pokémon.
 */
function openTeamMember(key){
  const overlay=$('#teamManagementOverlay');
  if(!equippedTeamMembers().length){showToast(t('team.noPartner'));return}
  if(overlay.classList.contains('hidden'))openTeamManagement();
  selectTeamMember(key,true);
}
function openTeamManagement(){const overlay=$('#teamManagementOverlay'),button=$('#myPokemonNavButton');if(!overlay.classList.contains('hidden')){closeTeamManagement();return}const members=equippedTeamMembers();if(!members.length){showToast(t('team.noPartner'));return}closeHuntWindows();overlay.classList.remove('hidden');button.classList.add('active');button.setAttribute('aria-expanded','true');selectTeamMember(members.some(member=>member.key===teamManagementSelection)?teamManagementSelection:members[0].key,true)}
function closeTeamManagement(){const overlay=$('#teamManagementOverlay'),button=$('#myPokemonNavButton');overlay.classList.add('hidden');button.classList.remove('active');button.setAttribute('aria-expanded','false');teamMoveDraftDirty=false}
const missingActorFrames=new Set();
// Posição dos atores.
//
// Antes usávamos left/top em %, o que força LAYOUT da árvore inteira a cada
// frame — com ~17 mil nós na página isso era o principal custo da hunt. As
// coordenadas continuam em % do mundo, mas viram a propriedade `translate`
// (composição na GPU). `translate` é aplicada ANTES de `transform`, então o
// `transform:translate(-50%,-76%)` que centraliza o sprite continua valendo
// sem precisar ser mesclado aqui.
function setActorPercent(el,xPercent,yPercent){
  if(!el)return;
  el.style.setProperty('--ax',xPercent);
  el.style.setProperty('--ay',yPercent);
}
// O mundo precisa expor o próprio tamanho em px para o calc() de --ax/--ay.
function setWorldMetrics(world,widthPx,heightPx){
  if(!world)return;
  world.style.setProperty('--world-w',`${Math.max(1,Math.round(widthPx))}px`);
  world.style.setProperty('--world-h',`${Math.max(1,Math.round(heightPx))}px`);
}
// Ciclo de caminhada.
//
// O acervo só tem 3 frames por direção. Tocá-los em sequência (0,1,2,0,1,2...)
// dá um "tranco" no retorno, porque o pé volta do fim do passo direto para o
// início. Em ping-pong (0,1,2,1) o movimento lê como ida e volta natural — é o
// truque padrão para ciclos de 3 frames e não custa arte nova.
const WALK_CYCLE=[0,1,2,1];
const WALK_FRAME_MS=130;
const CITY_WALK_FRAME_MS=220;
// Teto para o boot do renderer de tiles liberar o WASD mesmo se as texturas
// nunca resolverem. Generoso de propósito: em conexão ruim o carregamento
// legítimo ainda cabe, e passar disso é preferível a travar o jogador.
const CITY_RENDERER_BOOT_TIMEOUT_MS=12000;
function setActor(el,name,dir,moving,clock,{shiny,frameMs=WALK_FRAME_MS}={}){
  if(!el)return;
  const requestedFrame=moving?WALK_CYCLE[Math.floor(clock/frameMs)%WALK_CYCLE.length]:0;
  const key=`${shiny?'shiny-':''}${name}-${dir}-${requestedFrame}`;
  const frame=missingActorFrames.has(key)?0:requestedFrame;
  const img=el.querySelector('img');
  if(spriteScaleBySlug[entitySlug(name)])el.style.setProperty('--pokemon-sprite-scale',pokemonSpriteScale(name));
  else el.style.removeProperty('--pokemon-sprite-scale');
  // Parado ganha a respiração em CSS; andando, ela sairia por cima do passo.
  el.classList.toggle('idle',!moving);
  if(shiny!==undefined){
    el.classList.remove('shiny','shiny-real','shiny-fallback');
    el.classList.add(...shinyClassFor({name,shiny},'entity').split(' ').filter(Boolean));
  }
  applyActorSprite(img,name,dir,frame,{shiny:!!shiny});
}
function renderCityPartner(){
  const el=$('#cityPartner');if(!el)return;
  el.classList.toggle('hidden',!state.starter);
  if(!state.starter)return;
  $('#cityPartnerLabel').textContent=title(state.starter.name);
  setActor(el,state.starter.name,cityFollower.dir,false,performance.now(),{shiny:!!state.starter.shiny});
}
function resetCityFollower(){
  const back={north:[0,1.35],south:[0,-1.35],east:[-1.2,0],west:[1.2,0]}[cityPlayer.dir]||[0,1.35];
  const candidates=[[cityPlayer.x+back[0],cityPlayer.y+back[1]],[cityPlayer.x-1.2,cityPlayer.y],[cityPlayer.x+1.2,cityPlayer.y],[cityPlayer.x,cityPlayer.y+1.35]];
  const point=candidates.find(([x,y])=>canMoveCity(x,y))||[cityPlayer.x,cityPlayer.y];
  cityFollower.x=point[0];cityFollower.y=point[1];cityFollower.dir=cityPlayer.dir==='north'?'south':cityPlayer.dir==='south'?'north':cityPlayer.dir==='east'?'west':'east';
  cityTrail.length=0;cityTrailLast={x:cityPlayer.x,y:cityPlayer.y};renderCityPartner();updateCityCamera();
}
function recordCityTrail(){
  if(Math.hypot(cityPlayer.x-cityTrailLast.x,cityPlayer.y-cityTrailLast.y)<.16)return;
  cityTrail.push({x:cityPlayer.x,y:cityPlayer.y});cityTrailLast={x:cityPlayer.x,y:cityPlayer.y};
  if(cityTrail.length>90)cityTrail.splice(0,cityTrail.length-90);
}
function moveCityFollower(now,dt){
  const el=$('#cityPartner');if(!el||!state.starter)return;
  const target=cityTrail.length>5?cityTrail[0]:null;
  if(!target){setActor(el,state.starter.name,cityFollower.dir,false,now,{shiny:!!state.starter.shiny});return}
  const dx=target.x-cityFollower.x,dy=target.y-cityFollower.y,distance=Math.hypot(dx,dy);
  if(distance<.1){cityTrail.shift();setActor(el,state.starter.name,cityFollower.dir,false,now,{shiny:!!state.starter.shiny});return}
  const step=Math.min(4.8*dt,distance);cityFollower.x+=dx/distance*step;cityFollower.y+=dy/distance*step;cityFollower.dir=directionFor(dx,dy);
  setActorPercent(el,cityFollower.x,cityFollower.y);setActor(el,state.starter.name,cityFollower.dir,true,now,{shiny:!!state.starter.shiny,frameMs:CITY_WALK_FRAME_MS});
}
let lastEnemyId=null;
function updateEnemyHud(wild){
  if(!wild)return;state.enemy={name:wild.name,level:wild.level};state.enemyHp=wild.hp;
  if(lastEnemyId!==wild.id){lastEnemyId=wild.id;const hud=$('.route-combat-hud');hud.classList.remove('hud-swap');void hud.offsetWidth;hud.classList.add('hud-swap')}
  const bossBadge=wild.boss?`<em class="enemy-boss-badge">${t(wild.zoneMythical?'zone.mythicalBoss':wild.zoneLegendary?'zone.legendaryBoss':'boss.label')}</em>`:'';
  const shinyMark=wild.shiny?'✦ ':'';
  $('#enemyName').innerHTML=`${shinyMark}${title(wild.name)}${bossBadge}`;$('#enemyLevel').textContent=wild.level;paintTypeBadge($('#enemyType'),wild.types);$('#enemyHpBar').style.width=wild.hp+'%';setHpState($('#enemyHpBar').parentElement,wild.hp/100);
}
function createWild(name,index,opts={}){
  const [min,max]=ranges[state.range],routeType=route()[0];
  let level=Math.floor(Math.random()*(max-min+1))+min;
  const allowServerEnc=serverGameplayReady()
    &&!opts.summon&&!opts.forceBoss&&!opts.zoneLegendary&&!opts.zoneMythical&&!opts.species;
  let serverEnc=opts.serverEncounter
    ||(allowServerEnc?takeQueuedEncounterSync({
      route:encounterRouteLevel(),
      routeType:encounterRouteKey(),
      species:state.huntMode==='species'?state.huntSpecies:null,
    }):null);

  // (captura local viraria fantasma no depósito). Refill em background.
  if(allowServerEnc&&!serverEnc){
    ensureEncounterQueue({
      route:encounterRouteLevel(),
      routeType:encounterRouteKey(),
      species:state.huntMode==='species'?state.huntSpecies:null,
      min:Math.max(10,routeWildTargetCount()),
    }).catch(()=>{});
    return null;
  }
  // Boss/especial forjado no client sem encounterId também vira fantasma.
  if(serverGameplayReady()&&!serverEnc&&!opts.summon&&(opts.forceBoss||opts.zoneLegendary||opts.zoneMythical||opts.species)){
    return null;
  }
  if(serverEnc){
    name=serverEnc.species;
    level=serverEnc.encounter_level||level;
  }else if(opts.summon&&name){
    level=opts.level||Math.max(1,level-10);
  }else if(opts.species){
    name=opts.species;
    level=opts.level||state.huntLevel||min;
  }else if(state.huntMode==='species'&&state.huntSpecies){
    name=state.huntSpecies;
    const minLv=speciesMinRouteLevel(name)||1;
    const bandBase=ranges[state.range]?.[0]??min;
    level=opts.level||encounterLevel({minLevel:minLv,maxLevel:isZoneHuntLevel(state.huntLevel)?state.huntLevel:300},bandBase,state.huntDifficulty||0);
    state.huntLevel=level;
  }else if(state.huntMode==='zone'){
    name=name||zoneReinforceSpecies()||speciesForLevel(routeType,level);
    level=state.huntLevel||min;
  }else{
    name=name||speciesForLevel(routeType,level);
  }
  if(opts.level&&!serverEnc)level=opts.level;
  const entry=pokedexEntry(name);
  const speciesRarity=serverEnc?.pokedex_rarity||entry?.rarity||'Comum';
  const researchKills=state.shinyResearch[name]||0;
  let shiny=false;
  if(serverEnc){
    shiny=!!serverEnc.shiny;
  }else if(!state.altarShiny?.server&&state.altarShiny?.species===name&&(state.altarShiny.encounters|0)>0){
    shiny=true;state.altarShiny.encounters--;if(state.altarShiny.encounters<=0)state.altarShiny=null;
  }else{
    shiny=Math.random()<shinyEncounterChance(speciesRarity,researchKills,trainerAccountPerks().shinyMultiplier);
  }
  const typesForWild=speciesTypes(name,routeType);
  const isBoss=serverEnc
    ?!!serverEnc.boss
    :!!opts.forceBoss||(!opts.summon&&shouldRollBossEncounter(level));
  const bossProfile=isBoss?bossProfileFor(bossSpeciesPayload(name,typesForWild),level):null;
  let stats=statsFor(name,routeType,level);
  if(bossProfile){
    const sm=bossProfile.statMult||1.35;
    stats={...stats,
      hp:Math.max(stats.hp,bossProfile.hp||stats.hp),
      atk:Math.round(stats.atk*sm),
      def:Math.round(stats.def*sm),
      spa:Math.round(stats.spa*sm),
      spd:Math.round(stats.spd*sm),
      spe:Math.round(stats.spe*Math.min(sm,1.2)),
    };
  }else if(opts.statMult||opts.hpMult){
    const sm=opts.statMult||1,hm=opts.hpMult||1;
    stats={...stats,hp:Math.round(stats.hp*hm),atk:Math.round(stats.atk*sm),def:Math.round(stats.def*sm),spa:Math.round(stats.spa*sm),spd:Math.round(stats.spd*sm),spe:Math.round(stats.spe*sm)};
  }
  const zone=currentZone();
  if(zone){
    const sm=zone.effects.enemyStatMult||1,hm=zone.effects.enemyHpMult||1;
    stats={...stats,hp:Math.round(stats.hp*hm),atk:Math.round(stats.atk*sm),def:Math.round(stats.def*sm),spa:Math.round(stats.spa*sm),spd:Math.round(stats.spd*sm),spe:Math.round(stats.spe*sm)};
  }
  const wildMaxHp=Math.max(1,Math.round(stats.hp*WILD_HP_MULTIPLIER));
  let [x,y]=routeLand?.landList?.length
    ?pickRandomLandPercent(routeLand,ROUTE_EDGE_MARGIN)
    :constrainRouteLand(50+(Math.random()-.5)*20,50+(Math.random()-.5)*20,ROUTE_EDGE_MARGIN);
  if(opts.near&&Number.isFinite(opts.near.x)){
    x=Math.max(6,Math.min(94,opts.near.x+(Math.random()-.5)*(opts.near.spread||10)));
    y=Math.max(10,Math.min(88,opts.near.y+(Math.random()-.5)*(opts.near.spread||10)));
    if(routeLand?.landList?.length){const snapped=constrainToLand(x,y,routeLand,ROUTE_EDGE_MARGIN);x=snapped[0];y=snapped[1]}
  }else if(routeLand?.landList?.length&&routeSim.player){
    // Prefere spawn alcançável por terra (evita lago entre o partner e o alvo).
    for(let attempt=0;attempt<10;attempt++){
      const[px,py]=pickRandomLandPercent(routeLand,ROUTE_EDGE_MARGIN);
      if(!landPathBlocked(routeSim.player.x,routeSim.player.y,px,py,routeLand)){
        x=px;y=py;break;
      }
      if(attempt===9){x=px;y=py}
    }
  }
  const roam=routeType==='água'?2.8:(state.huntMode==='zone'?4.2:7.5);
  if(shiny){addLog(t('shiny.wildAppeared',{name:title(name)}),`✦ ${title(name)}`);showToast(t('shiny.wildAppeared',{name:title(name)}))}
  const wild={
    id:`wild-${Date.now()}-${index}-${Math.floor(Math.random()*1e6)}`,
    name,level:opts.level&&!serverEnc?opts.level:level,types:typesForWild,stats,
    currentHp:wildMaxHp,maxHp:wildMaxHp,hp:100,x,y,homeX:x,homeY:y,roamRadius:roam,dir:'south',
    wander:Math.random()*Math.PI*2,captureOffered:false,engaged:false,moveCds:{},combatTurn:0,shiny,boss:!!bossProfile,bossProfile,
    summon:!!opts.summon,speciesRarity,zonePack:opts.zonePack??null,
    zoneLegendary:!!opts.zoneLegendary||!!serverEnc?.zone_special&&serverEnc?.pokedex_rarity==='Lendário',
    zoneMythical:!!opts.zoneMythical||!!serverEnc?.zone_special&&serverEnc?.pokedex_rarity==='Mítico',
    spawnedAt:performance.now(),
    encounterId:serverEnc?.id||null,
    serverLoot:serverEnc?.loot||null,
    specimenRarity:serverEnc?.species_rarity||null,
    specimenMult:serverEnc?.rarity_mult||null,
    speciesFactor:serverEnc?.species_factor||null,
    serverLegendary:!!serverEnc?.legendary,
  };
  return wild;
}
function spawnBossSummons(boss){
  if(!boss?.boss||!boss.bossProfile)return;
  const pool=(typeof allPokedexSpecies==='function'?allPokedexSpecies():[]).map(entry=>({
    slug:entry.slug||entry.name,types:entry.types||speciesTypes(entry.slug||entry.name),
  })).filter(entry=>entry.slug);
  const summons=rollBossSummons(boss.bossProfile,pool,{level:boss.level,excludeSpecies:boss.name});
  let spawned=0;
  for(const summon of summons){
    if(routeSim.wilds.length>=ROUTE_WILD_MAX)break;
    const add=createWild(summon.species,routeSim.wilds.length,{summon:true,level:summon.level,hpMult:summon.hpMult,statMult:summon.statMult,near:{x:boss.x,y:boss.y}});
    if(add){routeSim.wilds.push(add);spawned++}
  }
  if(spawned){showToast(t('boss.adds',{count:spawned}));renderWilds()}
}
function wildLabelMarkup(w){
  return`${w.shiny?'✦ ':''}${title(w.name)}${w.boss?`<span class="wild-boss-tag">${t(w.zoneLegendary?'zone.legendaryBoss':'boss.label')}</span>`:''}<span>${t('common.lv')} ${w.level}</span><div class="wild-hp"><i style="width:${w.hp}%"></i></div>`;
}
/**
 * Sincroniza a camada de selvagens com routeSim.wilds.
 *
 * Antes isto era um `innerHTML=` que refazia os 12 atores a cada spawn — e
 * spawn acontece a cada abate. Recriar o nó zera qualquer animação em curso:
 * o recuo de dano morria antes de aparecer, a respiração de idle reiniciava
 * sem parar, a classe .target sumia e os 12 <img> eram decodificados de novo.
 * Agora reconciliamos por id: cria o que entrou, remove o que saiu, e mexe
 * apenas no que mudou de fato.
 */
function renderWilds(){
  const layer=$('#routeEntityLayer');if(!layer)return;
  const vivos=new Set();
  for(const w of routeSim.wilds){
    vivos.add(String(w.id));
    let el=document.getElementById(w.id);
    if(!el){
      el=document.createElement('div');
      el.id=w.id;
      el.innerHTML=`<img src="${entityAsset(w.name,w.dir,0)}" alt="${title(w.name)}"><div class="wild-label"></div>`;
      layer.appendChild(el);
    }
    const shinyClasses=shinyClassFor(w,'entity');
    const classes=`wild-actor${shinyClasses?` ${shinyClasses}`:''}${w.boss?' boss':''}${w.zoneLegendary?' zone-legendary':''}`;
    // Preserva as classes de estado (hit/idle/target) que o loop de combate e
    // o de animação aplicam — só reescreve se a identidade mudou.
    if(el.dataset.wildClasses!==classes){
      el.dataset.wildClasses=classes;
      for(const c of ['wild-actor','shiny','shiny-real','shiny-fallback','boss','zone-legendary'])el.classList.remove(c);
      el.classList.add(...classes.split(' '));
    }
    applyActorSprite(el.querySelector('img'),w.name,w.dir,0,{shiny:!!w.shiny});
    setActorPercent(el,w.x,w.y);
    const scale=String(pokemonSpriteScale(w.name));
    if(el.dataset.wildScale!==scale){
      el.dataset.wildScale=scale;
      el.style.setProperty('--pokemon-sprite-scale',scale);
    }
    const label=el.querySelector('.wild-label');
    const assinatura=`${w.name}|${w.level}|${w.shiny?1:0}|${w.boss?1:0}|${w.zoneLegendary?1:0}`;
    if(label&&label.dataset.sig!==assinatura){
      label.dataset.sig=assinatura;
      label.innerHTML=wildLabelMarkup(w);
    }
    const barra=label?.querySelector('.wild-hp i');
    if(barra)barra.style.width=`${w.hp}%`;
  }
  for(const el of [...layer.children]){
    if(!vivos.has(el.id))el.remove();
  }
}
// População de selvagens. Com o mapa em tiles o mundo ficou muito maior que na
// época em que 12 foi escolhido, e o parceiro passava boa parte da caça só se
// deslocando. Adensar encurta o trajeto até a próxima presa sem acelerar nada.
// O teto acompanha para zonas com invocações de chefe.
const ROUTE_WILD_COUNT=22,ROUTE_WILD_MAX=40;
const ZONE_CORNER_ANCHORS=Object.freeze([
  Object.freeze({x:16,y:20}),
  Object.freeze({x:84,y:20}),
  Object.freeze({x:16,y:80}),
  Object.freeze({x:84,y:80}),
]);
function routeWildTargetCount(){
  const level=ranges[state.range]?.[0]||0;
  if(state.huntMode==='zone')return 24;
  return level>=200?16:ROUTE_WILD_COUNT;
}
function zonePoolSlugs(){
  return speciesHuntEntries({band:state.range})
    .filter((row)=>row.zone&&!row.legendaryBoss)
    .map((row)=>row.slug)
    .filter(Boolean);
}
function zonePackSize(level){
  const base=level>=500?6:level>=400?5:4;
  const jitter=level>=450?0:Math.floor(Math.random()*2);
  return Math.max(4,Math.min(6,base+jitter));
}
function shuffleInPlace(list){
  for(let i=list.length-1;i>0;i--){
    const j=Math.floor(Math.random()*(i+1));
    [list[i],list[j]]=[list[j],list[i]];
  }
  return list;
}
function zoneReinforceSpecies(){
  const packs=routeSim.zonePacks||[];
  if(!packs.length)return null;
  const living=new Map();
  for(const wild of routeSim.wilds){
    if(wild.summon||wild.boss)continue;
    living.set(wild.name,(living.get(wild.name)||0)+1);
  }
  const under=[...packs].filter((pack)=> (living.get(pack.species)||0)<pack.targetCount)
    .sort((a,b)=>((living.get(a.species)||0)/a.targetCount)-((living.get(b.species)||0)/b.targetCount));
  return under[0]?.species||packs[Math.floor(Math.random()*packs.length)]?.species||null;
}
function spawnZoneCornerPacks(){
  const level=state.huntLevel||ranges[state.range]?.[0]||ZONE_HUNT_MIN_LEVEL;
  const zone=zoneConfigForBand(state.range);
  const pool=shuffleInPlace([...new Set(zonePoolSlugs())]);
  if(!pool.length){
    for(let i=0;i<routeWildTargetCount();i++){
      const wild=createWild(null,i);
      if(wild)routeSim.wilds.push(wild);
    }
    return;
  }
  const cornerCount=Math.min(4,Math.max(1,pool.length));
  routeSim.zonePacks=[];
  for(let i=0;i<cornerCount;i++){
    const species=pool[i%pool.length];
    const anchor=ZONE_CORNER_ANCHORS[i];
    const count=zonePackSize(level);
    routeSim.zonePacks.push({species,x:anchor.x,y:anchor.y,targetCount:count});
    for(let n=0;n<count;n++){
      if(routeSim.wilds.length>=ROUTE_WILD_MAX)break;
      routeSim.wilds.push(createWild(species,routeSim.wilds.length,{
        species,
        level,
        zonePack:i,
        near:{x:anchor.x,y:anchor.y,spread:8},
      }));
    }
  }
  if(Math.random()<0.7&&routeSim.wilds.length<ROUTE_WILD_MAX){
    const bossSpecies=pool[Math.floor(Math.random()*pool.length)];
    const boss=createWild(bossSpecies,routeSim.wilds.length,{
      species:bossSpecies,
      level,
      forceBoss:true,
      near:{x:50,y:50,spread:6},
    });
    routeSim.wilds.push(boss);
    spawnBossSummons(boss);
  }
}
let routePopulationRetryTimer=null;
let routePopulationRetryAttempts=0;
async function spawnRoutePopulation(loadId=routeLandLoadId){
  if(loadId!==routeLandLoadId)return;
  routeSim.wilds=[];
  routeSim.zonePacks=[];
  if(serverGameplayReady()){
    await ensureEncounterQueue({
      route:encounterRouteLevel(),
      routeType:encounterRouteKey(),
      species:state.huntMode==='species'?state.huntSpecies:null,
      min:Math.max(10,routeWildTargetCount()),
    }).catch(error=>console.warn('encounter batch failed',error));
    if(loadId!==routeLandLoadId)return;
  }
  if(state.huntMode==='zone'&&!serverGameplayReady()){
    spawnZoneCornerPacks();
  }else if(state.huntMode==='zone'&&serverGameplayReady()){
    // Zona: popula a partir do lote server (sem packs locais forjados)
    const count=routeWildTargetCount();
    for(let i=0;i<count;i++){
      const wild=createWild(null,i);
      if(wild)routeSim.wilds.push(wild);
    }
    for(const wild of[...routeSim.wilds]){if(wild.boss)spawnBossSummons(wild)}
  }else{
    const count=routeWildTargetCount();
    for(let i=0;i<count;i++){
      const wild=createWild(null,i);
      if(wild)routeSim.wilds.push(wild);
    }
    for(const wild of[...routeSim.wilds]){if(wild.boss)spawnBossSummons(wild)}
  }
  if(serverGameplayReady()&&!routeSim.wilds.length){
    routeSim.target=null;
    $('#battleStatus').textContent=t('battle.searchingNext');
    renderWilds();
    if(routePopulationRetryAttempts<5){
      const attempt=++routePopulationRetryAttempts;
      clearTimeout(routePopulationRetryTimer);
      routePopulationRetryTimer=setTimeout(()=>{
        routePopulationRetryTimer=null;
        spawnRoutePopulation(loadId).catch(error=>console.warn('route population retry failed',error));
      },Math.min(3000,400*attempt));
    }
    return;
  }
  routePopulationRetryAttempts=0;
  routeSim.target=null;routeSim.spawnTimer=0;
  renderWilds();
}
async function addWild(){
  if(routeSim.wilds.length>=ROUTE_WILD_MAX)return;
  if(serverGameplayReady()){
    // Prefetch sem bloquear spawn se a fila já tem itens
    if(encounterQueueLength()<10){
      ensureEncounterQueue({
        route:encounterRouteLevel(),
        routeType:encounterRouteKey(),
        species:state.huntMode==='species'?state.huntSpecies:null,
        min:10,
      }).catch(()=>{});
    }
  }
  if(state.huntMode==='zone'){
    const packs=routeSim.zonePacks||[];
    const living=new Map();
    for(const wild of routeSim.wilds){
      if(wild.summon||wild.boss)continue;
      living.set(wild.name,(living.get(wild.name)||0)+1);
    }
    const under=packs.find((pack)=>(living.get(pack.species)||0)<pack.targetCount);
    if(under){
      const wild=createWild(under.species,routeSim.wilds.length,{
        species:under.species,
        level:state.huntLevel||ranges[state.range]?.[0],
        zonePack:packs.indexOf(under),
        near:{x:under.x,y:under.y,spread:8},
      });
      if(wild)routeSim.wilds.push(wild);
      renderWilds();
      return;
    }
    const zone=zoneConfigForBand(state.range);
    if(!routeSim.wilds.some((w)=>w.boss)&&Math.random()<0.25){
      const pool=zonePoolSlugs();
      const bossSpecies=pool[Math.floor(Math.random()*pool.length)];
      if(bossSpecies){
        const boss=createWild(bossSpecies,routeSim.wilds.length,{
          species:bossSpecies,
          level:state.huntLevel||ranges[state.range]?.[0],
          forceBoss:true,
          near:{x:50,y:50,spread:6},
        });
        if(boss){
          routeSim.wilds.push(boss);
          spawnBossSummons(boss);
          renderWilds();
          return;
        }
      }
    }
  }
  const wild=createWild(null,routeSim.wilds.length);
  if(!wild)return;
  routeSim.wilds.push(wild);
  if(wild.boss)spawnBossSummons(wild);
  renderWilds();
}
/* 15 faixas → 15 mapas de região (world-region-XX-*.webp; 11–14 reusam arte do 10). */
const rangeThemes=[
  {name:'Saffron Meadows',sky:'#7ea086',land1:'#5a8054',land2:'#7a9a64',accent:'#f0e5b4'},
  {name:'Viridian Trail',sky:'#6a8a6e',land1:'#3f6a44',land2:'#5a8054',accent:'#c8e090'},
  {name:'Pewter Forests',sky:'#5a7a6a',land1:'#2f5f3e',land2:'#456b4a',accent:'#b6d585'},
  {name:'Pewter Woods',sky:'#4e7460',land1:'#2a5538',land2:'#3f6848',accent:'#a8d070'},
  {name:'Rock Tunnel Swamps',sky:'#4a5a5e',land1:'#3a4f48',land2:'#566860',accent:'#8aa590'},
  {name:'Rock Tunnel Caves',sky:'#3e4e52',land1:'#2e3f3a',land2:'#4a5850',accent:'#7a9588'},
  {name:'Cinnabar Volcano',sky:'#6a3a3a',land1:'#5a2620',land2:'#8a3a2c',accent:'#f0a050'},
  {name:'Cinnabar Ashes',sky:'#5a3038',land1:'#4a1e22',land2:'#7a3228',accent:'#e09060'},
  {name:'Legendary Isles',sky:'#3a4a7e',land1:'#28406e',land2:'#4a6092',accent:'#e0e0f5'},
  {name:'Glacial Sea',sky:'#2a3a6e',land1:'#1e3058',land2:'#3a5080',accent:'#b0d0f0'},
  {name:'Supreme Threshold',sky:'#2a2038',land1:'#1a1428',land2:'#3a3050',accent:'#f0d080'},
  {name:'Ashen Spire',sky:'#3a2438',land1:'#241428',land2:'#4a3050',accent:'#f0a080'},
  {name:'Obsidian Court',sky:'#241828',land1:'#180e1e',land2:'#3a2848',accent:'#e0b060'},
  {name:'Eclipse Rift',sky:'#1e1428',land1:'#120a18',land2:'#322040',accent:'#d090ff'},
  {name:'Final Horizon',sky:'#140c1c',land1:'#0c0612',land2:'#281830',accent:'#ffd070'},
];
function clampBand(band){
  return Math.max(0,Math.min(ranges.length-1,Number(band)||0));
}
function bandForZoneDefault(){
  const current=clampBand(mapPreviewRange);
  if(isZoneHuntLevel(ranges[current]?.[0]))return current;
  const firstZone=ranges.findIndex((range)=>isZoneHuntLevel(range[0]));
  return firstZone>=0?firstZone:current;
}
function routeNodePosition(typeName,band=mapPreviewRange){
  const layout=routeNodeAnchorsForBand(band);
  return layout[typeName]||[50,50];
}
function routeLevelLabel(band=state.range){
  const zone=zoneConfigForBand(band);
  return zone?t(zone.tier===0?'zone.apex':'zone.threatTier',{tier:zone.tier}):`${t('common.lv')} ${ranges[band]?.[0]??1}`;
}
function zoneLockHint(access){
  if(access.unlocked)return'';
  return access.missing.map(item=>t(`zone.requirement.${item.key}`,{value:item.required})).join(' · ');
}
function renderMapRanges(){
  const trainerLevel=trainerAccessLevel();
  const rangeButtons=ranges.map((r,i)=>{const required=ROUTE_UNLOCK_LEVELS[i]||1,zoneAccess=zoneAccessForBand(i),locked=trainerLevel<required||!zoneAccess.unlocked,hint=trainerLevel<required?t('map.unlockAt',{level:required}):zoneLockHint(zoneAccess);return`<button class="${state.mapMode==='ranges'&&i===mapPreviewRange?'active':''} ${locked?'range-locked':''}" data-range="${i}" title="${locked?hint:t('map.routeUnlocked')}">${locked?'🔒 ':''}${routeLevelLabel(i)}</button>`}).join('');
  const bossesBtn=`<button class="bosses-tab ${state.mapMode==='bosses'?'active':''}" data-mode="bosses">${t('map.bosses')}</button>`;
  $('#mapRangeSwitch').innerHTML=rangeButtons+bossesBtn;
  $$('#mapRangeSwitch button[data-range]').forEach(b=>b.onclick=()=>{state.mapMode='ranges';mapPreviewRange=+b.dataset.range;renderMapRanges();renderMapRoutes()});
  const bosses=$('#mapRangeSwitch button[data-mode="bosses"]');
  if(bosses)bosses.onclick=()=>{state.mapMode='bosses';renderMapRanges();renderMapRoutes();save()};
}
function worldmapSrc(band){
  const entry=worldMapEntry(band);
  return `public/assets/world/${entry.file}?v=${WORLD_MAP_ART_VERSION}`;
}
function worldmapWireframeSrc(band){
  const entry=worldMapEntry(band);
  return `public/assets/world/${entry.wireframe}?v=${WORLD_MAP_ART_VERSION}`;
}
function routeMapSrc(slug,rangeIndex,tier=activeHuntArtTier()){
  return `public/assets/world/route-${slug}-r${tier}-original.webp?v=${WORLD_MAP_ART_VERSION}`;
}
function typeOnRouteBand(typeName,band){
  return(ranges[band]?.[0]??1)>=typeUnlockLevel(typeName);
}
function routeNodeMeta(typeName,band,trainerLevel){
  const rangeRequired=ROUTE_UNLOCK_LEVELS[band]||1;
  const typeRequired=typeUnlockLevel(typeName);
  const routeLevel=ranges[band]?.[0]??1;
  const rangeOk=trainerLevel>=rangeRequired;
  const typeOnBand=routeLevel>=typeRequired;
  const typeOk=trainerLevel>=typeRequired&&typeOnBand;
  const zoneAccess=zoneAccessForBand(band);
  const unlocked=rangeOk&&typeOk&&zoneAccess.unlocked;
  let lockHint='';
  if(!rangeOk){
    lockHint=t('map.lockBand',{level:rangeRequired});
  }else if(!zoneAccess.unlocked){
    lockHint=zoneLockHint(zoneAccess);
  }else if(!typeOk){
    lockHint=t('map.lockLevel',{type:typeLabel(typeName),level:typeRequired});
  }
  const levelLabel=routeLevelLabel(band);
  return{unlocked,lockHint,levelLabel,typeOnBand,zoneAccess};
}
function renderMapRoutes(){
  const canvas=$('#worldMapCanvas'),img=$('#mapBiomeImg'),bossPanel=$('#mapBossesPanel'),city=$('#mapCityNode');
  const theme=rangeThemes[mapPreviewRange]||rangeThemes[0];
  const mapEntry=worldMapEntry(mapPreviewRange);
  if(state.mapMode!=='bosses'&&zoneConfigForBand(mapPreviewRange)){state.mapMode='bosses';renderMapRanges()}
  if(state.mapMode==='bosses'){
    if(!isZoneHuntLevel(ranges[mapPreviewRange]?.[0]))mapPreviewRange=bandForZoneDefault();
    const zoneBand=mapPreviewRange,zone=zoneConfigForBand(zoneBand);
    canvas.className=`world-map-canvas range-${zoneBand} mode-bosses zone-${zone?.id||'endgame'}`;
    if(img){
      img.classList.remove('map-biome-swapping');
      img.src=worldmapSrc(zoneBand);
      img.onerror=()=>{img.onerror=null;img.src=worldmapWireframeSrc(zoneBand)};
    }
    $('#mapThemeLabel').textContent=`${t(`zones.${zone.id}.title`)} · ${routeLevelLabel(zoneBand)}`;
    const paths=$('.paths-layer'); if(paths) paths.innerHTML='';
    $('#mapRouteNodes').innerHTML='';
    if(city)city.classList.add('hidden');
    if(bossPanel){
      bossPanel.classList.remove('hidden');
      const zoneBands=ENDGAME_ZONES;
      const access=zoneAccessForBand(zoneBand);
      const pool=speciesHuntEntries({band:zoneBand}).filter(row=>row.zone&&!row.legendaryBoss);
      const featured=zone?.specialKind?featuredSpecialSpecies(zone,Date.now()):null;
      const rotateMs=msUntilNextGmt3Hour(Date.now());
      const rotateLabel=formatZoneRotateCountdown(rotateMs);
      const odds=zone?.specialChancePerKill?Math.round(1/zone.specialChancePerKill):null;
      const typeIndex=types.findIndex(row=>row[0]===zone?.primaryType);
      bossPanel.innerHTML=`<div class="map-bosses-card">
        <span class="eyebrow">${escHtml(t('map.bossesZones'))}</span>
        <h3>${escHtml(t(`zones.${zone.id}.title`))}</h3>
        <p>${escHtml(t(`zones.${zone.id}.description`))}</p>
        <div class="map-zone-levels">${zoneBands.map(item=>{const itemAccess=zoneAccessForBand(item.band);return`<button type="button" class="map-zone-level ${item.band===mapPreviewRange?'active':''} ${itemAccess.unlocked?'':'locked'}" data-zone-band="${item.band}" title="${escHtml(zoneLockHint(itemAccess))}">${itemAccess.unlocked?'':'🔒 '}${escHtml(routeLevelLabel(item.band))}</button>`}).join('')}</div>
        <div class="map-zone-details">
          <div class="map-zone-stat"><small>${escHtml(t('zone.recommendedPower'))}</small><b>${formatNumber(zone.recommendedPower)}</b></div>
          <div class="map-zone-stat"><small>${escHtml(t('atlas.species'))}</small><b>${pool.length}</b></div>
          <div class="map-zone-stat"><small>${escHtml(t('zone.hourlyFeatured'))}</small><b>${featured?escHtml(title(featured)):escHtml(t('zone.noSpecial'))}</b></div>
        </div>
        ${zone?.specialKind?`<p class="map-zone-rotation"><small>${escHtml(t('zone.rotationCountdown',{time:rotateLabel}))}</small>${odds?` · <small>${escHtml(t('zone.specialOdds',{n:odds}))}</small>`:''}</p>`:`<p class="map-zone-rotation"><small>${escHtml(t('zone.noSpecialHint'))}</small></p>`}
        <p class="map-zone-effects">${escHtml(t('zone.effectsSummary',{xp:Math.round((zone.effects.xpMult-1)*100),loot:Math.round((zone.effects.lootMult-1)*100),damage:Math.round((zone.effects.wildDamageMult-1)*100)}))}</p>
        ${access.unlocked?'':`<p class="map-zone-lock">🔒 ${escHtml(zoneLockHint(access))}</p>`}
        <button type="button" class="map-zone-start" data-zone-start="${typeIndex}" ${access.unlocked?'':'disabled'}>${escHtml(t('zone.enter'))}</button>
      </div>`;
      bossPanel.querySelectorAll('[data-zone-band]').forEach((btn)=>{
        btn.onclick=()=>{mapPreviewRange=Number(btn.dataset.zoneBand);renderMapRoutes()};
      });
      const start=bossPanel.querySelector('[data-zone-start]');
      if(start)start.onclick=()=>travelToRoute(Number(start.dataset.zoneStart),{zone:true,level:ranges[mapPreviewRange][0]});
    }
    return;
  }
  bossPanel?.classList.add('hidden');
  canvas.className=`world-map-canvas range-${mapPreviewRange}`;
  if(img){
    img.classList.add('map-biome-swapping');
    const artSrc=worldmapSrc(mapPreviewRange),wireSrc=worldmapWireframeSrc(mapPreviewRange);
    img.onload=()=>{img.classList.remove('map-biome-swapping')};
    img.onerror=()=>{img.onerror=null;img.src=wireSrc};
    img.src=artSrc;
  }
  $('#mapThemeLabel').textContent=`${mapTitle(mapEntry.slug)||mapEntry.title||theme.name} · ${routeLevelLabel(mapPreviewRange)}`;
  const hubLabel=mapEntry.hubLabel||'Saffron City';
  if(city){
    city.classList.remove('hidden');
    city.style.left=`${SCHEMATIC_HUB.x}%`;
    city.style.top=`${SCHEMATIC_HUB.y}%`;
    city.querySelector('b').textContent=hubLabel;
    city.querySelector('small').textContent=mapPreviewRange===0?t('map.youAreHere'):t('map.region');
  }
  const trainerLevel=trainerAccessLevel();
  const visibleTypes=types.filter(t=>typeOnRouteBand(t[0],mapPreviewRange));
  const cityCx=Math.round(SCHEMATIC_HUB.x*10),cityCy=Math.round(SCHEMATIC_HUB.y*6.2);
  const pathDs=visibleTypes.map(t=>{
    const [x,y]=routeNodePosition(t[0],mapPreviewRange);
    const cx=Math.round(x*10),cy=Math.round(y*6.2);
    return `M${cityCx} ${cityCy} Q ${Math.round((cityCx+cx)/2)} ${Math.round((cityCy+cy)/2)+16} ${cx} ${cy}`;
  });
  const paths=$('.paths-layer'); if(paths) paths.innerHTML=pathDs.map(d=>`<path class="route-path" d="${d}"/>`).join('');
  $('#mapRouteNodes').innerHTML=visibleTypes.map(tp=>{
    const i=types.indexOf(tp);
    const pos=routeNodePosition(tp[0],mapPreviewRange);
    const meta=routeNodeMeta(tp[0],mapPreviewRange,trainerLevel);
    const encounters=routeEncounterRows(tp[0],mapPreviewRange);
    const horizontal=pos[0]<30?'tooltip-left':pos[0]>70?'tooltip-right':'tooltip-center',vertical=pos[1]>55?'tooltip-up':'tooltip-down';
    const list=encounters.length?encounters.map(entry=>{
      const color=typeColors[(entry.types||[])[0]]||typeColors[tp[0]]||'#82765b';
      return`<span class="route-encounter" title="${title(entry.slug)}: ${formatEncounterChance(entry.chance)}">${pokePortrait(entry.slug,color,'sm')}<span class="route-encounter-meta"><b>${title(entry.slug)}</b><em>${formatEncounterChance(entry.chance)}</em></span></span>`;
    }).join(''):`<span class="route-encounter empty"><span class="route-encounter-meta"><b>—</b><em></em></span></span>`;
    return `<button class="map-route-node type-${tp[0]} ${horizontal} ${vertical} ${meta.unlocked?'':'locked'}" data-type="${i}" data-label="${typeLabel(tp[0])} · ${meta.levelLabel}" aria-label="${t('map.route',{type:typeLabel(tp[0]),levels:meta.levelLabel})}${meta.unlocked?'':`, ${meta.lockHint}`}" style="left:${pos[0]}%;top:${pos[1]}%;--node-color:${tp[2]}"><span class="orb">${meta.unlocked?typeGlyph(tp[0]):'🔒'}</span><span class="route-hover-card"><strong>${t('map.route',{type:typeLabel(tp[0]),levels:meta.levelLabel})}</strong><small>${meta.unlocked?t('map.speciesChance',{count:encounters.length}):t('map.preview',{hint:meta.lockHint})}</small><span class="route-encounter-grid">${list}</span></span></button>`;
  }).join('');
  $$('#mapRouteNodes .poke-portrait img').forEach(centerPortrait);
  $$('.map-route-node').forEach(b=>b.onclick=()=>{
    const typeIndex=+b.dataset.type;
    const typeName=types[typeIndex]?.[0];
    const meta=routeNodeMeta(typeName,mapPreviewRange,trainerAccessLevel());
    if(!meta.unlocked){showToast(meta.lockHint);return}
    if(MAP_OPENS_ATLAS&&state.huntMode!=='legacy'){
      $('#worldMapModal').classList.add('hidden');
      const band=mapPreviewRange;
      openAtlas({
        typeIndex,
        band,
        step:isZoneHuntLevel(ranges[band]?.[0])?'zone':'band',
        zone:isZoneHuntLevel(ranges[band]?.[0]),
      });
      return;
    }
    travelToRoute(typeIndex);
  });
}
function renderCurrentRoute(){
  const focus=state.huntMode==='species'&&state.huntSpecies?state.huntSpecies:null;
  const zone=currentZone();
  $('#currentRouteIcon').innerHTML=typeGlyph(route()[0]);$('#currentRouteIcon').style.background=route()[2];
  $('#currentRouteName').textContent=focus
    ?t('hunt.speciesFocus',{name:title(focus)})
    :zone
      ?t('hunt.zoneFocus',{type:t(`zones.${zone.id}.title`),level:routeLevelLabel(state.range)})
      :t('hunt.territory',{type:typeLabel(route()[0])});
  $('#currentRouteRange').textContent=zone?t('zone.powerValue',{power:formatNumber(zone.recommendedPower)}):t('hunt.levelPokemon',{level:focus?state.huntLevel||ranges[state.range][0]:ranges[state.range][0]});
  const portraits=focus?[focus]:zone?zonePoolSlugs().slice(0,4):routeForms().slice(0,4);
  $('#currentRoutePokemon').innerHTML=portraits.map(n=>pokePortrait(n,typeColors[primaryTypeFor(n)]||route()[2],'sm')).join('');
  $$('#currentRoutePokemon .poke-portrait img').forEach(centerPortrait);
}
function formatHuntDuration(seconds){
  seconds=Math.max(0,seconds|0);
  if(seconds>=3600)return`${Math.floor(seconds/3600)}h ${String(Math.floor(seconds%3600/60)).padStart(2,'0')}m`;
  return`${String(Math.floor(seconds/60)).padStart(2,'0')}:${String(seconds%60).padStart(2,'0')}`
}
/* Sessão de hunt: taxas /h calculadas sobre uma janela móvel dos últimos 10 min. */
const HUNT_RATE_WINDOW_MS=600000;
function huntSession(){
  const hunt=state.activeHunt;if(!hunt)return null;
  if(!Array.isArray(hunt.samples)){hunt.samples=[];hunt.loot=hunt.loot||{};hunt.lootValue=hunt.lootValue||0;hunt.supplyValue=hunt.supplyValue||0;hunt.ballsUsed=hunt.ballsUsed||0;hunt.potionsUsed=hunt.potionsUsed||0;hunt.capturesValue=hunt.capturesValue||0}
  return hunt
}
function recordHuntEvent(ev){
  const hunt=huntSession();if(!hunt)return;
  const now=Date.now();hunt.samples.push({t:now,...ev});
  const cut=now-HUNT_RATE_WINDOW_MS;
  while(hunt.samples.length&&hunt.samples[0].t<cut)hunt.samples.shift();
  if(!$('#huntHistoryModal').classList.contains('hidden'))renderHuntHistory()
}
function huntRates(hunt){
  const now=Date.now(),divisor=Math.min(Math.max(now-hunt.startedAt,60000),HUNT_RATE_WINDOW_MS),cut=now-HUNT_RATE_WINDOW_MS;
  const sums={kills:0,caps:0,xp:0,loot:0,capValue:0,supply:0,deaths:0,ttkMs:0,ttkN:0};
  for(const e of hunt.samples||[]){if(e.t<cut)continue;sums.kills+=e.kills||0;sums.caps+=e.caps||0;sums.xp+=e.xp||0;sums.loot+=e.loot||0;sums.capValue+=e.capValue||0;sums.supply+=e.supply||0;sums.deaths+=e.deaths||0;if(e.ttkMs){sums.ttkMs+=e.ttkMs;sums.ttkN++}}
  const perHour=v=>v*3600000/divisor;
  return{kills:perHour(sums.kills),caps:perHour(sums.caps),xp:perHour(sums.xp),gross:perHour(sums.loot+sums.capValue),supply:perHour(sums.supply),profit:perHour(sums.loot+sums.capValue-sums.supply),deaths:perHour(sums.deaths),ttkSec:sums.ttkN?sums.ttkMs/sums.ttkN/1000:0}
}
function renderHuntHistory(){
  if(deferPanelRender('huntHistoryModal'))return;
  const body=$('#huntAnalyzerBody');if(!body)return;
  const live=huntSession(),hunt=live||state.lastHunt;
  if(!hunt){
    $('#huntHistoryStatus').textContent=t('hunt.last');$('#currentRouteIcon').textContent='⌛';$('#currentRouteIcon').style.background='#6d6041';$('#currentRouteName').textContent=t('hunt.none');$('#currentRouteRange').textContent=t('hunt.completeHint');$('#currentRoutePokemon').innerHTML='';
    body.innerHTML='';
    return;
  }
  const type=types[hunt.typeIndex]||types[0],range=ranges[hunt.rangeIndex]||ranges[0];
  $('#huntHistoryStatus').textContent=live?t('hunt.currentSession'):t('hunt.lastRoute');
  $('#currentRouteIcon').innerHTML=typeGlyph(type[0]);$('#currentRouteIcon').style.background=type[2];
  $('#currentRouteName').textContent=t('hunt.territory',{type:typeLabel(type[0])});$('#currentRouteRange').textContent=t('hunt.levelPokemon',{level:range[0]});
  $('#currentRoutePokemon').innerHTML=(hunt.pokemon||[]).map(name=>pokePortrait(name,typeColors[primaryTypeFor(name)]||'#82765b','sm')).join('');
  $$('#currentRoutePokemon .poke-portrait img').forEach(centerPortrait);
  const seconds=live?Math.max(1,Math.floor((Date.now()-live.startedAt)/1000)):Math.max(1,hunt.seconds||0);
  const defeated=live?Math.max(0,state.stats.defeated-live.defeated):hunt.defeated||0;
  const captured=live?Math.max(0,state.stats.captured-live.captured):hunt.captured||0;
  const xp=live?Math.max(0,state.stats.xp-live.xp):hunt.xp||0;
  const lootValue=Math.round(hunt.lootValue||0),supplyValue=Math.round(hunt.supplyValue||0),capturesValue=Math.round(hunt.capturesValue||0);
  const loot=hunt.loot||{},lootCount=Object.values(loot).reduce((a,b)=>a+b,0),balance=lootValue+capturesValue-supplyValue;
  const money=v=>coinsAmount(v,12);
  const rates=live?huntRates(live):{kills:defeated*3600/seconds,caps:captured*3600/seconds,xp:xp*3600/seconds,gross:(lootValue+capturesValue)*3600/seconds,supply:supplyValue*3600/seconds,profit:balance*3600/seconds};
  const rate=v=>formatNumber(Math.round(v));
  const stat=(icon,value,label,color='',sub='')=>`
    <div class="hunt-stat"${color?` style="--stat-color:${color}"`:''}>
      <i class="hunt-stat-icon">${icon}</i>
      <div class="hunt-stat-copy"><b class="hunt-stat-value">${value}</b><small>${label}${sub}</small></div>
    </div>`;
  const dropRows=Object.entries(loot).filter(([slug,qty])=>qty>0&&ITEM_BY_SLUG[slug]).map(([slug,qty])=>({slug,qty,value:sellValue(ITEM_BY_SLUG[slug])*qty})).sort((a,b)=>b.value-a.value);
  body.innerHTML=`
    <div class="hunt-analyzer-grid">
      ${stat('⚔',formatNumber(defeated),t('hunt.defeated'))}
      ${stat('⏱',formatHuntDuration(seconds),t('hunt.time'))}
      ${stat('✦',formatNumber(xp),t('hunt.xp'),'#74a9ff')}
      ${stat('◓',formatNumber(captured),t('hunt.captured'),'#ff9d8a',capturesValue>0?` <em>(+${money(capturesValue)})</em>`:'')}
      ${stat('💰',money(lootValue),t('hunt.loot'),'var(--gold-soft)',` <em>(${t('hunt.itemsCount',{count:formatNumber(lootCount)})})</em>`)}
      ${stat('🛒',`${supplyValue>0?'-':''}${money(supplyValue)}`,t('hunt.supply'),supplyValue>0?'#ff7a63':'',` <em>(${t('hunt.supplyDetail',{balls:formatNumber(hunt.ballsUsed||0),potions:formatNumber(hunt.potionsUsed||0)})})</em>`)}
    </div>
    <div class="hunt-balance${balance<0?' negative':''}"><small>${t('hunt.balance')}</small><b>${balance<0?'-':'+'}${money(balance)}</b></div>
    <div class="hunt-economy-health ${rates.profit<0?'negative':'positive'}">
      <div><small>${t('hunt.grossRate')}</small><b>${money(rates.gross)}/h</b></div>
      <div><small>${t('hunt.supplyRate')}</small><b>${money(rates.supply)}/h</b></div>
      <div><small>${t('hunt.netRate')}</small><b>${rates.profit<0?'-':'+'}${money(Math.abs(rates.profit))}/h</b></div>
      <span>${rates.profit<0?t('hunt.economyWarning'):t('hunt.economyHealthy')}</span>
    </div>
    <div class="hunt-rate-chips" title="${t('hunt.rateHint')}">
      <span class="hunt-rate-chip" style="--chip-color:${rates.profit<0?'#ff7a63':'#8fdc84'}">${rates.profit<0?'-':'+'}${money(rates.profit)}/h</span>
      <span class="hunt-rate-chip" style="--chip-color:#74a9ff">✦ ${rate(rates.xp)} XP/h</span>
      <span class="hunt-rate-chip">⚔ ${rate(rates.kills)}/h</span>
      <span class="hunt-rate-chip" style="--chip-color:#ff9d8a">◓ ${rate(rates.caps)}/h</span>
      <span class="hunt-rate-chip" style="--chip-color:#c9a0ff">⏱ TTK ${rates.ttkSec?rates.ttkSec.toFixed(1)+'s':'—'}</span>
      <span class="hunt-rate-chip" style="--chip-color:#ff7a63">💀 ${rate(rates.deaths||0)}/h</span>
    </div>
    <div class="hunt-drops">
      <span class="hunt-drops-title">${t('hunt.sessionDrops')}</span>
      ${dropRows.length?`<div class="hunt-drop-list">${dropRows.map(d=>`<div class="hunt-drop-row">${itemIcon(d.slug)}<span class="hunt-drop-name">${displayItem(d.slug)}</span><span class="hunt-drop-qty">×${formatNumber(d.qty)}</span><span class="hunt-drop-value">${money(d.value)}</span></div>`).join('')}</div>`:`<div class="hunt-drops-empty">${t('hunt.noDrops')}</div>`}
    </div>`;
}
function beginHunt(){
  const pokemon=state.huntMode==='species'&&state.huntSpecies
    ?[state.huntSpecies]
    :state.huntMode==='zone'
      ?zonePoolSlugs().slice(0,8)
      :routeForms().slice(0,4);
  const mapStage=huntMapStageFor(state.huntMode==='species'?state.huntSpecies:null,0);
  routeStarted=Date.now();state.activeHunt={typeIndex:state.type,rangeIndex:state.range,huntMode:state.huntMode,huntSpecies:state.huntSpecies,huntLevel:state.huntLevel,mapStage,startedAt:routeStarted,defeated:state.stats.defeated,captured:state.stats.captured,xp:state.stats.xp,pokemon,loot:{},lootValue:0,supplyValue:0,ballsUsed:0,potionsUsed:0,capturesValue:0,samples:[]};save();
  renderOfflineStatus();
}
function finishActiveHunt(){
  const hunt=state.activeHunt;if(!hunt)return;
  state.lastHunt={typeIndex:hunt.typeIndex,rangeIndex:hunt.rangeIndex,pokemon:hunt.pokemon,seconds:Math.max(0,Math.floor((Date.now()-hunt.startedAt)/1000)),defeated:Math.max(0,state.stats.defeated-hunt.defeated),captured:Math.max(0,state.stats.captured-hunt.captured),xp:Math.max(0,state.stats.xp-hunt.xp),loot:hunt.loot||{},lootValue:hunt.lootValue||0,supplyValue:hunt.supplyValue||0,ballsUsed:hunt.ballsUsed||0,potionsUsed:hunt.potionsUsed||0,capturesValue:hunt.capturesValue||0};
  state.activeHunt=null;save();
  renderOfflineStatus();
}
// Montar o mapa custa ~280ms e 17 mil sprites. switchView('adventure') e
// changeRoute() são chamados em sequência no início da caça, e sem esta trava
// os dois disparariam um build cada — o segundo só para descartar o primeiro.
let routePixiBooting=null;
async function bootRouteRenderer(world,mapImage,mapKey,loadId){
  if(routePixiBooting===mapKey)return;
  routePixiBooting=mapKey;
  try{
    const {renderer,topperRenderer}=await initRoutePixi($('#routePixiHost'),$('#routePixiOverlayHost'),mapKey);
    if(loadId!==routeLandLoadId||routeLandMapKey()!==mapKey){renderer.destroy();topperRenderer?.destroy();return}
    routePixi=renderer;
    routePixiToppers=topperRenderer;
    world.style.width=`${renderer.worldWidth}px`;
    world.style.height=`${renderer.worldHeight}px`;
    world.style.aspectRatio='auto';
    setWorldMetrics(world,renderer.worldWidth,renderer.worldHeight);
    world.classList.add('renderer-pixi');
    mapImage.hidden=true;
    updateRouteCamera();
  }catch(err){
    if(loadId!==routeLandLoadId)return;
    console.error('[RouteRenderer]',err);
    routePixi=null;
    routePixiToppers=null;
    mapImage.hidden=false;
  }finally{
    if(routePixiBooting===mapKey)routePixiBooting=null;
  }
}
/**
 * Garante o renderer de tiles da rota atual. Idempotente: se já estiver de pé
 * para o mesmo mapa, não faz nada. Chamado ao entrar na aba de aventura e ao
 * trocar de rota.
 */
function ensureRouteRenderer(){
  if(!isPixiRendererEnabled())return;
  if(!$('#adventureView')?.classList.contains('active'))return;
  const world=$('#routeMapWorld'),mapImage=$('#routeMapImage');
  if(!world||!mapImage)return;
  if(routePixi&&world.classList.contains('renderer-pixi'))return;
  // Reaproveita o loadId corrente em vez de incrementar: subir um novo id aqui
  // cancelaria o ensureRouteLand que changeRoute() deixou pendente.
  bootRouteRenderer(world,mapImage,routeLandMapKey(),routeLandLoadId);
}
function changeRoute(){
  const zone=currentZone();
  routeStarted=Date.now();state.stats.seconds=0;routeSim.moveCds={};routeSim.playerTurn=0;routeSim.nextPlayerAttackAt=0;routeSim.nextEnemyAttackAt=0;document.documentElement.style.setProperty('--route-glow',route()[2]);$('#routeLabel').textContent=zone?`${t(`zones.${zone.id}.title`)} · ${routeLevelLabel(zone.band)}`:t('battle.routeLabel',{type:typeLabel(route()[0],{upper:true}),min:ranges[state.range][0],max:ranges[state.range][1]});
  const world=$('#routeMapWorld'),mapImage=$('#routeMapImage'),slug=routeSlugs[route()[0]];world.className=`route-map-world route-${slug}${zone?` zone-${zone.id}`:''}`;
  routePixi?.destroy();routePixiToppers?.destroy();routePixi=null;routePixiToppers=null;routePixiBooting=null;$('#routePixiHost').replaceChildren();$('#routePixiOverlayHost')?.replaceChildren();mapImage.hidden=false;
  mapImage.onload=()=>{
    if(world.classList.contains('renderer-pixi'))return;
    const nw=Math.max(1,mapImage.naturalWidth),nh=Math.max(1,mapImage.naturalHeight);
    world.style.height='auto';
    world.style.aspectRatio=`${nw}/${nh}`;
    const zoom=Math.max(2.2,Math.min(3,2900/nw));
    const widthPx=Math.round(nw*zoom);
    world.style.width=`${widthPx}px`;
    // height fica em auto (aspect-ratio), então o valor em px vem da proporção.
    setWorldMetrics(world,widthPx,widthPx*nh/nw);
    updateRouteCamera();
  };
  const preferred=routeMapSrc(slug,state.range,activeHuntArtTier()), fallback=`public/assets/world/route-${slug}-original.webp?v=${WORLD_MAP_ART_VERSION}`;
  mapImage.onerror=()=>{if(mapImage.dataset.fallbackTried)return;mapImage.dataset.fallbackTried='1';mapImage.src=fallback};
  delete mapImage.dataset.fallbackTried;
  mapImage.src=preferred;
  const partner=partnerName(),actor=$('#routePartner'),trainerActor=$('#routeTrainer'),mapKey=routeLandMapKey(),rawStart=rawPlayerStartForRoute();
  const start=clampRoutePos(rawStart[0],rawStart[1],ROUTE_EDGE_MARGIN);
  // respectLand: sem isso o treinador podia nascer fora da terra ao entrar ou
  // voltar para a hunt, e já começava travado.
  const trainerStart=routeTrainerStart(start[0],start[1],'north',true);
  routeSim.player={x:start[0],y:start[1],dir:'north',frame:0,stepAt:0};routeSim.trainer={x:trainerStart[0],y:trainerStart[1],dir:'north'};routeSim.last=performance.now();routeSim.wilds=[];routeSim.target=null;routeSim.nextTargetAt=0;routeSim.spawnTimer=0;routeSim.chaseBestDist=null;routeSim.chaseProgressAt=performance.now();routeSim.trainerBestDist=null;routeSim.trainerProgressAt=performance.now();routeSim.unreachableUntil=new Map();
  if(actor){setActorPercent(actor,start[0],start[1]);const label=actor.querySelector('small');if(label)label.textContent=t('battle.yourPokemon',{name:title(partner)});setActor(actor,partner,'north',false,performance.now(),{shiny:!!state.starter?.shiny})}
  if(trainerActor){setActorPercent(trainerActor,trainerStart[0],trainerStart[1]);$('#routeTrainerLabel').textContent=state.trainer.name||t('profile.trainer');setActor(trainerActor,trainerSprite(),'north',false,performance.now())}
  renderWilds();updateRouteCamera();renderPartnerHud();$('#battleStatus').textContent=t('battle.searching');$('#battleTimer').textContent=t('battle.seekingTarget',{name:title(partner)});
  clearTimeout(routePopulationRetryTimer);routePopulationRetryTimer=null;routePopulationRetryAttempts=0;
  const loadId=++routeLandLoadId;
  if($('#adventureView').classList.contains('active')){
    // O vendor do Pixi é buildado com os polyfills de pixi.js/unsafe-eval
    // (tools/build-pixi-vendor.mjs), então roda sob a CSP estrita de produção,
    // sem 'unsafe-eval' — inclusive no caminho WebGL.
    if(isPixiRendererEnabled())bootRouteRenderer(world,mapImage,mapKey,loadId);
    ensureRouteLand(mapKey).then(()=>{
      if(loadId!==routeLandLoadId||routeLandMapKey()!==mapKey)return;
      const landStart=routeLand?.landList?.length
        ?pickRandomLandPercent(routeLand,ROUTE_EDGE_MARGIN)
        :constrainRouteLand(rawStart[0],rawStart[1],ROUTE_EDGE_MARGIN);
      routeSim.player.x=landStart[0];routeSim.player.y=landStart[1];
      const landedTrainer=routeTrainerStart(landStart[0],landStart[1],'north',true);
      routeSim.trainer.x=landedTrainer[0];routeSim.trainer.y=landedTrainer[1];
      setActorPercent(actor,landStart[0],landStart[1]);
      if(trainerActor)setActorPercent(trainerActor,landedTrainer[0],landedTrainer[1]);
      spawnRoutePopulation(loadId);updateRouteCamera();
    });
  }
  save();
}
function travelToRoute(typeIndex,{species=null,level=null,guaranteedShiny=false,zone=false}={}){
  if(!canStartAuthoritativeGameplay())return;
  const zoneConfig=zoneConfigForBand(mapPreviewRange);
  if((zone||(!species&&zoneConfig))&&zoneConfig){const primaryIndex=types.findIndex(row=>row[0]===zoneConfig.primaryType);if(primaryIndex>=0)typeIndex=primaryIndex}
  const typeName=types[typeIndex]?.[0];
  if(!typeOnRouteBand(typeName,mapPreviewRange)){showToast(t('map.lockHint',{type:typeLabel(typeName),level:typeUnlockLevel(typeName)}));return}
  const meta=routeNodeMeta(typeName,mapPreviewRange,trainerAccessLevel());
  let partner=null;
  try{
    if(!state.starter)recoverStarterFromCollection();
    partner=ensureStarterCombat();
  }catch(error){console.error('[Hunt] ensureStarterCombat failed',error);showToast(t('atlas.startFailed'));return}
  if(!meta.unlocked){showToast(meta.lockHint);return}
  if(!partner){clearPartnerHud();showToast(t('atlas.needPartner'));return}
  if(partner.currentHp<=0){$('#worldMapModal')?.classList.add('hidden');returnToPokemonCenter(partner.name);return}
  stopFishing();
  finishActiveHunt();state.type=typeIndex;state.range=mapPreviewRange;
  const routeLevel=level||ranges[mapPreviewRange][0];
  const enterZone=zone||(!species&&isZoneHuntLevel(routeLevel));
  if(enterZone){
    state.huntMode='zone';
    state.huntSpecies=null;
    state.huntLevel=routeLevel;
    if(partner.level>=100&&!state.starter?.aoeMove){
      showToast(t('atlas.zoneAoeWarn'));
    }
  }else if(species){
    state.huntMode='species';
    state.huntSpecies=species;
    state.huntLevel=routeLevel;
  }else if(state.huntMode!=='species'){
    state.huntSpecies=null;
  }
  if(guaranteedShiny&&species)state.altarShiny={species,encounters:3};
  state.running=true;state.lastView='adventure';$('#worldMapModal').classList.add('hidden');
  switchView('adventure');
  // O estágio visual da hunt precisa existir antes de changeRoute() montar o
  // renderer; caso contrário Abra nasce no art genérico e nunca recebe a
  // pirâmide prevista para a primeira cena.
  beginHunt();changeRoute();
  tutorialEvent('hunt:start');
  requestAnimationFrame(()=>requestAnimationFrame(updateRouteCamera));
  if(enterZone){
    const activeZone=zoneConfigForBand(state.range);
    addLog(t('hunt.zoneFocus',{type:t(`zones.${activeZone.id}.title`),level:routeLevelLabel(state.range)}));
    showToast(t('atlas.startZone',{type:t(`zones.${activeZone.id}.title`),level:routeLevelLabel(state.range)}));
  }else{
    addLog(species?t('hunt.speciesFocus',{name:title(species)}):t('map.travelLog',{type:typeLabel(route()[0])}));
    showToast(species?t('atlas.startHunt',{name:title(species),level:state.huntLevel}):t('map.arriving',{type:typeLabel(route()[0])}));
  }
}
function openMap(){mapPreviewRange=state.range;renderMapRanges();renderMapRoutes();$('#worldMapModal').classList.remove('hidden')}
function injectFeatureNav(){
  const nav=$('#headerMapButton')?.parentElement;if(!nav||$('#altarNavButton'))return;
  const mk=(id,labelKey,icon,color)=>{
    const label=t(labelKey);
    return`<button class="nav-item" id="${id}" type="button" style="--nav-accent:${color}" data-i18n-aria-label="${labelKey}" data-i18n-title="${labelKey}" aria-label="${label}" title="${label}"><span class="nav-icon">${uiIcon(icon)}</span></button>`;
  };
  $('#headerMapButton')?.insertAdjacentHTML('beforebegin',mk('altarNavButton','nav.altar','sparkles','#c68cff')+mk('breedingNavButton','nav.breeding','egg','#f3a6c8')+mk('systemsNavButton','nav.systems','school','#9ad0ff')+mk('pokemonCompareNavButton','nav.compare','swords','#81d4fa'));
  $('#altarNavButton').onclick=()=>openAltar();
  $('#breedingNavButton').onclick=()=>openBreeding();
  $('#systemsNavButton').onclick=()=>openMasterPanel('hub');
  onLocaleChange(()=>{
    for(const[id,key]of[['altarNavButton','nav.altar'],['breedingNavButton','nav.breeding'],['systemsNavButton','nav.systems'],['pokemonCompareNavButton','nav.compare'],['headerMapButton','nav.atlas']]){
      const el=$(`#${id}`);if(!el)continue;
      el.setAttribute('aria-label',t(key));el.setAttribute('title',t(key));
    }
  });
}
function seenSpeciesRows(){
  const seen=new Set([...(state.captureHistory||[]).map(p=>p.name),...state.collection.map(p=>p.name)]);
  if(state.starter?.name)seen.add(state.starter.name);
  if(isPokedexReady()){
    for(const s of allPokedexSpecies()){
      if((ownedBySpecies().get(s.slug)||[]).length)seen.add(s.slug);
    }
  }
  return[...seen].filter(Boolean).map(slug=>({slug,name:title(slug)}));
}
function initFeatureOverlays(){
  initAltarUI({
    getCards:()=>serverGameplayReady()?itemCount('shiny-card'):state.shinyCards||0,
    getSeenSpecies:seenSpeciesRows,
    pokemonImage:(slug)=>entityAsset(slug,'south',0),
    title,
    showToast,
    onInvoke:async(slug,cost)=>{
      if(!slug)return{ok:false,reason:'species'};
      if(serverGameplayReady()){
        try{
          const response=await invokeShinyAltar(slug,crypto.randomUUID());
          if(response?.inventory)applyServerInventory(response.inventory,{force:true});
          const invocation={
            id:response?.invocation_id,
            species:response?.species||slug,
            remaining:response?.encounters_remaining||3,
            server:true,
          };
          state.altarShiny=invocation;
          setShinyAltarInvocation(invocation);
          state.altar=state.altar||{history:[]};
          state.altar.history.push({species:slug,at:Date.now(),cost,server:true});
          const entry=pokedexEntry(slug);
          const typeName=(entry?.types||speciesTypes(slug)||[])[0]||route()[0];
          const typeIndex=Math.max(0,types.findIndex(tp=>tp[0]===typeName));
          mapPreviewRange=state.range;
          travelToRoute(typeIndex>=0?typeIndex:state.type,{species:slug,level:ranges[state.range][0],guaranteedShiny:false});
          save();
          return{ok:true};
        }catch(error){
          const reason=String(error?.code||error?.message||'');
          if(/insufficient_shiny_cards|inventory_migration_required/i.test(reason))return{ok:false,reason:'cards'};
          if(/altar_species_not_seen|invalid_altar_species/i.test(reason))return{ok:false,reason:'species'};
          return{ok:false,reason:'sync'};
        }
      }
      if((state.shinyCards||0)<cost)return{ok:false,reason:'cards'};
      state.shinyCards-=cost;
      state.altar=state.altar||{history:[]};
      state.altar.history.push({species:slug,at:Date.now(),cost});
      const entry=pokedexEntry(slug);
      const typeName=(entry?.types||speciesTypes(slug)||[])[0]||route()[0];
      const typeIndex=Math.max(0,types.findIndex(tp=>tp[0]===typeName));
      mapPreviewRange=state.range;
      travelToRoute(typeIndex>=0?typeIndex:state.type,{species:slug,level:ranges[state.range][0],guaranteedShiny:true});
      save();
      return{ok:true};
    },
  });
  initBreedingUI({
    getState:()=>state,
    getBoxPokemon:()=>state.collection.filter(p=>!p.locked&&!isOnTeam(p)&&(String(p.id)!==String(state.starter?.id))),
    pokemonImage:(slug)=>entityAsset(slug,'south',0),
    title,
    rarityColor:(rarity)=>rarityInfo({rarity}).color,
    formatIv:formatPokemonIv,
    ivScore:(p)=>ivScoreFor(p),
    getCoins:()=>state.stats.coins||0,
    getItemCount:(slug)=>itemCount(slug),
    itemImg:(slug)=>ITEM_BY_SLUG[slug]?.img||'',
    itemName:(slug)=>displayItem(slug),
    getSpeciesTypes:(slug)=>pokedexEntry(slug)?.types||speciesTypes(slug),
    typeColor:(name)=>typeColors[name]||'#777',
    stoneRows:(stonesByType)=>Object.entries(stonesByType||{}).map(([type,qty])=>{
      const options=STONES_BY_TYPE[type]||[];
      const stone=options[0];
      const owned=options.reduce((sum,entry)=>sum+itemCount(entry.slug),0);
      return{type,qty:Math.max(0,Math.ceil(Number(qty)||0)),name:stone?displayItem(stone.slug):typeLabel(type),img:stone?.img||'',owned};
    }),
    showToast,
    save,
    onSelectParent:(slot,id)=>{
      if(!state.breeding)state.breeding=normalizeBreedingState();
      state.breeding.pair[slot]=id;save();
    },
    onClearParent:(slot)=>{
      if(!state.breeding)state.breeding=normalizeBreedingState();
      state.breeding.pair[slot]=null;save();
    },
    onSetMode:(mode)=>{
      if(!state.breeding)state.breeding=normalizeBreedingState();
      state.breeding.mode=String(mode).toLowerCase()==='free'?'free':'pheromones';save();
    },
    onToggleDoubleStones:(value)=>{
      if(!state.breeding)state.breeding=normalizeBreedingState();
      state.breeding.doubleStones=!!value;save();
    },
    onCreateEgg:async(api)=>{
      if(!state.breeding)state.breeding=normalizeBreedingState();
      const [idA,idB]=state.breeding.pair;
      const a=state.collection.find(p=>String(p.id)===String(idA));
      const b=state.collection.find(p=>String(p.id)===String(idB));
      const compat=api.breedingCompatibility(a,b);
      if(!compat.ok)return{ok:false,reason:compat.reason==='species'||compat.reason==='same'?'incompatible':'pair'};
      const mode=api.normalizeBreedingMode(state.breeding.mode);
      const doubleStones=!!state.breeding.doubleStones;
      const donor=(a.mult||1)>=(b.mult||1)?a:b;
      const costChild={...donor,types:speciesTypes(a.name||donor.name),mult:donor.mult};
      const cost=api.breedingCost(costChild,{mode,doubleStones});
      if((state.stats.coins||0)<cost.coins)return{ok:false,reason:'coins'};
      if(!canAffordBreedingStones(cost.stones||{},1))return{ok:false,reason:'stones'};
      const pherNeeded=mode==='pheromones'?Math.max(1,Number(cost.pheromones)||0):0;
      if(pherNeeded&&itemCount('pheromone')<pherNeeded)return{ok:false,reason:'pheromones'};
      const free=state.breeding.incubator.findIndex(s=>!s);
      if(free<0)return{ok:false,reason:'incubator'};

      if(serverGameplayReady()){
        if(!a.serverId&&!a.id)return{ok:false,reason:'incompatible'};
        try{
          const response=await serverBreedCreateEgg({
            parentA:a.serverId||a.id,
            parentB:b.serverId||b.id,
            mode,
            doubleStones,
            stonePayments:breedingStonePayments(cost.stones||{},1),
          });
          if(!response?.ok||!response.egg)return{ok:false,reason:'sync'};
          if(response.wallet)acceptMarketWallet(response.wallet);
          if(response.inventory)applyServerInventory(response.inventory,{force:true});
          const eggData=response.egg;
          const egg={
            id:eggData.id,
            serverId:eggData.id,
            species:eggData.species,name:eggData.species,
            ivs:eggData.ivs,ivTotal:eggData.ivTotal||eggData.iv_total_pct||0,
            ivScore:eggData.ivScore||eggData.iv_total||0,
            mult:eggData.mult,rarityName:eggData.rarityName||eggData.rarity,
            defeatsNeeded:eggData.defeatsNeeded||eggData.defeats_needed||600,
            defeatsDone:eggData.defeatsDone||eggData.defeats_done||0,
          };
          state.breeding.incubator[free]=egg;
          state.collection=state.collection.filter(p=>String(p.id)!==String(a.id)&&String(p.id)!==String(b.id));
          state.breeding.pair=[null,null];
          renderCollection();renderDropBag();renderStats();save();
          return{ok:true};
        }catch(error){
          console.warn('breed_create_egg failed',error);
          return{ok:false,reason:'sync'};
        }
      }

      let child;
      try{child=api.breedChild(a,b,{mode,doubleStones})}
      catch{return{ok:false,reason:'incompatible'}}
      applyIdlecoinDelta(-cost.coins,'breeding');
      if(!spendBreedingStones(cost.stones||{},1))return{ok:false,reason:'stones'};
      if(pherNeeded)spendItem('pheromone',pherNeeded);
      const egg={
        species:child.species||a.name,name:child.species||a.name,
        ivs:breedingIvsToGame(child.ivs),ivTotal:child.ivTotal,ivScore:child.ivScore||child.ivTotal,
        mult:child.mult,rarityName:child.rarityName,
        defeatsNeeded:api.incubationDefeatsFor(child),defeatsDone:0,
      };
      state.breeding.incubator[free]=egg;
      state.collection=state.collection.filter(p=>String(p.id)!==String(a.id)&&String(p.id)!==String(b.id));
      state.breeding.pair=[null,null];
      renderCollection();renderDropBag();renderStats();save();
      return{ok:true};
    },
  });
  initAtlasUI({
    types:()=>types,
    ranges:()=>ranges,
    typeLabel:(name)=>typeLabel(name),
    typeColor:(name)=>typeColors[name]||'#777',
    typeGlyph,
    trainerLevel:()=>trainerAccessLevel(),
    isTypeUnlocked:(typeName,band)=>!!routeNodeMeta(typeName,band,trainerAccessLevel()).unlocked,
    isBandUnlocked:(band)=>trainerAccessLevel()>=(ROUTE_UNLOCK_LEVELS[band]||1)&&zoneAccessForBand(band).unlocked,
    bandAccess:(band)=>{
      if(zoneConfigForBand(band)){
        const access=zoneAccessForBand(band);
        return{...access,hint:zoneLockHint(access)};
      }
      const required=ROUTE_UNLOCK_LEVELS[band]||1;
      return{unlocked:trainerAccessLevel()>=required,hint:t('map.unlockAt',{level:required})};
    },
    bandLabel:(band)=>routeLevelLabel(band),
    zoneConfig:(band)=>zoneConfigForBand(band),
    zoneProgress:(band)=>zoneProgressFor(band),
    zoneAccess:(band)=>{const access=zoneAccessForBand(band);return{...access,hint:zoneLockHint(access)}},
    getEntries:(typeName,band)=>zoneConfigForBand(band)?speciesHuntEntries({band}):speciesHuntEntries({type:typeName,band},routeEncounterRows(typeName,band)),
    isSeen:(slug)=>seenSpeciesRows().some(r=>r.slug===slug)||(ownedBySpecies().get(slug)||[]).length>0,
    isCaught:(slug)=>seenSpeciesRows().some((row)=>row.slug===slug),
    pokemonImage:(slug)=>entityAsset(slug,'south',0),
    getSpeciesTypes:(slug)=>pokedexEntry(slug)?.types||speciesTypes(slug),
    title,
    showToast,
    getDifficulty:()=>state.huntDifficulty||0,
    setDifficulty:(d)=>{state.huntDifficulty=HUNT_DIFFICULTIES.includes(Number(d))?Number(d):0;save()},
    initialType:state.type,
    initialBand:state.range,
    onStartHunt:({typeIndex,band,species,level,zone})=>{
      mapPreviewRange=band;
      let huntLevel=level;
      if(!zone&&species){
        const bandBase=ranges[band]?.[0]??1;
        huntLevel=encounterLevel({minLevel:speciesMinRouteLevel(species)||1,maxLevel:300},bandBase,state.huntDifficulty||0);
      }
      travelToRoute(typeIndex,{species:zone?null:species,level:huntLevel,zone:!!zone});
    },
  });
  initMasterSystemsUI({
    getState:()=>state,
    onPanelOpen:id=>tutorialEvent('panel:open',{id}),
    save,
    showToast,
    formatNumber,
    teamPower:()=>{
      const p=state.starter;if(!p)return 50;
      try{return pokemonPower(statsFor(p.name,route()[0],p.level||1,p.ivs,p.mult||1),p.mult||1)}catch{return (p.level||1)*20}
    },
    refreshEconomy:()=>{renderStats();renderDropBag();renderInventory()},
    serverEconomyReady:()=>walletSyncEnabled()&&inventorySyncEnabled(),
    openMarket:()=>openMarket(),
    openFishing:()=>{switchView('city');openCityDialog('fish')},
    beginEmeraldCheckout,
    spendEmerald,
    purchasePremiumProduct,
    activatePremiumBoost,
    purchaseVip,
    purchaseSeasonPass,
    claimSeasonTier: claimSeasonTier,
    claimDailyQuest,
    reportDailyQuestProgress,
    fetchDailyQuests,
    claimDailyGift:claimDailyGiftRemote,
    fetchDailyGift:fetchDailyGiftRemote,
    claimRaidRewards,
    fetchRaid:getActiveWorldRaid,
    fetchClan:getMyClan,
    joinClanOnServer,
    skipClanRankOnServer,
    acceptWallet:acceptMarketWallet,
    applyInventory:inv=>applyServerInventory(inv,{force:true}),
    applyPremiumBoosts:applyServerPremiumBoosts,
    trackEvent,
    userId:()=>state.accountUserId||'local',
    marketFeeRate:()=>trainerAccountPerks().marketFeeRate,
    refreshDailyGiftBadge,
  });
}
function refreshDailyGiftBadge(){
  try{normalizeMeta(state)}catch{}
  const badge=$('#dailyGiftBadge');if(!badge)return;
  const canClaim=dailyGiftProgress(state).canClaim;
  badge.textContent=canClaim?'!':'0';
  badge.classList.toggle('is-zero',!canClaim);
}
function switchView(name){
  $$('.nav-item[data-view]').forEach(n=>n.classList.toggle('active',n.dataset.view===name));$$('.view').forEach(v=>v.classList.remove('active'));$(`#${name}View`).classList.add('active');
  if(name==='city'){
    if(state.running)finishActiveHunt();state.running=false;state.lastView='city';$('#battleStatus').textContent=t('battle.paused');
    ++routeLandLoadId;clearTimeout(routePopulationRetryTimer);routePopulationRetryTimer=null;routePopulationRetryAttempts=0;routeSim.wilds=[];routeSim.target=null;
    routePixi?.destroy();routePixi=null;routePixiBooting=null;$('#routePixiHost')?.replaceChildren();
    $('#routeMapWorld')?.classList.remove('renderer-pixi');if($('#routeMapImage'))$('#routeMapImage').hidden=false;
  }else if(name==='adventure'){
    state.lastView='adventure';
    // Voltar da cidade precisa remontar o mapa de tiles. Ir para a cidade
    // destrói o renderer (acima), e changeRoute() só o constrói quando a aba de
    // aventura já está ativa — ou seja, quem entrasse na caça pela cidade
    // ficava com a imagem PNG única esticada no lugar do mapa jogável.
    ensureRouteRenderer();
    lockMapScale($('#environment'));
  }
  tutorialEvent('view:change',{name});
}
/** Em frente ao balcão do Centro Pokémon (Nurse Joy). */
function teleportToCityCenter(){
  if(state.running)finishActiveHunt();
  state.running=false;
  closeCityDialog();
  cityPlayer.x=47.87;cityPlayer.y=42;cityPlayer.dir='north';
  const el=$('#cityTrainer');
  if(el)setActor(el,trainerSprite(),cityPlayer.dir,false,performance.now());
  resetCityFollower();
  switchView('city');
  updateCityCamera();updateBuildingState();
}
function teleportToCityDepot(){
  if(state.running)finishActiveHunt();
  state.running=false;
  closeCityDialog();
  cityPlayer.x=43.4;cityPlayer.y=42;cityPlayer.dir='north';
  const el=$('#cityTrainer');
  if(el)setActor(el,trainerSprite(),cityPlayer.dir,false,performance.now());
  resetCityFollower();
  switchView('city');
  updateCityCamera();updateBuildingState();
}
function addLog(message,highlight=''){const now=formatTime(new Date());state.log.unshift({now,message,highlight});state.log=state.log.slice(0,20);renderLog();save()}
function renderLog(){const log=$('#logEntries');if(!log)return;log.innerHTML=state.log.map(x=>`<div class="log-entry"><span>${x.now}</span>${x.highlight?`<strong>${x.highlight}</strong> `:''}${x.message}</div>`).join('')||`<div class="log-entry">${t('log.ready')}</div>`}
function hasDetailedIvs(pokemon){return Object.keys(pokemon?.ivs||{}).length>0}
function captureHistorySource(entry){return state.collection.find(candidate=>entry.id!=null&&String(candidate.id)===String(entry.id)||candidate.name===entry.name&&String(candidate.capturedAt)===String(entry.capturedAt))||null}
function captureHistoryEntryKey(entry,index=0){return entry.id!=null?`id:${entry.id}`:`capture:${entry.name}:${entry.capturedAt??index}:${entry.ivScore??''}`}
function renderCaptureLog(){
  if(deferPanelRender('captureHistoryModal'))return;
  const list=$('#captureLogEntries');if(!list)return;
  const history=state.captureHistory||[],visible=history.filter(p=>captureHistoryFilter==='all'||captureHistoryFilter==='shiny'&&p.shiny||captureHistoryFilter==='normal'&&!p.shiny);
  if(captureLogExpandedKey&&!history.some((entry,index)=>captureHistoryEntryKey(entry,index)===captureLogExpandedKey))captureLogExpandedKey=null;
  const oldScrollTop=list.scrollTop,oldExpanded=[...list.querySelectorAll('.capture-log-row')].find(row=>row.dataset.captureKey===captureLogExpandedKey),oldExpandedTop=oldExpanded?.offsetTop;
  $('#captureTotal').textContent=history.length;$('#captureShinyTotal').textContent=history.filter(p=>p.shiny).length;$('#captureNormalTotal').textContent=history.filter(p=>!p.shiny).length;
  $$('#captureHistoryFilters button').forEach(button=>button.classList.toggle('active',button.dataset.captureFilter===captureHistoryFilter));
  list.innerHTML=visible.length?visible.map((p,index)=>{
    const source=hasDetailedIvs(p)?null:captureHistorySource(p),entry=source?{...p,ivs:source.ivs,id:p.id??source.id}:p;
    const capturedAt=entry.capturedAt?formatDateTime(entry.capturedAt):'—',r=rarityInfo(entry.rarity?entry:{...entry,rarity:'Comum'}),level=entry.encounterLevel||entry.level||1;
    const ptypes=entry.types||speciesTypes(entry.name,primaryTypeFor(entry.name)),portraitColor=typeColors[ptypes[0]]||'#82765b',ivEntries=Object.keys(entry.ivs||{}),entryKey=captureHistoryEntryKey(entry,index),open=entryKey===captureLogExpandedKey,isNew=!!entry.isNew;
    return`<article class="capture-log-row ${entry.shiny?'shiny':''} ${rarityTierClass(r)} ${open?'open':''} ${isNew?'is-new':''}" style="--rarity:${r.color}" role="button" tabindex="0" data-capture-key="${entryKey}" aria-expanded="${open}">
      ${isNew?`<span class="capture-new-marker" role="img" title="${t('common.new')}" aria-label="${t('common.new')}">!</span>`:''}
      ${pokePortrait(entry.name,portraitColor,'',entry)}
      <div class="capture-log-copy">
        <div class="capture-log-title"><b>${title(entry.name)}</b>${entry.shiny?'<em class="capture-shiny-pill">✦ SHINY</em>':''}</div>
        <div class="capture-log-badges"><em class="collection-rarity-pill" style="--badge:${r.color}">${r.label}</em><em class="collection-iv-pill" style="--iv-color:${r.color}">IV ${formatPokemonIv(entry)}</em></div>
        <div class="capture-log-meta"><span>${t('common.lv')} ${level}</span><span>${ptypes.map(type=>`${typeIconCircle(type,typeColors[type]||'#777')}${typeLabel(type)}`).join(' / ')}</span><span class="capture-log-ball">${resolveItemLabel(entry.ball)}</span></div>
      </div>
      <time>${capturedAt}</time>
      <section class="capture-log-ivs"${open?' style="display:block"':''}><div class="team-detail-label"><span>IVS</span><b>${t('team.ivsTotal',{value:formatPokemonIv(entry)})}</b></div>${ivEntries.length?pokemonIvsGrid(entry):`<p class="capture-log-ivs-empty">${t('capture.ivUnavailable')}</p>`}</section>
    </article>`
  }).join(''):`<div class="capture-log-empty">${t('capture.empty')}</div>`;
  const newExpanded=[...list.querySelectorAll('.capture-log-row')].find(row=>row.dataset.captureKey===captureLogExpandedKey);list.scrollTop=oldExpandedTop!=null&&newExpanded?oldScrollTop+newExpanded.offsetTop-oldExpandedTop:oldScrollTop;
  $$('#captureLogEntries .poke-portrait img').forEach(centerPortrait);
  $$('#captureLogEntries .capture-log-row').forEach(row=>{
    const setOpen=(target,open)=>{target.classList.toggle('open',open);target.setAttribute('aria-expanded',String(open));target.querySelector('.capture-log-ivs').style.display=open?'block':''};
    const toggle=()=>{const key=row.dataset.captureKey,open=captureLogExpandedKey!==key;captureLogExpandedKey=open?key:null;$$('#captureLogEntries .capture-log-row').forEach(target=>setOpen(target,open&&target.dataset.captureKey===key))};
    row.addEventListener('mouseenter',()=>dismissCaptureMarker(row));
    row.addEventListener('focus',()=>dismissCaptureMarker(row));
    row.addEventListener('click',toggle);
    row.addEventListener('keydown',event=>{if(event.key!=='Enter'&&event.key!==' ')return;event.preventDefault();toggle()});
  });
}
function migrateCapturedLevels(){
  let changed=false;
  state.collection=(Array.isArray(state.collection)?state.collection:[]).map(normalizeCollectionPokemon).filter(Boolean);
  for(const p of state.collection){
    if(!p?.name)continue;
    const score=ivScoreFor(p);
    if(p.ivScore!==score){p.ivScore=score;changed=true}
    if(p.encounterLevel==null){
      p.encounterLevel=p.level||1;
      const primary=primaryTypeFor(p.name);
      p.types=p.types||speciesTypes(p.name,primary);
      p.stats=statsFor(p.name,primary,p.level||1,p.ivs,p.mult||1);
      changed=true;
    }
    if(p.captureProtectionVersion!==1){
      if(shouldProtectCapture(p))p.locked=true;
      p.captureProtectionVersion=1;
      changed=true;
    }
  }
  for(const p of state.captureHistory||[]){
    if(!p?.name)continue;
    const source=hasDetailedIvs(p)?null:captureHistorySource(p);
    if(source?.ivs){p.ivs={...source.ivs};if(p.id==null)p.id=source.id;changed=true}
    if(p.ivScore==null){p.ivScore=ivScoreFor(p);changed=true}
  }
  const pendingCaptures=Math.min(state.notifications?.captures||0,state.captureHistory?.length||0);
  if(pendingCaptures>0&&!state.captureHistory.some(entry=>entry?.isNew)){
    state.captureHistory=state.captureHistory.map((entry,index)=>index<pendingCaptures?{...entry,isNew:true}:entry);
    changed=true;
  }
  if(changed)save();
}
/* ---- Render adiado dos painéis pesados ----
   A Coleção e o Histórico de Capturas sozinhos somavam ~15 mil nós de DOM
   construídos no boot e reconstruídos a cada captura/venda/evolução — mesmo com
   o painel fechado. Isso inflava todo style recalc e toda consulta ao DOM da
   página. Agora, com o painel fechado, o render só marca o painel como sujo;
   ao abrir, renderiza uma vez. */
const dirtyPanelRenders=new Set();
/** Retorna true quando o chamador deve abortar o render (painel fechado). */
function deferPanelRender(layerId){
  const layer=document.getElementById(layerId);
  if(layer&&!layer.classList.contains('hidden'))return false;
  dirtyPanelRenders.add(layerId);
  return true;
}
const floatingPanels={huntPanel:{layer:'huntHistoryModal',button:'huntPanelButton'},capturePanel:{layer:'captureHistoryModal',button:'capturePanelButton'},automationPanel:{layer:'automationPanelLayer',button:'automationPanelButton'},inventoryPanel:{layer:'inventoryPanelLayer',button:'inventoryNavButton'},pokedexPanel:{layer:'pokedexPanelLayer',button:'pokedexNavButton'},collectionPanel:{layer:'collectionPanelLayer',button:'cityDepotButton'},pokemonComparePanel:{layer:'pokemonComparePanelLayer',button:'pokemonCompareNavButton'},chatPanel:{layer:'chatPanelLayer'}};
function clampPanelPosition(panel,x,y){return{x:Math.max(8,Math.min(x,innerWidth-panel.offsetWidth-8)),y:Math.max(74,Math.min(y,innerHeight-panel.offsetHeight-8))}}
function defaultPanelPosition(id,panel){const y=82;if(id==='chatPanel')return{x:14,y:Math.max(74,innerHeight-panel.offsetHeight-14)};if(id==='huntPanel')return{x:14,y};if(id==='capturePanel'||id==='inventoryPanel'||id==='pokedexPanel'||id==='collectionPanel'||id==='pokemonComparePanel')return{x:Math.max(14,Math.round((innerWidth-panel.offsetWidth)/2)),y};return{x:Math.max(14,innerWidth-panel.offsetWidth-14),y}}
function visibleScreenRect(element,gap=12){
  if(!element||element.classList.contains('hidden')||element.classList.contains('closing'))return null;
  const rect=element.getBoundingClientRect();if(rect.width<1||rect.height<1)return null;
  return{left:rect.left-gap,top:rect.top-gap,right:rect.right+gap,bottom:rect.bottom+gap};
}
function occupiedScreenRects(excludeId){
  const elements=[];
  Object.entries(floatingPanels).forEach(([id,config])=>{if(id!==excludeId&&!$(`#${config.layer}`)?.classList.contains('hidden'))elements.push($(`#${id}`))});
  elements.push($('#combatFeedback'),$('#captureFeedback'),$('#levelUpBanner:not(.hidden) .level-up-card'),$('#toast.show'));
  return elements.map(element=>visibleScreenRect(element)).filter(Boolean);
}
function panelOverlapArea(position,width,height,rect){
  const overlapWidth=Math.max(0,Math.min(position.x+width,rect.right)-Math.max(position.x,rect.left));
  const overlapHeight=Math.max(0,Math.min(position.y+height,rect.bottom)-Math.max(position.y,rect.top));
  return overlapWidth*overlapHeight;
}
function freePanelPosition(id,panel,preferred){
  const width=panel.offsetWidth,height=panel.offsetHeight,maxX=Math.max(8,innerWidth-width-8),maxY=Math.max(74,innerHeight-height-8),occupied=occupiedScreenRects(id);
  if(!occupied.length)return clampPanelPosition(panel,preferred.x,preferred.y);
  const xs=new Set([8,maxX,Math.round((8+maxX)/2)]),ys=new Set([74,maxY,Math.round((74+maxY)/2)]),gap=12;
  for(let x=8;x<=maxX;x+=32)xs.add(x);for(let y=74;y<=maxY;y+=32)ys.add(y);
  occupied.forEach(rect=>{xs.add(Math.round(rect.left-width-gap));xs.add(Math.round(rect.right+gap));ys.add(Math.round(rect.top-height-gap));ys.add(Math.round(rect.bottom+gap))});
  const preferredClamped=clampPanelPosition(panel,preferred.x,preferred.y);xs.add(preferredClamped.x);ys.add(preferredClamped.y);
  let best=preferredClamped,bestScore=Infinity;
  xs.forEach(rawX=>ys.forEach(rawY=>{
    const position=clampPanelPosition(panel,rawX,rawY),overlap=occupied.reduce((sum,rect)=>sum+panelOverlapArea(position,width,height,rect),0);
    const distance=Math.abs(position.x-preferredClamped.x)+Math.abs(position.y-preferredClamped.y),score=overlap*10000+distance;
    if(score<bestScore){best=position;bestScore=score}
  }));
  return best;
}
function placeFloatingPanel(id){const panel=$(`#${id}`),saved=floatingPanelPositions[id],fallback=defaultPanelPosition(id,panel),preferred={x:Number.isFinite(saved?.x)?saved.x:fallback.x,y:Number.isFinite(saved?.y)?saved.y:fallback.y},position=freePanelPosition(id,panel,preferred);panel.style.left=`${position.x}px`;panel.style.top=`${position.y}px`;panel.style.right='auto';panel.style.bottom='auto'}
function bringFloatingPanelForward(panel){floatingPanelZ++;panel.closest('.floating-panel-layer').style.zIndex=floatingPanelZ}
function closeFloatingPanel(id){const config=floatingPanels[id];if(!config)return;if(id==='capturePanel')markNavNotificationSeen('captures');if(id==='inventoryPanel'){markNavNotificationSeen('inventory');hideInventoryFloatTip()}$(`#${config.layer}`).classList.add('hidden');if(config.button)$(`#${config.button}`).classList.remove('active')}
function toggleFloatingPanel(id){
  const config=floatingPanels[id],layer=$(`#${config.layer}`),willOpen=layer.classList.contains('hidden');
  if(!willOpen){closeFloatingPanel(id);return}
  // Sai do hidden ANTES de renderizar: os renders pesados abortam enquanto o
  // painel está fechado, então renderizar primeiro deixaria o painel vazio.
  layer.classList.remove('hidden');
  dirtyPanelRenders.delete(config.layer);
  if(id==='huntPanel')renderHuntHistory();
  if(id==='capturePanel')renderCaptureLog();
  if(id==='inventoryPanel')renderPlayerInventory();
  if(id==='pokedexPanel')renderPokedex();
  if(id==='collectionPanel')switchDepositTab(depositActiveTab);
  if(id==='pokemonComparePanel')renderPokemonCompare();
  placeFloatingPanel(id);
  bringFloatingPanelForward($(`#${id}`));
  if(config.button)$(`#${config.button}`)?.classList.add('active');
  tutorialEvent('panel:open',{id});
}
function openHuntWindow(id){toggleFloatingPanel(id)}
/* ---- Battle lab: simulador de espécies + comparador de exemplares possuídos ---- */
const COMPARE_SIDES=['left','right'];
/* Cores das bandas de IV seguem a escada de raridade do jogo (Comum→Lendário). */
const COMPARE_BAND_COLORS={regular:SPECIMEN_RARITIES[0].color,promissor:SPECIMEN_RARITIES[1].color,elite:SPECIMEN_RARITIES[2].color,perfeito:SPECIMEN_RARITIES[4].color};
const COMPARE_POKEMON_LEVEL_MAX=COMPARE_LEVEL_MAX;
const compareLab={
  left:{mode:COMPARE_MODE_SPECIES,species:'',query:'',rarity:'Comum',iv:50,level:50,ownedKey:'',ownedQuery:'',evolution:'',open:false},
  right:{mode:COMPARE_MODE_SPECIES,species:'',query:'',rarity:'Incomum',iv:50,level:50,ownedKey:'',ownedQuery:'',evolution:'',open:false},
};
const compareSlotEl=side=>$(side==='left'?'#compareSlotLeft':'#compareSlotRight');
const compareSearchEl=side=>$(side==='left'?'#compareSearchLeft':'#compareSearchRight');
const compareBandFor=percent=>IV_QUALITY_BANDS.find(band=>percent>=band.min&&percent<=band.max)||(percent<IV_QUALITY_BANDS[0].min?IV_QUALITY_BANDS[0]:IV_QUALITY_BANDS.at(-1));
function compareOwnedRows(){return ownedCompareEntries(state.starter,state.collection)}
function compareOwnedPokemon(key){return compareOwnedRows().find(entry=>entry.key===String(key))?.pokemon||null}
function compareSpeciesMatches(query){
  if(!isPokedexReady())return[];
  const q=String(query||'').trim().toLowerCase(),all=allPokedexSpecies();
  const filtered=q?all.filter(s=>s.name.toLowerCase().includes(q)||s.slug.includes(q)||String(s.id)===q||formatDexNumber(s.id).toLowerCase().includes(q)):all;
  return filtered.slice(0,9);
}
function compareOwnedMatches(query){
  const q=String(query||'').trim().toLowerCase();
  return compareOwnedRows().filter(({pokemon})=>!q||String(pokemon.name||'').toLowerCase().includes(q)||String(pokemon.id||'').toLowerCase().includes(q)).slice(0,20);
}
function compareEvolutionChain(name){
  const chain=chainForSpecies(name);
  return Array.isArray(chain)&&chain.length?chain:[name];
}
function compareEvolutionLabel(species){return pokedexEntry(species)?.name||title(species)}
function compareOwnedIvs(pokemon,ivPercent){
  if(pokemon?.ivs&&Object.keys(pokemon.ivs).length)return{...pokemon.ivs};
  const ivPerStat=Math.max(0,Math.min(31,Math.round(ivPercent/100*31)));
  return{hp:ivPerStat,atk:ivPerStat,def:ivPerStat,spa:ivPerStat,spd:ivPerStat,spe:ivPerStat};
}
function compareSimulate(slot){
  const owned=slot.mode===COMPARE_MODE_OWNED?compareOwnedPokemon(slot.ownedKey):null;
  const ownedSelection=resolveOwnedCompareSelection(slot,owned,chainForSpecies);
  const species=ownedSelection?.species||slot.species,entry=pokedexEntry(species);
  if(!entry)return null;
  const tier=ownedSelection?rarityInfo(ownedSelection.pokemon):SPECIMEN_RARITIES.find(r=>r.name===slot.rarity)||SPECIMEN_RARITIES[0];
  const ownedIvScore=ownedSelection?ivScoreFor(ownedSelection.pokemon):0;
  const ivPercent=ownedSelection?Math.max(0,Math.min(100,Math.round(ownedIvScore/IV_TOTAL_MAX*100))):Math.max(1,Math.min(100,Math.round(Number(slot.iv)||1)));
  const ivPerStat=Math.max(0,Math.min(31,Math.round(ivPercent/100*31))),ivs=ownedSelection?.ivs||compareOwnedIvs(ownedSelection?.pokemon,ivPercent);
  const level=ownedSelection?ownedSelection.level:Math.max(1,Math.min(COMPARE_POKEMON_LEVEL_MAX,Math.round(Number(slot.level)||1)));
  const type=primaryTypeFor(entry.slug),stats=statsFor(entry.slug,type,level,ivs,tier.mult);
  return{entry,tier,level,levelMax:ownedSelection?Math.max(COMPARE_POKEMON_LEVEL_MAX,ownedSelection.actualLevel):COMPARE_POKEMON_LEVEL_MAX,ivScore:ownedSelection?ownedIvScore:ivPerStat*6,ivPercent,stats,power:pokemonPower(stats,tier.mult),types:speciesTypes(entry.slug,type),ownedPokemon:ownedSelection?.pokemon||null,mode:ownedSelection?.mode||COMPARE_MODE_SPECIES,actualLevel:ownedSelection?.actualLevel||null};
}
const compareIvLabel=(slot,model)=>`IV ${model?model.ivScore:0}/${IV_TOTAL_MAX} · ${model?.ivPercent??Math.max(1,Math.min(100,Math.round(Number(slot.iv)||1)))}%`;
function renderCompareDropdown(side){
  const slot=compareLab[side],host=compareSearchEl(side);
  if(!host)return;
  if(!slot.open){host.innerHTML='';host.classList.remove('open');return}
  if(slot.mode===COMPARE_MODE_OWNED){
    const rows=compareOwnedMatches(slot.ownedQuery),empty=!compareOwnedRows().length?t('compare.noOwned'):t('dex.noneFound');
    host.innerHTML=rows.length?rows.map(({key,pokemon})=>{
      const colors=normalizePokemonTypes(pokemon.types,pokemon.name),r=rarityInfo(pokemon);
      return`<button type="button" class="compare-search-option compare-owned-option" data-compare-owned-pick="${side}" data-owned-key="${escHtml(key)}">${pokePortrait(pokemon.name,typeColors[colors[0]]||'#777','',pokemon)}<b>${pokemon.shiny?'✦ ':''}${escHtml(title(pokemon.name))}</b><small>${t('common.lv')} ${Math.max(1,Math.floor(Number(pokemon.level)||1))} · ${escHtml(rarityLabel(r.name))} · ${compareIvLabel({iv:0},{ivScore:ivScoreFor(pokemon),ivPercent:Math.round(ivScoreFor(pokemon)/IV_TOTAL_MAX*100)})}</small></button>`;
    }).join(''):`<div class="compare-search-empty">${empty}</div>`;
  }else{
    const list=compareSpeciesMatches(slot.query);
    host.innerHTML=list.length?list.map(s=>{
      const color=typeColors[(s.types||[])[0]]||'#777';
      return`<button type="button" class="compare-search-option" data-compare-pick="${side}" data-species="${escHtml(s.slug)}">${pokePortrait(s.slug,color)}<b>${escHtml(s.name)}</b><small>${formatDexNumber(s.id)}</small></button>`;
    }).join(''):`<div class="compare-search-empty">${t('dex.noneFound')}</div>`;
  }
  host.classList.add('open');
  host.querySelectorAll('.poke-portrait img').forEach(centerPortrait);
}
function closeCompareSearch(side){
  const slot=compareLab[side];
  if(!slot.open)return;
  slot.open=false;
  if(slot.mode===COMPARE_MODE_OWNED)slot.ownedQuery='';else slot.query='';
  renderCompareDropdown(side);
  const input=compareSlotEl(side)?.querySelector('[data-compare-search]'),model=compareSimulate(slot);
  if(input)input.value=model?(model.ownedPokemon?model.ownedPokemon.name:model.entry.name):'';
}
function compareModeButton(side,mode,label,selected){return`<button type="button" class="compare-mode ${selected?'selected':''}" data-compare-mode="${side}" data-mode="${mode}" aria-pressed="${selected}">${label}</button>`}
function renderCompareSlot(side){
  const host=compareSlotEl(side);
  if(!host)return;
  const slot=compareLab[side],model=compareSimulate(slot),tier=model?.tier||SPECIMEN_RARITIES.find(r=>r.name===slot.rarity)||SPECIMEN_RARITIES[0],owned=model?.ownedPokemon;
  const levelMax=model?.levelMax||COMPARE_POKEMON_LEVEL_MAX;
  const hero=model?`<div class="compare-hero ${owned?'compare-hero-owned':''}">
      ${pokePortrait(model.entry.slug,typeColors[model.types[0]]||tier.color,'',owned)}
      <div class="compare-hero-info"><b>${escHtml(model.entry.name)}</b><small class="compare-hero-types">${model.types.map(tp=>`<em style="--type:${typeColors[tp]||'#9c947e'}">${typeIconCircle(tp,typeColors[tp]||'#9c947e')}${typeLabel(tp,{upper:true})}</em>`).join('')}</small>${owned&&model.entry.slug!==owned.name?`<small class="compare-evolved-hint">${t('compare.evolution')}: ${escHtml(model.entry.name)}</small>`:''}</div>
      <label class="compare-level"><span>${t(owned?'compare.simulatedLevel':'common.lv')}</span><input type="number" min="1" max="${levelMax}" step="1" value="${model.level}" data-compare-level="${side}"></label>
    </div>`:`<div class="compare-hero-empty"><span>?</span><p>${t('compare.pick')}</p></div>`;
  let pickers='';
  if(model&&owned){
    const options=compareEvolutionOptions(compareEvolutionChain(owned.name));
    const chainValue=options.some(option=>option.species===model.entry.slug)?model.entry.slug:owned.name;
    pickers=`<div class="compare-owned-meta"><span>${t('compare.ownedBadge')}</span><small>${t('compare.originalLevel')}: ${model.actualLevel} · ${escHtml(rarityLabel(tier.name))} · ${compareIvLabel(slot,model)}${owned.shiny?` · ${t('compare.shiny')}`:''}</small></div>
    <div class="compare-picker compare-evolution-picker"><label class="eyebrow" for="compareEvolution${side}">${t('compare.evolution')}</label><select id="compareEvolution${side}" data-compare-evolution="${side}" value="${escHtml(chainValue)}">${options.map(option=>`<option value="${escHtml(option.species)}" ${option.species===chainValue?'selected':''}>${escHtml(compareEvolutionLabel(option.species))} · ${t('compare.evolutionRequirement',{level:option.requiredLevel})}</option>`).join('')}</select></div>
    <div class="compare-power"><span>${t('compare.power')}</span><b>${formatNumber(model.power)}</b></div>`;
  }else if(model){
    pickers=`<div class="compare-picker">
      <small class="eyebrow">${t('compare.rarity')}</small>
      <div class="compare-rarity-grid">${SPECIMEN_RARITIES.map(r=>`<button type="button" class="compare-rarity ${r.name===slot.rarity?'selected':''}" style="--rarity:${r.color}" data-compare-rarity="${side}" data-rarity="${escHtml(r.name)}" aria-pressed="${r.name===slot.rarity}"><i></i><b>${escHtml(rarityLabel(r.name))}</b><em>×${formatNumber(r.mult,{minimumFractionDigits:2,maximumFractionDigits:2})}</em></button>`).join('')}</div>
    </div>
    <div class="compare-picker">
      <small class="eyebrow">${t('compare.quality')}</small>
      <div class="compare-iv-chips">${IV_QUALITY_BANDS.map(band=>`<button type="button" class="compare-iv-chip ${band.name===compareBandFor(slot.iv).name?'selected':''}" style="--band:${COMPARE_BAND_COLORS[band.name]||'#a9b5ae'}" data-compare-band="${side}" data-band="${band.name}" aria-pressed="${band.name===compareBandFor(slot.iv).name}"><b>${t(`compare.band.${band.name}`)}</b><small>${band.min}–${band.max}%</small></button>`).join('')}</div>
      <div class="compare-iv-slider"><input type="range" min="1" max="100" step="1" value="${slot.iv}" style="--fill:${slot.iv}%" data-compare-iv="${side}" aria-label="${t('compare.quality')}"><b class="compare-iv-value">${compareIvLabel(slot,model)}</b></div>
    </div>
    <div class="compare-power"><span>${t('compare.power')}</span><b>${formatNumber(model.power)}</b></div>`;
  }
  const searchValue=slot.open?(slot.mode===COMPARE_MODE_OWNED?slot.ownedQuery:slot.query):(model?(owned?owned.name:model.entry.name):'');
  host.innerHTML=`<article class="compare-card ${rarityTierClass(tier)} ${owned?'compare-card-owned':''}" style="--rarity:${tier.color}">
    <small class="compare-side">${t(side==='left'?'compare.left':'compare.right')}</small>
    <div class="compare-mode-switch" role="tablist" aria-label="${escHtml(t('compare.modeLabel'))}">${compareModeButton(side,COMPARE_MODE_SPECIES,t('compare.modeSpecies'),slot.mode===COMPARE_MODE_SPECIES)}${compareModeButton(side,COMPARE_MODE_OWNED,t('compare.modeOwned'),slot.mode===COMPARE_MODE_OWNED)}</div>
    <div class="compare-search-wrap">
      <div class="compare-search"><span>⌕</span><input type="text" value="${escHtml(searchValue)}" placeholder="${escHtml(t(slot.mode===COMPARE_MODE_OWNED?'compare.searchOwned':'compare.search'))}" data-compare-search="${side}" autocomplete="off" spellcheck="false">${model?`<button type="button" class="compare-search-clear" data-compare-clear="${side}" aria-label="×">×</button>`:''}</div>
      <div class="compare-search-results" id="${side==='left'?'compareSearchLeft':'compareSearchRight'}"></div>
    </div>
    ${hero}
    ${pickers}
  </article>`;
  if(slot.open)renderCompareDropdown(side);
  host.querySelectorAll('.poke-portrait img').forEach(centerPortrait);
}
function syncCompareSlotLive(side){
  const host=compareSlotEl(side);
  if(!host)return;
  const slot=compareLab[side],model=compareSimulate(slot);
  if(!model)return;
  const band=compareBandFor(model.ivPercent),range=host.querySelector('[data-compare-iv]');
  if(range)range.style.setProperty('--fill',`${slot.iv}%`);
  const label=host.querySelector('.compare-iv-value');
  if(label)label.textContent=compareIvLabel(slot,model);
  host.querySelectorAll('.compare-iv-chip').forEach(chip=>chip.classList.toggle('selected',chip.dataset.band===band.name));
  const power=host.querySelector('.compare-power b');
  if(power)power.textContent=formatNumber(model.power);
}
function renderCompareOutcome(){
  const left=compareSimulate(compareLab.left),right=compareSimulate(compareLab.right),versus=$('#compareVersus'),results=$('#pokemonCompareResults');
  if(!versus||!results)return;
  const complete=!!(left&&right),delta=complete?right.power-left.power:0;
  const percent=complete?Math.round(Math.abs(delta)/Math.max(1,Math.min(left.power,right.power))*100):0;
  const verdict=complete?(delta===0?`<b>${t('compare.tie')}</b>`:`<b>${t('compare.wins',{name:title((delta>0?right:left).entry.name)})}</b><small>${t('compare.powerLead',{percent})}</small>`):'';
  versus.innerHTML=`<span class="compare-vs-badge">VS</span><div class="compare-versus-verdict">${verdict}</div><button type="button" class="compare-swap" id="pokemonCompareSwap" data-i18n-aria-label="compare.swap" aria-label="${escHtml(t('compare.swap'))}">⇄</button>`;
  if(!complete){results.innerHTML=`<div class="compare-outcome-empty">${t('compare.needBoth')}</div>`;return}
  const statRow=(label,l,r,big=false)=>{
    const max=Math.max(l,r,1);
    return`<div class="compare-stat-row ${big?'compare-stat-total':''}"><b class="${l>r?'lead-l':''}">${formatNumber(l)}</b><div class="compare-stat-mid"><span>${label}</span><div class="compare-bars"><u class="cl"><i style="width:${Math.round(l/max*100)}%"></i></u><u class="cr"><i style="width:${Math.round(r/max*100)}%"></i></u></div></div><b class="${r>l?'lead-r':''}">${formatNumber(r)}</b></div>`;
  };
  results.innerHTML=`<section class="compare-results" style="--cl:${left.tier.color};--cr:${right.tier.color}">
    <small class="eyebrow">${t('compare.results')}</small>
    ${['hp','atk','def','spa','spd','spe'].map(key=>statRow(t(`dex.stat.${key}`),left.stats[key],right.stats[key])).join('')}
    ${statRow(t('compare.power'),left.power,right.power,true)}
  </section>`;
}
function renderPokemonCompare(){
  if(deferPanelRender('pokemonComparePanelLayer'))return;
  if(!$('#pokemonComparePanel'))return;
  if(!isPokedexReady()){loadPokedexData().then(()=>{if(!$('#pokemonComparePanelLayer')?.classList.contains('hidden'))renderPokemonCompare()});return}
  renderCompareSlot('left');renderCompareSlot('right');renderCompareOutcome();
}
function closeHuntWindows(){Object.keys(floatingPanels).filter(id=>id!=='chatPanel').forEach(closeFloatingPanel)}
function initFloatingPanels(){
  Object.keys(floatingPanels).forEach(id=>{
    const panel=$(`#${id}`);
    if(!panel)return;
    const handle=panel.querySelector('.floating-panel-handle');
    const layer=$(`#${floatingPanels[id].layer}`);
    panel.addEventListener('pointerdown',()=>bringFloatingPanelForward(panel));
    handle?.addEventListener('pointerdown',event=>{
      if(event.button!==0||event.target.closest('button,input,label,select'))return;
      event.preventDefault();
      bringFloatingPanelForward(panel);
      const rect=panel.getBoundingClientRect(),startX=event.clientX,startY=event.clientY;
      panel.classList.add('dragging');
      const move=moveEvent=>{
        const position=clampPanelPosition(panel,rect.left+moveEvent.clientX-startX,rect.top+moveEvent.clientY-startY);
        panel.style.left=`${position.x}px`;
        panel.style.top=`${position.y}px`;
      };
      const stop=()=>{
        panel.classList.remove('dragging');
        floatingPanelPositions[id]={x:parseFloat(panel.style.left),y:parseFloat(panel.style.top)};
        localStorage.setItem('idlemon-panel-positions',JSON.stringify(floatingPanelPositions));
        removeEventListener('pointermove',move);
        removeEventListener('pointerup',stop);
      };
      addEventListener('pointermove',move);
      addEventListener('pointerup',stop,{once:true});
    });
    if(layer&&!layer.classList.contains('hidden'))placeFloatingPanel(id);
  });
  addEventListener('resize',()=>Object.entries(floatingPanels).forEach(([id,config])=>{
    if(!$(`#${config.layer}`)?.classList.contains('hidden'))placeFloatingPanel(id);
  }));
  // Redimensionar a janela ou dar zoom muda a escala do mundo. O canvas se
  // ajusta sozinho, mas a camada DOM dos atores só é reposicionada aqui —
  // sem isto os sprites ficariam um frame fora de lugar após o zoom.
  addEventListener('resize',()=>updateRouteCamera());
}
function captureChanceFor(ball,speciesName,enemyLevel=state.enemy?.level||1){
  if(!ball)return 0;
  const entry=pokedexEntry(speciesName);
  const meta=arguments[3]||{};
  const zoneSpecial=!!(meta.zoneLegendary||meta.zoneMythical);
  return balancedCaptureChance({
    ballPower:ball.capture,
    enemyLevel,
    speciesFactor:speciesCatchFactor(entry),
    legendary:!!(entry?.legendary||entry?.rarity==='Lendário'||entry?.rarity==='Mítico'||zoneSpecial),
    trainerMultiplier:trainerAccountPerks().captureMultiplier,
    boss:!!meta.boss||zoneSpecial,
    keeper:!!meta.keeper,
    zoneSpecial,
    ballSlug:ball.slug,
  });
}
function nextCaptureId(){return globalThis.crypto?.randomUUID?.()||`capture-${Date.now()}-${++captureIdSequence}`}
const CAPTURE_FEEDBACK_MS=12000,CAPTURE_TOAST_MS=2800,CAPTURE_QUEUE_MAX=5,CAPTURE_TOAST_QUEUE_MAX=8;
let recentFaints=[],captureToastQueue=[],captureToastShowing=false,captureFeedbackTimer=null,captureFeedbackCloseAnim=null,captureFeedbackMode='panel';
function captureToastPriority(result){const tier=Math.max(0,SPECIMEN_RARITIES.findIndex(entry=>entry.name===result?.rarity?.name));return(result?.shiny?1000:0)+((result?.ivTotal??0)>=88?300:0)+tier*20+(result?.ok?10:0)}
function enqueueCaptureToast(result){captureToastQueue.push(result);captureToastQueue.sort((a,b)=>captureToastPriority(b)-captureToastPriority(a));if(captureToastQueue.length>CAPTURE_TOAST_QUEUE_MAX)captureToastQueue.length=CAPTURE_TOAST_QUEUE_MAX}
function faintSnapshot(wild){
  return{
    id:wild.id||`faint-${Date.now()}-${Math.floor(Math.random()*1e5)}`,
    name:wild.name,
    level:wild.level||1,
    types:[...(wild.types||speciesTypes(wild.name,primaryTypeFor(wild.name)))],
    hpPct:typeof wild.hp==='number'?wild.hp:100,
    liveWildId:wild.id,
    x:Number.isFinite(wild.x)?wild.x:null,
    y:Number.isFinite(wild.y)?wild.y:null,
    dir:wild.dir||'south',
    at:Date.now(),
    status:'ready',
    shiny:!!wild.shiny,
    boss:!!wild.boss,
    zoneLegendary:!!wild.zoneLegendary,
    zoneMythical:!!wild.zoneMythical,
    speciesRarity:wild.speciesRarity||pokedexEntry(wild.name)?.rarity||'Comum',
    encounterId:wild.encounterId||null,
    specimenRarity:wild.specimenRarity||null,
    specimenMult:wild.specimenMult||null,
    speciesFactor:wild.speciesFactor||null,
  };
}
function isPremiumBall(slug){return slug==='masterball'||slug==='apexball'}
function selectableCaptureBalls(){
  return BALLS.filter(b=>!isPremiumBall(b.slug)||(state.inventory[b.slug]||0)>0);
}
function hideCaptureFeedback({clearQueue=false}={}){
  clearTimeout(captureFeedbackTimer);captureFeedbackTimer=null;
  if(clearQueue){recentFaints=[];captureToastQueue=[];captureToastShowing=false}
  const box=$('#captureFeedback');
  if(!box||box.classList.contains('hidden')||box.classList.contains('closing')){
    return;
  }
  const wasToast=captureFeedbackMode==='toast';
  box.classList.remove('paused');box.classList.add('closing');
  clearTimeout(captureFeedbackCloseAnim);
  captureFeedbackCloseAnim=setTimeout(()=>{
    box.classList.add('hidden');box.classList.remove('closing','toast-mode','result-ok','result-fail');
    if(clearQueue)captureToastShowing=false;
    if(wasToast){captureToastShowing=false;const next=!clearQueue&&captureToastQueue.shift();if(next)showCaptureToast(next)}
  },220);
}
/** Passos do tutorial que vivem dentro do painel de captura. */
const TUTORIAL_CAPTURE_STEPS=['capture-panel','capture-ball'],TUTORIAL_CAPTURE_HOLD_MS=90000;
function restartCaptureFeedbackTimer(ms=CAPTURE_FEEDBACK_MS){
  const box=$('#captureFeedback');
  box?.style.setProperty('--capture-feedback-duration',`${ms}ms`);
  const bar=$('#captureFeedbackTimer');
  if(bar){bar.style.animation='none';void bar.offsetWidth;bar.style.animation=''}
  clearTimeout(captureFeedbackTimer);
  // Enquanto o tutorial aponta para dentro do painel, dá folga para ler (mas ainda fecha sozinho).
  if(TUTORIAL_CAPTURE_STEPS.includes(activeTutorialStepId())){
    ms=Math.max(ms,TUTORIAL_CAPTURE_HOLD_MS);
    box?.style.setProperty('--capture-feedback-duration',`${ms}ms`);
  }
  captureFeedbackTimer=setTimeout(()=>hideCaptureFeedback({clearQueue:captureFeedbackMode==='panel'}),ms);
}
function commitCaughtPokemon(caughtPokemon,{quiet=false,shiny=false,quality=null,target=null,chance=0,ball=null}={}){
  const targetName=caughtPokemon.name;
  const isNew=addNavNotification('captures',1);
  state.collection.unshift(caughtPokemon);state.captureHistory.unshift(captureHistorySnapshot(caughtPokemon,{isNew}));state.captureHistory=state.captureHistory.slice(0,100);
  state.stats.captured++;
  // Só o que é notável vira aviso no chat; capturas comuns encheriam a janela.
  if(shiny||caughtPokemon.boss||caughtPokemon.zoneLegendary){
    try{
      pushChatSystemMessage(t('chat.systemCapture',{
        trainer:state.trainer?.name||t('profile.trainer'),
        name:title(targetName),
        tag:shiny?'✦ shiny':t('boss.label'),
      }));
    }catch(error){console.warn('chat system message failed',error)}
  }
  if(shiny)state.shinyResearch[targetName]=0;
  const huntCap=huntSession();
  if(huntCap){const captureValue=pokemonSellPrice(caughtPokemon,pokedexEntry(targetName))||0;huntCap.capturesValue+=captureValue;recordHuntEvent({caps:1,capValue:captureValue})}
  try{
    trackQuestProgress('capture',1);
    if(shiny)logShinyCapture(state,targetName);
    if(quality)logIvQualityCapture(state,quality);
    checkAchievements(state);
  }catch{}
  if($('#pokedexCount')&&isPokedexReady())$('#pokedexCount').textContent=allPokedexSpecies().filter(s=>(ownedBySpecies().get(s.slug)||[]).length>0).length;
  addLog(t('log.captured',{level:caughtPokemon.level,rarity:rarityLabel(caughtPokemon.rarity),iv:formatPokemonIv(caughtPokemon)}),`${shiny?'✨ ':''}${title(targetName)}`);
  if(shiny){showToast(t('shiny.captured',{name:title(targetName)}));addLog(t('shiny.captured',{name:title(targetName)}),`✦ ${title(targetName)}`)}
  else if(!quiet)showToast(t('log.capturedToast',{name:title(targetName),level:caughtPokemon.level,rarity:rarityLabel(caughtPokemon.rarity)}));
  if(target?.zoneLegendary||target?.zoneMythical)noteZoneSpecialResolved(target);
  if(target?.liveWildId||target?.id)removeCapturedWild(target.liveWildId||target.id);
  renderCollection();renderCaptureLog();renderPartnerHud();
  const r=rarityInfo({rarity:caughtPokemon.rarity,mult:caughtPokemon.mult});
  tutorialEvent('capture:success',{species:targetName});
  return{ok:true,reason:'caught',name:targetName,level:caughtPokemon.encounterLevel||target?.level||1,types:caughtPokemon.types||[],chance,ball,rarity:r,ivs:caughtPokemon.ivs,ivScore:caughtPokemon.ivScore,ivTotal:caughtPokemon.ivTotal,ivQuality:caughtPokemon.ivQuality,shiny};
}
async function attemptCapture(target,{ballSlug=selectedBall,quiet=false}={}){
  if(!target?.name)return null;
  const targetName=target.name,targetLevel=target.level||1;
  const ball=ITEM_BY_SLUG[ballSlug];
  if(!ball||(state.inventory[ballSlug]||0)<=0){
    const ballLabel=ball?displayItem(ball.slug):displayItem('pokeball');
    addLog(t('log.noBall',{ball:ballLabel}));
    if(!quiet)showToast(t('log.noBallToast',{ball:ballLabel}));
    return{ok:false,reason:'no-ball',name:targetName,level:targetLevel,types:target.types||[],chance:0,ball:ball||null,rarity:null,shiny:false};
  }
  // Com coleção no servidor, captura SEM encounterId vira fantasma (some no F5).
  // Bloqueia antes de debitar bola; só rolo local quando sync de coleção está off.
  const collectionOnServer=collectionSyncEnabled();
  const useServerCapture=(serverGameplayReady()||collectionOnServer)&&!!target.encounterId;
  if(collectionOnServer&&!useServerCapture){
    ensureEncounterQueue({
      route:encounterRouteLevel(),
      routeType:encounterRouteKey(),
      species:state.huntMode==='species'?state.huntSpecies:null,
      min:Math.max(10,routeWildTargetCount()),
    }).catch(()=>{});
    addLog(t('log.noEncounter',{name:title(targetName)}));
    if(!quiet)showToast(t('log.noEncounterToast'));
    return{ok:false,reason:'no-encounter',name:targetName,level:targetLevel,types:target.types||[],chance:0,ball,rarity:null,shiny:false};
  }
  const inventoryOnServer=inventorySyncEnabled();
  if(useServerCapture){
    // attempt_capture debita a bola
  }else if(inventoryOnServer){
    const debited=await consumeGameplayItem(ballSlug,1);
    if(!debited){
      const ballLabel=displayItem(ball.slug);
      addLog(t('log.noBall',{ball:ballLabel}));
      if(!quiet)showToast(t('log.noBallToast',{ball:ballLabel}));
      return{ok:false,reason:'no-ball',name:targetName,level:targetLevel,types:target.types||[],chance:0,ball,rarity:null,shiny:false};
    }
  }else{
    state.inventory[ballSlug]--;renderInventory();renderBallSelect();
  }
  const huntBall=huntSession();
  if(huntBall){huntBall.supplyValue+=ball.price||0;huntBall.ballsUsed++;recordHuntEvent({supply:ball.price||0})}
  const isShinyTarget=!!target.shiny;
  const entry=pokedexEntry(targetName);
  const speciesRarity=target.speciesRarity||entry?.rarity||'Comum';
  const chance=isShinyTarget?shinyCaptureChance(speciesRarity,ball.capture||1):captureChanceFor(ball,targetName,targetLevel,{
    boss:!!target.boss,
    keeper:!!target.keeper,
    zoneLegendary:!!target.zoneLegendary,
    zoneMythical:!!target.zoneMythical,
  });

  if(useServerCapture){
    try{
      const response=await serverAttemptCapture({
        encounterId:target.encounterId,
        ball:ball.slug,
        moves:isMovesReady()?defaultLoadout(targetName,1):[],
      });
      if(response?.inventory)applyServerInventory(response.inventory,{force:true});
      else{
        state.inventory[ballSlug]=Math.max(0,(state.inventory[ballSlug]||0)-1);
        renderInventory();renderBallSelect();
      }
      if(!response?.ok){
        addLog(t('log.escaped',{name:title(targetName),ball:displayItem(ball.slug),chance:Math.round((response?.chance||chance)*100),difficulty:localizedCatchDifficulty(entry,response?.chance||chance)}));
        return{ok:false,reason:'escaped',name:targetName,level:targetLevel,types:target.types||[],chance:response?.chance||chance,ball,rarity:null,shiny:false};
      }
      const caught=response.local;
      if(!caught.types?.length)caught.types=speciesTypes(targetName,route()[0]);
      if(!caught.stats)caught.stats=statsFor(targetName,caught.types[0],caught.level||1,caught.ivs,caught.mult||1);
      if(!caught.ball||caught.ball===ball.slug)caught.ball=ball.name;
      return commitCaughtPokemon(caught,{quiet,shiny:!!caught.shiny,quality:caught.ivQuality,target,chance:response.chance||chance,ball});
    }catch(error){
      // A capture RPC can debit the ball before rejecting on a server cap. Reconcile
      // the authoritative inventory before rendering the failure.
      const failureReason=captureErrorReason(error);
      if(inventoryOnServer){
        try{await refreshInventory()}catch(refreshError){console.warn('capture inventory refresh failed',refreshError)}
      }else{
        // Falha local: não houve autoridade remota para confirmar o débito.
        state.inventory[ballSlug]=(state.inventory[ballSlug]||0)+1;renderInventory();renderBallSelect();
      }
      console.warn('server capture failed',error);
      if(!quiet)showToast(t(captureFailureMessageKey(failureReason))||'Capture sync failed');
      return{ok:false,reason:failureReason,name:targetName,level:targetLevel,types:target.types||[],chance,ball,rarity:null,shiny:false};
    }
  }

  // Rolo local só sem coleção no servidor — bola já debitada acima
  if(Math.random()>chance){
    addLog(t('log.escaped',{name:title(targetName),ball:displayItem(ball.slug),chance:Math.round(chance*100),difficulty:localizedCatchDifficulty(entry,chance)}));
    return{ok:false,reason:'escaped',name:targetName,level:targetLevel,types:target.types||[],chance,ball,rarity:null,shiny:false};
  }
  const r=rollSpecimenRarity(),rolled=rollIvs(),shiny=isShinyTarget?true:false,ivs=rolled.ivs,ivScore=rolled.ivScore,ivTotal=rolled.ivTotal,capturedLevel=1;
  const capturedStats=statsFor(targetName,route()[0],capturedLevel,ivs,r.mult),capturedTypes=speciesTypes(targetName,route()[0]);
  const caughtPokemon={id:nextCaptureId(),name:targetName,level:capturedLevel,xp:0,encounterLevel:targetLevel,capturedAt:Date.now(),ball:ball.name,rarity:r.name,mult:r.mult,color:r.color,ivs,ivScore,ivTotal,ivQuality:rolled.quality,shiny,locked:shouldProtectCapture({shiny,ivTotal,rarity:r.name}),captureProtectionVersion:1,types:capturedTypes,stats:capturedStats,equippedMoves:isMovesReady()?defaultLoadout(targetName,1):[],autoMoves:true,moveCursor:0,aoeMove:null};
  return commitCaughtPokemon(caughtPokemon,{quiet,shiny,quality:rolled.quality,target,chance,ball});
}
async function capture(wild=routeSim.target){
  return attemptCapture(wild||state.enemy,{quiet:false});
}
const CAPTURE_BALL_FX=Object.freeze({
  pokeball:{accent:'#e3350d',glow:'#ff8a65'},
  greatball:{accent:'#7c5cff',glow:'#ef4444'},
  superball:{accent:'#f07178',glow:'#ffe8e8'},
  ultraball:{accent:'#f5c518',glow:'#2b2317'},
  masterball:{accent:'#a855f7',glow:'#f472b6'},
  apexball:{accent:'#38bdf8',glow:'#f5c518'}
});
function playCaptureAttempt(target,result){
  const layer=fxLayer(),ball=result?.ball;
  if(!layer||!ball?.img||!Number.isFinite(target?.x)||!Number.isFinite(target?.y))return Promise.resolve();
  const fromX=Number.isFinite(routeSim.player?.x)?routeSim.player.x:50,fromY=Number.isFinite(routeSim.player?.y)?routeSim.player.y:82;
  const throwAngle=Math.atan2(target.y-fromY,target.x-fromX)*180/Math.PI;
  const palette=CAPTURE_BALL_FX[ball.slug]||CAPTURE_BALL_FX.pokeball;
  const fx=document.createElement('div');
  fx.className=`capture-attempt-fx ball-${ball.slug||'pokeball'}`;
  fx.style.setProperty('--capture-from-x',`${fromX}%`);
  fx.style.setProperty('--capture-from-y',`${fromY}%`);
  fx.style.setProperty('--capture-to-x',`${target.x}%`);
  fx.style.setProperty('--capture-to-y',`${target.y}%`);
  fx.style.setProperty('--throw-angle',`${throwAngle.toFixed(1)}deg`);
  fx.style.setProperty('--ball-accent',palette.accent);
  fx.style.setProperty('--ball-glow',palette.glow);
  fx.innerHTML=`<span class="capture-attempt-target" style="${pokemonSpriteScaleStyle(target.name)}"><img src="${entityAsset(target.name,target.dir||'south',0)}" alt=""></span><span class="capture-attempt-throw" aria-hidden="true"><i class="capture-attempt-streak"></i><i class="capture-attempt-streak"></i><i class="capture-attempt-streak"></i><img class="capture-attempt-ball" src="${ball.img}" alt="${displayItem(ball.slug)}"></span><span class="capture-attempt-impact"></span><span class="capture-attempt-spark"></span><b class="capture-attempt-result"></b>`;
  layer.appendChild(fx);
  const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const impactAt=reduced?40:480,resolveAt=reduced?140:1380,finishAt=reduced?420:2050;
  return new Promise(resolve=>{
    setTimeout(()=>fx.classList.add('impact'),impactAt);
    setTimeout(()=>{
      fx.classList.add(result.ok?'caught':'escaped');
      playImpactSprite(target.x,target.y,result.ok?24:23,8);
      const label=fx.querySelector('.capture-attempt-result');
      if(label)label.textContent=result.ok?t('capture.caught'):t(captureFailureMessageKey(result.reason));
    },resolveAt);
    setTimeout(()=>{fx.remove();resolve()},finishAt);
  });
}
function renderCaptureBallStrip(){
  const strip=$('#captureFeedbackBalls');if(!strip)return;
  const balls=selectableCaptureBalls();
  if(!balls.some(b=>b.slug===selectedBall))selectedBall=balls.find(b=>(state.inventory[b.slug]||0)>0)?.slug||balls[0]?.slug||'pokeball';
  strip.innerHTML=balls.map(b=>{
    const qty=state.inventory[b.slug]||0;
    return`<button type="button" class="capture-ball-pill ${selectedBall===b.slug?'active':''}" data-capture-ball="${b.slug}" ${qty<=0?'disabled':''} title="${displayItem(b.slug)}">${itemIcon(b.slug)}<em>${qty}</em></button>`;
  }).join('');
  $$('#captureFeedbackBalls [data-capture-ball]').forEach(btn=>{
    btn.onclick=()=>{
      if(btn.disabled)return;
      selectedBall=btn.dataset.captureBall;
      state.selectedBall=selectedBall;
      renderBallSelect();
      renderCapturePanel();
      save();
    };
  });
}
function renderCapturePanel(){
  const box=$('#captureFeedback'),body=$('#captureFeedbackBody'),badge=$('#captureFeedbackBadge'),balls=$('#captureFeedbackBalls');
  if(!box||!body)return;
  captureFeedbackMode='panel';
  box.classList.remove('toast-mode','result-ok','result-fail');
  if(balls)balls.hidden=false;
  const readyCount=recentFaints.filter(f=>f.status==='ready').length;
  if(badge){
    badge.hidden=!recentFaints.length;
    badge.textContent=t('capture.ready',{count:readyCount});
  }
  renderCaptureBallStrip();
  const ball=ITEM_BY_SLUG[selectedBall];
  body.innerHTML=`<div class="capture-feedback-list">${recentFaints.map(faint=>{
    const colors=faint.types.map(tp=>typeColors[tp]||'#777');
    const typeBg=colors.length>1?`linear-gradient(90deg,${colors[0]} 0 48%,${colors[1]} 52% 100%)`:colors[0];
  const chance=ball?Math.round((faint.shiny?shinyCaptureChance(faint.speciesRarity||pokedexEntry(faint.name)?.rarity||'Comum',ball.capture||1):captureChanceFor(ball,faint.name,faint.level,{boss:!!faint.boss,zoneLegendary:!!faint.zoneLegendary,zoneMythical:!!faint.zoneMythical}))*100):0;
    const hasBall=(state.inventory[selectedBall]||0)>0;
    let action='';
    if(faint.status==='ready'){
      action=hasBall
        ?`<button type="button" class="capture-throw-btn" data-throw-faint="${faint.id}">${t('capture.throw')}</button>`
        :`<span class="capture-faint-status no-ball">${t('capture.noBall')}</span>`;
    }else if(faint.status==='caught'){
      const reward=faint.result?`${faint.result.shiny?'✨ SHINY · ':''}${rarityLabel(faint.result.rarity?.name||'Comum')} · IV ${formatPokemonIv(faint.result)}`:'';
      action=`<span class="capture-faint-status caught">${t('capture.caught')}${reward?`<small>${reward}</small>`:''}</span>`;
    }else if(faint.status==='escaped'){
      action=`<span class="capture-faint-status escaped">${t('capture.escaped')}</span>`;
    }else if(faint.status==='attempting'){
      action=`<span class="capture-faint-status attempting">${t('capture.throw')}…</span>`;
    }else{
      action=`<span class="capture-faint-status no-ball">${t('capture.noBall')}</span>`;
    }
    return`<article class="capture-faint-row ${shinyClassFor(faint)}" data-faint-id="${faint.id}" style="--slot-color:${colors[0]||'#82765b'}">
      <span class="capture-faint-portrait ${shinyClassFor(faint)}"><img src="${entityAsset(faint.name,'south',0,{shiny:!!faint.shiny})}" alt="${title(faint.name)}"></span>
      <div class="capture-faint-copy">
        <b>${title(faint.name)}</b>
        <div class="capture-faint-meta">
          <small>${t('common.lv')} ${faint.level}</small>
          <span class="capture-faint-type" style="--type-color:${typeBg}">${typeBadgeContent(faint.types)}</span>
          ${faint.status==='ready'?`<span class="capture-faint-chance">${t('capture.hpChance',{hp:Math.round(faint.hpPct),pct:chance})}</span>`:''}
        </div>
      </div>
      ${action}
    </article>`;
  }).join('')}</div>`;
  body.querySelectorAll('.capture-faint-portrait img').forEach(centerPortrait);
  $$('#captureFeedbackBody [data-throw-faint]').forEach(btn=>{
    btn.onclick=()=>throwAtFaint(btn.dataset.throwFaint,btn);
  });
}
function showCapturePanel(){
  const box=$('#captureFeedback');if(!box||!recentFaints.length)return;
  captureToastQueue=[];captureToastShowing=false;
  clearTimeout(captureFeedbackCloseAnim);
  box.classList.remove('hidden','closing','paused','toast-mode');
  renderCapturePanel();
  applyStaticI18n(box);
  restartCaptureFeedbackTimer(CAPTURE_FEEDBACK_MS);
}
function showCaptureToast(result){
  const box=$('#captureFeedback'),body=$('#captureFeedbackBody'),badge=$('#captureFeedbackBadge'),balls=$('#captureFeedbackBalls');
  if(!box||!body||!result||result.skipped)return;
  if(captureToastShowing){enqueueCaptureToast(result);return}
  captureToastShowing=true;
  recentFaints=[];
  captureFeedbackMode='toast';
  clearTimeout(captureFeedbackCloseAnim);
  if(badge)badge.hidden=true;
  if(balls)balls.hidden=true;
  box.classList.remove('hidden','closing','paused');
  box.classList.add('toast-mode');
  box.classList.toggle('result-ok',!!result.ok);
  box.classList.toggle('result-fail',!result.ok);
  const rare=!!(result.ok&&(result.shiny||(result.ivTotal??0)>=88||['Lendário','Mítico','Celestial','Ancião','Secreto'].includes(result.rarity?.name)));
  const statusLabel=result.ok
    ?`<span class="ok-label">${t('capture.autoCaught')}</span>`
    :`<span class="fail-label">${t(captureFailureMessageKey(result.reason))}</span>`;
  body.innerHTML=`<div class="capture-toast-card ${result.ok?'ok':'fail'}${rare?' rare':''}">
    <span class="capture-toast-ball">${result.ball?itemIcon(result.ball.slug):''}</span>
    <span class="capture-faint-portrait ${shinyClassFor(result)}" style="--slot-color:${typeColors[(result.types||[])[0]]||'#82765b'}"><img src="${entityAsset(result.name,'south',0,{shiny:!!result.shiny})}" alt="${title(result.name)}"></span>
    <div class="capture-toast-copy">
      <b>${title(result.name)}</b>
      ${statusLabel}
      ${result.ok?`<strong class="capture-toast-reward">${result.shiny?'✨ SHINY · ':''}${rarityLabel(result.rarity?.name||'Comum')} · IV ${formatPokemonIv(result)}</strong>`:''}
    </div>
  </div>`;
  body.querySelectorAll('img').forEach(centerPortrait);
  applyStaticI18n(box);
  restartCaptureFeedbackTimer(CAPTURE_TOAST_MS);
}
async function throwAtFaint(id,button){
  const faint=recentFaints.find(f=>f.id===id);
  if(!faint||faint.status!=='ready')return;
  if(button){button.disabled=true;button.classList.add('throwing')}
  const result=await attemptCapture(faint,{quiet:true});
  if(!result||result.reason==='no-ball'||result.reason==='sync-failed'){
    faint.status='no-ball';
    renderCapturePanel();
    return;
  }
  if(result.skipped){
    faint.status='escaped';
    renderCapturePanel();
    return;
  }
  faint.status='attempting';
  renderCapturePanel();
  // O tutorial avança na tentativa: fugir também é um resultado válido de aprendizado.
  tutorialEvent('capture:attempt',{name:faint.name});
  restartCaptureFeedbackTimer(CAPTURE_FEEDBACK_MS);
  playCaptureAttempt(faint,result).then(()=>{
    faint.status=result.ok?'caught':'escaped';
    faint.result=result;
    renderCapturePanel();
    const row=$(`#captureFeedbackBody [data-faint-id="${id}"]`);
    if(row){row.classList.add(result.ok?'flash-ok':'flash-fail');setTimeout(()=>row.classList.remove('flash-ok','flash-fail'),450)}
    restartCaptureFeedbackTimer(CAPTURE_FEEDBACK_MS);
  });
}
function removeCapturedWild(wildId){
  const wild=routeSim.wilds.find(entry=>entry.id===wildId);if(!wild)return;
  const wasTarget=routeSim.target===wild;routeSim.wilds=routeSim.wilds.filter(entry=>entry!==wild);if(wasTarget)routeSim.target=null;
  recentFaints=recentFaints.filter(entry=>entry.liveWildId!==wildId);$(`#${wildId}`)?.remove();routeSim.spawnTimer=performance.now()+380;
  $('#battleStatus').textContent=t('battle.searchingNext');
}
function offerWildForCapture(wild){
  if(!wild?.name)return;
  if(wild.captureOffered)return;wild.captureOffered=true;
  const snap=faintSnapshot(wild);
  const autoCaptureUnlocked=trainerAccountPerks().autoCaptureUnlocked;
  const shouldAutoCapture=autoCaptureUnlocked&&(snap.shiny?state.autoShiny:state.autoCapture);
  if(shouldAutoCapture){
    // Shiny e encontros normais respeitam as bolas escolhidas separadamente.
    const ballSlug=snap.shiny?(selectedShinyBall||state.selectedShinyBall||''):(selectedBall||state.selectedBall||'');
    if(!ballSlug||(state.inventory[ballSlug]||0)<=0){
      showCaptureToast({ok:false,reason:'no-ball',name:snap.name,level:snap.level,types:snap.types,chance:0,ball:ITEM_BY_SLUG[ballSlug]||null,rarity:null,shiny:false});
      return;
    }
    if(trainerAccountPerks().autoRestock){
      for(const slug of ['pokeball','greatball']){
        if((state.inventory[slug]||0)<=0&&state.stats.coins>=(ITEM_BY_SLUG[slug]?.price||40)){
          if(serverGameplayReady()&&walletSyncEnabled()){
            purchaseShopItem(slug,1,crypto.randomUUID()).then(response=>{
              if(response?.wallet)acceptMarketWallet(response.wallet);
              if(response?.inventory)applyServerInventory(response.inventory,{force:true});
              else state.inventory[slug]=(state.inventory[slug]||0)+1;
              renderInventory();renderBallSelect();
            }).catch(()=>{});
          }else{
            state.stats.coins-=ITEM_BY_SLUG[slug].price;state.inventory[slug]=(state.inventory[slug]||0)+1;
          }
        }
      }
    }
    // Revalida após restock: ainda só usa a bola selecionada.
    if((state.inventory[ballSlug]||0)<=0){
      showCaptureToast({ok:false,reason:'no-ball',name:snap.name,level:snap.level,types:snap.types,chance:0,ball:ITEM_BY_SLUG[ballSlug]||null,rarity:null,shiny:false});
      return;
    }
    const resultPromise=attemptCapture(snap,{ballSlug,quiet:true});
    Promise.resolve(resultPromise).then(result=>{
      if(result&&!result.skipped)playCaptureAttempt(snap,result).then(()=>showCaptureToast(result));
      else showCaptureToast({ok:false,reason:'no-ball',name:snap.name,level:snap.level,types:snap.types,chance:0,ball:ITEM_BY_SLUG[ballSlug]||null,rarity:null,shiny:false});
    });
    return;
  }
  recentFaints.unshift(snap);
  if(recentFaints.length>CAPTURE_QUEUE_MAX)recentFaints.length=CAPTURE_QUEUE_MAX;
  showCapturePanel();
  tutorialEvent('wild:faint');
  // `showCapturePanel()` arma 12 s antes de o evento abrir o passo (em microtask).
  // Rearma logo depois para que `activeTutorialStepId()` aplique a folga de 90 s.
  queueMicrotask(()=>restartCaptureFeedbackTimer(CAPTURE_FEEDBACK_MS));
}
function advanceIncubators(){
  void (async()=>{
    if(!state.breeding)state.breeding=normalizeBreedingState();
    const slots=state.breeding.incubator||[null,null];
    let hatched=false;
    const hatchJobs=[];
    const hasServerEggs=serverGameplayReady()&&slots.some(e=>e?.serverId||e?.id);
    if(hasServerEggs){
      try{
        const response=await serverBreedTickEggs(1);
        const byId=new Map((response?.eggs||[]).map(e=>[String(e.id),e]));
        for(const egg of slots){
          if(!egg)continue;
          const remote=byId.get(String(egg.serverId||egg.id||''));
          if(remote){
            egg.defeatsDone=remote.defeats_done;
            egg.defeatsNeeded=remote.defeats_needed;
          }
        }
      }catch(error){console.warn('breed_tick_eggs failed',error)}
    }else{
      for(const egg of slots){if(egg)egg.defeatsDone=(egg.defeatsDone||0)+1}
    }
    for(let i=0;i<slots.length;i++){
      const egg=slots[i];if(!egg)continue;
      if((egg.defeatsDone||0)<(egg.defeatsNeeded||1))continue;
      const species=egg.species||egg.name;
      const rarityName=egg.rarityName||'Comum';
      const ivs=egg.ivs||{HP:15,ATK:15,DEF:15,ESP:15,RES:15,VEL:15};
      const childBase={
        id:nextCaptureId(),name:species,level:1,xp:0,encounterLevel:1,capturedAt:Date.now(),
        ball:'egg',rarity:rarityName,mult:egg.mult||1,color:rarityInfo({rarity:rarityName}).color,
        ivs,ivScore:egg.ivScore||egg.ivTotal||0,ivTotal:egg.ivTotal||0,
        shiny:false,locked:shouldProtectCapture({shiny:false,ivTotal:egg.ivTotal||0,rarity:rarityName}),
        captureProtectionVersion:1,types:speciesTypes(species),equippedMoves:isMovesReady()?defaultLoadout(species,1):[],
        autoMoves:true,moveCursor:0,aoeMove:null,fromBreeding:true,
      };
      slots[i]=null;hatched=true;
      if(serverGameplayReady()&&(egg.serverId||egg.id)){
        hatchJobs.push(serverBreedHatch({
          eggId:egg.serverId||egg.id,
          moves:childBase.equippedMoves,
        }).then(response=>{
          if(!response?.ok||!response.local)throw new Error('breed_hatch_failed');
          const child=response.local;
          if(!child.types?.length)child.types=speciesTypes(species);
          if(!child.stats)child.stats=statsFor(species,child.types[0],1,child.ivs,child.mult||1);
          child.fromBreeding=true;
          const isNew=addNavNotification('captures',1);
          state.collection.unshift(child);state.captureHistory.unshift(captureHistorySnapshot(child,{isNew}));state.captureHistory=state.captureHistory.slice(0,100);
          showToast(t('breeding.hatched',{name:title(child.name)}));
          addLog(t('breeding.hatched',{name:title(child.name)}),title(child.name));
        }).catch(error=>{
          console.warn('breed hatch sync failed',error);
          slots[i]=egg;
          showToast(t('sys.syncFail')||'Breed sync failed');
        }));
      }else if(!serverGameplayReady()){
        const isNew=addNavNotification('captures',1);
        state.collection.unshift(childBase);state.captureHistory.unshift(captureHistorySnapshot(childBase,{isNew}));state.captureHistory=state.captureHistory.slice(0,100);
        showToast(t('breeding.hatched',{name:title(childBase.name)}));
        addLog(t('breeding.hatched',{name:title(childBase.name)}),title(childBase.name));
      }
    }
    state.breeding.incubator=slots;
    if(hatched){
      await Promise.all(hatchJobs).catch(()=>{});
      renderCollection();renderCaptureLog();refreshBreeding();
    }
    save();
  })();
}
function detachWildFromRoute(wild){
  if(!wild)return;
  const wasTarget=routeSim.target===wild;
  routeSim.wilds=routeSim.wilds.filter(w=>w!==wild);
  if(wasTarget){routeSim.target=null;routeSim.nextTargetAt=performance.now()+ROUTE_TARGET_ACQUIRE_DELAY_MS}
  $(`#${wild.id}`)?.remove();
  routeSim.spawnTimer=performance.now()+380;
  $('#battleStatus').textContent=t('battle.searchingNext');
}
function sweepDefeatedWilds(){
  const dead=routeSim.wilds.filter(w=>!w||!(w.currentHp>0));
  if(!dead.length)return;
  for(const wild of dead)detachWildFromRoute(wild);
}
let huntMapTransitionTimer=null;
function maybeAdvanceHuntMap(){
  const hunt=state.activeHunt;
  if(!hunt||state.huntMode!=='species'||!state.huntSpecies)return;
  const nextStage=huntMapStageFor(state.huntSpecies,activeHuntDefeats());
  if(nextStage==null)return;
  const currentStage=Number.isFinite(Number(hunt.mapStage))?Math.max(0,Math.floor(Number(hunt.mapStage))):0;
  if(nextStage<=currentStage)return;
  const config=huntMapStageConfigFor(state.huntSpecies,nextStage);
  hunt.mapStage=nextStage;
  save();
  clearTimeout(huntMapTransitionTimer);
  huntMapTransitionTimer=setTimeout(()=>{
    huntMapTransitionTimer=null;
    if(!state.running||state.activeHunt!==hunt||hunt.mapStage!==nextStage)return;
    changeRoute();
    const label=title(state.huntSpecies);
    showToast(t('hunt.mapTransition',{name:label}));
    addLog(t('hunt.mapTransitionLog',{name:label}),label);
  },0);
  return config;
}
function finishWildKo(wild,xpBonus=0,expectedLoadId=routeLandLoadId){
  if(expectedLoadId!==routeLandLoadId||!wild||wild._koResolved)return;
  wild._koResolved=true;
  // Remove da rota ANTES dos rewards/VFX — crash depois disso não deixa HP 0 preso.
  const wasBoss=!!wild.boss;
  detachWildFromRoute(wild);
  try{
  const previousKillBonus=killXpBonusForDefeats(state.stats.defeated);
  state.stats.defeated++;
  recordZoneDefeat(wild);
  if(!state.killCounts||typeof state.killCounts!=='object')state.killCounts={};
  if(wild?.name)state.killCounts[wild.name]=(state.killCounts[wild.name]|0)+1;
  if(progressSyncEnabled()&&wild?.name&&wild.encounterId)recordServerKill(wild.name,1,wild.encounterId);
  const perks=trainerAccountPerks(),zone=currentZone(),killBonus=killXpBonusForDefeats(state.stats.defeated);
  const commonXpMultiplier=(perks.baseXpMultiplier||1)+killBonus;
  const trainerXpMultiplier=commonXpMultiplier*(perks.trainerXpMultiplier||1)*(zone?.effects.xpMult||1);
  const pokemonXpMultiplier=commonXpMultiplier*(perks.pokemonXpMultiplier||1)*(zone?.effects.xpMult||1);
  state.shinyResearch=state.shinyResearch&&typeof state.shinyResearch==='object'?state.shinyResearch:{};
  state.shinyResearch[wild.name]=(state.shinyResearch[wild.name]||0)+(perks.researchMultiplier||1);
  const baseXp=combatXpReward(wild.level,xpBonus,wild.name,state.starter?.level||1);
  // Treinador tem curva e base próprias (trainerXpForKill espelha o servidor, que
  // é quem manda no nível). Usar a base do Pokémon aqui fazia o HUD subir de nível
  // e ser corrigido para baixo no flush seguinte.
  const trainerXp=Math.max(1,Math.round(
    trainerXpForKill(wild.level,state.trainer?.prestige||0,state.stats?.defeated||0)*(zone?.effects.xpMult||1)));
  const pokemonXp=Math.max(1,Math.round(baseXp*pokemonXpMultiplier));
  const xp=trainerXp;
  state.stats.xp+=trainerXp;
  const trainerGain=grantTrainerXp(trainerXp);
  const pokeGain=grantStarterXp(pokemonXp);
  grantReserveXp(pokemonXp);
  const stage=evolutionDepthForSpecies(wild.name);
  // Loot autoritativo do servidor: pré-rolado no encounter (wild.serverLoot) e
  // creditado igual por report_session. Mostra na hora do kill; applyServerInventory
  // reconcilia a mochila depois (mesmos valores, sem fantasma).
  const serverOwnsDrops=inventorySyncEnabled();
  const drops=serverOwnsDrops?serverLootToDrops(wild.serverLoot):rollDrops(wild.types,stage,wild.level,Math.random,wild.name,zone?.id);
  const zoneLootMultiplier=perks.lootMultiplier*(zone?.effects.lootMult||1);
  // Multiplicador de zona só no roll local — o server credita o loot pré-rolado como está.
  if(!serverOwnsDrops&&zoneLootMultiplier>1)for(const drop of drops){const boosted=drop.qty*zoneLootMultiplier,whole=Math.floor(boosted);drop.qty=Math.max(1,whole+(Math.random()<boosted-whole?1:0))}
  let receivedItems=0;for(const drop of drops){state.drops[drop.slug]=(state.drops[drop.slug]||0)+drop.qty;receivedItems+=Math.max(0,Number(drop.qty)||0);addNavNotification('inventory',drop.qty,drop.slug)}
  {
    let dropsBag=0;
    for(const[slug,qty]of Object.entries(state.drops||{})){
      const it=ITEM_BY_SLUG[slug];if(it)dropsBag+=sellValue(it)*Math.max(0,Number(qty)||0);
    }
    if(receivedItems>0)tutorialEvent('drops:gain',{value:dropsBag});
  }
  const cardDropQty=serverOwnsDrops?0:Number(rollShinyCardDrop({level:wild.level,boss:!!wild.boss,speciesRarity:wild.speciesRarity}))||0;
  if(cardDropQty>0){state.shinyCards=(state.shinyCards||0)+cardDropQty;showToast(t('shiny.cardDrop',{count:cardDropQty}));addLog(t('shiny.cardDrop',{count:cardDropQty}),'✦')}
  advanceIncubators();
  const huntNow=huntSession();
  if(huntNow){
    let dropsValue=0;
    for(const drop of drops){huntNow.loot[drop.slug]=(huntNow.loot[drop.slug]||0)+drop.qty;const it=ITEM_BY_SLUG[drop.slug];if(it)dropsValue+=sellValue(it)*drop.qty}
    huntNow.lootValue+=dropsValue;
    const ttkMs=wild.spawnedAt?Math.max(0,performance.now()-wild.spawnedAt):0;
    recordHuntEvent({kills:1,xp,loot:dropsValue,ttkMs,items:Object.fromEntries(drops.map(drop=>[drop.slug,drop.qty]))});
    maybeAdvanceHuntMap();
    try{
      trackQuestProgress('defeat',1);
      // Raid contribution/rewards are unavailable until the server owns the
      // boss state and validates every combat contribution.
    }catch{}
  }
  const dropText=drops.map(d=>`${d.qty}× ${itemName(d.slug)||d.name}`).join(', '),rareDrop=drops.find(d=>d.rare);
  showCombatFeedback({name:wild.name,trainerXp:trainerGain.gained,pokemonXp:pokeGain.gained,trainerLevels:trainerGain.leveled,pokemonLevels:pokeGain.leveled,drops});
  if(rareDrop){addLog(t('log.defeatedRare',{xp,drops:dropText}),title(wild.name));showToast(t('log.rareToast',{name:title(wild.name),item:itemName(rareDrop.slug)||rareDrop.name}))}
  else if(drops.length)addLog(t('log.defeatedDrop',{xp,drops:dropText}),title(wild.name));
  else addLog(t('log.defeatedXp',{xp}),title(wild.name));
  if(killBonus>previousKillBonus){addLog(t('specialization.killMilestoneLog',{kills:formatNumber(state.stats.defeated),value:formatNumber(killBonus*100,{minimumFractionDigits:1,maximumFractionDigits:1})}),t('profile.trainer'));showToast(t('specialization.killMilestoneToast',{value:formatNumber(killBonus*100,{minimumFractionDigits:1,maximumFractionDigits:1})}))}
  if(!$('#specializationDialog')?.classList.contains('hidden'))renderSpecialization();
  renderDropBag();
  renderPlayerInventory();
  if(wasBoss)renderWilds();
  }catch(error){
    console.warn('finishWildKo rewards failed',error);
  }
}
async function usePotion(slug){
  const potion=ITEM_BY_SLUG[slug];if(!potion||!potion.heal||!state.starter)return false;
  if((state.inventory[slug]||0)<=0)return false;
  const partner=ensureStarterCombat();if(!partner||partner.currentHp<=0)return false;
  if(serverGameplayReady()){
    const ok=await consumeGameplayItem(slug,1);
    if(!ok)return false;
  }else{
    state.inventory[slug]--;
  }
  const huntPotion=huntSession();
  if(huntPotion){huntPotion.supplyValue+=potion.price||0;huntPotion.potionsUsed++;recordHuntEvent({supply:potion.price||0})}
  const healAmount=Math.round(partner.maxHp*potion.heal),before=partner.currentHp;
  state.starter.currentHp=Math.min(partner.maxHp,partner.currentHp+healAmount);
  renderPartnerHud();renderInventory();renderPotionSelect();save();
  addLog(t('log.potionUsed',{name:title(partner.name),item:displayItem(slug),hp:state.starter.currentHp-before}));
  return true;
}
function tryAutoPotion(){
  if(!state.autoPotion.enabled)return;
  const partner=ensureStarterCombat();if(!partner||partner.currentHp<=0)return;
  const hpPct=partner.currentHp/partner.maxHp;
  if(hpPct>state.autoPotion.threshold/100)return;
  if(!selectedPotion){
    const best=[...POTIONS].filter(p=>p.heal).sort((a,b)=>b.heal-a.heal).find(p=>(state.inventory[p.slug]||0)>0);
    if(best)void usePotion(best.slug);
    return;
  }
  if((state.inventory[selectedPotion]||0)<=0){
    const fallback=[...POTIONS].filter(p=>p.heal&&p.slug!==selectedPotion).sort((a,b)=>b.heal-a.heal).find(p=>(state.inventory[p.slug]||0)>0);
    if(fallback)void usePotion(fallback.slug);
    return;
  }
  void usePotion(selectedPotion);
}
const POTION_THRESHOLDS=[25,50,75,90];
function renderPotionThreshold(){
  const box=$('#potionThreshold');if(!box)return;
  box.innerHTML=`<select class="automation-select" aria-label="${t('auto.potionWhen')}">${POTION_THRESHOLDS.map(th=>`<option value="${th}" ${state.autoPotion.threshold===th?'selected':''}>${th}%</option>`).join('')}</select>`;
  $('#potionThreshold select')?.addEventListener('change',event=>{state.autoPotion.threshold=+event.target.value;save()});
}
function renderPotionSelect(){
  const box=$('#potionSelect');if(!box)return;
  const owned=POTIONS.filter(p=>p.heal&&(state.inventory[p.slug]||0)>0);
  if(!selectedPotion||(state.inventory[selectedPotion]||0)<=0){selectedPotion=owned.length?owned[0].slug:null}
  state.selectedPotion=selectedPotion;
  box.innerHTML=owned.length?`<select class="automation-select" aria-label="${t('auto.potionUsed')}">${owned.map(p=>`<option value="${p.slug}" ${selectedPotion===p.slug?'selected':''}>${displayItem(p.slug)} ×${state.inventory[p.slug]||0} · +${Math.round(p.heal*100)}%</option>`).join('')}</select>`:`<div class="automation-empty">${t('toast.emptyPotion')}</div>`;
  const total=owned.reduce((s,p)=>s+(state.inventory[p.slug]||0),0);
  if($('#potionStock'))$('#potionStock').textContent=total?t('auto.potionStock',{count:total}):'';
  $('#potionSelect select')?.addEventListener('change',event=>{selectedPotion=event.target.value;state.selectedPotion=selectedPotion;save()});
}
function renderReviveSelect(){
  const box=$('#reviveSelect');if(!box)return;
  const revive=ITEM_BY_SLUG.revive,owned=revive&&(state.inventory.revive||0)>0?[revive]:[];
  if(!owned.some(item=>item.slug===state.selectedRevive))state.selectedRevive=owned[0]?.slug||'revive';
  box.innerHTML=owned.length?`<select class="automation-select" aria-label="${t('auto.reviveUsed')}">${owned.map(item=>`<option value="${item.slug}" ${state.selectedRevive===item.slug?'selected':''}>${displayItem(item.slug)} ×${state.inventory[item.slug]||0}</option>`).join('')}</select>`:`<div class="automation-empty">${t('auto.reviveNone')}</div>`;
  if($('#reviveStock'))$('#reviveStock').textContent=owned.length?t('auto.reviveStock',{count:state.inventory.revive||0}):'';
  $('#reviveSelect select')?.addEventListener('change',event=>{state.selectedRevive=event.target.value;save()});
}
function returnToPokemonCenter(pokemonName){
  // A escolha explícita evita gastar um Revive quando o jogador o desativou.
  const reviveSlug=state.selectedRevive||'revive';
  if(state.autoRevive?.enabled&&(state.inventory[reviveSlug]||0)>0){
    void(async()=>{
      if(await tryUseRevive(reviveSlug))return;
      endHuntAtCenter(pokemonName);
    })();
    return;
  }
  endHuntAtCenter(pokemonName);
}
async function tryUseRevive(slug=state.selectedRevive||'revive'){
  if((state.inventory[slug]||0)<=0||!state.starter)return false;
  if(serverGameplayReady()){
    const ok=await consumeGameplayItem(slug,1);
    if(!ok)return false;
  }else{
    state.inventory[slug]--;
  }
  const partner=ensureStarterCombat();
  if(partner){
    state.starter.currentHp=Math.max(1,Math.round(partner.maxHp*0.5));
    state.teamHp=Math.round((state.starter.currentHp/partner.maxHp)*100);
  }
  const hunt=huntSession();
  if(hunt){hunt.supplyValue+=(ITEM_BY_SLUG[slug]?.price||0);hunt.potionsUsed++;recordHuntEvent({supply:ITEM_BY_SLUG[slug]?.price||0})}
  renderPartnerHud();renderInventory();renderPotionSelect();save();
  addLog(t('log.reviveUsed',{name:title(state.starter?.name||'Pokémon')}));
  showToast(t('toast.revived'));
  return true;
}
function endHuntAtCenter(pokemonName){
  finishActiveHunt();state.running=false;routeSim.target=null;routeSim.spawnTimer=0;
  recordHuntEvent({deaths:1});
  const partner=ensureStarterCombat();if(partner)state.starter.currentHp=partner.maxHp;
  state.teamHp=100;state.collection.forEach(p=>p.hp=100);
  cityPlayer.x=47.87;cityPlayer.y=42;cityPlayer.dir='south';
  resetCityFollower();
  switchView('city');updateCityCamera();updateBuildingState();renderPartnerHud();renderOfflineStatus();
  const noSupplies=healingSupplyCount()<=0;
  addLog(t('dialog.faintedLog',{name:title(pokemonName)}),'Nurse Joy');
  showToast(noSupplies?t('offline.faintedNoSupplies'):t('dialog.faintedToast'));
  save();
}
function setCityTeleportOpen(open){
  const menu=$('#cityTeleportMenu'),toggle=$('#cityTeleportToggle');if(!menu||!toggle)return;
  menu.classList.toggle('hidden',!open);
  toggle.setAttribute('aria-expanded',String(open));
}
function renderCityTeleportOptions(){
  const host=$('#cityTeleportOptions');if(host)host.innerHTML='';
  const count=$('#cityTeleportCount');if(count){count.textContent='$';count.title=t('city.teleportHint')}
}
function teleportToCityNpc(id){
  if(!$('#cityView')?.classList.contains('active'))return;
  const npc=CITY_NPCS.find(entry=>entry.id===id);if(!npc)return;
  closeCityDialog();
  keys.clear();
  cityPlayer.x=npc.teleportX;cityPlayer.y=npc.teleportY;cityPlayer.dir=npc.teleportDir||'north';
  const el=$('#cityTrainer');
  if(el)setActor(el,trainerSprite(),cityPlayer.dir,false,performance.now());
  resetCityFollower();
  updateCityCamera();updateBuildingState();
  setCityTeleportOpen(false);
  showToast(t('city.arrivedNpc',{name:t(npc.labelKey)}));
}
function prepareTutorialStep(id){
  if(id==='heal-nurse'){
    closeHuntWindows();closeFloatingPanel('chatPanel');closeTeamManagement();closeCityDialog();teleportToCityNpc('nurse');
  }else if(id==='shop-npc'){
    closeHuntWindows();closeFloatingPanel('chatPanel');closeTeamManagement();closeCityDialog();teleportToCityNpc('shop');
  }else if(id==='deposit'){
    closeCityDialog();closeHuntWindows();closeFloatingPanel('chatPanel');closeTeamManagement();teleportToCityDepot();
  }else if(id==='nav-specialization'){
    closeProfile();
  }else if(id==='nav-pokedex'){
    closeSpecialization();
  }else if(id==='nav-altar'||id==='game-pass'){
    document.getElementById('masterSystemsDialog')?.classList.add('hidden');
  }else if(id==='market'||id==='chat'){
    closeMarket();
  }
}
function applyHitToWild(wild,partnerData,move){
  if(!wild||!move)return{damage:0,mult:1,ko:false};
  if(move.power<=0||move.category==='status'){
    wild.status=move.effect&&move.effect!=='none'?move.effect:'status';
    wild.statusUntil=performance.now()+3500;
    return{damage:0,mult:1,ko:false,status:true};
  }
  const hit=damageFor(partnerData,wild,move.type,move.power,move.category);
  const mastery=masteryDamageMultiplier(partnerData.masteryLevel),typeEmphasis=hit.mult>0?emphasizedEffectiveness(hit.mult)/hit.mult:1;
  let damage=hit.damage>0?Math.max(1,Math.round(hit.damage*mastery*typeEmphasis)):0;
  const wouldKo=damage>=wild.currentHp;
  // A captura recebe um snapshot do derrotado e nunca bloqueia o próximo alvo.
  wild.currentHp=Math.max(0,Number(wild.currentHp-damage)||0);
  wild.hp=Math.max(0,wild.currentHp/Math.max(1,wild.maxHp)*100);
  if(damage>0){
    wild.engaged=true;
    // Já engajou: não pode ficar marcado como “inalcançável” senão a hunt troca de alvo.
    routeSim.unreachableUntil?.delete(wild.id);
  }
  const captureReady=!wild.captureOffered&&wouldKo;
  return{...hit,damage,mastery,ko:!(wild.currentHp>0),captureReady};
}
function collectAoeTargets(primary,radius,maxTargets=3){
  const targets=[primary];
  const others=routeSim.wilds.filter(w=>w!==primary).map(w=>({w,d:routeDistance(primary.x,primary.y,w.x,w.y,routeLand)})).sort((a,b)=>a.d-b.d);
  for(const o of others){
    if(targets.length>=maxTargets)break;
    if(o.d<=radius)targets.push(o.w);
  }
  return targets;
}
function damageMoveScore(move,attacker,target){
  if(!move||!target||(move.power||0)<=0||move.targeting==='self')return-Infinity;
  const hit=damageFor(attacker,target,move.type,move.power,move.category,()=>.5);
  if(hit.mult===0)return 0;
  const mastery=masteryDamageMultiplier(attacker.masteryLevel),typeEmphasis=emphasizedEffectiveness(hit.mult)/hit.mult;
  return Math.min(target.currentHp,hit.damage*mastery*typeEmphasis);
}
function pickPlayerMove(partnerData,{commit=true}={}){
  ensureStarterLoadout();
  const equipped=[...(state.starter.equippedMoves||[])];
  if(state.starter.aoeMove&&(partnerData.level||0)>=100&&!equipped.includes(state.starter.aoeMove))equipped.push(state.starter.aoeMove);
  const wild=routeSim.target;
  const fallbackType=partnerData.types.find(type=>!wild||effectiveness(type,wild.types)>0)
    ||types.map(entry=>entry[0]).find(type=>!wild||effectiveness(type,wild.types)>0)||'normal';
  const fallbackCategory=partnerData.stats.spa>partnerData.stats.atk?'special':'physical';
  const fallback={id:'fallback',name:t('battle.fallbackAttack'),type:fallbackType,power:35,category:fallbackCategory,cooldown:1,targeting:'single',aoeRadius:0,range:fallbackCategory==='special'?10:6};
  const fallbackScore=wild?damageMoveScore(fallback,partnerData,wild):0;
  const aoeTargetCap=Math.min(8,3+Math.floor(Math.max(0,partnerData.level-150)/75));
  const scoreMove=id=>{
    const move=getMove(id)||(id===state.starter.aoeMove?{id,name:id,type:partnerData.types[0]||'normal',power:80,category:'special',targeting:'area',aoe:true,aoeRadius:14}:null);
    if(!move||!wild)return-Infinity;
    if(!isCombatMove(move))return-Infinity;
    const targets=(move.targeting==='area'||move.aoe)
      ?routeSim.wilds.filter(target=>target.currentHp>0).slice(0,aoeTargetCap)
      :[wild];
    return targets.reduce((total,target)=>total+damageMoveScore(move,partnerData,target),0);
  };
  const pick=pickNextMove(equipped,routeSim.moveCds,routeSim.playerTurn,scoreMove);
  if(pick.moveId){
    const move=getMove(pick.moveId)||(pick.moveId===state.starter.aoeMove?{id:pick.moveId,name:pick.moveId,type:partnerData.types[0]||'normal',power:80,category:'special',targeting:'area',aoe:true,aoeRadius:14,cooldown:2}:null);
    if(move&&pick.score>fallbackScore*1.05){if(commit)routeSim.moveCds[pick.moveId]=routeSim.playerTurn+moveCooldownTurns(move)+1;return move}
  }
  return fallback;
}
function pickWildMove(wild,partnerData){
  const combatTurn=Math.max(0,wild.combatTurn||0),moveCds=wild.moveCds||(wild.moveCds={});
  const learned=unlockedMoves(wild.name,wild.level);
  const pick=pickNextMove(learned,moveCds,combatTurn,id=>{
    const move=getMove(id);
    return damageMoveScore(move,wild,partnerData);
  });
  let move=pick.moveId?getMove(pick.moveId):null;
  if(move){
    moveCds[pick.moveId]=combatTurn+moveCooldownTurns(move)+1;
  }else{
    const fallbackType=[...(wild.types||[])].sort((a,b)=>effectiveness(b,partnerData.types)-effectiveness(a,partnerData.types))[0]||'normal';
    const category=wild.stats.spa>wild.stats.atk?'special':'physical';
    move={id:'wild-fallback',name:t('battle.fallbackAttack'),type:fallbackType,power:30,category,cooldown:0,targeting:'single',aoeRadius:0,range:category==='special'?9:4};
  }
  wild.combatTurn=combatTurn+1;
  return move;
}
function fxLayer(){return $('#routeFxLayer')||$('#routeMapWorld')}
function spawnCombatNode(className,x,y,color,html=''){
  const layer=fxLayer();if(!layer)return null;
  const el=document.createElement('div');
  el.className=className;
  setActorPercent(el,x,y);
  if(color)el.style.setProperty('--fx',color);
  if(html)el.innerHTML=html;
  layer.appendChild(el);
  return el;
}
const TYPE_FX_FALLBACK={
  normal:{missile:null,impact:3,phases:4},fogo:{missile:4,impact:15,phases:8},água:{missile:3,impact:53,phases:8},
  elétrico:{missile:5,impact:48,phases:8},planta:{missile:9,impact:45,phases:8},gelo:{missile:29,impact:43,phases:6},
  lutador:{missile:null,impact:9,phases:8},veneno:{missile:15,impact:16,phases:5},terra:{missile:30,impact:9,phases:8},
  voador:{missile:3,impact:3,phases:4},psíquico:{missile:36,impact:11,phases:8},inseto:{missile:9,impact:9,phases:8},
  pedra:{missile:10,impact:9,phases:8},fantasma:{missile:11,impact:140,phases:4},dragão:{missile:5,impact:36,phases:8},
  sombrio:{missile:11,impact:140,phases:4},aço:{missile:2,impact:9,phases:8},fada:{missile:38,impact:11,phases:8}
};
function resolveMoveFx(move){return getMoveFx(move?.id)||TYPE_FX_FALLBACK[move?.type]||TYPE_FX_FALLBACK.normal}
function playImpactSprite(x,y,impactId,phases=1){
  const el=spawnCombatNode('combat-fx combat-sprite-fx',x,y);
  if(!el||impactId==null)return;
  const img=document.createElement('img');
  img.alt='';
  img.decoding='async';
  el.appendChild(img);
  let frame=0;
  const tick=()=>{
    img.src=`public/assets/effects/${impactId}-${frame}.png`;
    frame++;
    if(frame<phases)setTimeout(tick,55);
    else setTimeout(()=>el.remove(),60);
  };
  tick();
}
/** Duração do voo do projétil; casa com combatMissileFly no world.css. */
const MISSILE_FLIGHT_MS=360;
function playMissileSprite(from,to,missileId,onDone){
  const el=spawnCombatNode('combat-fx combat-missile-fx',from.x,from.y);
  if(!el||missileId==null){onDone?.();return}
  const img=document.createElement('img');
  img.src=`public/assets/missiles/${missileId}.png`;
  img.alt='';
  img.decoding='async';
  el.appendChild(img);
  const dx=to.x-from.x,dy=to.y-from.y;
  const angle=Math.atan2(dy,dx)*180/Math.PI;
  el.style.setProperty('--to-x',`${to.x}%`);
  el.style.setProperty('--to-y',`${to.y}%`);
  el.style.setProperty('--rot',`${angle}deg`);
  requestAnimationFrame(()=>el.classList.add('fly'));
  setTimeout(()=>{el.remove();onDone?.()},MISSILE_FLIGHT_MS);
}
/**
 * Atraso até o golpe "acertar".
 *
 * Quem consome isto precisa esperar antes de mostrar dano e antes de remover o
 * selvagem: sem isso o número subia e o bicho desaparecia enquanto o projétil
 * ainda estava no ar, e o efeito parecia sair depois da morte.
 */
function moveFxImpactDelay(move,from=null){
  const fx=resolveMoveFx(move);
  return fx?.missile!=null&&from?MISSILE_FLIGHT_MS:0;
}
function spawnMoveFx(move,to,from=null,onImpact=null){
  const color=typeColors[move?.type]||'#e9cf59';
  const fx=resolveMoveFx(move);
  const hasMissile=fx?.missile!=null&&from;
  const hasImpact=fx?.impact!=null;
  const finishImpact=()=>{
    if(hasImpact)playImpactSprite(to.x,to.y,fx.impact,fx.phases||1);
    else{
      const category=move?.category||'physical';
      const area=move?.targeting==='area';
      const burstClass=category==='status'?'combat-fx combat-status':category==='physical'?'combat-fx combat-slash':'combat-fx combat-burst';
      const impact=spawnCombatNode(`${burstClass}${area?' area':''}`,to.x,to.y,color);
      if(impact){
        for(let i=0;i<(area?12:7);i++){
          const spark=document.createElement('i');
          spark.style.setProperty('--a',`${(360/(area?12:7))*i+Math.random()*12}deg`);
          spark.style.setProperty('--d',`${16+Math.random()*26}px`);
          impact.appendChild(spark);
        }
        setTimeout(()=>impact.remove(),620);
      }
      const ring=spawnCombatNode(`combat-fx combat-ring${area?' area':''}`,to.x,to.y,color);
      if(ring)setTimeout(()=>ring.remove(),580);
    }
    onImpact?.();
  };
  if(hasMissile)playMissileSprite(from,to,fx.missile,finishImpact);
  else finishImpact();
}
function spawnFloatDamage(x,y,value,mult=1,type='normal',status=false,opts={}){
  const color=typeColors[type]||'#fff';
  let cls='combat-fx combat-dmg';
  let html='';
  if(status){
    cls+=' status';
    html=`<em>${value}</em>`;
  }else if(mult===0){
    cls+=' miss';
    html=`<b>0</b><small>${t('battle.unaffected')}</small>`;
  }else{
    if(mult>1)cls+=' super';
    else if(mult>0&&mult<1)cls+=' resist';
    const tag=mult>1?t('battle.superEffective'):(mult>0&&mult<1?t('battle.notEffective'):'');
    html=`<b>-${formatNumber(value)}</b>${tag?`<small>${tag}</small>`:''}`;
  }
  if(opts.moveName)html=`<i class="combat-dmg-move">${opts.moveName}</i>${html}`;
  const el=spawnCombatNode(cls,x,y,color,html);
  if(!el)return;
  const jitter=(Math.random()-.5)*2.2;
  el.style.setProperty('--dmg-x',`${jitter}px`);
  setTimeout(()=>el.remove(),1100);
}
function playerCombatTurn(now){
  const wild=routeSim.target,partnerData=ensureStarterCombat();
  const combatLoadId=routeLandLoadId;
  if(!state.running||!wild||!partnerData)return false;
  if(partnerData.currentHp<=0){returnToPokemonCenter(partnerData.name);return false}
  if(!routeSim.wilds.includes(wild)||!(wild.currentHp>0))return false;
  const move=pickPlayerMove(partnerData);
  const partner=$('#routePartner');
  partner?.classList.add('attacking');
  const from={x:routeSim.player.x,y:routeSim.player.y};
  let primaryHit={damage:0,mult:1};
  const isArea=move.targeting==='area'||move.aoe;
  // Um único relógio para o golpe: o projétil voa, o impacto estoura, e só
  // então entram o número de dano, o recuo do alvo e a remoção por KO. Antes
  // tudo isso saía no mesmo frame do disparo, e a animação chegava atrasada —
  // às vezes sobre um selvagem que já tinha sumido.
  const impactDelay=moveFxImpactDelay(move,from);
  const onImpact=(target,result)=>{
    try{
      if(combatLoadId!==routeLandLoadId)return;
      const actor=$(`#${target.id}`);
      actor?.classList.add('hit');
      actor?.querySelector('.wild-hp i')?.style.setProperty('width',`${target.hp}%`);
      setTimeout(()=>actor?.classList.remove('hit'),280);
      if(result.status)spawnFloatDamage(target.x,target.y,move.name,1,move.type,true);
      else if(result.mult===0)spawnFloatDamage(target.x,target.y,0,0,move.type,false,{moveName:move.name});
      else if(result.damage>0)spawnFloatDamage(target.x,target.y,result.damage,result.mult,move.type,false,{moveName:move.name});
    }catch(error){console.warn('combat fx failed',error)}
  };
  const resolveHitFx=(target,result)=>{
    try{
      spawnMoveFx(move,{x:target.x,y:target.y},from,()=>onImpact(target,result));
    }catch(error){console.warn('combat fx failed',error)}
  };
  const resolveKo=(target,result)=>{
    // Snapshot antes do detach — captura não pode bloquear a remoção do selvagem.
    const captureSnap=result.captureReady?faintSnapshot(target):null;
    const finish=()=>{
      if(combatLoadId!==routeLandLoadId)return;
      if(result.ko)finishWildKo(target,0,combatLoadId);
      if(captureSnap){
        try{offerWildForCapture({...target,...captureSnap,captureOffered:false,id:target.id})}
        catch(error){console.warn('capture offer failed',error)}
      }
    };
    // KO espera o impacto + a piscada do alvo; sem isso o bicho evapora antes
    // de o jogador ver o golpe conectar.
    if(result.ko)setTimeout(finish,impactDelay+200);
    else finish();
  };
  if(isArea){
    const enemies=routeSim.wilds.filter(entry=>entry.currentHp>0);
    const moveForCore={...move,effectiveness:(enemy)=>effectiveness(move.type,enemy.types||[])};
    let results=[];
    try{results=resolveAoE(partnerData,enemies,moveForCore)}catch{results=enemies.map(enemy=>({...enemy,damage:0,hpBefore:enemy.currentHp,hpAfter:enemy.currentHp,defeated:false}))}
    for(const snap of results){
      const target=routeSim.wilds.find(entry=>entry.id===snap.id);if(!target)continue;
      const damage=Math.max(0,Number(snap.damage)||Math.max(0,(snap.hpBefore??target.currentHp)-(snap.hpAfter??snap.currentHp??0)));
      const wouldKo=damage>=target.currentHp;
      target.currentHp=Math.max(0,Number(snap.hpAfter??snap.currentHp??(target.currentHp-damage))||0);
      target.hp=Math.max(0,target.currentHp/Math.max(1,target.maxHp)*100);
      if(damage>0){
        target.engaged=true;
        routeSim.unreachableUntil?.delete(target.id);
      }
      const mult=typeof move.effectiveness==='function'?1:effectiveness(move.type,target.types);
      const result={damage,mult,ko:!(target.currentHp>0),captureReady:!target.captureOffered&&wouldKo};
      if(target===wild)primaryHit=result;
      resolveHitFx(target,result);
      resolveKo(target,result);
    }
  }else{
    const result=applyHitToWild(wild,partnerData,move);
    primaryHit=result;
    resolveHitFx(wild,result);
    resolveKo(wild,result);
  }
  routeSim.playerTurn++;
  // CD global do jogador: 1s entre ações, mesmo após hitkill / troca de alvo
  routeSim.nextPlayerAttackAt=now+combatIntervalMs(partnerData.stats.spe)*trainerAccountPerks().combatIntervalFactor;
  if(routeSim.target)updateEnemyHud(routeSim.target);
  flashHud('.route-combat-hud');
  const dmgLabel=primaryHit.status
    ? `${move.name} (status)`
    : primaryHit.mult===0
      ? t('battle.unaffected')
      : `-${primaryHit.damage}${primaryHit.mult&&primaryHit.mult!==1?` ×${primaryHit.mult}`:''}`;
  $('#damageNumber').textContent=`${move.name}: ${dmgLabel}${isArea&&!primaryHit.status?' AoE':''}`;
  $('#damageNumber').classList.remove('show');void $('#damageNumber').offsetWidth;$('#damageNumber').classList.add('show');
  setTimeout(()=>partner?.classList.remove('attacking'),280);
  renderStats();save();
  return routeSim.wilds.includes(wild)&&wild.currentHp>0;
}
function enemyCombatTurn(){
  const wild=routeSim.target,partnerData=ensureStarterCombat();
  const combatLoadId=routeLandLoadId;
  if(!state.running||!wild||!partnerData)return false;
  if(!routeSim.wilds.includes(wild)||!(wild.currentHp>0))return false;
  if(partnerData.currentHp<=0){returnToPokemonCenter(partnerData.name);return false}
  const silenced=wild.statusUntil&&performance.now()<wild.statusUntil&&['sleep','paralyze','flinch'].includes(wild.status);
  if(silenced){
    $('#damageNumber').textContent=t('battle.cannotAttack',{name:title(wild.name)});
    $('#damageNumber').classList.remove('show');void $('#damageNumber').offsetWidth;$('#damageNumber').classList.add('show');
    routeSim.nextEnemyAttackAt=performance.now()+combatIntervalMs(wild.stats.spe);return true;
  }
  const move=pickWildMove(wild,partnerData),zoneDamage=currentZone()?.effects.wildDamageMult||1;
  const hit=damageFor(wild,partnerData,move.type,move.power,move.category),typeEmphasis=hit.mult>0?emphasizedEffectiveness(hit.mult)/hit.mult:1,damage=hit.mult===0?0:Math.max(1,Math.round(hit.damage*WILD_DAMAGE_MULTIPLIER*zoneDamage*typeEmphasis));
  state.starter.currentHp=Math.max(0,state.starter.currentHp-damage);
  {
    // Dispara uma vez por "mergulho" de HP — rearma só quando o parceiro se recupera.
    const partner=ensureStarterCombat();
    if(partner&&partner.maxHp>0){
      const pct=partner.currentHp/partner.maxHp;
      if(pct<0.4&&!lowHpAnnounced){lowHpAnnounced=true;tutorialEvent('partner:lowhp')}
      else if(pct>0.6&&lowHpAnnounced)lowHpAnnounced=false;
    }
  }
  const actor=$(`#${wild.id}`);
  actor?.classList.add('attacking');
  setTimeout(()=>actor?.classList.remove('attacking'),280);
  // Mesma regra do turno do jogador: o número só sobe quando o golpe conecta.
  spawnMoveFx(move,{x:routeSim.player.x,y:routeSim.player.y},{x:wild.x,y:wild.y},()=>{
    if(combatLoadId!==routeLandLoadId)return;
    spawnFloatDamage(routeSim.player.x,routeSim.player.y,damage,hit.mult,move.type,false,{moveName:move.name});
  });
  $('#damageNumber').textContent=`${title(wild.name)} · ${move.name}: -${damage}`;
  $('#damageNumber').classList.remove('show');void $('#damageNumber').offsetWidth;$('#damageNumber').classList.add('show');
  renderPartnerHud();flashHud('.route-partner-hud');tryAutoPotion();
  if(state.starter.currentHp<=0){returnToPokemonCenter(partnerData.name);return false}
  renderStats();save();
  routeSim.nextEnemyAttackAt=performance.now()+combatIntervalMs(wild.stats.spe);
  return true;
}
function resetCombatTurns(now=performance.now()){
  const partner=ensureStarterCombat(),wild=routeSim.target;if(!partner||!wild)return;
  const playerLead=combatIntervalMs(partner.stats.spe),enemyLead=combatIntervalMs(wild.stats.spe);
  routeSim.nextPlayerAttackAt=now+Math.min(220,playerLead*.2);
  routeSim.nextEnemyAttackAt=now+Math.min(300,enemyLead*.25)+(partner.stats.spe>=wild.stats.spe?80:0);
}
function advanceCombat(now){
  const wild=routeSim.target,partner=ensureStarterCombat();if(!wild||!partner)return;
  if(!routeSim.nextPlayerAttackAt||!routeSim.nextEnemyAttackAt)resetCombatTurns(now);
  const playerDue=now>=routeSim.nextPlayerAttackAt,enemyDue=now>=routeSim.nextEnemyAttackAt;if(!playerDue&&!enemyDue)return;
  const playerFirst=playerDue&&(!enemyDue||routeSim.nextPlayerAttackAt<routeSim.nextEnemyAttackAt||(routeSim.nextPlayerAttackAt===routeSim.nextEnemyAttackAt&&partner.stats.spe>=wild.stats.spe));
  if(playerFirst)playerCombatTurn(now);else enemyCombatTurn();
}
function directionFor(dx,dy){return Math.abs(dx)>Math.abs(dy)?(dx>0?'east':'west'):(dy>0?'south':'north')}
function routeTrainerStart(x,y,dir='north',respectLand=false){
  const legacyBack={north:[0,ROUTE_TRAINER_FOLLOW_DISTANCE],south:[0,-ROUTE_TRAINER_FOLLOW_DISTANCE],east:[-ROUTE_TRAINER_FOLLOW_DISTANCE,0],west:[ROUTE_TRAINER_FOLLOW_DISTANCE,0]}[dir]||[0,ROUTE_TRAINER_FOLLOW_DISTANCE];
  const back=scaleRouteDelta(legacyBack[0],legacyBack[1],routeLand);
  const point=clampRoutePos(x+back[0],y+back[1],ROUTE_EDGE_MARGIN);
  return respectLand?constrainRouteLand(point[0],point[1],ROUTE_EDGE_MARGIN):point;
}
// Se o treinador passar disto sem andar, ele está encostado numa parede.
const ROUTE_TRAINER_STUCK_MS=900;
// O contorno greedy desliza pela parede mas não atravessa istmo fechado (medido:
// 4000 passos sem chegar). Passando disto sem andar, teleporta — o treinador é
// seguidor cosmético, ficar preso é sempre erro.
const ROUTE_TRAINER_RESCUE_DISTANCE=ROUTE_TRAINER_FOLLOW_DISTANCE*2;
function moveRouteTrainer(now,dt){
  const trainer=routeSim.trainer,player=routeSim.player,actor=$('#routeTrainer');
  if(!trainer||!player||!actor)return;
  const dx=player.x-trainer.x,dy=player.y-trainer.y,distance=routeDistance(trainer.x,trainer.y,player.x,player.y,routeLand);
  let moving=false;
  if(Number.isFinite(distance)&&distance>ROUTE_TRAINER_FOLLOW_DISTANCE){
    const step=Math.min(ROUTE_TRAINER_FOLLOW_SPEED*dt,distance-ROUTE_TRAINER_FOLLOW_DISTANCE);
    // Mesmo passo do parceiro (stepPartnerToward): contorna água/margem em vez
    // de andar reto contra o obstáculo e travar ali.
    const[nx,ny]=bestStepTowardLand(trainer.x,trainer.y,player.x,player.y,step,routeLand,ROUTE_EDGE_MARGIN);
    moving=routeDistance(trainer.x,trainer.y,nx,ny,routeLand)>.0001;
    trainer.x=nx;trainer.y=ny;
    if(moving)trainer.dir=directionFor(dx,dy);
    // Progresso, não movimento: encostado na parede o contorno greedy desliza
    // para sempre, então `moving` continua true e um timer de movimento nunca
    // dispararia. É o mesmo critério do chaseProgressAt do parceiro.
    const after=routeDistance(trainer.x,trainer.y,player.x,player.y,routeLand);
    if(routeSim.trainerBestDist==null||after<routeSim.trainerBestDist-0.15){
      routeSim.trainerBestDist=after;
      routeSim.trainerProgressAt=now;
    }
    if(!routeSim.trainerProgressAt)routeSim.trainerProgressAt=now;
    if(now-routeSim.trainerProgressAt>ROUTE_TRAINER_STUCK_MS&&after>ROUTE_TRAINER_RESCUE_DISTANCE){
      // Istmo fechado ou spawn fora da terra: teleporta para uma tile de terra
      // ao lado do parceiro em vez de deixar o jogador "comendo parede".
      const rescue=routeTrainerStart(player.x,player.y,player.dir||'north',true);
      trainer.x=rescue[0];trainer.y=rescue[1];
      routeSim.trainerBestDist=null;
      routeSim.trainerProgressAt=now;
      moving=true;
    }
  }else{
    routeSim.trainerBestDist=null;
    routeSim.trainerProgressAt=now;
  }
  setActorPercent(actor,trainer.x,trainer.y);
  setActor(actor,trainerSprite(),trainer.dir||player.dir||'south',moving,now);
}
function pointInPolygon(x,y,polygon){let inside=false;for(let i=0,j=polygon.length-1;i<polygon.length;j=i++){const[xi,yi]=polygon[i],[xj,yj]=polygon[j];if(((yi>y)!==(yj>y))&&(x<(xj-xi)*(y-yi)/(yj-yi)+xi))inside=!inside}return inside}
function canMoveCity(xPercent,yPercent){const x=Math.floor(970+xPercent/100*141),y=Math.floor(975+yPercent/100*138);if(cityPixi)return cityPixi.walkable(x,y);return pointInPolygon(x+.5,y+.5,cityBoundary)&&(!cityCollision||cityCollision.has(`${x},${y}`))}
// Conversões entre o par x%,y% do jogador e o tile do mapa — o mesmo par de
// constantes que canMoveCity usa.
function cityTileAt(xPercent,yPercent){return[Math.floor(970+xPercent/100*141),Math.floor(975+yPercent/100*138)]}
function cityPercentAtTile(tileX,tileY){return[(tileX+.5-970)*100/141,(tileY+.5-975)*100/138]}
// Rede de segurança: se o jogador terminar em cima de um tile bloqueado (mapa
// que carregou depois, teleporte com coordenada ruim, mudança de colisão num
// deploy), ele fica travado para sempre porque moveCity só testa o destino.
// Procura em anéis o tile andável mais próximo e coloca o jogador nele.
function rescueCityPlayer(){
  if(canMoveCity(cityPlayer.x,cityPlayer.y))return false;
  const[tileX,tileY]=cityTileAt(cityPlayer.x,cityPlayer.y);
  for(let radius=1;radius<=16;radius++){
    for(let dy=-radius;dy<=radius;dy++)for(let dx=-radius;dx<=radius;dx++){
      if(Math.max(Math.abs(dx),Math.abs(dy))!==radius)continue;
      const[px,py]=cityPercentAtTile(tileX+dx,tileY+dy);
      if(!canMoveCity(px,py))continue;
      cityPlayer.x=px;cityPlayer.y=py;
      resetCityFollower();updateCityCamera();updateBuildingState();
      return true;
    }
  }
  return false;
}
function updateCityCamera(){
  const world=$('#cityMapWorld'),actor=$('#cityTrainer'),partner=$('#cityPartner');
  if(!world)return;
  // O canvas do Pixi fica fora de #cityMapWorld e parado: quem anda é o mundo.
  // Os dois usam o mesmo par x%,y% e o mesmo tamanho de mundo (11280x11040),
  // e o renderer da cidade sobe com clampCamera:false, então o offset que ele
  // devolve é exatamente o que o translate(-x%,-y%) do DOM produz.
  if(cityPixi)cityPixi.setCameraPercent(cityPlayer.x,cityPlayer.y);
  world.style.transform=`translate(-${cityPlayer.x}%,-${cityPlayer.y}%)`;
  if(actor)setActorPercent(actor,cityPlayer.x,cityPlayer.y);
  if(partner)setActorPercent(partner,cityFollower.x,cityFollower.y);
}
function updateRouteCamera(){
  const world=$('#routeMapWorld'),player=routeSim.player;
  if(!world||!player)return;
  if(routePixi){
    const offset=routePixi.setCameraPercent(player.x,player.y);
    routePixiToppers?.setCameraPercent(player.x,player.y);
    if(offset)world.style.transform=`translate(${offset.x}px,${offset.y}px)`;
    return;
  }
  world.style.transform=`translate(-${player.x}%,-${player.y}%)`;
}
// DEBUG TEMPORÁRIO — `?roofshift=N` (ou `?roofshiftx=A&roofshifty=B`).
//
// O mapa de tiles não desenha telhado nenhum: o saffron.json só tem o andar
// z=7 e a camada `toppers` tem 4 sprites no mapa inteiro. Todo telhado vem de
// três overlays WebP (PC, loja, casas). O do Centro Pokémon encaixa porque
// alguém alinhou as paredes dele à mão em pc-wall-nudge.js; loja e casas nunca
// foram alinhadas. Este parâmetro desloca os overlays em tiles para descobrir
// o desvio real antes de corrigir na extração. Remover quando o offset estiver
// aplicado na origem.
function applyRoofShiftDebug(){
  const params=new URLSearchParams(location.search);
  if(!params.has('roofshift')&&!params.has('roofshiftx')&&!params.has('roofshifty'))return;
  const base=Number(params.get('roofshift'))||0;
  const dx=params.has('roofshiftx')?Number(params.get('roofshiftx'))||0:base;
  const dy=params.has('roofshifty')?Number(params.get('roofshifty'))||0:base;
  const CELL=80; // px de mundo por tile (tile-utils.CELL)
  const layers=$$('.city-roof-layer');
  layers.forEach(el=>{el.style.transform=`translate(${dx*CELL}px,${dy*CELL}px)`});
  showToast(`roofshift ${dx},${dy} tiles · ${layers.length} camadas`);
}
function updateBuildingState(){
  const world=$('#cityMapWorld'),insideCenter=cityPlayer.x>41.3&&cityPlayer.x<53.5&&cityPlayer.y>33.4&&cityPlayer.y<45.6,insideShop=cityPlayer.x>27&&cityPlayer.x<39&&cityPlayer.y>50&&cityPlayer.y<64;
  world.classList.toggle('inside-building',insideCenter);world.classList.toggle('inside-shop',insideShop);
  // O telhado agora é tile do andar de cima, não mais overlay WebP: cada prédio
  // some sozinho ao entrar, sem levar junto o telhado dos vizinhos.
  if(cityPixi?.setRoofVisible){
    cityPixi.setRoofVisible('pc',!insideCenter);
    cityPixi.setRoofVisible('shop',!insideShop);
  }
  ensureCityNpcMarkers();
}
function ensureCityNpcMarkers(){
  const host=$('#cityNpcMarkers');if(!host||host.dataset.ready)return;
  host.dataset.ready='1';
  host.innerHTML=CITY_NPCS.filter(n=>!['shop','tmShop','nurse','fisher'].includes(n.id)).map(n=>
    `<button type="button" class="city-system-npc" data-npc-id="${n.id}" style="left:${n.x}%;top:${n.y}%" aria-label="${t(n.labelKey)||n.id}"><img class="city-npc-sprite" src="${entityAsset(n.sprite||'meowth','south',0)}" alt="" onerror="this.style.display='none'"><b data-npc-label="${n.id}">${t(n.labelKey)||n.id}</b></button>`
  ).join('');
  host.querySelectorAll('[data-npc-id]').forEach(btn=>{
    const npc=CITY_NPCS.find(n=>n.id===btn.dataset.npcId);
    btn.onclick=()=>openCityNpcPanel(npc);
    applyNpcSprite(btn.querySelector('img'),npc);
  });
  const fisher=CITY_NPCS.find(n=>n.id==='fisher');
  applyNpcSprite(document.querySelector('.fishing-npc[data-npc="fisher"] img'),fisher);
}
function renderCityNpcLabels(){
  for(const npc of CITY_NPCS){
    const marker=$(`[data-npc-id="${npc.id}"]`),label=$(`[data-npc-label="${npc.id}"]`);
    if(marker)marker.setAttribute('aria-label',t(npc.labelKey)||npc.id);
    if(label)label.textContent=t(npc.labelKey)||npc.id;
  }
}
function openCityNpcPanel(npc){
  if(!npc)return;
  if(npc.panel==='center'){openCityDialog('heal');return}
  if(npc.panel==='shop'||npc.panel==='tm-shop'||npc.panel==='fish'){openCityDialog(npc.panel);return}
  if(npc.panel==='market'){try{openMarket()}catch{openMasterPanel('shopEmerald')};return}
  openMasterPanel(npc.panel);
}
function moveCity(now,dt){
  if(!$('#cityView').classList.contains('active')||!$('#cityDialog').classList.contains('hidden'))return;
  if(!cityWorldReady)return;
  let dx=(keys.has('d')?1:0)-(keys.has('a')?1:0),dy=(keys.has('s')?1:0)-(keys.has('w')?1:0),moving=false;
  if(dx||dy)rescueCityPlayer();
  if(dx||dy){const length=Math.hypot(dx,dy),beforeX=cityPlayer.x,beforeY=cityPlayer.y;dx/=length;dy/=length;const nextX=cityPlayer.x+dx*4*dt,nextY=cityPlayer.y+dy*4*dt;if(canMoveCity(nextX,cityPlayer.y))cityPlayer.x=nextX;if(canMoveCity(cityPlayer.x,nextY))cityPlayer.y=nextY;moving=Math.hypot(cityPlayer.x-beforeX,cityPlayer.y-beforeY)>.0001;cityPlayer.dir=directionFor(dx,dy);setActor($('#cityTrainer'),trainerSprite(),cityPlayer.dir,moving,now,{frameMs:CITY_WALK_FRAME_MS});if(moving)recordCityTrail();updateCityCamera();updateBuildingState()}
  moveCityFollower(now,dt)
}
function moveWilds(now,dt){
  for(const wild of routeSim.wilds){
    if(wild===routeSim.target)continue;
    wild.wander+=(Math.random()-.5)*dt*2.4;
    const speed=ROUTE_WILD_WANDER_SPEED;
    const[dx,dy]=scaleRouteDelta(Math.cos(wild.wander)*speed*dt,Math.sin(wild.wander)*speed*dt,routeLand),radius=wild.roamRadius||5,[radiusX,radiusY]=scaleRouteDelta(radius,radius,routeLand);
    let nx=Math.max(wild.homeX-radiusX,Math.min(wild.homeX+radiusX,wild.x+dx));
    let ny=Math.max(wild.homeY-radiusY,Math.min(wild.homeY+radiusY,wild.y+dy));
    [nx,ny]=stepOnLand(wild.x,wild.y,nx,ny,routeLand,ROUTE_EDGE_MARGIN);
    let moved=routeDistance(wild.x,wild.y,nx,ny,routeLand)>.0001;
    if(!moved){
      // Colidiu com água/borda: vira e tenta um passo curto na nova direção.
      wild.wander+=Math.PI*(0.55+Math.random()*0.7);
      const[sx,sy]=scaleRouteDelta(Math.cos(wild.wander)*speed*dt,Math.sin(wild.wander)*speed*dt,routeLand);
      let tx=Math.max(wild.homeX-radiusX,Math.min(wild.homeX+radiusX,wild.x+sx));
      let ty=Math.max(wild.homeY-radiusY,Math.min(wild.homeY+radiusY,wild.y+sy));
      [tx,ty]=stepOnLand(wild.x,wild.y,tx,ty,routeLand,ROUTE_EDGE_MARGIN);
      nx=tx;ny=ty;
      moved=routeDistance(wild.x,wild.y,nx,ny,routeLand)>.0001;
    }
    const prevX=wild.x,prevY=wild.y;
    wild.x=nx;wild.y=ny;
    if(moved)wild.dir=directionFor(nx-prevX,ny-prevY);
    const el=$(`#${wild.id}`);
    // .target destaca a etiqueta do alvo atual; as demais ficam esmaecidas.
    if(el){setActorPercent(el,wild.x,wild.y);el.classList.toggle('target',routeSim.target===wild);setActor(el,wild.name,wild.dir,moved,now)}
  }
}
function stepPartnerToward(fromX,fromY,toX,toY,step){
  return bestStepTowardLand(fromX,fromY,toX,toY,step,routeLand,ROUTE_EDGE_MARGIN);
}
function wildHpRatio(wild){
  return Math.max(0,Math.min(1,(Number(wild?.currentHp)||0)/Math.max(1,Number(wild?.maxHp)||1)));
}
function wildIsEngaged(wild){
  return !!wild&&(wild.engaged||wildHpRatio(wild)<0.999);
}
function partnerCombatReach(partnerData,preferredMove){
  const preferred=moveCombatRange(preferredMove);
  // Usa o maior alcance disponível no loadout para não “sair” do combate
  // só porque o Water Gun entrou em CD e o move preferido virou corpo-a-corpo.
  ensureStarterLoadout();
  const equipped=[...(state.starter?.equippedMoves||[])];
  if(state.starter?.aoeMove&&(partnerData?.level||0)>=100&&!equipped.includes(state.starter.aoeMove))equipped.push(state.starter.aoeMove);
  let maxRange=preferred;
  for(const id of equipped){
    const move=getMove(id);
    if(!isCombatMove(move))continue;
    maxRange=Math.max(maxRange,moveCombatRange(move));
  }
  return Math.max(preferred,maxRange,6);
}
function markWildUnreachable(wild,now,ms=9000){
  if(!wild?.id||wildIsEngaged(wild))return;
  if(!routeSim.unreachableUntil)routeSim.unreachableUntil=new Map();
  routeSim.unreachableUntil.set(wild.id,now+ms);
}
function isWildTemporarilyUnreachable(wild,now){
  if(!wild?.id||!routeSim.unreachableUntil||wildIsEngaged(wild))return false;
  const until=routeSim.unreachableUntil.get(wild.id);
  if(until==null)return false;
  if(until<=now){routeSim.unreachableUntil.delete(wild.id);return false}
  return true;
}
function pickNearestWild(player,exclude=null,now=performance.now()){
  const living=routeSim.wilds.filter(w=>w&&w.currentHp>0);
  const candidates=living.filter(w=>w!==exclude&&!isWildTemporarilyUnreachable(w,now));
  const pool=candidates.length?candidates:living.filter(w=>w!==exclude);
  if(!pool.length)return null;
  const reachable=pool.filter(w=>!landPathBlocked(player.x,player.y,w.x,w.y,routeLand));
  const ranked=reachable.length?reachable:pool;
  return ranked.reduce((best,w)=>{
    if(!best)return w;
    const dBest=routeDistance(player.x,player.y,best.x,best.y,routeLand);
    const dW=routeDistance(player.x,player.y,w.x,w.y,routeLand);
    // Em distâncias parecidas, prioriza finalizar quem já está ferido.
    if(Math.abs(dW-dBest)<=5){
      const engagedBest=wildIsEngaged(best),engagedW=wildIsEngaged(w);
      if(engagedW&&!engagedBest)return w;
      if(engagedBest&&!engagedW)return best;
      const hpBest=wildHpRatio(best),hpW=wildHpRatio(w);
      if(hpW<hpBest-0.04)return w;
      if(hpBest<hpW-0.04)return best;
    }
    return dW<dBest?w:best;
  },null);
}
function moveRoute(now,dt){
  if(!state.running)return;
  sweepDefeatedWilds();
  state.stats.seconds=Math.floor((Date.now()-routeStarted)/1000);
  if(routeSim.spawnTimer&&now>=routeSim.spawnTimer){
    routeSim.spawnTimer=0;addWild();
    if(routeSim.wilds.length<routeWildTargetCount())routeSim.spawnTimer=now+420;
  }else if(routeSim.wilds.length<routeWildTargetCount()&&!routeSim.spawnTimer)routeSim.spawnTimer=now+420;
  moveWilds(now,dt);
  const player=routeSim.player,partner=$('#routePartner'),partnerPokemon=partnerName();
  // Alvo engajado/ferido é sticky: não troca por unreachable temporário.
  if(!routeSim.target||!routeSim.wilds.includes(routeSim.target)||!(routeSim.target.currentHp>0)||(!wildIsEngaged(routeSim.target)&&isWildTemporarilyUnreachable(routeSim.target,now))){
    if(now<routeSim.nextTargetAt){moveRouteTrainer(now,dt);updateRouteCamera();return}
    routeSim.target=pickNearestWild(player,null,now);
    routeSim.lastMoveAt=now;
    routeSim.chaseFromDist=null;
    routeSim.chaseBestDist=null;
    routeSim.chaseProgressAt=now;
    attackStart=Date.now();
    if(routeSim.target){
      updateEnemyHud(routeSim.target);
      routeSim.nextPlayerAttackAt=0;routeSim.nextEnemyAttackAt=0;
    }
  }
  const target=routeSim.target;
  if(!target){moveRouteTrainer(now,dt);updateRouteCamera();return}
  const partnerData=ensureStarterCombat();
  if(!partnerData){updateRouteCamera();return}
  const dx=target.x-player.x,dy=target.y-player.y,distance=routeDistance(player.x,player.y,target.x,target.y,routeLand);
  const preferredMove=pickPlayerMove(partnerData,{commit:false});
  const battleRange=partnerCombatReach(partnerData,preferredMove);
  const engaged=wildIsEngaged(target);
  // Latch generoso + histerese: depois de engajar, só “descola” se afastar bastante.
  const engageDistance=battleRange+1.35;
  const disengageDistance=battleRange+(engaged?5.5:1.35);
  const stuckRetargetMin=battleRange+(engaged?10:4);
  if(!Number.isFinite(distance)){routeSim.target=null;routeSim.nextTargetAt=now+ROUTE_TARGET_ACQUIRE_DELAY_MS;routeSim.chaseFromDist=null;routeSim.chaseBestDist=null;return}
  if(routeSim.chaseFromDist==null)routeSim.chaseFromDist=Math.max(distance,battleRange+1);
  if(routeSim.chaseBestDist==null||distance<routeSim.chaseBestDist-0.15){
    routeSim.chaseBestDist=distance;
    routeSim.chaseProgressAt=now;
  }
  let chasing=distance>(engaged?disengageDistance:engageDistance);
  if(chasing){
    const step=Math.min(ROUTE_PARTNER_CHASE_SPEED*dt,Math.max(0.01,distance-battleRange)),previousX=player.x,previousY=player.y;
    const[nx,ny]=stepPartnerToward(player.x,player.y,target.x,target.y,step);
    player.x=nx;player.y=ny;
    const moved=routeDistance(previousX,previousY,player.x,player.y,routeLand)>.0001;
    if(moved)routeSim.lastMoveAt=now;
    const stuckStill=!moved&&now-routeSim.lastMoveAt>650;
    const stuckNoProgress=now-routeSim.chaseProgressAt>1400;
    if(stuckStill||stuckNoProgress){
      if(distance<=stuckRetargetMin||engaged){
        // Engajado ou já em cima: força combate / insiste no mesmo alvo.
        if(distance<=stuckRetargetMin)chasing=false;
        else{
          // Continua perseguindo o ferido; não troca de presa no meio da hunt.
          routeSim.chaseProgressAt=now;
          routeSim.lastMoveAt=now;
        }
      }else{
        markWildUnreachable(target,now);
        const next=pickNearestWild(player,target,now);
        routeSim.target=next;
        routeSim.chaseFromDist=null;
        routeSim.chaseBestDist=null;
        routeSim.chaseProgressAt=now;
        routeSim.lastMoveAt=now;
        if(!next)routeSim.nextTargetAt=now+ROUTE_TARGET_ACQUIRE_DELAY_MS;
        else updateEnemyHud(next);
        moveRouteTrainer(now,dt);updateRouteCamera();
        return;
      }
    }
  }
  if(chasing){
    player.dir=directionFor(dx,dy);
    setActorPercent(partner,player.x,player.y);
    setActor(partner,partnerPokemon,player.dir,true,now,{shiny:!!state.starter?.shiny});
    moveRouteTrainer(now,dt);
    updateRouteCamera();
    $('#battleStatus').textContent=t('battle.goingTo',{attacker:title(partnerPokemon).toUpperCase(),target:title(target.name).toUpperCase()});
    $('#battleTimer').textContent=t('battle.walking');
    const span=Math.max(0.5,routeSim.chaseFromDist-battleRange);
    const progress=Math.max(0,Math.min(100,(1-(distance-battleRange)/span)*100));
    $('#battleProgress').style.width=progress+'%';
    return;
  }
  // Garante sprite no ponto de combate atual.
  setActorPercent(partner,player.x,player.y);
  setActor(partner,partnerPokemon,player.dir,false,now,{shiny:!!state.starter?.shiny});
  moveRouteTrainer(now,dt);
  updateRouteCamera();
  $('#battleStatus').textContent=t('battle.fightingWith',{attacker:title(partnerPokemon).toUpperCase(),target:title(target.name).toUpperCase()});
  if(!partnerData){$('#battleProgress').style.width='0%';$('#battleTimer').textContent=t('battle.walking');return}
  if(!routeSim.nextPlayerAttackAt||!routeSim.nextEnemyAttackAt)resetCombatTurns(now);
  advanceCombat(now);
  if(routeSim.target!==target){$('#battleProgress').style.width='0%';$('#battleTimer').textContent=t('battle.searching');return}
  const nextAt=Math.min(routeSim.nextPlayerAttackAt||Infinity,routeSim.nextEnemyAttackAt||Infinity),wait=Number.isFinite(nextAt)?Math.max(0,nextAt-now):0,maxWait=Math.max(450,combatIntervalMs(partnerData.stats.spe));
  $('#battleProgress').style.width=Math.min(100,(1-wait/maxWait)*100)+'%';
  $('#battleTimer').textContent=`${t('battle.initiative')} · ${(wait/1000).toFixed(1)}s`;
}
// Passo de simulação por tempo real (movimento + combate). Dirigido pelo rAF
// quando a aba está visível e pelo Web Worker de fundo quando está oculta.
// Substeps de 0.05s dão determinismo; o teto de catch-up evita teleporte.
// Enquanto a hunt roda, segura a aba "viva" (áudio inaudível em loop): sem isso o
// Memory Saver do Chrome congela/descarta a aba minimizada e o worker morre junto.
let keepAliveOn=null;
function syncBackgroundKeepAlive(){
  const want=!!state.running;
  if(want===keepAliveOn)return;
  keepAliveOn=want;
  setBackgroundKeepAlive(want);
}
// P2.5: o teto de catch-up e a suspensão do SO descartam tempo quando a aba
// trava. Sem contador isso é uma perda silenciosa — o servidor agrega em
// background_metrics.
const backgroundMetrics={droppedCatchupSeconds:0};
function takeBackgroundMetrics(){
  const dropped=backgroundMetrics.droppedCatchupSeconds;
  backgroundMetrics.droppedCatchupSeconds=0;
  return{dropped_catchup_seconds:Math.round(dropped*100)/100};
}
function stepSim(now,maxCatchup){
  syncBackgroundKeepAlive();
  const elapsed=Math.max(0,(now-routeSim.last)/1000||0);
  const window=simulationWindow(elapsed,{maxCatchupSeconds:maxCatchup,resumeGapSeconds:5});
  backgroundMetrics.droppedCatchupSeconds+=window.droppedSeconds;
  const total=window.simulateSeconds;
  routeSim.last=now;
  // Um gap maior que 5s é tratado como retorno de suspensão: rebaseamos o
  // relógio em vez de disparar centenas de kills/XP/overlays em uma rajada.
  let simNow=now-total*1000;
  let remain=total;
  while(remain>0){
    const dt=Math.min(.05,remain);
    simNow+=dt*1000;
    moveCity(simNow,dt);
    moveRoute(simNow,dt);
    remain-=dt;
  }
}
// Motor de segundo plano: com a aba oculta o navegador CONGELA o requestAnimationFrame
// e estrangula setInterval/Timeout (~1x/min). Um Web Worker não sofre esse throttling,
// então ele envia ticks ~4x/s e avançamos a simulação por tempo real, SEM renderizar
// (o repaint volta ao focar a aba). É isso que mantém a hunt rodando em outra aba /
// navegador minimizado / atrás de outro app.
let bgEngine=null;
let rafActive=false;
const BG_MAX_CATCHUP_S=30;
function startBackgroundEngine(){
  if(bgEngine||typeof Worker==='undefined')return;
  try{
    const src='var h=setInterval(function(){postMessage(0)},250);self.onmessage=function(){};';
    const blob=new Blob([src],{type:'text/javascript'});
    const url=URL.createObjectURL(blob);
    bgEngine=new Worker(url);
    URL.revokeObjectURL(url);
    bgEngine.onmessage=()=>{ if(document.hidden)stepSim(performance.now(),BG_MAX_CATCHUP_S); };
  }catch(error){console.warn('background engine unavailable',error)}
}
let resumeReconcilePromise=null;
async function reconcileAfterVisibilityResume(){
  if(resumeReconcilePromise)return resumeReconcilePromise;
  // Rebase before awaiting network calls so a delayed Worker message cannot
  // replay the OS-sleep interval while this reconciliation is in flight.
  routeSim.last=performance.now();
  resumeReconcilePromise=(async()=>{
    await flushSessionSync().catch(()=>{});
    await flushPokemonXpGrants().catch(()=>{});
    await refreshProgress().catch(()=>{});
    await refreshInventory().catch(()=>{});
    await flushGameSave().catch(()=>{});
    try{renderTrainerHud();renderPartnerHud();renderStats();renderWilds()}catch{}
  })().finally(()=>{resumeReconcilePromise=null});
  return resumeReconcilePromise;
}
// Ao voltar o foco, religa o rAF (que estava parado enquanto oculto) sem contar de
// novo o tempo que o worker já simulou.
function resumeForegroundLoop(){
  routeSim.last=performance.now();
  if(!rafActive){rafActive=true;requestAnimationFrame(tick)}
}
function tick(now){
  if(document.hidden){rafActive=false;return} // Worker assume; não reagenda rAF morto.
  rafActive=true;
  requestAnimationFrame(tick);
  stepSim(now,.25);
  if(now-lastStatsRenderAt>=STATS_RENDER_INTERVAL_MS){
    lastStatsRenderAt=now;
    renderStats();
  }
}
// Contadores de moeda animados.
//
// Escrever o número novo direto faz o ganho passar despercebido — o valor
// simplesmente troca. Interpolar em ~340ms e pulsar o elemento transforma cada
// drop em recompensa visível. Ganhos minúsculos vão direto, para o HUD não
// ficar em animação perpétua durante a hunt.
const counterTweens=new Map();
const COUNTER_TWEEN_MS=340;
function setCounterValue(el,value){
  if(!el)return;
  const target=Number(value)||0;
  const current=counterTweens.get(el)?.value ?? Number(el.dataset.counterValue);
  if(!Number.isFinite(current)||Math.abs(target-current)<1||Math.abs(target-current)>1e12){
    counterTweens.get(el)?.cancel();
    counterTweens.delete(el);
    el.dataset.counterValue=String(target);
    el.textContent=formatNumber(target);
    return;
  }
  counterTweens.get(el)?.cancel();
  const from=current,start=performance.now();
  let raf=0;
  const step=(now)=>{
    const p=Math.min(1,(now-start)/COUNTER_TWEEN_MS);
    // easeOutCubic: rápido no início, assenta no fim.
    const eased=1-Math.pow(1-p,3);
    const shown=Math.round(from+(target-from)*eased);
    el.dataset.counterValue=String(shown);
    el.textContent=formatNumber(shown);
    if(p<1){raf=requestAnimationFrame(step);counterTweens.set(el,{value:shown,cancel})}
    else{counterTweens.delete(el);el.dataset.counterValue=String(target)}
  };
  function cancel(){cancelAnimationFrame(raf)}
  if(target>from){el.classList.remove('counter-pop');void el.offsetWidth;el.classList.add('counter-pop')}
  counterTweens.set(el,{value:from,cancel});
  raf=requestAnimationFrame(step);
}
function renderStats(){
  renderNavNotifications();
  setCounterValue($('#coins'),state.stats.coins);
  if($('#emerald'))setCounterValue($('#emerald'),state.emerald||0);
  renderTrainerHud();if($('#shopCoins'))setCounterValue($('#shopCoins'),state.stats.coins)
}
function itemIcon(slug){const it=ITEM_BY_SLUG[slug];return it?`<img class="shop-item-icon" src="${it.img}" alt="${displayItem(slug)}" loading="lazy">`:''}
function renderDropBag(){
  if(!$('#dropBag')||!$('#dropBagValue'))return;
  const owned=Object.keys(state.drops).filter(s=>state.drops[s]>0&&ITEM_BY_SLUG[s]);
  const total=owned.reduce((sum,slug)=>sum+sellValue(ITEM_BY_SLUG[slug])*state.drops[slug],0);
  $('#dropBag').innerHTML=owned.length?owned.map(slug=>{const d=ITEM_BY_SLUG[slug];return `<div class="drop-bag-item" title="${displayItem(slug)} · ${sellValue(d)} ${t('common.coins')}">${itemIcon(slug)}<em>${state.drops[slug]}</em></div>`}).join(''):`<div class="drop-bag-empty">${t('dialog.noDrops')}</div>`;
  $('#dropBagValue').textContent=formatNumber(total);
}
function inventoryQty(slug){return(state.inventory[slug]||0)+(state.drops[slug]||0)}
function ensureInventoryFloatTip(){
  let tip=$('#inventoryFloatTip');
  if(!tip){
    tip=document.createElement('div');
    tip.id='inventoryFloatTip';
    tip.className='inventory-float-tip';
    tip.setAttribute('role','tooltip');
    document.body.appendChild(tip);
  }
  return tip;
}
function hideInventoryFloatTip(){
  const tip=$('#inventoryFloatTip');
  if(!tip)return;
  tip.classList.remove('show');
  tip.innerHTML='';
}
function placeInventoryFloatTip(slot){
  const tip=ensureInventoryFloatTip(),src=slot.querySelector('.inventory-tip-content');
  if(!src)return;
  tip.innerHTML=src.innerHTML;
  tip.classList.add('show');
  tip.style.left='0px';tip.style.top='0px';
  const rect=slot.getBoundingClientRect(),position=inventoryTooltipPosition(
    rect,
    {width:tip.offsetWidth,height:tip.offsetHeight},
    {width:window.innerWidth,height:window.innerHeight},
    slot.closest('.inventory-panel')?.getBoundingClientRect(),
  );
  tip.style.left=`${position.left}px`;
  tip.style.top=`${position.top}px`;
}
function bindInventoryTooltips(){
  hideInventoryFloatTip();
  $$('#inventorySections .inventory-slot').forEach(slot=>{
    const dismiss=()=>dismissInventoryMarker(slot.dataset.inventorySlug,slot);
    slot.onmouseenter=()=>{dismiss();placeInventoryFloatTip(slot)};
    slot.onfocus=()=>{dismiss();placeInventoryFloatTip(slot)};
    slot.onmouseleave=hideInventoryFloatTip;
    slot.onblur=hideInventoryFloatTip;
    slot.onclick=event=>{
      if(!event.shiftKey||!slot.dataset.chatLink)return;
      event.preventDefault();event.stopPropagation();hideInventoryFloatTip();
      linkAssetToChat(inventoryChatAssets.get(slot.dataset.chatLink));
    };
  });
  const panel=$('#inventoryPanel');
  if(panel&&!panel.dataset.tipScrollBound){
    panel.dataset.tipScrollBound='1';
    panel.addEventListener('scroll',hideInventoryFloatTip,{passive:true});
  }
}
function chatPokemonAttachment(pokemon,{equipped=false,localId=''}={}){
  const payload=marketPokemonPayload(pokemon),type=primaryTypeFor(pokemon.name),stats=pokemon.stats||statsFor(pokemon.name,type,pokemon.level,pokemon.ivs,pokemon.mult||1);
  return{kind:'pokemon',slug:entitySlug(pokemon.name),local_id:String(localId||pokemon.id||'starter'),custody_id:payload.market_asset_id,
    level:payload.level,ivs:payload.ivs,iv_total:ivScoreFor(pokemon),rarity:payload.rarity,mult:payload.mult,
    shiny:payload.shiny,ball:payload.ball,moves:payload.moves,power:pokemonPower(stats,payload.mult),equipped};
}
function renderPlayerInventory(){
  if(deferPanelRender('inventoryPanelLayer'))return;
  const sections=$('#inventorySections');if(!sections)return;
  inventoryChatAssets.clear();
  const fmt=n=>formatNumber(n);
  const groups=[
    {title:t('inv.section.balls'),category:'BALL',items:BALLS.filter(b=>!isPremiumBall(b.slug)||(state.inventory[b.slug]||0)>0).map(b=>({...b,qty:state.inventory[b.slug]||0}))},
    {title:t('inv.section.potions'),category:'POTION',items:POTIONS.map(p=>({...p,qty:state.inventory[p.slug]||0}))},
    {title:t('inv.section.stones'),category:'STONE',items:STONES.map(s=>({...s,qty:(state.inventory[s.slug]||0)+(state.drops[s.slug]||0)}))},
    {title:t('inv.section.drops'),category:'LOOT',items:DROP_ITEMS.map(d=>({...d,qty:state.drops[d.slug]||0}))}
  ];
  let totalItems=0,dropValue=0;
  sections.innerHTML=groups.map(group=>{
    const owned=group.items.filter(it=>it.qty>0);
    owned.forEach(it=>{totalItems+=it.qty;if(group.category==='LOOT')dropValue+=sellValue(it)*it.qty});
    return`<section class="ui-section inventory-section"><header><small class="eyebrow">${group.title}</small><b>${owned.length?owned.reduce((s,i)=>s+i.qty,0):0}</b></header>
      <div class="inventory-grid">${owned.length?owned.map(it=>{
        const unit=sellValue(it)||0,total=unit*it.qty,unreadQty=inventoryUnreadQty(state.notifications,it.slug),isNew=unreadQty>0;
        const chatKey=`item:${it.slug}`;inventoryChatAssets.set(chatKey,{kind:'item',slug:it.slug,local_id:it.slug,qty:it.qty,img:it.img});
        return`<article class="inventory-slot ${isNew?'is-new':''}" tabindex="0" data-chat-link="${chatKey}" data-inventory-slug="${it.slug}">
          ${isNew?`<span class="inventory-new-marker" role="img" title="${t('common.new')}" aria-label="${t('common.new')}">!</span>`:''}
          ${itemIcon(it.slug)}
          <em>${fmt(it.qty)}</em>
          <div class="inventory-tip-content" hidden>
            <div class="inventory-tip-head"><b>${displayItem(it.slug)}</b><span>×${fmt(it.qty)}</span></div>
            <small>${group.title}</small>
            <div class="inventory-tip-value">${idlecoinMark(12)}<span>${fmt(unit)} ${t('common.coins')}</span></div>
            <div class="inventory-tip-value total">${idlecoinMark(12)}<span>${fmt(total)} ${t('common.coins')}</span></div>
          </div>
        </article>`;
      }).join(''):`<div class="inventory-empty">${t('inv.empty')}</div>`}</div></section>`;
  }).join('');
  const pokemonEntries=equippedTeamMembers().map(member=>({pokemon:member.pokemon,equipped:true,main:member.kind==='starter',key:member.kind==='starter'?'starter':String(member.id)}));
  sections.insertAdjacentHTML('beforeend',`<section class="ui-section inventory-section inventory-pokemon-section"><header><small class="eyebrow">${t('inv.section.pokemon')}</small><b>${pokemonEntries.length}</b></header><div class="inventory-grid inventory-pokemon-grid">${pokemonEntries.length?pokemonEntries.map(entry=>{
    const p=entry.pokemon,r=rarityInfo(p),chatKey=`pokemon:${entry.key}`,attachment=chatPokemonAttachment(p,{equipped:entry.equipped,localId:entry.key});inventoryChatAssets.set(chatKey,attachment);
    const ivs=attachment.ivs||{},power=attachment.power||0,ivLabel=formatPokemonIv(p);
    const ivCells=['hp','atk','def','spa','spd','spe'].map(stat=>{
      const value=ivs[stat]??0;
      return`<span class="${value>=28?'iv-high':''}">${stat.toUpperCase()} <b>${value}</b></span>`;
    }).join('');
    return`<article class="inventory-slot inventory-pokemon-slot ${shinyClassFor(p)} ${rarityTierClass(r)}" tabindex="0" data-chat-link="${chatKey}" style="--rarity:${r.color}">
      <img src="${entityAsset(p.name,'south',0,{shiny:!!p.shiny})}" alt="${title(p.name)}">
      ${p.shiny?'<i class="inventory-shiny">✦</i>':''}
      ${entry.equipped?`<span class="inventory-equipped">${entry.main?t('chat.partner'):t('chat.equipped')}</span>`:''}
      <div class="inventory-tip-content" hidden>
        <div class="inventory-tip-head"><b>${p.shiny?'✦ ':''}${title(p.name)}</b><span class="inventory-tip-level">${t('common.lv')} ${p.level}</span></div>
        <div class="inventory-tip-meta">
          <em class="team-rarity-pill" style="--badge:${r.color}">${r.label}<span>· ×${formatNumber(r.mult,{minimumFractionDigits:2,maximumFractionDigits:2})}</span></em>
          <em class="collection-iv-pill" style="--iv-color:${r.color}">IV ${ivLabel}</em>
          <span class="inventory-tip-power">${formatNumber(power)} ${t('common.power')}</span>
        </div>
        <div class="inventory-tip-ivs">${ivCells}</div>
        <div class="inventory-tip-value total"><span>${t('chat.shiftToLink')}</span></div>
      </div>
    </article>`;
  }).join(''):`<div class="inventory-empty">${t('col.empty')}</div>`}</div></section>`);
  if($('#inventoryTotalItems'))$('#inventoryTotalItems').textContent=fmt(totalItems);
  if($('#inventoryDropValue'))$('#inventoryDropValue').textContent=fmt(dropValue);
  if($('#inventoryPokemonCount'))$('#inventoryPokemonCount').textContent=pokemonEntries.length;
  const invSub=$('#inventoryPanel [data-i18n="inv.sub"]');if(invSub)invSub.textContent=t('inv.sub');
  $$('#inventorySections .inventory-pokemon-slot img').forEach(centerPortrait);
  bindInventoryTooltips();
}
function renderBallSelect(){
  const box=$('#ballSelect');if(!box)return;
  const selectableBalls=selectableCaptureBalls().filter(ball=>(state.inventory[ball.slug]||0)>0);
  if(!selectableBalls.some(ball=>ball.slug===selectedBall))selectedBall=selectableBalls[0]?.slug||'pokeball';
  state.selectedBall=selectedBall;
  box.innerHTML=selectableBalls.length?`<select class="automation-select" aria-label="${t('auto.ball')}">${selectableBalls.map(ball=>`<option value="${ball.slug}" ${selectedBall===ball.slug?'selected':''}>${displayItem(ball.slug)} ×${state.inventory[ball.slug]||0}</option>`).join('')}</select>`:`<div class="automation-empty">${t('auto.ballNone')}</div>`;
  $('#ballSelect select')?.addEventListener('change',event=>{selectedBall=event.target.value;state.selectedBall=selectedBall;const cap=$('#captureFeedback');if(cap&&!cap.classList.contains('hidden')&&!cap.classList.contains('toast-mode'))renderCapturePanel();save()});
  renderShinyBallSelect();
}
function renderShinyBallSelect(){
  const box=$('#shinyBallSelect');if(!box)return;
  const selectableBalls=selectableCaptureBalls().filter(ball=>(state.inventory[ball.slug]||0)>0);
  if(!selectableBalls.some(ball=>ball.slug===selectedShinyBall))selectedShinyBall=selectableBalls[0]?.slug||'pokeball';
  state.selectedShinyBall=selectedShinyBall;
  box.innerHTML=selectableBalls.length?`<select class="automation-select" aria-label="${t('auto.shinyBall')}">${selectableBalls.map(ball=>`<option value="${ball.slug}" ${selectedShinyBall===ball.slug?'selected':''}>${displayItem(ball.slug)} ×${state.inventory[ball.slug]||0}</option>`).join('')}</select>`:`<div class="automation-empty">${t('auto.ballNone')}</div>`;
  $('#shinyBallSelect select')?.addEventListener('change',event=>{selectedShinyBall=event.target.value;state.selectedShinyBall=selectedShinyBall;save()});
}
// Espelha o least() de purchase_shop_item no servidor — os dois PRECISAM bater,
// senão a UI cobra por N e o servidor entrega o teto dele.
const SHOP_MAX_BUY_QTY=999;
let shopBuyQty=1;
let shopVendor='general';
const shopSellSelected=new Map();
const shopPokeSelected=new Set();
/* Filtro da loja começa com TODAS as raridades marcadas; clicar desmarca (esconde). */
const shopRarityFilter=new Set();
function resetShopRarityFilter(){shopRarityFilter.clear();for(const r of rarity)shopRarityFilter.add(r.name)}
resetShopRarityFilter();
function sellQtyFor(slug,stock){
  const max=Math.max(1,stock|0);
  const cur=shopSellSelected.has(slug)?+shopSellSelected.get(slug):max;
  return Math.max(1,Math.min(max,Math.round(cur)||max));
}
function setSellQty(slug,value,stock){
  const max=Math.max(1,stock|0);
  const qty=Math.max(1,Math.min(max,Math.round(+value||1)));
  shopSellSelected.set(slug,qty);
  return qty;
}
function shopItemEffect(it){
  if(it.tm)return t('dialog.tmEffect',{type:typeLabel(it.type),level:it.minLevel||100});
  if(it.capture!=null)return`×${it.capture}`;
  if(it.heal!=null)return`${Math.round(it.heal*100)}%`;
  if(it.cure)return it.cure;
  if(it.revive)return'Revive';
  if(it.fishing){
    const rod=fishingRodFor(it.slug),max=ranges[rod?.maxBand]?.[1]||1;
    return t('fish.rodEffect',{max});
  }
  return itemDesc(it.slug)||it.desc||'';
}
function syncShopBuyQty(value){
  shopBuyQty=Math.max(1,Math.min(SHOP_MAX_BUY_QTY,Math.round(+value||1)));
  if($('#shopBuyQty'))$('#shopBuyQty').value=shopBuyQty;
  if($('#shopBuyQtyRange'))$('#shopBuyQtyRange').value=shopBuyQty;
  $$('#shopGrid [data-item]').forEach(row=>{
    const price=+row.dataset.price||0;
    const totalEl=row.querySelector('[data-buy-total]');
    if(totalEl)totalEl.innerHTML=coinsAmount(price*shopBuyQty);
  });
}
function renderShopBuy(){
  const grid=$('#shopGrid');if(!grid)return;
  const fmt=n=>formatNumber(n);
  const catalog=shopVendor==='tm'?PURCHASABLE_TM_ITEMS:SHOP_ITEMS;
  grid.innerHTML=catalog.length?catalog.map(it=>{
    const own=state.inventory[it.slug]||0;
    return`<article class="shop-row" data-item="${it.slug}" data-price="${it.price}">
      ${itemIcon(it.slug)}
      <div class="shop-row-copy ui-copy"><b>${displayItem(it.slug)}</b><small>${shopItemEffect(it)}${own?` · ${t('dialog.inStock',{qty:fmt(own)})}`:''}</small></div>
      <strong data-buy-total>${coinsAmount(it.price*shopBuyQty)}</strong>
      <button type="button" class="ui-btn shop-row-buy" data-buy="${it.slug}">${t('common.buy')}</button>
    </article>`;
  }).join(''):`<div class="shop-empty">${t('dialog.tmDropOnly')}</div>`;
}
function renderShopSell(){
  const list=$('#shopSell');if(!list)return;
  const fmt=n=>formatNumber(n);
  const owned=Object.keys(state.drops).filter(s=>(state.drops[s]||0)>0&&ITEM_BY_SLUG[s]);
  for(const slug of [...shopSellSelected.keys()])if(!owned.includes(slug))shopSellSelected.delete(slug);
  list.innerHTML=owned.length?owned.map(slug=>{
    const d=ITEM_BY_SLUG[slug],stock=state.drops[slug],each=sellValue(d),checked=shopSellSelected.has(slug);
    const sellQty=checked?sellQtyFor(slug,stock):stock;
    if(checked)shopSellSelected.set(slug,sellQty);
    const lineTotal=each*(checked?sellQty:stock);
    const qtyControls=checked?`<div class="shop-sell-qty" data-sell-controls="${slug}">
      <input type="number" min="1" max="${stock}" value="${sellQty}" data-sell-qty="${slug}" aria-label="${t('dialog.qty')}">
      <input type="range" min="1" max="${stock}" value="${sellQty}" data-sell-qty-range="${slug}" aria-label="${t('dialog.qty')}">
    </div>`:'';
    return`<div class="shop-row sell ${checked?'selected':''}" data-sell-row="${slug}">
      <input type="checkbox" data-sell-drop="${slug}" ${checked?'checked':''}>
      ${itemIcon(slug)}
      <div class="shop-row-copy ui-copy"><b>${displayItem(slug)}</b><small>${t('dialog.stockLine',{qty:fmt(stock),total:formatCoins(lineTotal)})}</small>${qtyControls}</div>
      <strong data-sell-total>${coinsAmount(lineTotal)}</strong>
    </div>`;
  }).join(''):`<div class="shop-empty">${t('dialog.noDrops')}</div>`;
}
function syncShopSellQtyRow(slug){
  const stock=state.drops[slug]|0;if(stock<=0||!shopSellSelected.has(slug))return;
  const qty=setSellQty(slug,shopSellSelected.get(slug),stock);
  const each=sellValue(ITEM_BY_SLUG[slug]);
  const lineTotal=each*qty;
  const row=$(`#shopSell [data-sell-row="${slug}"]`);if(!row)return;
  const num=row.querySelector('[data-sell-qty]'),range=row.querySelector('[data-sell-qty-range]'),small=row.querySelector('.shop-row-copy small'),totalEl=row.querySelector('[data-sell-total]');
  if(num&&+num.value!==qty)num.value=qty;
  if(range){range.max=stock;if(+range.value!==qty)range.value=qty}
  if(num)num.max=stock;
  if(small)small.textContent=t('dialog.stockLine',{qty:formatNumber(stock),total:formatCoins(lineTotal)});
  if(totalEl)totalEl.innerHTML=coinsAmount(lineTotal);
}
function renderShopPokemon(){
  const list=$('#shopPokemon');if(!list)return;
  const ivMin=$('#shopIvMin')?.value===''?null:+$('#shopIvMin').value;
  const ivMax=$('#shopIvMax')?.value===''?null:+$('#shopIvMax').value;
  const visible=state.collection.filter(p=>{
    const iv=ivScoreFor(p);
    if(ivMin!=null&&!Number.isNaN(ivMin)&&iv<ivMin)return false;
    if(ivMax!=null&&!Number.isNaN(ivMax)&&iv>ivMax)return false;
    if(!shopRarityFilter.has(p.rarity||'Comum'))return false;
    return true;
  });
  for(const id of [...shopPokeSelected])if(!visible.some(p=>String(p.id)===String(id)))shopPokeSelected.delete(id);
  let selectedTotal=0,selectedCount=0;
  for(const p of visible){
    if(!shopPokeSelected.has(String(p.id))||isOnTeam(p)||p.locked)continue;
    selectedCount++;selectedTotal+=pokemonSellPrice(p,pokedexEntry(p.name));
  }
  const totalBox=$('#shopPokeSellTotal');
  if(totalBox)totalBox.innerHTML=`<small>${t('dialog.sellTotal',{count:selectedCount})}</small><b>${coinsAmount(selectedTotal)}</b>`;
  list.innerHTML=visible.length?visible.map(p=>{
    const entry=pokedexEntry(p.name),price=pokemonSellPrice(p,entry),r=rarityInfo(p),onTeam=isOnTeam(p),locked=!!p.locked,checked=shopPokeSelected.has(String(p.id)),disabled=onTeam||locked;
    return`<div class="shop-row poke ${shinyClassFor(p,'portrait')} ${checked?'selected':''} ${disabled?'disabled':''}" style="--rarity:${r.color}">
      <input type="checkbox" data-sell-poke="${p.id}" ${checked?'checked':''} ${disabled?'disabled':''}>
      ${pokePortrait(p.name,typeColors[(p.types||[])[0]]||'#82765b','',p)}
      <div class="shop-row-copy ui-copy"><b>${title(p.name)}</b><small>${t('common.lv')} ${p.level} · <i style="color:${r.color}">${rarityLabel(r.name)}</i> · IV ${formatPokemonIv(p)}${onTeam?` · ${t('dialog.onTeam')}`:''}</small></div>
      <strong>${coinsAmount(price)}</strong>
      <button type="button" class="shop-lock ${locked?'on':''}" data-lock-poke="${p.id}" title="${locked?t('dialog.unlockSale'):t('dialog.lockSale')}">${locked?'🔒':'🔓'}</button>
    </div>`;
  }).join(''):`<div class="shop-empty">${t('dialog.noPokemonFilter')}</div>`;
  $$('#shopPokemon .poke-portrait img').forEach(centerPortrait);
}
function renderShopRarityFilters(){
  const box=$('#shopRarityFilters');if(!box)return;
  box.innerHTML=rarity.map(r=>{const on=shopRarityFilter.has(r.name);return`<button type="button" class="ui-pill shop-rarity-pill ${on?'active':''}" data-shop-rarity="${r.name}" style="--badge:${r.color}" aria-pressed="${on}"><i></i>${rarityLabel(r.name)}</button>`}).join('');
}
function refreshShopPanes(){
  renderShopBuy();renderShopSell();renderShopPokemon();
  if($('#shopCoins'))$('#shopCoins').textContent=formatNumber(state.stats.coins);
}
function renderInventory(){renderBallSelect();renderPotionSelect();renderReviveSelect();renderPlayerInventory()}
let pokedexSelectedId=null;
function ownedBySpecies(){
  const map=new Map();
  for(const p of state.collection||[]){
    const key=String(p.name).toLowerCase().replace(/_/g,'-');
    if(!map.has(key))map.set(key,[]);
    map.get(key).push(p);
  }
  return map;
}
function renderPokedex(){
  if(deferPanelRender('pokedexPanelLayer'))return;
  if(!isPokedexReady()||!$('#pokedexList'))return;
  const typeFilter=$('#pokedexTypeFilter');
  if(typeFilter&&typeFilter.options.length<=1){
    typeFilter.innerHTML=`<option value="">${t('dex.allTypes')}</option>`+types.map(tp=>`<option value="${tp[0]}">${typeLabel(tp[0])}</option>`).join('');
  }
  const q=($('#pokedexSearch')?.value||'').trim().toLowerCase();
  const type=$('#pokedexTypeFilter')?.value||'';
  const ownedOnly=$('#pokedexOwnedOnly')?.checked;
  const ownedMap=ownedBySpecies();
  const all=allPokedexSpecies();
  const ownedCount=all.filter(s=>(ownedMap.get(s.slug)||[]).length>0).length;
  if($('#pokedexSeen'))$('#pokedexSeen').textContent=all.length;
  if($('#pokedexTotal'))$('#pokedexTotal').textContent=all.length;
  if($('#pokedexOwned'))$('#pokedexOwned').textContent=ownedCount;
  if($('#pokedexCount')){$('#pokedexCount').textContent=ownedCount;$('#pokedexCount').classList.toggle('is-zero',ownedCount<=0)}
  const filtered=all.filter(s=>{
    const owns=(ownedMap.get(s.slug)||[]).length>0;
    if(ownedOnly&&!owns)return false;
    if(type&&!(s.types||[]).includes(type))return false;
    if(!q)return true;
    const num=String(s.id);
    return s.name.toLowerCase().includes(q)||s.slug.includes(q)||num===q||formatDexNumber(s.id).toLowerCase().includes(q);
  });
  $('#pokedexList').innerHTML=filtered.map(s=>{
    const owns=(ownedMap.get(s.slug)||[]).length;
    const active=pokedexSelectedId===s.id?'active':'';
    const colors=(s.types||[]).map(t=>typeColors[t]||'#777');
    return`<button type="button" class="pokedex-row ${active} ${owns?'owned':'missing'}" data-dex-id="${s.id}">
      <span class="pokedex-num">${formatDexNumber(s.id)}</span>
      ${pokePortrait(s.slug,colors[0])}
      <span class="pokedex-name"><b>${s.name}</b><small class="pokedex-types">${(s.types||[]).map(tp=>`<em style="color:${typeColors[tp]||'#9c947e'}">${typeIconCircle(tp,typeColors[tp]||'#777')}${typeLabel(tp,{upper:true})}</em>`).join('<i>·</i>')}</small></span>
      <span class="pokedex-badges">${owns?`<em>×${owns}</em>`:'<i>·</i>'}</span>
    </button>`;
  }).join('')||`<div class="pokedex-empty">${t('dex.noneFound')}</div>`;
  $$('#pokedexList .poke-portrait img').forEach(centerPortrait);
  $$('#pokedexList [data-dex-id]').forEach(btn=>btn.onclick=()=>{pokedexSelectedId=+btn.dataset.dexId;renderPokedex();renderPokedexDetail()});
  if(pokedexSelectedId)renderPokedexDetail();
  else $('#pokedexDetail').innerHTML=`<div class="pokedex-detail-empty">${t('dex.emptyDetail')}</div>`;
}
function renderPokedexDetail(){
  const box=$('#pokedexDetail');if(!box||!pokedexSelectedId)return;
  const entry=pokedexEntry(pokedexSelectedId);if(!entry)return;
  const owned=(ownedBySpecies().get(entry.slug)||[]).slice().sort((a,b)=>b.level-a.level);
  const base=entry.baseStats||{};
  const evo=entry.evolutionChain||[entry.slug];
  const sellHint=pokemonSellPrice({level:1,ivTotal:50,mult:1},entry);
  const typeColor=typeColors[(entry.types||[])[0]]||'#82765b';
  const locs=speciesLocations(entry.slug);
  const catchLabel=localizedCatchDifficulty(entry);
  const lootRows=lootTableForSpecies(entry.slug,entry.types||[]).filter(row=>ITEM_BY_SLUG[row.slug]);
  const rarityTag=entry.rarity?` · ${rarityLabel(entry.rarity).toUpperCase()}`:entry.legendary?` · ${t('dex.legendary')}`:'';
  const statRows=[['hp',base.hp],['atk',base.atk],['def',base.def],['spa',base.spa],['spd',base.spd],['spe',base.spe]];
  const sellNoteHtml=t('dex.sellNote',{price:formatNumber(sellHint||0)}).replace(formatNumber(sellHint||0),`<b>${formatNumber(sellHint||0)}</b>`);
  box.innerHTML=`<div class="pokedex-detail-card">
    <header>
      ${pokePortrait(entry.slug,typeColor,'lg')}
      <div>
        <small>${formatDexNumber(entry.id)}${rarityTag}</small>
        <h3>${entry.name}</h3>
        <div class="pokedex-type-pills">${(entry.types||[]).map(tp=>`<span style="--tc:${typeColors[tp]||'#777'}">${typeIconCircle(tp,typeColors[tp]||'#777')}${typeLabel(tp,{upper:true})}</span>`).join('')}</div>
      </div>
    </header>
    <section>
      <small class="label">${t('dex.locations')}</small>
      ${locs.length?`<div class="pokedex-locs">${locs.map(loc=>{
        const bands=loc.bands.map(([a,b],index)=>{
          const range=a===b?a:`${a}–${b}`;
          if(loc.mode==='zone'){const band=ranges.findIndex(item=>item[0]===a);return routeLevelLabel(band)}
          return loc.mode==='hunt'?range:`${range} (${formatEncounterChance(loc.chances?.[index])})`;
        }).join(', ');
        const label=loc.type==='pesca'
          ?t('dex.fishing')
          :loc.mode==='zone'
            ?`${loc.legendaryBoss?'◆ ':''}${t(`zones.${loc.zoneId}.title`)}`
          :`${typeIconCircle(loc.type,typeColors[loc.type]||'#777')}${typeLabel(loc.type)}`;
        const tc=loc.type==='pesca'?'#55aee2':loc.mode==='zone'?'#c68cff':(typeColors[loc.type]||'#777');
        const prefix=loc.mode==='hunt'?`${t('dex.atlasFocus')} · `:loc.mode==='zone'?`${t('atlas.zoneTag')} · `:'';
        return`<div class="pokedex-loc" style="--tc:${tc}"><b>${label}</b><small>${prefix}${loc.mode==='zone'?bands:`${t('common.lv')} ${bands}`}</small></div>`;
      }).join('')}</div>`:`<p class="pokedex-sell-note">${t('dex.noLocations')}</p>`}
    </section>
    <section class="pokedex-capture-section">
      <small class="label">${t('dex.capture')}</small>
      <div class="pokedex-capture-summary"><div><small>${t('dex.captureDifficulty')}</small><b>${catchLabel}</b></div></div>
    </section>
    <section>
      <small class="label">${t('dex.possibleDrops')}</small>
      <p class="pokedex-section-hint">${t('dex.dropHint')}</p>
      <div class="pokedex-drop-grid">${lootRows.map(row=>{
        const item=ITEM_BY_SLUG[row.slug];
        const pct=formatNumber(row.chance/1000,{maximumFractionDigits:row.chance<1000?2:1});
        const qty=row.min===row.max?`${row.min}`:`${row.min}–${row.max}`;
        const tone=row.stone?'stone':row.chance<20000?'signature':'primary';
        const sell=sellValue(item);
        return`<article>${itemIcon(item.slug)}<div><b>${displayItem(item.slug)}</b><span><em class="${tone}"><span>${row.stone?t('dex.drop.stoneRole'):t('dex.drop.lootRole')}</span><strong>${pct}%</strong></em><em class="qty"><span>${t('dialog.qty')}</span><strong>×${qty}</strong></em><em class="sell"><span>$</span><strong>${formatNumber(sell)}</strong></em></span></div></article>`;
      }).join('')||`<p class="pokedex-sell-note">${t('dex.noDrops')}</p>`}</div>
    </section>
    <section>
      <small class="label">${t('dex.baseStats')}</small>
      <div class="pokedex-stats">${statRows.map(([k,v])=>`<div><span>${t('dex.stat.'+k)}</span><b>${v??'—'}</b><i style="width:${Math.min(100,(v||0)/2)}%"></i></div>`).join('')}</div>
    </section>
    <section>
      <small class="label">${t('dex.evoLine')}</small>
      <div class="pokedex-evo">${evo.map((slug,i)=>{
        const e=pokedexEntry(slug);const lvl=i>0?evolutionLevelRequired(evo,i-1):null;
        const eColor=typeColors[(e?.types||[])[0]]||'#82765b';
        return`<button type="button" data-jump-dex="${e?.id||''}" class="${slug===entry.slug?'current':''}">${pokePortrait(slug,eColor)}<b>${e?.name||slug}</b>${lvl?`<small>${t('common.lv')} ${lvl}</small>`:i===0?`<small>${t('dex.baseForm')}</small>`:''}</button>${i<evo.length-1?'<span class="evo-arrow">→</span>':''}`;
      }).join('')}</div>
    </section>
    <section>
      <small class="label">${t('dex.sellSection')}</small>
      <p class="pokedex-sell-note">${sellNoteHtml}</p>
      ${owned.length?`<div class="pokedex-owned-list">${owned.map(p=>{
        const price=pokemonSellPrice(p,entry);
        return`<article class="pokedex-owned-row">
          <div><b>${p.shiny?'✦ SHINY · ':''}${title(p.name)}</b><small>${t('common.lv')} ${p.level} · ${rarityLabel(p.rarity||'Comum')} · IV ${formatPokemonIv(p)}</small></div>
          <button type="button" class="pokedex-sell-btn" data-sell-pokemon="${p.id}" data-sell-price="${price}">${t('common.sell')} · ${formatNumber(price)}</button>
        </article>`;
      }).join('')}</div>`:`<div class="pokedex-empty">${t('dex.notOwned')}</div>`}
    </section>
  </div>`;
  $$('#pokedexDetail .poke-portrait img').forEach(centerPortrait);
  $$('#pokedexDetail [data-jump-dex]').forEach(b=>b.onclick=()=>{const id=+b.dataset.jumpDex;if(!id)return;pokedexSelectedId=id;renderPokedex();renderPokedexDetail()});
  $$('#pokedexDetail [data-sell-pokemon]').forEach(b=>b.onclick=()=>sellOwnedPokemon(b.dataset.sellPokemon,+b.dataset.sellPrice));
}
async function sellOwnedPokemon(id,price){
  const idx=state.collection.findIndex(p=>String(p.id)===String(id));
  if(idx<0)return;
  const pokemon=state.collection[idx];
  if(pokemon.locked){showToast(t('toast.noEligiblePokemon'));return}
  if(isOnTeam(pokemon)){showToast(t('toast.removeFromTeam'));return}
  const sellMessage=[t('common.sell'),title(pokemon.name),`${t('common.lv')}${pokemon.level}`,'-',formatNumber(price),t('common.coins')].join(' ')+'?';
  if(!await showGameConfirm(sellMessage))return;
  if(walletSyncEnabled()&&collectionSyncEnabled()){
    const serverId=pokemon.serverId||pokemon.id;
    if(!isPokemonUuid(serverId)){showToast(t('toast.noEligiblePokemon'));return}
    try{
      const response=await sellPlayerPokemon([serverId],crypto.randomUUID());
      if(response?.wallet)acceptMarketWallet(response.wallet);
      if(Array.isArray(response?.pokemon))await refreshPlayerPokemon();
      else{
        state.collection.splice(idx,1);
        state.team=state.team.filter(teamId=>String(teamId)!==String(pokemon.id));
      }
      const gained=Number(response?.gained)||price;
      renderStats();renderCollection();renderCaptureLog();renderPokedex();renderPokedexDetail();if(!$('#shopDialogCard')?.classList.contains('hidden'))refreshShopPanes();save();
      addLog(t('log.soldFor',{total:formatNumber(gained)}),title(pokemon.name));
      showToast(`${title(pokemon.name)} · +${formatNumber(gained)} ${t('common.coins')}`);
    }catch(error){
      console.warn('sell_player_pokemon failed',error);
      try{await refreshPlayerPokemon()}catch{}
      showToast(sellPokemonErrorToast(error));
    }
    return;
  }
  state.collection.splice(idx,1);
  state.team=state.team.filter(teamId=>String(teamId)!==String(pokemon.id));
  applyIdlecoinDelta(price,'pokemon_sale');
  renderStats();renderCollection();renderCaptureLog();renderPokedex();renderPokedexDetail();if(!$('#shopDialogCard')?.classList.contains('hidden'))refreshShopPanes();save();
  addLog(t('log.soldFor',{total:formatNumber(price)}),title(pokemon.name));
  showToast(`${title(pokemon.name)} · +${formatNumber(price)} ${t('common.coins')}`);
}
function openCityDialog(mode){
  const tmShop=mode==='tm-shop',shop=mode==='shop'||tmShop,fish=mode==='fish';
  $('#centerDialogCard')?.classList.toggle('hidden',shop||fish);
  $('#shopDialogCard')?.classList.toggle('hidden',!shop);
  $('#fishingDialogCard')?.classList.toggle('hidden',!fish);
  if(shop){
    shopVendor=tmShop?'tm':'general';
    $('#shopMarkTitle').textContent=t(tmShop?'dialog.tmShopTitle':'dialog.shopTitle');
    $('#shopTabs')?.classList.toggle('tm-only',tmShop);
    const intro=$('#shopVendorIntro'),introText=$('#shopVendorIntroText');
    if(intro){intro.classList.toggle('hidden',!tmShop);if(introText)introText.textContent=tmShop?t('dialog.tmShopIntro'):''}
    shopSellSelected.clear();shopPokeSelected.clear();resetShopRarityFilter();
    syncShopBuyQty(1);renderShopRarityFilters();switchShopTab('buy');refreshShopPanes();
  }else if(fish){
    renderFishingDialog();
  }else{
    $('#dialogEyebrow').textContent=t('dialog.pcEyebrow');
    $('#dialogTitle').textContent='Nurse Joy';
    $('#dialogText').textContent=t('dialog.pcText');
  }
  $('#cityDialog').classList.remove('hidden');
}
function renderTmTestResult(slug){
  const result=$('#tmTestLabResult'),item=ITEM_BY_SLUG[slug],move=getMove(item?.move||slug?.replace(/^tm-/,''));
  if(!result||!move)return;
  const pokemon=state.starter||{};
  const type=primaryTypeFor(pokemon.name||'squirtle'),level=Math.max(100,Number(pokemon.level)||100);
  const attacker={level,types:pokemon.types||[type],stats:statsFor(pokemon.name||'squirtle',type,level,pokemon.ivs||{},pokemon.mult||1)};
  const enemies=Array.from({length:3},(_,index)=>({id:`dummy-${index+1}`,level,types:['normal'],stats:{hp:2200,atk:120,def:120,spa:120,spd:120,spe:120},currentHp:2200,maxHp:2200}));
  const hits=resolveAoE(attacker,enemies,move),total=hits.reduce((sum,hit)=>sum+hit.damage,0);
  result.innerHTML=`<b>${move.name}</b><div class="move-chip-row"><span class="move-chip">${typeLabel(move.type)}</span><span class="move-chip">Power ${move.power}</span><span class="move-chip">${moveCooldownTurns(move)} turns</span><span class="move-chip">${t('dialog.tmDropOnlyShort')}</span></div><p>Preview: ${hits.map((hit,index)=>`Target ${index+1}: <strong>${hit.damage}</strong> dmg`).join(' · ')} · <strong>${total}</strong> total</p><small>Resultado determinístico para comparação de impacto. Nenhum item foi consumido.</small>`;
  $$('#tmTestLabList button').forEach(button=>button.classList.toggle('active',button.dataset.tmTest===slug));
}
function openTmTestLab(){
  const modal=$('#tmTestLab'),list=$('#tmTestLabList');if(!modal||!list)return;
  list.innerHTML=TM_ITEMS.map(item=>`<button type="button" data-tm-test="${item.slug}">${displayItem(item.slug)||item.slug}<small>${t('dialog.tmDropOnlyShort')} · Nv. ${item.minLevel}</small></button>`).join('');
  list.querySelectorAll('[data-tm-test]').forEach(button=>button.onclick=()=>renderTmTestResult(button.dataset.tmTest));
  modal.classList.remove('hidden');
  renderTmTestResult(TM_ITEMS[0]?.slug);
}
function closeTmTestLab(){$('#tmTestLab')?.classList.add('hidden')}
function closeCityDialog(){
  stopFishing();
  $('#cityDialog').classList.add('hidden');
  $('#shopDialogCard')?.classList.add('hidden');
  $('#fishingDialogCard')?.classList.add('hidden');
  $('#centerDialogCard')?.classList.remove('hidden');
}
let fishingTimer=null,fishingNextAt=0,fishingCastRaf=0,fishingCastStartedAt=0;
function stopFishingCastBar(){
  if(fishingCastRaf){cancelAnimationFrame(fishingCastRaf);fishingCastRaf=0}
  const bar=$('#fishingCastProgress');if(bar){bar.hidden=true;const fill=bar.querySelector('i');if(fill)fill.style.width='0%'}
}
function tickFishingCastBar(){
  const bar=$('#fishingCastProgress');
  if(!bar||!state.fishing.active||!fishingNextAt){stopFishingCastBar();return}
  bar.hidden=false;
  const total=Math.max(1,fishingNextAt-fishingCastStartedAt);
  const left=Math.max(0,fishingNextAt-performance.now());
  const pct=Math.min(100,Math.max(0,(1-left/total)*100));
  const fill=bar.querySelector('i');if(fill)fill.style.width=`${pct}%`;
  fishingCastRaf=requestAnimationFrame(tickFishingCastBar);
}
function equippedFishingRod(){
  const preferred=fishingRodFor(state.fishing?.rod);
  if(preferred&&(state.inventory[preferred.slug]||0)>0)return preferred;
  return bestOwnedFishingRod(state.inventory);
}
function fishingBandForRod(rod){
  const band=clampBand(state.range);
  if(!rod)return band;
  return Math.max(rod.minBand,Math.min(rod.maxBand,band));
}
function renderFishingDialog(){
  const rod=equippedFishingRod();
  const selectedBand=clampBand(state.range),band=fishingBandForRod(rod);
  const selectedLevel=ranges[selectedBand]?.[0]||1;
  const [min,max]=ranges[band]||[1,1];
  const status=$('#fishingStatus'),hint=$('#fishingBandHint'),toggle=$('#fishingToggle'),row=$('#fishingRodRow');
  const spotRow=$('#fishingSpotRow'),baitRow=$('#fishingBaitRow'),xpLabel=$('#fishingXpLabel');
  const spot=FISHING_SPOTS.find(s=>s.id===state.fishing?.spot)||FISHING_SPOTS[0];
  const fishLevel=Math.max(1,Number(state.fishing?.level)||1);
  if(hint)hint.textContent=t('fish.bandHint',{min,max,selected:selectedLevel,rod:rod?displayItem(rod.slug):'—'});
  if(xpLabel)xpLabel.textContent=t('fish.xpLabel',{level:fishLevel,xp:state.fishing?.xp||0});
  if(spotRow){
    spotRow.innerHTML=FISHING_SPOTS.map(s=>{
      const locked=fishLevel<s.minFishLevel;
      return`<button type="button" class="ui-tile fishing-pick ${spot.id===s.id?'selected':''} ${locked?'locked':''}" data-fish-spot="${s.id}" ${locked?'disabled':''}><span class="ui-iconbox" aria-hidden="true">〰</span><span class="ui-copy"><b>${t(s.labelKey)}</b><small>${locked?t('fish.spotLocked',{level:s.minFishLevel}):t('fish.spotReady')}</small></span></button>`;
    }).join('');
    $$('#fishingSpotRow [data-fish-spot]').forEach(btn=>{
      btn.onclick=()=>{if(btn.disabled)return;state.fishing.spot=btn.dataset.fishSpot;save();renderFishingDialog()};
    });
  }
  if(baitRow){
    baitRow.innerHTML=`<button type="button" class="ui-tile fishing-pick ${!state.fishing?.bait?'selected':''}" data-fish-bait=""><span class="ui-iconbox" aria-hidden="true">○</span><span class="ui-copy"><b>${t('fish.noBait')}</b><small>${t('fish.baitNoneHint')}</small></span></button>`+FISHING_BAITS.map(b=>{
      const owned=(state.inventory[b.id]||0)+(state.drops[b.id]||0);
      return`<button type="button" class="ui-tile fishing-pick ${state.fishing?.bait===b.id?'selected':''}" data-fish-bait="${b.id}" ${owned<=0?'disabled':''}><span class="ui-iconbox" aria-hidden="true">◈</span><span class="ui-copy"><b>${t(b.labelKey)}</b><small>×${owned}</small></span></button>`;
    }).join('');
    $$('#fishingBaitRow [data-fish-bait]').forEach(btn=>{
      btn.onclick=()=>{if(btn.disabled)return;state.fishing.bait=btn.dataset.fishBait||null;save();renderFishingDialog()};
    });
  }
  if(row){
    row.innerHTML=FISHING_ROD_ITEMS.map(item=>{
      const qty=state.inventory[item.slug]||0;
      const meta=fishingRodFor(item.slug);
      const selected=rod?.slug===item.slug;
      const maxLevel=ranges[meta?.maxBand]?.[1]||1;
      return`<button type="button" class="ui-tile fishing-pick ${selected?'selected':''}" data-fish-rod="${item.slug}" ${qty<=0?'disabled':''}>${itemIcon(item.slug)}<span class="ui-copy"><b>${displayItem(item.slug)}</b><small>${t('fish.rodRange',{max:maxLevel})} · ×${qty}</small></span></button>`;
    }).join('');
    $$('#fishingRodRow [data-fish-rod]').forEach(btn=>{
      btn.onclick=()=>{
        if(btn.disabled)return;
        state.fishing.rod=btn.dataset.fishRod;save();renderFishingDialog();
      };
    });
  }
  if(status&&!state.fishing.active)status.textContent=t('fish.idle');
  if(toggle){
    toggle.textContent=state.fishing.active?t('fish.stop'):t('fish.start');
    toggle.disabled=!rod;
  }
  if(state.fishing.active&&fishingNextAt)tickFishingCastBar();
  else stopFishingCastBar();
}
function stopFishing(){
  state.fishing.active=false;
  clearTimeout(fishingTimer);fishingTimer=null;fishingNextAt=0;fishingCastStartedAt=0;
  stopFishingCastBar();
  renderFishingDialog();
}
function scheduleFishingCast(){
  clearTimeout(fishingTimer);
  const rod=equippedFishingRod();
  if(!state.fishing.active||!rod){stopFishing();return;}
  const castMs=fishingCastMs(rod,state.fishing?.bait,state.fishing?.level||1);
  fishingCastStartedAt=performance.now();
  fishingNextAt=fishingCastStartedAt+castMs;
  fishingTimer=setTimeout(resolveFishingBite,castMs);
  const status=$('#fishingStatus');if(status)status.textContent=t('fish.casting');
  tickFishingCastBar();
}
function startFishing(){
  if(state.running){showToast(t('fish.busyHunt'));return;}
  const rod=equippedFishingRod();
  if(!rod){showToast(t('fish.needRod'));return;}
  state.fishing.active=true;state.fishing.rod=rod.slug;save();
  showToast(t('fish.started'));
  scheduleFishingCast();
  renderFishingDialog();
}
function toggleFishing(){
  if(state.fishing.active){stopFishing();showToast(t('fish.stopped'));return;}
  startFishing();
}
function grantFishingXp(amount){
  state.fishing.xp=Math.max(0,(state.fishing.xp||0)+amount);
  let level=Math.max(1,Number(state.fishing.level)||1);
  while(state.fishing.xp>=level*40){state.fishing.xp-=level*40;level+=1}
  state.fishing.level=level;
}
async function consumeFishingBait(){
  const baitId=state.fishing?.bait;if(!baitId)return true;
  if(inventorySyncEnabled()){
    const ok=await consumeGameplayItem(baitId,1);
    return ok;
  }
  if((state.inventory[baitId]||0)>0){state.inventory[baitId]--;return true}
  if((state.drops[baitId]||0)>0){state.drops[baitId]--;if(state.drops[baitId]<=0)delete state.drops[baitId];return true}
  return false;
}
async function resolveFishingBite(){
  if(!state.fishing.active)return;
  if(activeAccount&&!serverGameplayReady()){
    showToast('O servidor ainda está sincronizando sua conta.');
    stopFishing();
    return;
  }
  const rod=equippedFishingRod();
  if(!rod){stopFishing();showToast(t('fish.needRod'));return;}
  const spot=FISHING_SPOTS.find(s=>s.id===state.fishing?.spot)||FISHING_SPOTS[0];
  const fishLevel=Math.max(1,Number(state.fishing?.level)||1);
  if(fishLevel<spot.minFishLevel){state.fishing.spot='pier';}
  const band=fishingBandForRod(rod);
  const [min,max]=ranges[band]||[1,1];
  const slug=rollFish(band)||'magikarp';
  const level=Math.floor(Math.random()*(max-min+1))+min;
  const types=speciesTypes(slug,'água');
  let mats=[];
  const serverFishing=serverGameplayReady();

  if(serverFishing){
    try{
      const selectedBait=state.fishing?.bait||'';
      const serverBait=inventorySyncEnabled()
        &&(selectedBait==='common-bait'||selectedBait==='elite-bait')
        &&(state.inventory[selectedBait]|0)>0
        ?selectedBait:null;
      const response=await resolveFishingCastRpc({
        spot:spot.id,
        fishLevel,
        rod:rod.slug,
        bait:serverBait,
      },crypto.randomUUID());
      mats=Object.entries(response?.credited||{}).map(([itemSlug,qty])=>({slug:itemSlug,qty:Number(qty)||0})).filter(row=>row.qty>0);
      if(response?.inventory){
        applyServerInventory(response.inventory,{force:true});
        for(const row of mats)addNavNotification('inventory',row.qty,row.slug);
      }
    }catch(error){
      console.warn('resolve_fishing_cast failed',error);
      const status=$('#fishingStatus');
      if(status)status.textContent=t('fish.noBaitStock')||t('fish.nibble');
      stopFishing();
      return;
    }
  }else{
    if(!(await consumeFishingBait())){
      const status=$('#fishingStatus');
      if(status)status.textContent=t('fish.noBaitStock')||t('fish.nibble');
      stopFishing();
      return;
    }
    const rareBonus=(spot.rareBonus||0)+(FISHING_BAITS.find(b=>b.id===state.fishing?.bait)?.rareBonus||0);
    mats=rollFishingMaterials(spot.id,fishLevel,Math.random,rareBonus);
    for(const m of mats){state.drops[m.slug]=(state.drops[m.slug]||0)+m.qty;addNavNotification('inventory',m.qty,m.slug)}
  }

  grantFishingXp(8+Math.floor(level/5)+(spot.id==='deep-sea'?6:0));

  let captureTarget={name:slug,level,types,hp:35};
  if(serverGameplayReady()){
    try{
      // route_type 'fishing' — não expira a fila de hunt (outro route_type).
      const batch=await requestEncountersRpc({
        route:level,
        count:1,
        routeType:'fishing',
        species:slug,
      },crypto.randomUUID());
      const enc=batch?.encounters?.[0];
      if(enc?.id){
        captureTarget={
          name:enc.species||slug,
          level:enc.encounter_level||level,
          types:speciesTypes(enc.species||slug,'água'),
          hp:35,
          shiny:!!enc.shiny,
          encounterId:enc.id,
          speciesRarity:enc.species_rarity||enc.pokedex_rarity,
        };
      }
    }catch(error){
      console.warn('fishing encounter failed',error);
    }
  }

  const result=await attemptCapture(captureTarget,{quiet:false});
  const status=$('#fishingStatus');
  const matLabel=mats.length?` · ${mats.map(m=>`${t(`fish.mat.${m.slug}`)}×${m.qty}`).join(', ')}`:'';
  if(result?.ok){
    try{logFishCaught(state,slug);trackQuestProgress('fish',1);checkAchievements(state)}catch{}
    if(status)status.textContent=t('fish.caught',{name:title(captureTarget.name||slug),level:captureTarget.level||level})+matLabel;
  }else if(result?.reason==='escaped'){
    if(status)status.textContent=t('fish.escaped',{name:title(captureTarget.name||slug)});
  }else if(result?.reason==='no-ball'||result?.reason==='sync-failed'){
    if(status)status.textContent=t('fish.noBall');
  }else if(status)status.textContent=t('fish.nibble');
  if(result?.reason==='no-ball'||result?.reason==='sync-failed'){stopFishing();return;}
  save();renderDropBag();scheduleFishingCast();
}
function switchShopTab(tab){
  $$('#shopTabs .shop-tab').forEach(b=>b.classList.toggle('active',b.dataset.tab===tab));
  $('#shopBuyPane')?.classList.toggle('hidden',tab!=='buy');
  $('#shopSellPane')?.classList.toggle('hidden',tab!=='sell');
  $('#shopPokemonPane')?.classList.toggle('hidden',tab!=='pokemon');
  if(tab==='sell')renderShopSell();
  if(tab==='pokemon')renderShopPokemon();
  if(tab==='buy')renderShopBuy();
}
async function buyShopItem(slug){
  const it=ITEM_BY_SLUG[slug];if(!it)return;
  if(it.dropOnly){showToast(t('dialog.dropOnlyItem'));return;}
  const catalog=shopVendor==='tm'?PURCHASABLE_TM_ITEMS:SHOP_ITEMS;
  if(!catalog.some(item=>item.slug===slug))return;
  const qty=shopBuyQty,total=it.price*qty;
  if(state.stats.coins<total){showToast(t('dialog.noCoins'));return}
  if(walletSyncEnabled()){
    try{
      const response=await purchaseShopItem(slug,qty,crypto.randomUUID());
      if(response?.wallet)acceptMarketWallet(response.wallet);
      if(response?.inventory)applyServerInventory(response.inventory,{force:true});
      else{state.inventory[slug]=(state.inventory[slug]||0)+qty}
      addNavNotification('inventory',qty,slug);
      renderStats();renderInventory();renderPotionSelect();refreshShopPanes();save();
      showToast(t('dialog.bought',{qty,name:displayItem(slug)}));
    }catch(error){
      console.warn('purchase_shop_item failed',error);
      showToast(t('dialog.noCoins'));
    }
    return;
  }
  applyIdlecoinDelta(-total,'shop_purchase');state.inventory[slug]=(state.inventory[slug]||0)+qty;addNavNotification('inventory',qty,slug);
  renderStats();renderInventory();renderPotionSelect();refreshShopPanes();save();
  showToast(t('dialog.bought',{qty,name:displayItem(slug)}));
}
async function sellSelectedDrops(){
  if(!shopSellSelected.size){showToast(t('dialog.pickItem'));return}
  if(walletSyncEnabled()&&inventorySyncEnabled()){
    // Flush kills pendentes + reconcilia mochila: o UI pode estar à frente do
    // player_inventory (loot otimista). Sem isso a RPC abortava o lote inteiro.
    try{
      await flushSessionSync().catch(()=>{});
      await refreshInventory();
      renderShopSell();
    }catch(error){
      console.warn('sell inventory refresh failed',error);
    }
    const items=[];
    for(const[slug,wanted]of[...shopSellSelected]){
      const d=ITEM_BY_SLUG[slug],stock=state.drops[slug]|0;if(!d||stock<=0)continue;
      const qty=Math.max(1,Math.min(stock,Math.round(+wanted||stock)));
      items.push({slug,qty});
    }
    if(!items.length){showToast(t('toast.nothingToSell'));return}
    try{
      const response=await sellInventoryItems(items,crypto.randomUUID());
      if(response?.wallet)acceptMarketWallet(response.wallet);
      if(response?.inventory)applyServerInventory(response.inventory,{force:true});
      shopSellSelected.clear();
      const gained=Number(response?.gained)||0;
      const sold=Number(response?.sold)||0;
      renderStats();renderDropBag();renderPlayerInventory();refreshShopPanes();save();
      try{trackQuestProgress('sell',sold)}catch{}
      showToast(t('dialog.soldDrops',{total:formatNumber(gained)}));
      addLog(t('log.soldCoins',{total:formatNumber(gained)}),t('dialog.shop'));
    }catch(error){
      console.warn('sell_inventory_items failed',error);
      const code=String(error?.message||error||'');
      try{await refreshInventory();renderShopSell()}catch{}
      showToast(
        code.includes('insufficient_item')||code.includes('nothing_to_sell')
          ? t('toast.sellStockMismatch')
          : t('toast.nothingToSell')
      );
    }
    return;
  }
  let gained=0,sold=0;
  for(const [slug,wanted] of [...shopSellSelected]){
    const d=ITEM_BY_SLUG[slug],stock=state.drops[slug]|0;if(!d||stock<=0)continue;
    const qty=Math.max(1,Math.min(stock,Math.round(+wanted||stock)));
    const total=sellValue(d)*qty;state.drops[slug]=stock-qty;if(state.drops[slug]<=0)delete state.drops[slug];
    gained+=total;sold+=qty;
  }
  shopSellSelected.clear();
  if(!sold){showToast(t('toast.nothingToSell'));return}
  applyIdlecoinDelta(gained,'item_sale');renderStats();renderDropBag();renderPlayerInventory();refreshShopPanes();save();
  try{trackQuestProgress('sell',sold)}catch{}
  showToast(t('dialog.soldDrops',{total:formatNumber(gained)}));
  addLog(t('log.soldCoins',{total:formatNumber(gained)}),t('dialog.shop'));
}
function isPokemonUuid(value){
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(String(value||''));
}
const SELL_POKEMON_BATCH=50;
function chunkIds(ids,size=SELL_POKEMON_BATCH){
  const out=[];
  for(let i=0;i<ids.length;i+=size)out.push(ids.slice(i,i+size));
  return out;
}
function sellPokemonErrorToast(error){
  const code=String(error?.message||error||'');
  if(code.includes('nothing_to_sell'))return t('toast.unlockToSell')||t('toast.noEligiblePokemon');
  if(code.includes('too_many_pokemon')||code.includes('invalid_pokemon_ids'))return t('toast.sellPokemonBatch');
  return t('toast.noEligiblePokemon');
}
async function sellSelectedPokemon(){
  const ids=[...shopPokeSelected];
  if(!ids.length){showToast(t('dialog.pickPokemon'));return}
  if(walletSyncEnabled()&&collectionSyncEnabled()){
    try{await refreshPlayerPokemon()}catch(error){console.warn('sell pokemon refresh failed',error)}
    const serverIds=[];
    for(const id of ids){
      const pokemon=state.collection.find(p=>String(p.id)===String(id)||String(p.serverId||'')===String(id));
      if(!pokemon||pokemon.locked||isOnTeam(pokemon)||pokemon.isActive||pokemon.origin==='starter')continue;
      const serverId=pokemon.serverId||pokemon.id;
      if(isPokemonUuid(serverId))serverIds.push(serverId);
    }
    if(!serverIds.length){showToast(t('toast.noEligiblePokemon'));renderShopPokemon();return}
    try{
      let gained=0,count=0,lastPokemon=null;
      for(const batch of chunkIds(serverIds)){
        const response=await sellPlayerPokemon(batch,crypto.randomUUID());
        if(response?.wallet)acceptMarketWallet(response.wallet);
        if(Array.isArray(response?.pokemon))lastPokemon=response.pokemon;
        gained+=Number(response?.gained)||0;
        count+=Number(response?.count)||batch.length;
      }
      if(Array.isArray(lastPokemon))await refreshPlayerPokemon();
      else await refreshPlayerPokemon().catch(()=>{});
      shopPokeSelected.clear();
      renderStats();renderCollection();renderCaptureLog();renderPokedex();renderPokedexDetail();refreshShopPanes();save();
      showToast(t('dialog.soldPokemon',{count,total:formatNumber(gained)}));
      addLog(t('log.soldMany',{count,total:formatNumber(gained)}),t('dialog.shop'));
    }catch(error){
      console.warn('sell_player_pokemon failed',error);
      try{await refreshPlayerPokemon();renderShopPokemon()}catch{}
      showToast(sellPokemonErrorToast(error));
    }
    return;
  }
  let gained=0,count=0;
  for(const id of ids){
    const idx=state.collection.findIndex(p=>String(p.id)===String(id));if(idx<0)continue;
    const pokemon=state.collection[idx];
    if(pokemon.locked||isOnTeam(pokemon))continue;
    const price=pokemonSellPrice(pokemon,pokedexEntry(pokemon.name));
    state.collection.splice(idx,1);gained+=price;count++;
  }
  shopPokeSelected.clear();
  if(!count){showToast(t('toast.noEligiblePokemon'));return}
  applyIdlecoinDelta(gained,'pokemon_sale');renderStats();renderCollection();renderCaptureLog();renderPokedex();renderPokedexDetail();refreshShopPanes();save();
  showToast(t('dialog.soldPokemon',{count,total:formatNumber(gained)}));
  addLog(t('log.soldMany',{count,total:formatNumber(gained)}),t('dialog.shop'));
}
async function sellItem(button){
  const slug=button.dataset.drop,price=+button.dataset.sell;if(!slug)return;
  if(walletSyncEnabled()&&inventorySyncEnabled()){
    try{
      await flushSessionSync().catch(()=>{});
      await refreshInventory();
    }catch(error){
      console.warn('sell inventory refresh failed',error);
    }
    const qty=state.drops[slug]|0;if(qty<=0){showToast(t('toast.nothingToSell'));renderShopSell();return}
    try{
      const response=await sellInventoryItems([{slug,qty}],crypto.randomUUID());
      if(response?.wallet)acceptMarketWallet(response.wallet);
      if(response?.inventory)applyServerInventory(response.inventory,{force:true});
      const total=Number(response?.gained)||price*qty;
      renderStats();renderShopSell();renderDropBag();renderPlayerInventory();save();
      showToast(t('dialog.soldDrops',{total:formatNumber(total)}));addLog(t('log.soldCoins',{total:formatNumber(total)}));
    }catch(error){
      console.warn('sell_inventory_items failed',error);
      try{await refreshInventory();renderShopSell()}catch{}
      showToast(t('toast.sellStockMismatch'));
    }
    return;
  }
  const qty=state.drops[slug]||0;if(qty<=0)return;
  const total=price*qty;state.drops[slug]=0;applyIdlecoinDelta(total,'item_sale');renderStats();renderShopSell();renderDropBag();renderPlayerInventory();save();showToast(t('dialog.soldDrops',{total:formatNumber(total)}));addLog(t('log.soldCoins',{total:formatNumber(total)}))
}
function healTeam(){const partner=ensureStarterCombat();if(partner)state.starter.currentHp=partner.maxHp;state.teamHp=100;state.collection.forEach(p=>p.hp=100);renderPartnerHud();save();closeCityDialog();addLog(t('dialog.healedLog'),'Nurse Joy');showToast(t('dialog.healedToast'))}
function buyItem(button){buyShopItem(button.dataset.item)}
function legacyCollectionFilters(){return{q:($('#colSearch')?.value||'').trim().toLowerCase(),type:$('#colType')?.value||'',rarity:$('#colRarity')?.value||'',ivMode:$('#colIvMode')?.value||'min',ivValue:$('#colIvValue')?.value??''}}
function legacyFilterCollection(f){
  return state.collection.filter(p=>{
    const ptypes=p.types||speciesTypes(p.name,primaryTypeFor(p.name));
    if(f.q&&!p.name.toLowerCase().includes(f.q))return false;
    if(f.type&&!ptypes.includes(f.type))return false;
    if(f.rarity&&p.rarity!==f.rarity)return false;
    if(f.ivValue!==''){const v=Math.max(0,Math.min(IV_TOTAL_MAX,+f.ivValue));const score=ivScoreFor(p);if(f.ivMode==='min'?score<v:score>v)return false}
    return true;
  })
}
function toggleTeamPokemon(id){
  const pokemon=state.collection.find(p=>String(p.id)===String(id));if(!pokemon)return;
  if(isOnTeam(pokemon)){
    state.team=state.team.filter(teamId=>String(teamId)!==String(pokemon.id));
    showToast(t('col.removedToast',{name:title(pokemon.name)}));
  }else{
    if(state.team.length>=5){showToast(t('toast.teamFull'));return}
    state.team.push(pokemon.id);showToast(t('col.equippedToast',{name:title(pokemon.name)}));
  }
  renderCollection();renderPartnerHud();if(!$('#teamManagementOverlay').classList.contains('hidden'))selectTeamMember('starter',true);save();
  if(collectionSyncEnabled()){
    void syncTeamRosterToServer().catch(()=>showToast(t('toast.teamSyncFailed')));
  }
}
function legacyRenderCollection(){
  $('#collectionCount').textContent=state.collection.length;
  const filtered=filterCollection(collectionFilters());
  $('#colResults').textContent=state.collection.length?t('col.resultsOf',{filtered:filtered.length,total:state.collection.length}):'';
  $('#collectionList').innerHTML=!state.collection.length?`<div class="collection-empty">${t('col.empty')}</div>`:!filtered.length?`<div class="collection-empty">${t('col.noMatch')}</div>`:filtered.map((p,i)=>{
    const type=primaryTypeFor(p.name),types=p.types||speciesTypes(p.name,type),computed=p.stats||statsFor(p.name,type,p.level,p.ivs,p.mult||1),equipped=isOnTeam(p),r=rarityInfo(p),ivLabel=formatPokemonIv(p);
    return`<div class="collection-row ${shinyClassFor(p,'portrait')} ${rarityTierClass(r)}" data-index="${i}" style="--rarity:${r.color}">
      <button class="collection-row-main">
        ${pokePortrait(p.name,typeColors[types[0]]||'#82765b','',p)}
        <div class="collection-row-copy">
          <div class="collection-row-title"><b>${p.shiny?'✦ SHINY · ':''}${title(p.name)}</b><em class="collection-rarity-pill" style="--badge:${r.color}">${r.label}<span>· ×${formatNumber(r.mult,{minimumFractionDigits:2,maximumFractionDigits:2})}</span></em><em class="collection-iv-pill" style="--iv-color:${r.color}">IV ${ivLabel}</em></div>
          <small>${t('common.lv')} ${p.level} · ${types.map(tp=>`${typeIconCircle(tp,typeColors[tp]||'#777')}${typeLabel(tp)}`).join(' / ')}</small>
        </div>
      </button>
      <div class="collection-detail">
        <div class="detail-label">${t('col.detailStatus',{level:p.level})}</div>
        <div class="detail-grid"><span>${t('dex.stat.hp')} <b>${computed.hp}</b></span><span>${t('dex.stat.atk')} <b>${computed.atk}</b></span><span>${t('dex.stat.def')} <b>${computed.def}</b></span><span>${t('dex.stat.spa')} <b>${computed.spa}</b></span><span>${t('dex.stat.spd')} <b>${computed.spd}</b></span><span>${t('dex.stat.spe')} <b>${computed.spe}</b></span></div>
        <div class="detail-label">${t('col.ivsTotal',{value:ivLabel})}</div>
        <div class="detail-grid">${Object.entries(p.ivs||{}).map(([k,v])=>`<span>${k} <b>${v}</b></span>`).join('')}</div>
        <div class="detail-foot" style="color:${r.color}">${r.label}</div>
        ${evolutionRequirement(p)?`<button class="collection-evolve" data-evolve-kind="collection" data-evolve-id="${p.id}">${t('team.evolveTo',{name:title(evolutionRequirement(p).next)})}</button>`:''}
        <button class="collection-equip ${equipped?'equipped':''}" data-pokemon-id="${p.id}">${equipped?t('col.unequip'):t('col.equip')}</button>
      </div>
    </div>`}).join('');
  $$('#collectionList .collection-row-main').forEach(button=>button.onclick=()=>{
    const row=button.parentElement,willOpen=!row.classList.contains('open');
    $$('#collectionList .collection-row.open').forEach(openRow=>openRow.classList.remove('open'));
    if(willOpen)row.classList.add('open');
  });
  $$('#collectionList .poke-portrait img').forEach(centerPortrait);
  $$('.collection-equip').forEach(b=>b.onclick=e=>{e.stopPropagation();toggleTeamPokemon(b.dataset.pokemonId)})
}
const depositRarityFilter=new Set();
let depositShinyOnly=false;
let depositActiveTab='pokemon';
const BALL_SLUGS=new Set(BALLS.map(item=>item.slug)),POTION_SLUGS=new Set(POTIONS.map(item=>item.slug)),STONE_SLUGS=new Set(STONES.map(item=>item.slug));
function itemCategoryFor(slug){return BALL_SLUGS.has(slug)?'BALL':POTION_SLUGS.has(slug)?'POTION':STONE_SLUGS.has(slug)?'STONE':'LOOT'}
function collectionFilters(){
  const numberValue=id=>{const value=$(`#${id}`)?.value??'';return value===''?null:+value};
  return{q:($('#colSearch')?.value||'').trim().toLowerCase(),type:$('#colType')?.value||'',rarities:new Set(depositRarityFilter),shinyOnly:depositShinyOnly,ivMin:numberValue('colIvMin'),ivMax:numberValue('colIvMax'),levelMin:numberValue('colLevelMin'),levelMax:numberValue('colLevelMax')}
}
function filterCollection(f){
  return state.collection.filter(p=>{
    const ptypes=p.types||speciesTypes(p.name,primaryTypeFor(p.name)),score=ivScoreFor(p),level=+p.level||1;
    if(f.q&&!title(p.name).toLowerCase().includes(f.q))return false;
    if(f.type&&!ptypes.includes(f.type))return false;
    if(!matchesShinyFilter(p,f.shinyOnly))return false;
    if(f.rarities.size&&!f.rarities.has(p.rarity||'Comum'))return false;
    if(f.ivMin!=null&&score<Math.max(0,Math.min(IV_TOTAL_MAX,f.ivMin)))return false;
    if(f.ivMax!=null&&score>Math.max(0,Math.min(IV_TOTAL_MAX,f.ivMax)))return false;
    if(f.levelMin!=null&&level<Math.max(1,f.levelMin))return false;
    if(f.levelMax!=null&&level>Math.max(1,Math.floor(Number(f.levelMax)||1)))return false;
    return true;
  })
}
function renderDepositRarityFilters(){
  const box=$('#colRarityFilters');if(!box)return;
  const shinyButton=$('#colShinyFilter');
  if(shinyButton){shinyButton.classList.toggle('active',depositShinyOnly);shinyButton.setAttribute('aria-pressed',String(depositShinyOnly))}
  box.innerHTML=rarity.map(r=>`<button type="button" class="${depositRarityFilter.has(r.name)?'active':''}" data-deposit-rarity="${r.name}" style="--badge:${r.color}">${rarityLabel(r.name)}</button>`).join('')
}
function depositPokemonRow(p,{team=false,starter=false}={}){
  const type=primaryTypeFor(p.name),ptypes=normalizePokemonTypes(p.types,p.name),r=rarityInfo(p),ivLabel=formatPokemonIv(p);
  return`<div class="${team?`deposit-team-row ${shinyClassFor(p,'portrait')}`:`collection-row ${shinyClassFor(p,'portrait')} ${rarityTierClass(r)}`}" style="--rarity:${r.color}">
    ${team?`${pokePortrait(p.name,typeColor(ptypes[0]),'',p)}<div class="deposit-row-copy"><b>${p.shiny?'✦ SHINY · ':''}${title(p.name)}</b><small>${t('common.lv')} ${p.level} · IV ${ivLabel} · ${r.label}</small></div><button type="button" class="deposit-move-button" ${starter?'disabled title="'+t('deposit.mainPartner')+'"':`data-team-to-box="${p.id}" title="${t('deposit.moveToBox')}"`}>→</button>`:`<div class="collection-row-main"><button type="button" class="collection-row-open">${pokePortrait(p.name,typeColor(ptypes[0]),'',p)}<div class="collection-row-copy"><div class="collection-row-title"><b>${p.shiny?'✦ SHINY · ':''}${title(p.name)}</b><em class="collection-rarity-pill" style="--badge:${r.color}">${r.label}</em><em class="collection-iv-pill" style="--iv-color:${r.color}">IV ${ivLabel}</em></div><small>${t('common.lv')} ${p.level} · ${ptypes.map(tp=>`${typeIconCircle(tp,typeColor(tp))}${typeLabel(tp)}`).join(' / ')}</small></div></button><button type="button" class="deposit-move-button" data-box-to-team="${p.id}" title="${t('deposit.moveToTeam')}">←</button></div><div class="collection-detail"><div class="detail-label">${t('col.detailStatus',{level:p.level})}</div><div class="detail-grid"><span>${t('dex.stat.hp')} <b>${(p.stats||statsFor(p.name,type,p.level,p.ivs,p.mult||1)).hp}</b></span><span>${t('dex.stat.atk')} <b>${(p.stats||statsFor(p.name,type,p.level,p.ivs,p.mult||1)).atk}</b></span><span>${t('dex.stat.def')} <b>${(p.stats||statsFor(p.name,type,p.level,p.ivs,p.mult||1)).def}</b></span></div><section class="deposit-ivs"><div class="team-detail-label"><span>IVS</span><b>${t('team.ivsTotal',{value:ivLabel})}</b></div>${pokemonIvsGrid(p)}</section>${evolutionRequirement(p)?`<button class="collection-evolve" data-evolve-kind="collection" data-evolve-id="${p.id}">${t('team.evolveTo',{name:title(evolutionRequirement(p).next)})}</button>`:''}</div>`}
  </div>`
}
function renderCollection(){
  if(deferPanelRender('collectionPanelLayer'))return;
  const allBox=state.collection.filter(p=>!isOnTeam(p)),filtered=filterCollection(collectionFilters()).filter(p=>!isOnTeam(p)),teamMembers=equippedTeamMembers();
  if($('#depositTeamCount'))$('#depositTeamCount').textContent=`${teamMembers.length}/6`;
  if($('#depositBoxCount'))$('#depositBoxCount').textContent=allBox.length;
  if($('#colResults'))$('#colResults').textContent=t('deposit.resultsOf',{filtered:filtered.length,total:allBox.length});
  if($('#depositTeamList'))$('#depositTeamList').innerHTML=teamMembers.length?teamMembers.map(member=>depositPokemonRow(member.pokemon,{team:true,starter:member.kind==='starter'})).join(''):`<div class="collection-empty">${t('deposit.noTeam')}</div>`;
  if($('#collectionList'))$('#collectionList').innerHTML=!state.collection.length?`<div class="collection-empty">${t('col.empty')}</div>`:!filtered.length?`<div class="collection-empty">${t('col.noMatch')}</div>`:filtered.map(p=>depositPokemonRow(p)).join('');
  if(depositActiveTab==='pokemon'&&$('#depositCount'))$('#depositCount').textContent=t('deposit.pokemonCount',{count:state.collection.length});
  $$('#collectionPanel .poke-portrait img').forEach(centerPortrait);
  $$('#collectionList .collection-row-open').forEach(button=>button.onclick=()=>{const row=button.closest('.collection-row'),willOpen=!row.classList.contains('open');$$('#collectionList .collection-row.open').forEach(open=>open.classList.remove('open'));if(willOpen)row.classList.add('open')});
  $$('[data-team-to-box]').forEach(button=>button.onclick=()=>toggleTeamPokemon(button.dataset.teamToBox));
  $$('[data-box-to-team]').forEach(button=>button.onclick=()=>toggleTeamPokemon(button.dataset.boxToTeam))
}
function depositItemQuantity(slug){return(state.inventory[slug]||0)+(state.drops[slug]||0)}
function transferItemToDeposit(slug){
  if(inventorySyncEnabled()){showToast(t('deposit.serverItemsDisabled'));return}
  const qty=depositItemQuantity(slug);if(qty<=0)return;
  state.inventory[slug]=0;state.drops[slug]=0;state.depositItems[slug]=(state.depositItems[slug]||0)+qty;finishDepositItemTransfer()
}
function withdrawDepositItem(slug){
  if(inventorySyncEnabled()){showToast(t('deposit.serverItemsDisabled'));return}
  const qty=state.depositItems[slug]||0;if(qty<=0)return;
  const target=itemCategoryFor(slug)==='BALL'||itemCategoryFor(slug)==='POTION'?state.inventory:state.drops;
  target[slug]=(target[slug]||0)+qty;delete state.depositItems[slug];finishDepositItemTransfer()
}
function finishDepositItemTransfer(){renderDepositItems();renderPlayerInventory();renderInventory();renderDropBag();renderPotionSelect();save()}
function depositAllItems(){
  if(inventorySyncEnabled()){showToast(t('deposit.serverItemsDisabled'));return}
  for(const slug of Object.keys(ITEM_BY_SLUG)){const qty=depositItemQuantity(slug);if(qty<=0)continue;state.inventory[slug]=0;state.drops[slug]=0;state.depositItems[slug]=(state.depositItems[slug]||0)+qty}finishDepositItemTransfer()
}
function renderDepositItemRow(slug,qty,stored=false){return`<div class="deposit-item-row">${itemIcon(slug)}<div class="deposit-row-copy"><b>${displayItem(slug)}</b><small>${formatNumber(qty)}× · ${t(`deposit.category.${itemCategoryFor(slug)}`)}</small></div><button type="button" class="deposit-move-button" ${stored?`data-withdraw-item="${slug}" title="${t('deposit.withdrawItem')}"`:`data-deposit-item="${slug}" title="${t('deposit.storeItem')}"`}>${stored?'←':'→'}</button></div>`}
function renderDepositItems(){
  if(deferPanelRender('collectionPanelLayer'))return;
  const q=($('#depositItemSearch')?.value||'').trim().toLowerCase(),category=$('#depositItemCategory')?.value||'',matches=slug=>(!q||displayItem(slug).toLowerCase().includes(q))&&(!category||itemCategoryFor(slug)===category);
  const backpack=Object.keys(ITEM_BY_SLUG).filter(slug=>depositItemQuantity(slug)>0&&matches(slug)),stored=Object.keys(state.depositItems).filter(slug=>(state.depositItems[slug]||0)>0&&ITEM_BY_SLUG[slug]&&matches(slug));
  $('#depositBackpackList').innerHTML=backpack.length?backpack.map(slug=>renderDepositItemRow(slug,depositItemQuantity(slug))).join(''):`<div class="collection-empty">${t('deposit.emptyBackpack')}</div>`;
  $('#depositStoredItemList').innerHTML=stored.length?stored.map(slug=>renderDepositItemRow(slug,state.depositItems[slug],true)).join(''):`<div class="collection-empty">${t('deposit.emptyStorage')}</div>`;
  $('#depositAllItems').disabled=!Object.keys(ITEM_BY_SLUG).some(slug=>depositItemQuantity(slug)>0);
  if(depositActiveTab==='items')$('#depositCount').textContent=t('deposit.itemCount',{count:Object.values(state.depositItems).reduce((sum,qty)=>sum+(+qty||0),0)});
  $$('[data-deposit-item]').forEach(button=>button.onclick=()=>transferItemToDeposit(button.dataset.depositItem));$$('[data-withdraw-item]').forEach(button=>button.onclick=()=>withdrawDepositItem(button.dataset.withdrawItem))
}
function switchDepositTab(tab){
  depositActiveTab=tab==='items'?'items':'pokemon';
  $$('#collectionPanel [data-deposit-tab]').forEach(button=>{const active=button.dataset.depositTab===depositActiveTab;button.classList.toggle('active',active);button.setAttribute('aria-selected',String(active))});
  $('#depositItemsPane').classList.toggle('hidden',depositActiveTab!=='items');$('#depositPokemonPane').classList.toggle('hidden',depositActiveTab!=='pokemon');
  if(depositActiveTab==='items')renderDepositItems();else renderCollection()
}
function closeEvolutionDialog(){$('#evolutionDialog').classList.add('hidden');pendingEvolution=null}
function openEvolutionDialog(kind,id){
  const pokemon=evolutionTarget(kind,id),evolution=evolutionRequirement(pokemon);if(!pokemon||!evolution){showToast(t('toast.cannotEvolveYet'));return}
  pendingEvolution={kind,id:id??null};const stones=ownedEvolutionStones(pokemon);
  $('#evolutionTitle').textContent=t('evo.titleName',{name:title(pokemon.name)});
  $('#evolutionFromImage').src=asset(pokemon.name);$('#evolutionFromName').textContent=`${title(pokemon.name)} · ${t('common.lv')} ${pokemon.level}`;
  $('#evolutionToImage').src=asset(evolution.next);$('#evolutionToName').textContent=title(evolution.next);
  centerPortrait($('#evolutionFromImage'));centerPortrait($('#evolutionToImage'));
  $('#evolutionFromImage').closest('.evolution-portrait')?.style.setProperty('--slot-color',typeColors[primaryTypeFor(pokemon.name)]||'#82765b');
  $('#evolutionToImage').closest('.evolution-portrait')?.style.setProperty('--slot-color',typeColors[primaryTypeFor(evolution.next)]||'#82765b');
  $('#evolutionNormal').textContent=t('evo.normal');
  const coinCost=evolutionCoinCost(pokemon.level,evolution.index);$('#evolutionCoinCost').textContent=t('evo.coinCost',{cost:formatNumber(coinCost),level:pokemon.level});$('#evolutionCoins').disabled=state.stats.coins<coinCost;
  $('#evolutionStoneOptions').innerHTML=stones.length?stones.map(stone=>`<button data-evolution-stone="${stone.slug}">${itemIcon(stone.slug)}<span><b>${displayItem(stone.slug)}</b><small>${t('common.lv')} ${pokemon.level} · ×${stone.count}</small></span></button>`).join(''):`<p class="no-evolution-stone">${t('evo.warning')}</p>`;
  $('#evolutionDialog').classList.remove('hidden')
}
function consumeEvolutionStone(slug){
  if((state.drops[slug]||0)>0){state.drops[slug]--;return true}
  if((state.inventory[slug]||0)>0){state.inventory[slug]--;return true}
  return false;
}
async function applyEvolution(method='reset',stoneSlug=null){
  if(!pendingEvolution)return;const {kind,id}=pendingEvolution,pokemon=evolutionTarget(kind,id),evolution=evolutionRequirement(pokemon);if(!pokemon||!evolution){closeEvolutionDialog();showToast(t('toast.evolutionUnavailable'));return}
  const serverId=pokemon.serverId||pokemon.id;
  if(collectionSyncEnabled()&&serverId){
    try{
      const response=await evolvePlayerPokemon({
        pokemonId:serverId,
        nextSpecies:evolution.next,
        method,
        stoneSlug:method==='stone'?stoneSlug:null,
      },crypto.randomUUID());
      if(response?.inventory)applyServerInventory(response.inventory,{force:true});
      if(response?.wallet)acceptMarketWallet(response.wallet);
      if(response?.pokemon){
        applyServerPokemonUpdates([response.pokemon]);
        if(kind==='starter'&&state.starter){
          // applyServerPokemonUpdates already merged starter
        }
      }
      const previous=pokemon.name;
      closeEvolutionDialog();renderPartnerHud();renderCollection();renderCaptureLog();renderDropBag();if(!$('#teamManagementOverlay').classList.contains('hidden'))selectTeamMember(kind==='starter'?'starter':`collection:${id}`,true);save();
      addLog(t('evo.toast',{from:title(previous),to:title(evolution.next)}));showToast(t('evo.toast',{from:title(previous),to:title(evolution.next)}));
      playTeamEvolutionBurst(kind==='starter');
      return;
    }catch(error){
      console.warn('evolve_player_pokemon failed',error);
      showToast(t('sys.syncFail')||'Sync failed');
      return;
    }
  }
  if(method==='stone'){
    const compatible=ownedEvolutionStones(pokemon).some(stone=>stone.slug===stoneSlug);
    if(!compatible){showToast(t('toast.stoneUnavailable'));return}
    if(serverGameplayReady()){
      const ok=await consumeGameplayItem(stoneSlug,1);
      if(!ok){showToast(t('toast.stoneUnavailable'));return}
    }else if(!consumeEvolutionStone(stoneSlug)){showToast(t('toast.stoneUnavailable'));return}
  }
  if(method==='coins'){
    const cost=evolutionCoinCost(pokemon.level,evolution.index);
    if(state.stats.coins<cost){showToast(t('evo.notEnoughCoins'));return}
    if(walletSyncEnabled()){
      try{
        const response=await spendIdlecoin(cost,'evolution',crypto.randomUUID());
        if(response?.wallet)acceptMarketWallet(response.wallet);
      }catch(error){
        console.warn('spend_idlecoin evolution failed',error);
        showToast(t('evo.notEnoughCoins'));
        return;
      }
    }else applyIdlecoinDelta(-cost,'evolution');
  }
  const previous=pokemon.name,preservedLevel=pokemon.level,preservedXp=pokemon.xp||0;pokemon.name=evolution.next;
  pokemon.level=method==='reset'?1:preservedLevel;pokemon.xp=method==='reset'?0:preservedXp;
  if(method==='reset'){pokemon.masteryLevel=0;pokemon.masteryXp=0}
  const type=primaryTypeFor(pokemon.name);pokemon.types=speciesTypes(pokemon.name,type);pokemon.stats=statsFor(pokemon.name,type,pokemon.level,pokemon.ivs,pokemon.mult||1);
  ensurePokemonLoadout(pokemon);
  if(kind==='starter')pokemon.currentHp=pokemon.stats.hp;else pokemon.hp=100;
  closeEvolutionDialog();renderPartnerHud();renderCollection();renderCaptureLog();renderDropBag();if(!$('#teamManagementOverlay').classList.contains('hidden'))selectTeamMember(kind==='starter'?'starter':`collection:${id}`,true);save();
  addLog(t('evo.toast',{from:title(previous),to:title(pokemon.name)}));showToast(t('evo.toast',{from:title(previous),to:title(pokemon.name)}));
  playTeamEvolutionBurst(kind==='starter');
}
function playTeamEvolutionBurst(onStarter=true){
  const portrait=onStarter
    ?$('#partnerHudSprite')?.closest('.team-pokemon-portrait')
    :$('#routeReserveList .team-pokemon-portrait');
  if(!portrait)return;
  portrait.classList.remove('evo-burst');
  void portrait.offsetWidth;
  portrait.classList.add('evo-burst');
  setTimeout(()=>portrait.classList.remove('evo-burst'),950);
}
let gameConfirmResolve=null,gameConfirmLastFocus=null;
function closeGameConfirm(ok=false){
  const dialog=$('#gameConfirmDialog');
  if(!dialog||dialog.classList.contains('hidden'))return false;
  dialog.classList.add('hidden');
  const resolve=gameConfirmResolve;
  gameConfirmResolve=null;
  const lastFocus=gameConfirmLastFocus;
  gameConfirmLastFocus=null;
  if(lastFocus&&typeof lastFocus.focus==='function')setTimeout(()=>lastFocus.focus(),0);
  if(resolve)resolve(!!ok);
  return true;
}
function showGameConfirm(message,options={}){
  const dialog=$('#gameConfirmDialog'),titleEl=$('#gameConfirmTitle'),textEl=$('#gameConfirmText'),accept=$('#gameConfirmAccept'),cancel=$('#gameConfirmCancel'),close=$('#gameConfirmClose');
  if(!dialog||!titleEl||!textEl||!accept||!cancel){showToast(String(message||''));return Promise.resolve(false)}
  if(gameConfirmResolve)closeGameConfirm(false);
  applyStaticI18n(dialog);
  titleEl.textContent=options.title||t('confirm.title');
  textEl.textContent=String(message||'');
  accept.textContent=options.acceptLabel||t('common.yes');
  cancel.textContent=options.cancelLabel||t('common.no');
  dialog.classList.remove('hidden');
  gameConfirmLastFocus=document.activeElement;
  return new Promise(resolve=>{
    gameConfirmResolve=resolve;
    accept.onclick=()=>closeGameConfirm(true);
    cancel.onclick=()=>closeGameConfirm(false);
    if(close)close.onclick=()=>closeGameConfirm(false);
    dialog.onclick=event=>{if(event.target===dialog)closeGameConfirm(false)};
    setTimeout(()=>accept.focus(),0);
  });
}
function showToast(msg){$('#toast').textContent=msg;$('#toast').classList.add('show');setTimeout(()=>$('#toast').classList.remove('show'),2400)}
function renderSettingsLanguageList(){
  const list=$('#settingsLanguageList');if(!list)return;
  const current=getLocale();
  list.innerHTML=SUPPORTED_LOCALES.map(loc=>`<button type="button" class="settings-lang-option ${loc.id===current?'active':''}" data-locale="${loc.id}" role="option" aria-selected="${loc.id===current}">${t(loc.labelKey)}</button>`).join('');
}
function openSettings(){renderSettingsLanguageList();$('#settingsDialog')?.classList.remove('hidden')}
function closeSettings(){$('#settingsDialog')?.classList.add('hidden')}
function renderAccountSettings(){
  const name=$('#settingsAccountName'),email=$('#settingsAccountEmail'),block=document.querySelector('.settings-account');
  if(name)name.textContent=activeAccount?.profile?.trainer_name||state.trainer?.name||'—';
  if(email)email.textContent=activeAccount?.session?.user?.email||'—';
  block?.classList.toggle('is-admin',!!activeAccount?.admin?.is_admin);
}
function refreshLocaleUi(){
  applyStaticI18n(document);
  renderCityTeleportOptions();
  renderCityNpcLabels();
  renderSettingsLanguageList();
  $$('.team-pokemon-row.active').forEach(el=>el.setAttribute('data-active-label',t('common.active')));
  try{
    renderStats();renderInventory();renderPotionSelect();renderDropBag();renderPartnerHud();renderTrainerHud();renderTrainerProgress();renderSpecialization();renderOfflineStatus();
    renderCollection();renderCaptureLog();renderPokedex();renderPokedexDetail();
    renderMapRanges();renderMapRoutes();renderHuntHistory();renderLog();
    refreshDailyGiftBadge();
    if(!$('#starterModal')?.classList.contains('hidden'))renderOnboardingUi();
    if(!$('#profileDialog')?.classList.contains('hidden'))renderProfile();
    if(!$('#outfitDialog')?.classList.contains('hidden'))renderOutfitEditor();
    if(!$('#captureFeedback')?.classList.contains('hidden')&&!$('#captureFeedback')?.classList.contains('toast-mode')&&recentFaints.length)renderCapturePanel();
    if(!$('#shopDialogCard')?.classList.contains('hidden'))refreshShopPanes();
    if(!$('#teamManagementOverlay')?.classList.contains('hidden'))renderTeamManagement();
    const filter=$('#pokedexTypeFilter');
    if(filter){
      const selected=filter.value;
      filter.innerHTML=`<option value="">${t('dex.allTypes')}</option>`+types.map(tp=>`<option value="${tp[0]}">${typeLabel(tp[0])}</option>`).join('');
      filter.value=selected;
    }
    if($('#colType')){
      const selected=$('#colType').value;
      $('#colType').innerHTML=`<option value="">${t('col.allTypes')}</option>`+types.map(tp=>`<option value="${tp[0]}">${typeLabel(tp[0])}</option>`).join('');
      $('#colType').value=selected;
    }
    renderDepositRarityFilters();
    switchDepositTab(depositActiveTab);
    changeRoute();
  }catch(err){console.error('refreshLocaleUi',err)}
}
async function bootCityRenderer(){
  // Sem o renderer de tiles a colisão é só o polígono, que já vale desde o
  // primeiro frame: libera o andar na hora.
  if(!isPixiRendererEnabled()){cityWorldReady=true;return}
  // initCityPixi espera texturas da rede. Se uma delas nunca resolve nem
  // rejeita (tileset pendurado, conexão morta), o finally abaixo jamais roda e
  // o WASD fica travado para sempre. Depois do teto, libera com o polígono —
  // que é a mesma regra do fallback PNG — e rescueCityPlayer() conserta a
  // posição se a colisão definitiva chegar atrasada e mais restrita.
  const releaseTimer=setTimeout(()=>{
    if(cityWorldReady)return;
    console.warn('city renderer boot timed out — releasing movement on the polygon');
    cityWorldReady=true;rescueCityPlayer();
  },CITY_RENDERER_BOOT_TIMEOUT_MS);
  try{const host=$('#cityPixiHost');cityPixi=await initCityPixi(host,{boundary:cityBoundary,pointInPolygon});$('#cityMapWorld').classList.add('renderer-pixi');resetCityFollower();updateBuildingState();showToast(t('sys.pixiOn'))}
  catch(err){console.error(err);cityPixi=null;showToast(t('sys.pixiOff'))}
  finally{clearTimeout(releaseTimer);cityWorldReady=true;rescueCityPlayer()}
}
let onboardingDraft={
  step:1,
  region:DEFAULT_STARTER_REGION,
  starter:null,
  gender:DEFAULT_TRAINER_GENDER,
  sprite:DEFAULT_TRAINER_SPRITE,
  name:'',
  colorPiece:'body',
  colors:{...DEFAULT_OUTFIT_COLORS},
};

function setOnboardingError(message=''){
  const el=$('#onboardingError');
  if(!el)return;
  el.textContent=message||'';
  el.classList.toggle('hidden',!message);
}

function syncOnboardingStepChrome(){
  const step=Math.max(1,Math.min(2,onboardingDraft.step|0));
  onboardingDraft.step=step;
  $$('[data-onboarding-step]').forEach(panel=>{
    panel.classList.toggle('hidden',Number(panel.dataset.onboardingStep)!==step);
  });
  $$('[data-step-dot]').forEach(dot=>{
    const n=Number(dot.dataset.stepDot);
    dot.classList.toggle('active',n===step);
    dot.classList.toggle('done',n<step);
  });
  const title=$('#onboardingTitle'),hint=$('#onboardingHint');
  if(title)title.textContent=t(`starter.step${step}Title`);
  if(hint)hint.textContent=t(`starter.step${step}Hint`);
  const back=$('#onboardingBack'),next=$('#onboardingNext');
  if(back)back.classList.toggle('hidden',step<=1);
  if(next)next.textContent=step>=2?t('starter.start'):t('starter.next');
}

function starterTypeText(slug){
  return speciesTypes(slug).map(tp=>typeLabel(tp,{upper:true})).join(' · ');
}

function paintOnboardingLookPreview(img,slug){
  if(!img||!slug)return;
  const base=entityAsset(slug,'south',0);
  const request=`${slug}|${outfitColorsKey(onboardingDraft.colors)}`;
  img.dataset.lookPreview=request;
  compositeOutfitSprite(base,entityMaskAsset(slug,'south',0),onboardingDraft.colors).then(url=>{
    if(img.dataset.lookPreview!==request)return;
    img.src=url;
    centerPortrait(img);
  }).catch(()=>{
    if(img.dataset.lookPreview===request){img.src=base;centerPortrait(img)}
  });
}

function renderOnboardingRegions(){
  const host=$('#onboardingRegions');
  if(!host)return;
  host.innerHTML=STARTER_REGIONS.map(region=>{
    const selected=region.id===onboardingDraft.region;
    return`<button type="button" class="onboarding-region-btn ${selected?'selected':''}" data-region="${region.id}" role="tab" aria-selected="${selected}" aria-pressed="${selected}">${t(region.labelKey)}</button>`;
  }).join('');
  $$('#onboardingRegions [data-region]').forEach(btn=>{
    btn.onclick=()=>selectOnboardingRegion(btn.dataset.region);
  });
}

function renderOnboardingStarters(){
  const host=$('#onboardingStarters');
  if(!host)return;
  const region=regionById(onboardingDraft.region);
  const regionSlugs=region.starters.map(s=>s.slug);
  if(onboardingDraft.starter&&!regionSlugs.includes(onboardingDraft.starter))onboardingDraft.starter=null;
  host.innerHTML=region.starters.map(entry=>{
    const slug=entry.slug;
    const types=speciesTypes(slug);
    const accent=typeColors[types[0]]||'#82765b';
    const selected=slug===onboardingDraft.starter;
    const dex=pokedexEntry(slug)?.id||entry.dex;
    const name=pokedexEntry(slug)?.name||title(slug);
    return`<button type="button" data-starter="${slug}" style="--accent:${accent}" aria-pressed="${selected}" class="${selected?'selected':''}">
      <span class="starter-number">${formatDexNumber(dex).replace('#','')}</span>
      <span class="poke-portrait lg" style="--slot-color:${accent}"><img src="${entityAsset(slug,'south',0)}" alt="" /></span>
      <b>${name}</b>
      <small>${starterTypeText(slug)}</small>
      <span class="starter-chosen ${selected?'':'hidden'}">${t('starter.chosen')}</span>
    </button>`;
  }).join('');
  $$('#onboardingStarters [data-starter]').forEach(btn=>{
    btn.onclick=()=>selectOnboardingStarter(btn.dataset.starter);
  });
  $$('#onboardingStarters .poke-portrait img').forEach(centerPortrait);
}

function renderOnboardingLooks(){
  const host=$('#onboardingLooks');
  if(!host)return;
  const looks=looksForGender(onboardingDraft.gender);
  if(!looks.some(l=>l.slug===onboardingDraft.sprite))onboardingDraft.sprite=looks[0]?.slug||DEFAULT_TRAINER_SPRITE;
  host.innerHTML=looks.map(look=>{
    const selected=look.slug===onboardingDraft.sprite;
    return`<button type="button" class="onboarding-look ${selected?'selected':''}" data-look="${look.slug}" aria-pressed="${selected}"><span class="onboarding-look-frame"><img src="${entityAsset(look.slug,'south',0)}" alt=""></span><b>${t(look.labelKey)}</b></button>`;
  }).join('');
  $$('#onboardingLooks [data-look]').forEach(btn=>{
    btn.onclick=()=>{onboardingDraft.sprite=btn.dataset.look;setOnboardingError();renderOnboardingLooks();renderOnboardingColors()};
  });
  $$('#onboardingLooks img').forEach(img=>{
    const slug=img.closest('[data-look]')?.dataset.look;
    paintOnboardingLookPreview(img,slug);
  });
}

function renderOnboardingColors(){
  const piecesHost=$('#onboardingColorPieces');
  const gridHost=$('#onboardingColorGrid');
  const panel=$('#onboardingColors');
  if(!piecesHost||!gridHost||!panel)return;
  panel.classList.toggle('hidden',!isValidTrainerSprite(onboardingDraft.sprite));
  if(!OUTFIT_PIECES.includes(onboardingDraft.colorPiece))onboardingDraft.colorPiece='body';
  onboardingDraft.colors=normalizeOutfitColors(onboardingDraft.colors);
  piecesHost.innerHTML=OUTFIT_PIECES.map(piece=>{
    const selected=piece===onboardingDraft.colorPiece;
    const colorId=onboardingDraft.colors[piece];
    return`<button type="button" class="onboarding-color-piece" data-color-piece="${piece}" aria-pressed="${selected}"><i class="swatch" style="background:${outfitColorCss(colorId)}"></i>${t(`starter.color.${piece}`)}</button>`;
  }).join('');
  $$('#onboardingColorPieces [data-color-piece]').forEach(btn=>{
    btn.onclick=()=>{onboardingDraft.colorPiece=btn.dataset.colorPiece;renderOnboardingColors()};
  });
  const activePiece=onboardingDraft.colorPiece;
  const activeColor=onboardingDraft.colors[activePiece];
  gridHost.innerHTML=Array.from({length:OUTFIT_COLOR_COUNT},(_,id)=>{
    const selected=id===activeColor;
    return`<button type="button" class="onboarding-color-swatch" data-color-id="${id}" aria-pressed="${selected}" title="${id}" style="background:${outfitColorCss(id)}"></button>`;
  }).join('');
  $$('#onboardingColorGrid [data-color-id]').forEach(btn=>{
    btn.onclick=()=>{
      onboardingDraft.colors={...onboardingDraft.colors,[activePiece]:Number(btn.dataset.colorId)};
      renderOnboardingColors();
      $$('#onboardingLooks img').forEach(img=>{
        const slug=img.closest('[data-look]')?.dataset.look;
        paintOnboardingLookPreview(img,slug);
      });
    };
  });
}

function renderOnboardingUi(){
  syncOnboardingStepChrome();
  if(onboardingDraft.step===1){
    $$('.onboarding-gender-btn').forEach(btn=>{
      const selected=btn.dataset.gender===onboardingDraft.gender;
      btn.classList.toggle('selected',selected);
      btn.setAttribute('aria-pressed',String(selected));
    });
    renderOnboardingLooks();
    renderOnboardingColors();
    return;
  }
  renderOnboardingRegions();
  renderOnboardingStarters();
}

function selectOnboardingRegion(regionId){
  const region=regionById(regionId);
  onboardingDraft.region=region.id;
  if(onboardingDraft.starter&&!region.starters.some(s=>s.slug===onboardingDraft.starter))onboardingDraft.starter=null;
  setOnboardingError();
  renderOnboardingRegions();
  renderOnboardingStarters();
}

function selectOnboardingStarter(name){
  if(!isValidStarterSlug(name))return;
  onboardingDraft.starter=name;
  setOnboardingError();
  renderOnboardingStarters();
}

function selectOnboardingGender(gender){
  onboardingDraft.gender=gender==='m'?'m':'f';
  onboardingDraft.sprite=defaultSpriteForGender(onboardingDraft.gender);
  setOnboardingError();
  renderOnboardingLooks();
  renderOnboardingColors();
  $$('.onboarding-gender-btn').forEach(btn=>{
    const selected=btn.dataset.gender===onboardingDraft.gender;
    btn.classList.toggle('selected',selected);
    btn.setAttribute('aria-pressed',String(selected));
  });
}

function goOnboardingBack(){
  if(onboardingDraft.step<=1)return;
  onboardingDraft.step-=1;
  setOnboardingError();
  renderOnboardingUi();
}

function goOnboardingNext(){
  if(onboardingDraft.step===1){
    if(!isValidTrainerSprite(onboardingDraft.sprite)){setOnboardingError(t('starter.needLook'));return}
    onboardingDraft.step=2;
    setOnboardingError();
    renderOnboardingUi();
    return;
  }
  finishOnboarding();
}

function finishOnboarding(){
  const name=String(activeAccount?.profile?.trainer_name||onboardingDraft.name||state.trainer?.name||'').trim().slice(0,16);
  onboardingDraft.name=name;
  if(!isValidTrainerSprite(onboardingDraft.sprite)){
    onboardingDraft.step=1;setOnboardingError(t('starter.needLook'));renderOnboardingUi();return;
  }
  if(!onboardingDraft.starter||!isValidStarterSlug(onboardingDraft.starter)){
    onboardingDraft.step=2;setOnboardingError(t('starter.needStarter'));renderOnboardingUi();return;
  }
  const starterName=onboardingDraft.starter;
  state.trainer={
    ...state.trainer,
    name,
    gender:onboardingDraft.gender,
    sprite:onboardingDraft.sprite,
    colors:normalizeOutfitColors(onboardingDraft.colors),
  };
  state.starter={name:starterName,level:1,xp:0,ivs:{hp:15,atk:15,def:15,spa:15,spd:15,spe:15},currentHp:null,equippedMoves:[],autoMoves:true,moveCursor:0,starterOrigin:true,locked:true};
  ensureStarterCombat();
  if(isMovesReady())state.starter.equippedMoves=defaultLoadout(starterName,1);
  state.running=false;
  $('#starterModal').classList.add('hidden');
  setOnboardingError();
  addLog(t('starter.picked',{name:title(starterName)}));
  resetCityFollower();
  const el=$('#cityTrainer');
  if(el)setActor(el,trainerSprite(),cityPlayer.dir,false,performance.now());
  switchView('city');
  showToast(t('city.welcome'));
  save();
  renderPartnerHud();
  renderTrainerHud();renderOfflineStatus();
  tutorialEvent('onboarding:done');
  if(collectionSyncEnabled()){
    void(async()=>{
      try{
        const payload={
          id:state.starter?.serverId||state.starter?.id||null,
          species:state.starter.name,
          name:state.starter.name,
          level:state.starter.level||1,
          xp:state.starter.xp||0,
          ivs:state.starter.ivs,
          rarity:state.starter.rarity||'Comum',
          mult:state.starter.mult||1,
          ball:'pokeball',
          moves:state.starter.equippedMoves||[],
          mastery_level:state.starter.masteryLevel||0,
          mastery_xp:state.starter.masteryXp||0,
        };
        const response=await ensureStarterPokemon(payload,crypto.randomUUID());
        if(response?.pokemon){
          const mapped=serverPokemonToLocal(response.pokemon,{
            rarityColor:name=>rarityInfo({rarity:name}).color,
            statsFor:(name,type,level,ivs,mult)=>statsFor(name,type,level,ivs,mult),
          });
          if(mapped){
            state.starter={
              ...state.starter,
              ...mapped,
              serverId:mapped.serverId||mapped.id,
              starterOrigin:true,
              locked:true,
              isActive:true,
            };
            ensureStarterCombat();
            save();
            renderPartnerHud();
          }
          const activeId=response.pokemon.id||mapped?.serverId;
          if(activeId&&!response.pokemon.is_active){
            try{
              const active=await setActivePokemon(activeId,crypto.randomUUID());
              if(Array.isArray(active?.pokemon))applyServerCollection(active.pokemon,{force:true});
              else if(active?.pokemon)applyServerCollection(active.pokemon,{force:true});
            }catch(error){console.warn('set_active_pokemon after onboarding failed',error)}
          }
        }
      }catch(error){console.warn('ensure_starter_pokemon after onboarding failed',error)}
    })();
  }
}

function wireOnboarding(){
  $$('.onboarding-gender-btn').forEach(b=>b.onclick=()=>selectOnboardingGender(b.dataset.gender));
  $('#onboardingBack')?.addEventListener('click',goOnboardingBack);
  $('#onboardingNext')?.addEventListener('click',goOnboardingNext);
  renderOnboardingUi();
}
async function setup(){
  const previewMode=new URLSearchParams(location.search).get('preview');
  const boot=globalThis.IdlemonBoot;
  hydrateUiIcons();
  initI18n(); onLocaleChange(()=>refreshLocaleUi());
  injectFeatureNav();
  initFeatureOverlays();
  const localVisualPreview=location.hostname==='localhost'&&previewMode&&!['auth','auth-login'].includes(previewMode);
  if(!previewMode){
    initTutorial({
      getState:()=>state,
      save,
      t,
      switchView,
      openPanel:id=>toggleFloatingPanel(id),
      isBusy:()=>!!document.querySelector('#starterModal:not(.hidden), #accountScreen:not(.hidden), #offlineReportDialog:not(.hidden), #rulesDialog:not(.hidden)'),
      showToast,
      // Passo que exige a cidade nunca corta uma caça em andamento: ele espera.
      currentView:()=>$('#cityView')?.classList.contains('active')?'city':'adventure',
      isHunting:()=>!!state.running,
      prepareStep:prepareTutorialStep,
    });
  }
  if(localVisualPreview){$('#accountScreen')?.classList.add('hidden');$('#starterModal')?.removeAttribute('inert')}
  else{
    boot?.step('auth',26);
    activeAccount=await initAccountGate({suggestedTrainerName:state.trainer?.name||''});
    initAdminUI({context:activeAccount?.admin||{is_admin:false},showToast});
    stopGameNoticeFeed();
    const noticeUserId=activeAccount?.session?.user?.id;
    void initGameNoticeFeed({userId:noticeUserId,showToast}).then(cleanup=>{
      if(activeAccount?.session?.user?.id===noticeUserId)stopGameNoticeFeed=cleanup;
      else cleanup();
    });
    // O gate esconde o splash quando pede login; depois do submit ele volta.
    boot?.show();boot?.step('save',42);
    $('#starterModal')?.removeAttribute('inert');
    onClientSessionSuperseded(reason=>{
      stopClientSessionWatch();
      stopGameNoticeFeed();
      stopGameNoticeFeed=()=>{};
      activeAccount=null;
      cloudSaveReady=false;
      showToast(reason==='session_required'?t('auth.sessionRequired'):t('auth.sessionSuperseded'));
      setTimeout(()=>location.reload(),1200);
    });
    startClientSessionWatch({intervalMs:20000});
    try{await initCloudGameSave()}catch(error){cloudSaveReady=false;console.error('game save load failed',error)}
    boot?.step('save',56);
    try{await syncPremiumEntitlements()}catch(error){console.warn('premium entitlement sync failed',error)}
    state.trainer.name=activeAccount.profile.trainer_name;
    state.accountUserId=activeAccount.session.user.id;
    onboardingDraft.name=activeAccount.profile.trainer_name;
    save();
    const walletState=await initMarketState({
      account:activeAccount,
      getBalance:()=>state.stats.coins,
      setBalance:value=>{state.stats.coins=Math.max(0,Math.trunc(Number(value)||0));save();renderStats()},
      getTrainerLevel:()=>state.trainer?.level||1,
      getRouteLevel:()=>state.enemy?.level||ROUTE_LEVEL_RANGES[state.range]?.[0]||1,
      onWallet:value=>{activeAccount.wallet=value},
    });
    if(walletState?.migrationPending)console.info('IdleCoin migration awaits configured amnesty cap');
    initTelemetry({snapshot:()=>({
      idlecoin:Math.max(0,Math.trunc(Number(state.stats?.coins)||0)),
      emerald:Math.max(0,Math.trunc(Number(state.emerald)||0)),
      inventory_units:Object.values(state.inventory||{}).reduce((sum,qty)=>sum+Math.max(0,Number(qty)||0),0),
      drop_units:Object.values(state.drops||{}).reduce((sum,qty)=>sum+Math.max(0,Number(qty)||0),0),
      trainer_level:state.trainer?.level||1,
    })});
    try{
      await initCollectionSync({
        account:activeAccount,
        getCollection:()=>state.collection||[],
        applyCollection:list=>applyServerCollection(list,{force:true}),
        rarityColor:name=>rarityInfo({rarity:name}).color,
        statsFor:(name,type,level,ivs,mult)=>statsFor(name,type,level,ivs,mult),
        onMigrated:()=>console.info('collection migrated to server'),
      });
    }catch(error){console.warn('collection sync init failed',error)}
    // Recupera o XP de Pokémon que não chegou a ser enviado antes do F5.
    restorePokemonXpQueue();
    flushPokemonXpGrants().catch(()=>{});
    try{await restoreGhostCapturesFromHistory()}catch(error){console.warn('ghost capture restore failed',error)}
    try{
      await initProgressSync({
        account:activeAccount,
        getInventory:()=>{
          const merged={...(state.inventory||{})};
          for(const [slug,qty] of Object.entries(state.drops||{}))merged[slug]=(merged[slug]||0)+(Number(qty)||0);
          const localCards=Math.max(0,Math.floor(Number(state.shinyCards)||0));
          if(localCards>0)merged['shiny-card']=(merged['shiny-card']||0)+localCards;
          return merged;
        },
        applyInventory:inv=>applyServerInventory(inv,{force:true}),
        getProgress:()=>({
          trainer_level:state.trainer?.level||1,
          trainer_peak_level:state.trainer?.peakLevel||state.trainer?.level||1,
          trainer_xp:state.trainer?.xp||0,
          prestige:state.trainer?.prestige||0,
          defeated:state.stats?.defeated||0,
          captured:state.stats?.captured||0,
          shiny_research:state.shinyResearch||{},
          kill_counts:state.killCounts||{},
          route_level:state.enemy?.level||ROUTE_LEVEL_RANGES[state.range]?.[0]||1,
        }),
        applyProgress:applyServerProgress,
        getRouteLevel:()=>state.enemy?.level||ROUTE_LEVEL_RANGES[state.range]?.[0]||1,
        migrateProgressRpc:migrateProgress,
        takeMetrics:takeBackgroundMetrics,
      });
    }catch(error){console.warn('progress sync init failed',error)}
    try{
      initSessionLifecycle({
        userId:activeAccount?.session?.user?.id||'',
        onResume:()=>{resumeForegroundLoop();reconcileAfterVisibilityResume().catch(()=>{})},
      });
    }catch(error){console.warn('session lifecycle init failed',error)}
    // Offline Hunt: claim do tempo ausente ANTES de a hunt começar a reportar
    // (senão report_session avança last_sync_at e o gap some).
    try{await serverOfflineClaim()}catch(error){console.warn('offline claim failed',error)}
    try{
      await initEncounterSync({
        account:activeAccount,
        enabled:true,
        getRouteLevel:()=>encounterRouteLevel(),
        getRouteType:()=>encounterRouteKey(),
        getHuntSpecies:()=>state.huntMode==='species'?state.huntSpecies:null,
        onAltarProgress:({remaining,species}={})=>{
          if(!state.altarShiny?.server)return;
          if(species&&String(state.altarShiny.species)!==String(species))return;
          const next=Math.max(0,Math.floor(Number(remaining)||0));
          state.altarShiny.remaining=next;
          state.altarShiny.encounters=next;
          if(next<=0)state.altarShiny=null;
          save();
        },
      });
      if(state.altarShiny?.server)setShinyAltarInvocation(state.altarShiny);
    }catch(error){console.warn('encounter sync init failed',error)}
    try{
      if(collectionSyncEnabled()&&state.starter?.name){
        // Garante que a row origin=starter exista no servidor, mas NUNCA demove o
        // parceiro is_active já restaurado pelo collection sync (ex.: Bulbasaur equipado).
        const activeBefore={
          serverId:state.starter.serverId||null,
          name:state.starter.name,
          isActive:!!state.starter.isActive,
        };
        const payload={
          id:state.starter.serverId||state.starter.id||null,
          species:state.starter.name,
          name:state.starter.name,
          level:state.starter.level||1,
          xp:state.starter.xp||0,
          ivs:state.starter.ivs,
          rarity:state.starter.rarity||'Comum',
          mult:state.starter.mult||1,
          ball:'pokeball',
          moves:state.starter.equippedMoves||[],
          mastery_level:state.starter.masteryLevel||0,
          mastery_xp:state.starter.masteryXp||0,
        };
        const response=await ensureStarterPokemon(payload,crypto.randomUUID());
        if(response?.pokemon){
          const ensuredId=String(response.pokemon.id||'');
          const currentId=String(activeBefore.serverId||'');
          const keepSyncedActive=!!(currentId&&ensuredId&&currentId!==ensuredId&&activeBefore.isActive);
          if(keepSyncedActive){
            // Origin starter existe (Charmander etc.), mas o hunt partner é outro.
            state.collection=(state.collection||[]).filter(p=>String(p.id)!==currentId&&String(p.serverId||'')!==currentId);
            save();
          }else{
            const mapped=serverPokemonToLocal(response.pokemon,{
              rarityColor:name=>rarityInfo({rarity:name}).color,
              statsFor:(name,type,level,ivs,mult)=>statsFor(name,type,level,ivs,mult),
            });
            if(mapped){
              state.starter={
                ...state.starter,
                ...mapped,
                serverId:mapped.serverId||mapped.id,
                starterOrigin:response.pokemon.origin==='starter'||state.starter.starterOrigin!==false,
                locked:true,
                currentHp:state.starter.currentHp,
                isActive:true,
              };
              ensureStarterCombat();
              save();
            }
            const activeId=response.pokemon.id||mapped?.serverId;
            if(activeId&&!response.pokemon.is_active){
              try{
                const active=await setActivePokemon(activeId,crypto.randomUUID());
                if(Array.isArray(active?.pokemon))applyServerCollection(active.pokemon,{force:true});
                else if(active?.pokemon)applyServerCollection(active.pokemon,{force:true});
              }catch(error){console.warn('set_active_pokemon boot failed',error)}
            }else if(activeId){
              state.collection=(state.collection||[]).filter(p=>String(p.id)!==String(activeId)&&String(p.serverId||'')!==String(activeId));
              save();
            }
          }
        }
      }
    }catch(error){console.warn('ensure_starter_pokemon failed',error)}
    try{
      if(collectionSyncEnabled()){
        const eggs=await listPlayerEggs(['incubating']);
        if(Array.isArray(eggs)){
          if(!state.breeding)state.breeding=normalizeBreedingState();
          const slots=[null,null];
          eggs.slice(0,2).forEach((egg,i)=>{
            slots[i]={
              id:egg.id,
              serverId:egg.id,
              species:egg.species,
              rarity:egg.rarity,
              mult:Number(egg.mult)||1,
              ivs:egg.ivs,
              defeatsNeeded:egg.defeats_needed,
              defeatsDone:egg.defeats_done,
              createdAt:egg.created_at,
            };
          });
          state.breeding.incubator=slots;
          save();
          try{refreshBreeding()}catch{}
        }
      }
    }catch(error){console.warn('list_player_eggs failed',error)}
  }
  boot?.step('world',72);
  try{await loadMovesData()}catch(err){console.error('moves load failed',err);showToast(t('sys.movesFail'))}
  try{await loadSpriteIndex()}catch(err){console.error('sprite-index load failed',err)}
  try{const pokedex=await loadPokedexData();configureBattleData(pokedex);migrateLegacyHuntState(state);if($('#pokedexCount'))$('#pokedexCount').textContent=ownedBySpecies().size}catch(err){console.error('pokedex load failed',err)}
  if(activeAccount||localVisualPreview&&previewMode==='market')initMarketUI({
    userId:activeAccount?.session?.user?.id||'preview-user',
    getLocalItems:marketLocalItems,
    getLocalPokemon:marketLocalPokemon,
    preparePokemon:marketPokemonPayload,
    applyTransfer:applyMarketTransfer,
    flushSave:()=>flushGameSave(),
    pokemonImage:species=>entityAsset(species,'south',0),
    rarityColor:name=>rarityInfo({rarity:name}).color,
    showToast,
    marketFeeRate:()=>trainerAccountPerks().marketFeeRate,
    previewData:localVisualPreview&&previewMode==='market'?marketPreviewData():null,
  });
  if(activeAccount||localVisualPreview&&previewMode==='chat')await initChatUI({
    userId:activeAccount?.session?.user?.id||'preview-user',
    trainerName:activeAccount?.profile?.trainer_name||state.trainer?.name||'Trainer',
    isAdmin:!!activeAccount?.admin?.is_admin,
    openAdminUser:openAdminForUser,
    pokemonImage:species=>entityAsset(species,'south',0),
    typeColor:name=>typeColors[String(name||'').toLowerCase()]||'#777',
    rarityColor:name=>rarityInfo({rarity:name}).color,
    showToast,
    vipActive:()=>isVip(state,Date.now()),
    previewData:localVisualPreview&&previewMode==='chat'?chatPreviewData():null,previewOnline:18,
  });
  fetch('public/assets/world/saffron-collision.json?v=20260717-15').then(r=>r.json()).then(data=>cityCollision=new Set(data.walkable)).catch(()=>showToast(t('sys.collisionFail')));
  try{migrateCapturedLevels()}catch(err){console.error('migrateCapturedLevels failed',err)}
  state.running=false;
  try{renderMapRanges();renderMapRoutes()}catch(err){console.error('world map render failed',err)}
  try{
    renderLog();renderDepositRarityFilters();renderCollection();renderDepositItems();renderCaptureLog();renderStats();renderInventory();renderHuntHistory();renderDropBag();renderPotionThreshold();renderPotionSelect();
    refreshDailyGiftBadge();
  }catch(err){console.error('boot render failed',err)}
  boot?.step('world',90);
  try{
    if(state.starter?.name){
      $('#starterModal')?.classList.add('hidden');
      ensureStarterCombat();
      if(isMovesReady()&&!(state.starter.equippedMoves||[]).length)state.starter.equippedMoves=defaultLoadout(state.starter.name,state.starter.level);
      resetCityFollower();
      renderPartnerHud();
      const el=$('#cityTrainer');
      if(el)setActor(el,trainerSprite(),cityPlayer.dir,false,performance.now());
    }else{
      if(state.starter&&!state.starter.name)state.starter=null;
      recoverStarterFromCollection();
      if(state.starter?.name){
        $('#starterModal')?.classList.add('hidden');
        resetCityFollower();
        renderPartnerHud();
      }else{
        clearPartnerHud();
        const modal=$('#starterModal');
        if(modal){
          modal.classList.remove('hidden');
          modal.removeAttribute('inert');
          // Conta nova / sem parceiro: força o onboarding completo (look → starter).
          // Sem isso o modal nascia hidden e o jogador entrava na cidade sem escolher.
          onboardingDraft.step=1;
          onboardingDraft.starter=null;
          if(activeAccount?.profile?.trainer_name)onboardingDraft.name=activeAccount.profile.trainer_name;
          renderOnboardingUi();
        }
      }
    }
  }catch(err){console.error('starter boot failed',err)}
  if(previewMode)$('#starterModal')?.classList.add('hidden');
  try{updateCityCamera();updateBuildingState()}catch(err){console.error('city camera boot failed',err)}
  wireOnboarding();
  renderTrainerHud();
  renderAccountSettings();
  try{
  if($('#autoCapture'))$('#autoCapture').onchange=e=>{
    if(!trainerAccountPerks().autoCaptureUnlocked){
      e.target.checked=false;state.autoCapture=false;
      showToast(t('auto.captureVip'));save();return;
    }
    state.autoCapture=!!e.target.checked;
    if(state.autoCapture){recentFaints=[];hideCaptureFeedback({clearQueue:true})}
    $('#captureOptions')?.classList.toggle('enabled',state.autoCapture);
    $('#captureCard')?.classList.toggle('is-enabled',state.autoCapture);
    save();
  };
  if($('#autoPotion'))$('#autoPotion').onchange=e=>{$('#potionOptions')?.classList.toggle('enabled',e.target.checked);$('#potionCard')?.classList.toggle('is-enabled',e.target.checked);state.autoPotion.enabled=e.target.checked;save()};
  if($('#autoRevive'))$('#autoRevive').onchange=e=>{$('#reviveOptions')?.classList.toggle('enabled',e.target.checked);$('#reviveCard')?.classList.toggle('is-enabled',e.target.checked);state.autoRevive.enabled=e.target.checked;save()};
  if($('#autoShiny'))$('#autoShiny').onchange=e=>{
    if(!trainerAccountPerks().autoCaptureUnlocked){
      e.target.checked=false;state.autoShiny=false;
      showToast(t('auto.captureVip'));save();return;
    }
    state.autoShiny=!!e.target.checked;
    $('#shinyCaptureOptions')?.classList.toggle('enabled',state.autoShiny);
    $('#shinyCaptureCard')?.classList.toggle('is-enabled',state.autoShiny);
    save();
  };
  applyAutomationUi();
  const clearLogButton=$('#clearLog');if(clearLogButton)clearLogButton.onclick=()=>{state.log=[];renderLog();save()};
  $$('#shopTabs .shop-tab').forEach(b=>b.onclick=()=>switchShopTab(b.dataset.tab));
  $('#tmTestLabButton')?.addEventListener('click',openTmTestLab);
  $('#tmTestLabClose')?.addEventListener('click',closeTmTestLab);
  $('#tmTestLab')?.addEventListener('click',event=>{if(event.target.id==='tmTestLab')closeTmTestLab()});
  $('#shopBuyQty')?.addEventListener('input',e=>syncShopBuyQty(e.target.value));
  $('#shopBuyQtyRange')?.addEventListener('input',e=>syncShopBuyQty(e.target.value));
  $('#shopGrid')?.addEventListener('click',e=>{const btn=e.target.closest('[data-buy]');if(btn)buyShopItem(btn.dataset.buy)});
  $('#shopSell')?.addEventListener('click',e=>{
    if(e.target.closest('[data-sell-qty],[data-sell-qty-range],input[type=checkbox]'))return;
    const row=e.target.closest('[data-sell-row]');if(!row)return;
    const slug=row.dataset.sellRow,stock=state.drops[slug]|0;if(stock<=0)return;
    if(shopSellSelected.has(slug))shopSellSelected.delete(slug);else setSellQty(slug,stock,stock);
    renderShopSell();
  });
  $('#shopSell')?.addEventListener('change',e=>{
    const box=e.target.closest('[data-sell-drop]');
    if(box){
      const slug=box.dataset.sellDrop,stock=state.drops[slug]|0;
      if(box.checked)setSellQty(slug,stock,stock);else shopSellSelected.delete(slug);
      renderShopSell();
      return;
    }
  });
  $('#shopSell')?.addEventListener('input',e=>{
    const num=e.target.closest('[data-sell-qty]'),range=e.target.closest('[data-sell-qty-range]');
    const el=num||range;if(!el)return;
    const slug=el.dataset.sellQty||el.dataset.sellQtyRange,stock=state.drops[slug]|0;
    if(!slug||stock<=0)return;
    setSellQty(slug,el.value,stock);
    syncShopSellQtyRow(slug);
  });
  $('#shopSellSelectAll')?.addEventListener('click',()=>{
    Object.keys(state.drops).forEach(slug=>{
      const stock=state.drops[slug]|0;if(stock>0&&ITEM_BY_SLUG[slug])setSellQty(slug,stock,stock);
    });
    renderShopSell();
  });
  $('#shopSellConfirm')?.addEventListener('click',sellSelectedDrops);
  $('#shopPokemon')?.addEventListener('change',e=>{const box=e.target.closest('[data-sell-poke]');if(!box||box.disabled)return;const id=String(box.dataset.sellPoke);if(box.checked)shopPokeSelected.add(id);else shopPokeSelected.delete(id);renderShopPokemon()});
  $('#shopPokemon')?.addEventListener('click',e=>{
    const lock=e.target.closest('[data-lock-poke]');
    if(!lock)return;
    const p=state.collection.find(x=>String(x.id)===String(lock.dataset.lockPoke));
    if(!p)return;
    void (async()=>{
      const nextLocked=!p.locked;
      const serverId=p.serverId||p.id;
      if(collectionSyncEnabled()&&isPokemonUuid(serverId)){
        try{
          const response=await setPlayerPokemonLocked(serverId,nextLocked,crypto.randomUUID());
          if(response?.pokemon){
            applyServerPokemonUpdates([response.pokemon]);
            const mapped=state.collection.find(x=>String(x.serverId||x.id)===String(serverId));
            if(mapped)p.locked=!!mapped.locked;
            else p.locked=!!response.pokemon.locked;
          }else p.locked=nextLocked;
        }catch(error){
          console.warn('set_player_pokemon_locked failed',error);
          const code=String(error?.message||error||'');
          showToast(
            code.includes('pokemon_not_sellable')?t('toast.noEligiblePokemon')
              :t('sys.syncFail')||'Lock sync failed'
          );
          return;
        }
      }else{
        p.locked=nextLocked;
      }
      if(p.locked)shopPokeSelected.delete(String(p.id));
      renderShopPokemon();save();
    })();
  });
  $('#shopPokeSelectAll')?.addEventListener('click',()=>{$$('#shopPokemon [data-sell-poke]:not(:disabled)').forEach(box=>{shopPokeSelected.add(String(box.dataset.sellPoke));box.checked=true});renderShopPokemon()});
  $('#shopPokeSellConfirm')?.addEventListener('click',sellSelectedPokemon);
  $('#shopRarityFilters')?.addEventListener('click',e=>{const btn=e.target.closest('[data-shop-rarity]');if(!btn)return;const name=btn.dataset.shopRarity;if(shopRarityFilter.has(name))shopRarityFilter.delete(name);else shopRarityFilter.add(name);renderShopRarityFilters();renderShopPokemon()});
  ['#shopIvMin','#shopIvMax'].forEach(sel=>$(sel)?.addEventListener('input',()=>renderShopPokemon()));
  $('#shopDialogClose')?.addEventListener('click',closeCityDialog);
  $('#fishingDialogClose')?.addEventListener('click',closeCityDialog);
  $('#fishingToggle')?.addEventListener('click',toggleFishing);
  $$('.nav-item[data-view]').forEach(b=>b.onclick=()=>{
    if(b.dataset.view==='city'){teleportToCityCenter();return}
    switchView(b.dataset.view);
  });
  if($('#cityDepotButton'))$('#cityDepotButton').onclick=()=>openHuntWindow('collectionPanel');
  $('#pokemonCompareNavButton')?.addEventListener('click',()=>openHuntWindow('pokemonComparePanel'));
  const comparePanel=$('#pokemonComparePanel');
  comparePanel?.addEventListener('focusin',event=>{
    const input=event.target.closest?.('[data-compare-search]');
    if(!input)return;
    const side=input.dataset.compareSearch,slot=compareLab[side];
    slot.open=true;
    if(slot.mode===COMPARE_MODE_OWNED)slot.ownedQuery='';else slot.query='';
    input.value='';renderCompareDropdown(side);
  });
  comparePanel?.addEventListener('input',event=>{
    const target=event.target;
    if(target.matches?.('[data-compare-search]')){const side=target.dataset.compareSearch,slot=compareLab[side];if(slot.mode===COMPARE_MODE_OWNED)slot.ownedQuery=target.value;else slot.query=target.value;slot.open=true;renderCompareDropdown(side);return}
    if(target.matches?.('[data-compare-iv]')){const side=target.dataset.compareIv;compareLab[side].iv=Math.max(1,Math.min(100,Math.round(Number(target.value)||1)));syncCompareSlotLive(side);renderCompareOutcome();return}
    if(target.matches?.('[data-compare-level]')){const side=target.dataset.compareLevel,slot=compareLab[side],model=compareSimulate(slot);slot.level=slot.mode===COMPARE_MODE_OWNED?normalizeCompareLevel(target.value,model?.levelMax||COMPARE_POKEMON_LEVEL_MAX):Math.max(1,Math.min(COMPARE_POKEMON_LEVEL_MAX,Math.round(Number(target.value)||1)));syncCompareSlotLive(side);renderCompareOutcome()}
  });
  comparePanel?.addEventListener('change',event=>{
    const target=event.target;
    if(target.matches?.('[data-compare-level]'))renderCompareSlot(target.dataset.compareLevel);
    if(target.matches?.('[data-compare-evolution]')){const side=target.dataset.compareEvolution;compareLab[side].evolution=target.value;renderCompareSlot(side);renderCompareOutcome()}
  });
  comparePanel?.addEventListener('click',event=>{
    const mode=event.target.closest?.('[data-compare-mode]');
    if(mode){const side=mode.dataset.compareMode,slot=compareLab[side],nextMode=mode.dataset.mode===COMPARE_MODE_OWNED?COMPARE_MODE_OWNED:COMPARE_MODE_SPECIES;slot.mode=nextMode;slot.open=nextMode===COMPARE_MODE_OWNED&&!slot.ownedKey;if(nextMode===COMPARE_MODE_OWNED)slot.ownedQuery='';else slot.query='';renderCompareSlot(side);renderCompareOutcome();return}
    const ownedPick=event.target.closest?.('[data-compare-owned-pick]');
    if(ownedPick){const side=ownedPick.dataset.compareOwnedPick,slot=compareLab[side],key=ownedPick.dataset.ownedKey,pokemon=compareOwnedPokemon(key);if(!pokemon)return;slot.ownedKey=key;slot.evolution=pokemon.name;slot.level=normalizeCompareLevel(pokemon.level,Math.max(COMPARE_POKEMON_LEVEL_MAX,normalizeCompareLevel(pokemon.level,Number.MAX_SAFE_INTEGER)));slot.open=false;slot.ownedQuery='';renderCompareSlot(side);renderCompareOutcome();return}
    const pick=event.target.closest?.('[data-compare-pick]');
    if(pick){const side=pick.dataset.comparePick,slot=compareLab[side];slot.species=pick.dataset.species||'';slot.open=false;slot.query='';renderCompareSlot(side);renderCompareOutcome();return}
    const clear=event.target.closest?.('[data-compare-clear]');
    if(clear){const side=clear.dataset.compareClear,slot=compareLab[side];if(slot.mode===COMPARE_MODE_OWNED){slot.ownedKey='';slot.evolution='';slot.ownedQuery=''}else{slot.species='';slot.query=''}slot.open=true;renderCompareSlot(side);renderCompareOutcome();compareSlotEl(side)?.querySelector('[data-compare-search]')?.focus();return}
    const rarityBtn=event.target.closest?.('[data-compare-rarity]');
    if(rarityBtn){const side=rarityBtn.dataset.compareRarity;compareLab[side].rarity=rarityBtn.dataset.rarity||'Comum';renderCompareSlot(side);renderCompareOutcome();return}
    const bandBtn=event.target.closest?.('[data-compare-band]');
    if(bandBtn){const side=bandBtn.dataset.compareBand,band=IV_QUALITY_BANDS.find(entry=>entry.name===bandBtn.dataset.band);if(band)compareLab[side].iv=Math.round((band.min+band.max)/2);renderCompareSlot(side);renderCompareOutcome();return}
    if(event.target.closest?.('#pokemonCompareSwap')){compareLab.left.open=compareLab.right.open=false;[compareLab.left,compareLab.right]=[compareLab.right,compareLab.left];renderCompareSlot('left');renderCompareSlot('right');renderCompareOutcome();return}
    if(!event.target.closest?.('.compare-search-wrap'))COMPARE_SIDES.forEach(closeCompareSearch);
  });
  document.addEventListener('click',event=>{
    const panel=$('#pokemonComparePanel');
    if(!panel||$('#pokemonComparePanelLayer')?.classList.contains('hidden')||panel.contains(event.target))return;
    COMPARE_SIDES.forEach(closeCompareSearch);
  });
  if($('#myPokemonNavButton'))$('#myPokemonNavButton').onclick=openTeamManagement;
  // O card do Pokémon principal no HUD também abre a ficha. O de reservas é
  // religado a cada render, em renderRouteReserves().
  {
    const activeRow=$('#partnerHudSprite')?.closest('.team-pokemon-row');
    if(activeRow){
      activeRow.setAttribute('role','button');
      activeRow.setAttribute('tabindex','0');
      const open=event=>{if(event.target.closest('[data-evolve-kind]'))return;openTeamMember('starter')};
      activeRow.onclick=open;
      activeRow.onkeydown=event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();open(event)}};
    }
  }
  if($('#teamManagementClose'))$('#teamManagementClose').onclick=closeTeamManagement;
  $('#teamManagementOverlay')?.addEventListener('click',e=>{if(e.target===$('#teamManagementOverlay'))closeTeamManagement()});
  if($('#colType'))$('#colType').innerHTML=`<option value="">${t('col.allTypes')}</option>`+types.map(tp=>`<option value="${tp[0]}">${typeLabel(tp[0])}</option>`).join('');
  renderDepositRarityFilters();
  ['#colSearch','#colType','#colIvMin','#colIvMax','#colLevelMin','#colLevelMax'].forEach(sel=>{const el=$(sel);if(el)el.oninput=renderCollection});
  $('#colShinyFilter')?.addEventListener('click',()=>{depositShinyOnly=!depositShinyOnly;renderDepositRarityFilters();renderCollection()});
  $('#colRarityFilters')?.addEventListener('click',e=>{const button=e.target.closest('[data-deposit-rarity]');if(!button)return;const name=button.dataset.depositRarity;if(depositRarityFilter.has(name))depositRarityFilter.delete(name);else depositRarityFilter.add(name);renderDepositRarityFilters();renderCollection()});
  if($('#colClear'))$('#colClear').onclick=()=>{if($('#colSearch'))$('#colSearch').value='';if($('#colType'))$('#colType').value='';['colIvMin','colIvMax','colLevelMin','colLevelMax'].forEach(id=>{const el=$(`#${id}`);if(el)el.value=''});depositRarityFilter.clear();depositShinyOnly=false;renderDepositRarityFilters();renderCollection()};
  $$('#collectionPanel [data-deposit-tab]').forEach(button=>button.onclick=()=>switchDepositTab(button.dataset.depositTab));
  if($('#depositItemSearch'))$('#depositItemSearch').oninput=renderDepositItems;
  if($('#depositItemCategory'))$('#depositItemCategory').onchange=renderDepositItems;
  if($('#depositAllItems'))$('#depositAllItems').onclick=depositAllItems;
  if($('#headerMapButton'))$('#headerMapButton').onclick=()=>openAtlas({typeIndex:state.type,band:state.range,step:'type'});
  renderCityTeleportOptions();
  $('#cityTeleportToggle')?.addEventListener('click',()=>teleportToCityNpc('shop'));
  $('#cityTeleportClose')?.addEventListener('click',()=>setCityTeleportOpen(false));
  $('#cityTeleportOptions')?.addEventListener('click',event=>{const button=event.target.closest('[data-city-teleport]');if(button)teleportToCityNpc(button.dataset.cityTeleport)});
  document.addEventListener('click',event=>{if(!event.target.closest('#cityTeleport'))setCityTeleportOpen(false)});
  if($('#mapClose'))$('#mapClose').onclick=()=>$('#worldMapModal')?.classList.add('hidden');
  $('#worldMapModal')?.addEventListener('click',e=>{if(e.target===$('#worldMapModal'))$('#worldMapModal').classList.add('hidden')});
  if($('#huntPanelButton'))$('#huntPanelButton').onclick=()=>openHuntWindow('huntPanel');
  if($('#capturePanelButton'))$('#capturePanelButton').onclick=()=>openHuntWindow('capturePanel');
  if($('#automationPanelButton'))$('#automationPanelButton').onclick=()=>{openHuntWindow('automationPanel');renderOfflineStatus()};
  if($('#inventoryNavButton'))$('#inventoryNavButton').onclick=()=>openHuntWindow('inventoryPanel');
  if($('#pokedexNavButton'))$('#pokedexNavButton').onclick=()=>openHuntWindow('pokedexPanel');
  $$('[data-panel-close]').forEach(button=>button.onclick=()=>closeFloatingPanel(button.dataset.panelClose));
  $('#captureHistoryFilters')?.addEventListener('click',e=>{const button=e.target.closest('[data-capture-filter]');if(!button)return;captureHistoryFilter=button.dataset.captureFilter;renderCaptureLog()});
  try{initFloatingPanels()}catch(err){console.error('initFloatingPanels failed',err)}
  setInterval(()=>{if(state.activeHunt&&!$('#huntHistoryModal')?.classList.contains('hidden'))renderHuntHistory();if(!$('#automationPanelLayer')?.classList.contains('hidden'))renderOfflineStatus()},1000);
  $('#pokedexSearch')?.addEventListener('input',()=>renderPokedex());
  $('#pokedexTypeFilter')?.addEventListener('change',()=>renderPokedex());
  $('#pokedexOwnedOnly')?.addEventListener('change',()=>renderPokedex());
  $('#combatFeedbackClose')?.addEventListener('click',hideCombatFeedback);
  const combatFeedbackBox=$('#combatFeedback');
  // Clicar em qualquer ponto da caixa fecha. São avisos passageiros: não há
  // nada dentro para interagir, e o alvo de clique inteiro é bem mais fácil de
  // acertar que o "x" de 12px. O botão continua ali para leitores de tela.
  combatFeedbackBox?.addEventListener('click',hideCombatFeedback);
  combatFeedbackBox?.addEventListener('mouseenter',()=>{if(combatFeedbackBox.classList.contains('hidden'))return;clearTimeout(combatFeedbackTimer);combatFeedbackTimer=null;combatFeedbackBox.classList.add('paused')});
  combatFeedbackBox?.addEventListener('mouseleave',()=>{combatFeedbackBox.classList.remove('paused');if(!combatFeedbackBox.classList.contains('hidden')&&!combatFeedbackBox.classList.contains('closing'))restartCombatFeedbackTimer()});
  $('#captureFeedbackClose')?.addEventListener('click',()=>hideCaptureFeedback({clearQueue:true}));
  const captureFeedbackBox=$('#captureFeedback');
  captureFeedbackBox?.addEventListener('click',()=>hideCaptureFeedback({clearQueue:true}));
  captureFeedbackBox?.addEventListener('mouseenter',()=>{if(captureFeedbackBox.classList.contains('hidden'))return;clearTimeout(captureFeedbackTimer);captureFeedbackTimer=null;captureFeedbackBox.classList.add('paused')});
  captureFeedbackBox?.addEventListener('mouseleave',()=>{captureFeedbackBox.classList.remove('paused');if(!captureFeedbackBox.classList.contains('hidden')&&!captureFeedbackBox.classList.contains('closing'))restartCaptureFeedbackTimer(captureFeedbackMode==='toast'?CAPTURE_TOAST_MS:CAPTURE_FEEDBACK_MS)});
  if(location.hostname==='localhost'){
    window.__tutorialQaPrepareStep=prepareTutorialStep;
    window.__captureFeedbackDemo=(mode='panel')=>{
      if(mode==='toast'){
        showCaptureToast({ok:true,name:'pichu',level:4,types:['elétrico'],chance:.42,ball:ITEM_BY_SLUG.pokeball,rarity:{name:'Raro'},shiny:false});
        return;
      }
      recentFaints=[{id:'demo-1',name:'pichu',level:4,types:['elétrico'],hpPct:0,at:Date.now(),status:'ready'},{id:'demo-2',name:'pikachu',level:12,types:['elétrico'],hpPct:0,at:Date.now(),status:'ready'}];
      showCapturePanel();
    };
    window.__captureFxDemo=(ok=true)=>playCaptureAttempt({name:'pichu',dir:'south',x:routeSim.player.x+6,y:routeSim.player.y-6},{ok:ok!==false,ball:ITEM_BY_SLUG[selectedBall]||ITEM_BY_SLUG.pokeball});
  }
  if($('#soundButton'))$('#soundButton').onclick=e=>{e.currentTarget.textContent=e.currentTarget.textContent==='◕'?'○':'◕';showToast(t('city.soundSoon'))};
  if($('#marketNavButton'))$('#marketNavButton').onclick=()=>activeAccount||previewMode==='market'?openMarket():showToast(t('auth.errorGeneric'));
  if(localVisualPreview&&previewMode==='market')openMarket();
  $$('[data-city-action]').forEach(b=>b.onclick=()=>openCityDialog(b.dataset.cityAction));
  if($('#healTeam'))$('#healTeam').onclick=healTeam;
  if($('#cityDialogClose'))$('#cityDialogClose').onclick=closeCityDialog;
  $('#cityDialog')?.addEventListener('click',e=>{if(e.target===$('#cityDialog'))closeCityDialog()});
  if($('#emeraldStoreNavButton'))$('#emeraldStoreNavButton').onclick=()=>activeAccount||localVisualPreview?openMasterPanel('shopEmerald'):showToast(t('auth.errorGeneric'));
  if($('#gamePassNavButton'))$('#gamePassNavButton').onclick=()=>activeAccount||localVisualPreview?openMasterPanel('pass'):showToast(t('auth.errorGeneric'));
  if($('#dailyGiftNavButton'))$('#dailyGiftNavButton').onclick=()=>activeAccount||localVisualPreview?openMasterPanel('daily'):showToast(t('auth.errorGeneric'));
  refreshDailyGiftBadge();
  document.addEventListener('click',e=>{const button=e.target.closest('[data-evolve-kind]');if(button){e.stopPropagation();openEvolutionDialog(button.dataset.evolveKind,button.dataset.evolveId)}});
  if($('#evolutionDialogClose'))$('#evolutionDialogClose').onclick=closeEvolutionDialog;
  $('#evolutionDialog')?.addEventListener('click',e=>{if(e.target===$('#evolutionDialog'))closeEvolutionDialog()});
  if($('#evolutionNormal'))$('#evolutionNormal').onclick=()=>applyEvolution('reset');
  if($('#evolutionCoins'))$('#evolutionCoins').onclick=()=>applyEvolution('coins');
  $('#evolutionStoneOptions')?.addEventListener('click',e=>{const button=e.target.closest('[data-evolution-stone]');if(button)applyEvolution('stone',button.dataset.evolutionStone)});
  $('#trainerProgressButton')?.addEventListener('click',openProfile);
  $('#profileClose')?.addEventListener('click',closeProfile);
  $('#profileDialog')?.addEventListener('click',e=>{if(e.target===$('#profileDialog'))closeProfile()});
  $('#profileCaptureLogBtn')?.addEventListener('click',()=>{closeProfile();openHuntWindow('capturePanel')});
  $('#profileOutfitBtn')?.addEventListener('click',openOutfitEditor);
  $('#profileOpenProgress')?.addEventListener('click',()=>{closeProfile();openTrainerProgress()});
  $('#profileOpenSpecialization')?.addEventListener('click',()=>{closeProfile();openSpecialization()});
  $('#outfitClose')?.addEventListener('click',()=>{closeOutfitEditor();openProfile()});
  $('#outfitCancel')?.addEventListener('click',()=>{closeOutfitEditor();openProfile()});
  $('#outfitDialog')?.addEventListener('click',e=>{if(e.target===$('#outfitDialog')){closeOutfitEditor();openProfile()}});
  $('#outfitSave')?.addEventListener('click',saveOutfitEditor);
  $('#outfitGender')?.addEventListener('click',e=>{
    const btn=e.target.closest('[data-outfit-gender]');if(!btn)return;
    outfitDraft.gender=btn.dataset.outfitGender==='m'?'m':'f';
    outfitDraft.sprite=defaultSpriteForGender(outfitDraft.gender);
    renderOutfitEditor();
  });
  $('#trainerProgressClose')?.addEventListener('click',closeTrainerProgress);$('#trainerProgressDialog')?.addEventListener('click',e=>{if(e.target===$('#trainerProgressDialog'))closeTrainerProgress()});$('#trainerPrestigeButton')?.addEventListener('click',prestigeTrainer);
  $('#specializationNavButton')?.addEventListener('click',openSpecialization);$('#specializationClose')?.addEventListener('click',closeSpecialization);$('#specializationDialog')?.addEventListener('click',e=>{if(e.target===$('#specializationDialog'))closeSpecialization()});$('#specializationGrid')?.addEventListener('click',e=>{const button=e.target.closest('[data-talent-upgrade]');if(button)investTrainerTalent(button.dataset.talentUpgrade)});$('#specializationRespec')?.addEventListener('click',respecTrainerTalents);$('#systemsDiscoveryGrid')?.addEventListener('click',e=>{const button=e.target.closest('[data-open-system]');if(button)openSpecializationSystem(button.dataset.openSystem)});
  $('#offlineStartButton')?.addEventListener('click',startOfflineHunt);
  $('#offlineRestButton')?.addEventListener('click',()=>void restOfflineHunt());
  $('#restButton')?.addEventListener('click',()=>void restOfflineHunt());
  $('#offlineReportClose')?.addEventListener('click',closeOfflineReport);$('#offlineReportDialog')?.addEventListener('click',e=>{if(e.target===$('#offlineReportDialog'))closeOfflineReport()});$('#offlineClaimButton')?.addEventListener('click',claimOfflineReport);
  $('#settingsButton')?.addEventListener('click',openSettings);
  $('#settingsDialogClose')?.addEventListener('click',closeSettings);
  $('#settingsDialog')?.addEventListener('click',e=>{if(e.target===$('#settingsDialog'))closeSettings()});
  $('#adminSettingsButton')?.addEventListener('click',()=>{closeSettings();openAdminPanel()});
  $('#tutorialRestartButton')?.addEventListener('click',()=>{restartTutorial();closeSettings()});
  $('#accountSignOut')?.addEventListener('click',async event=>{
    const button=event.currentTarget;button.disabled=true;
    try{await flushGameSave().catch(()=>{});await flushWalletSync().catch(()=>{});await signOutAccount();location.reload()}catch(error){console.error('sign out failed',error);button.disabled=false;showToast(t('auth.errorGeneric'))}
  });
  addEventListener('visibilitychange',()=>{
    if(document.visibilityState==='hidden'){
      // A aba escondida não recebe o keyup: sem isto a tecla fica "presa" e o
      // par oposto (A+D / W+S) zera o movimento ao voltar.
      keys.clear();
      flushSessionSync().catch(()=>{});
      flushGameSave().catch(()=>{});
      flushPokemonXpGrants().catch(()=>{});
    }
    else if(document.visibilityState==='visible'){resumeForegroundLoop();reconcileAfterVisibilityResume().catch(()=>{})}
  });
  addEventListener('pagehide',()=>{
    flushSessionSync().catch(()=>{});
    flushGameSave().catch(()=>{});
    // Sem isto o debounce de 2,5s comia o XP de Pokémon no F5.
    flushPokemonXpGrants().catch(()=>{});
  },{once:true});
  $('#settingsLanguageList')?.addEventListener('click',e=>{const btn=e.target.closest('[data-locale]');if(!btn)return;setLocale(btn.dataset.locale);closeSettings();showToast(t('settings.language')+': '+t(`settings.language.${btn.dataset.locale}`))});
  addEventListener('keydown',e=>{
    if(e.key==='Escape'){
      if(closeGameConfirm(false)){e.preventDefault();return}
      hideCombatFeedback();hideCaptureFeedback({clearQueue:true});closeHuntWindows();closeEvolutionDialog();closeOutfitEditor();closeProfile();closeTrainerProgress();closeSpecialization();closeOfflineReport();closeTeamManagement();closeSettings();closeAdminPanel();setCityTeleportOpen(false);document.getElementById('masterSystemsDialog')?.classList.add('hidden')
    }
    const typingTarget=e.target?.closest?.('input,textarea,select,[contenteditable="true"]');
    if((e.key==='e'||e.key==='E')&&!typingTarget&&$('#cityView')?.classList.contains('active')){
      const near=npcNear(cityPlayer.x,cityPlayer.y);
      if(near){e.preventDefault();openCityNpcPanel(near);return}
    }
    // Com Ctrl/Alt/Meta o atalho é do navegador (Ctrl+D, Alt+D...): ele rouba o
    // foco e o keyup nunca chega, deixando a tecla presa no Set.
    if(['w','a','s','d'].includes(e.key.toLowerCase())&&!typingTarget&&!e.ctrlKey&&!e.altKey&&!e.metaKey){keys.add(e.key.toLowerCase());e.preventDefault()}
  });addEventListener('keyup',e=>{keys.delete(e.key.toLowerCase());setActor($('#cityTrainer'),trainerSprite(),cityPlayer.dir,false,performance.now())});addEventListener('blur',()=>keys.clear());
  }catch(err){console.error('boot wiring failed',err)}
  try{updateCityCamera();updateBuildingState()}catch(err){console.error('city camera final boot failed',err)}
  if(previewMode==='fire')state.type=1;
  state.running=false;
  syncAutomationRuntime();
  applyAutomationUi();
  try{renderBallSelect();renderPotionThreshold();renderPotionSelect()}catch(err){console.error('automation render failed',err)}
  const routePreview=['route','fire','capturefx','capturefx-fail'].includes(previewMode);
  if(routePreview){
    switchView('adventure');
    changeRoute();
    if(previewMode==='route'||previewMode==='fire')state.running=true;
  }else if(previewMode==='tm-shop'){
    switchView('city');
    setTimeout(()=>openCityDialog('tm-shop'),250);
  }else if(canResumeHunt()){
    resumeLastHunt();
  }else{
    switchView('city');
    changeRoute();
  }
  if(previewMode==='map')openMap();
  if(previewMode==='capturefx'||previewMode==='capturefx-fail')setTimeout(()=>playCaptureAttempt({name:'pichu',dir:'south',x:routeSim.player.x+6,y:routeSim.player.y-6},{ok:previewMode!=='capturefx-fail',ball:ITEM_BY_SLUG[selectedBall]||ITEM_BY_SLUG.pokeball}),450);
  if(shouldShowDailyGiftOnLogin({
    isAuthenticated:!!activeAccount,
    isFirstLogin:!state.starter?.name,
    isPreview:!!previewMode,
  }))openMasterPanel('daily');
  // Antes de subir os renderers: eles medem o host, que já precisa estar com
  // --map-scale aplicado para nascer com o viewport certo.
  lockMapScale($('.city-scene'));lockMapScale($('#environment'));
  startGameRuntime();
  await waitForCityBackdrop();
  boot?.finish();
}
let gameRuntimeStarted=false;
// O rAF e o renderer da cidade ficavam na última linha de um setup() de ~650
// linhas: qualquer throw acima deixava o jogo *parecendo* carregado (o splash
// tem hard timeout próprio e some sozinho) mas sem loop de simulação — Pokémon
// congelado no "procurando alvo", nenhum spawn, e cityWorldReady false, ou
// seja, WASD morto na cidade. O runtime não pode depender do sucesso do boot.
function startGameRuntime(){
  if(gameRuntimeStarted)return;
  gameRuntimeStarted=true;
  try{prepareOfflineReport()}catch(error){console.error('offline report failed',error)}
  try{bootCityRenderer()}catch(error){console.error('city renderer boot failed',error);cityWorldReady=true}
  try{applyRoofShiftDebug()}catch(error){console.error('roof shift debug failed',error)}
  try{startBackgroundEngine()}catch(error){console.error('background engine failed',error)}
  rafActive=true;requestAnimationFrame(tick);
}
// O mapa da cidade é o maior "pop" visual do boot: o splash espera ele decodificar.
function waitForCityBackdrop(){
  const img=$('.city-map-image');
  if(!img||img.complete)return Promise.resolve();
  return new Promise(resolve=>{
    const done=()=>resolve();
    img.addEventListener('load',done,{once:true});
    img.addEventListener('error',done,{once:true});
    setTimeout(done,4000);
  });
}
// Debug / panic: window.__idlemonServerReady() e localStorage idlemon-force-local-gameplay=1
try{
  window.__idlemonServerReady=()=>({
    ready:serverGameplayReady(),
    forceLocal:forceLocalGameplay(),
    collection:collectionSyncEnabled(),
    inventory:inventorySyncEnabled(),
    progress:progressSyncEnabled(),
    encounters:encountersSyncEnabled(),
    encounterQueue:encounterQueueLength(),
  });
  window.__idlemonForceLocal=(on=true)=>{
    localStorage.setItem('idlemon-force-local-gameplay',on?'1':'0');
    return window.__idlemonServerReady();
  };
}catch{}
// setup() é async: sem este catch, qualquer throw virava um unhandled rejection
// silencioso e o jogador ficava com a tela do jogo montada e nada funcionando.
// O finally garante o runtime mesmo num boot pela metade — é melhor jogar sem
// uma feature do que encarar uma cidade onde o boneco não anda.
setup().catch(error=>{
  console.error('boot failed',error);
  try{showToast(t('sys.bootDegraded'))}catch{}
}).finally(()=>{
  startGameRuntime();
  try{globalThis.IdlemonBoot?.finish()}catch{}
});
